(ns graph-ui.web.widgets
  "One reagent component per UI-DSL widget kind (PLAN-graph-ui-v0-001-02 Phase W2),
   now backed by Mantine components and CodeMirror 6 (ADR-graph-ui-v0-012-01).

   The Meta-UI contract is unchanged: descriptions still say `{:widget :tree}`;
   these functions are thin adapters from description props to Mantine."
  (:require [reagent.core :as r]
            [reagent.dom :as rdom]
            ["dockview-core" :as dockview]
            ["react-dom" :as react-dom]
            ["react" :as react]
            [clojure.string :as str]
            [clojure.walk]
            ["@mantine/core" :as mantine]
            ["@mantine/code-highlight" :refer [CodeHighlight]]
            ;; ONE FILE PER ICON, AND NOT THE PACKAGE (PLAN-ikc-v3-033-01
            ;; Phase 0's report). The import was `:as`, so the code read each
            ;; icon as a PROPERTY of the namespace and Closure could remove
            ;; none of it: 2.6 MB, or 43 percent of the bundle, measured
            ;; 2026-09-20.
            ;;
            ;; A `:refer` DID NOT FIX IT, AND THE BUNDLE SAID SO. Rebuilt with
            ;; `:refer` of these same 29 names, main.js held 6,147 icon markers
            ;; and still carried IconZeppelin. shadow-cljs bundles an npm module
            ;; whole, so naming what you want from the barrel removes nothing.
            ;; The package declares no `exports` map and ships one file per
            ;; icon, each with a default export, so these 30 files are all that
            ;; enters the bundle.
            ;;
            ;; THE PATH REACHES INSIDE THE PACKAGE, which is the cost. An
            ;; upgrade that moves dist/esm/icons is a BUILD failure, not a blank
            ;; square, and widgets-test asserts every one of the 30 resolves.
            ["@tabler/icons-react/dist/esm/icons/IconBook.mjs" :default IconBook]
            ["@tabler/icons-react/dist/esm/icons/IconCalendar.mjs" :default IconCalendar]
            ["@tabler/icons-react/dist/esm/icons/IconCheck.mjs" :default IconCheck]
            ["@tabler/icons-react/dist/esm/icons/IconChevronDown.mjs" :default IconChevronDown]
            ["@tabler/icons-react/dist/esm/icons/IconChevronLeft.mjs" :default IconChevronLeft]
            ["@tabler/icons-react/dist/esm/icons/IconChevronRight.mjs" :default IconChevronRight]
            ["@tabler/icons-react/dist/esm/icons/IconChevronUp.mjs" :default IconChevronUp]
            ["@tabler/icons-react/dist/esm/icons/IconContrast.mjs" :default IconContrast]
            ["@tabler/icons-react/dist/esm/icons/IconCopy.mjs" :default IconCopy]
            ["@tabler/icons-react/dist/esm/icons/IconDots.mjs" :default IconDots]
            ["@tabler/icons-react/dist/esm/icons/IconFileText.mjs" :default IconFileText]
            ["@tabler/icons-react/dist/esm/icons/IconFocus2.mjs" :default IconFocus2]
            ["@tabler/icons-react/dist/esm/icons/IconFolder.mjs" :default IconFolder]
            ["@tabler/icons-react/dist/esm/icons/IconHeading.mjs" :default IconHeading]
            ["@tabler/icons-react/dist/esm/icons/IconHome.mjs" :default IconHome]
            ["@tabler/icons-react/dist/esm/icons/IconLabel.mjs" :default IconLabel]
            ["@tabler/icons-react/dist/esm/icons/IconLink.mjs" :default IconLink]
            ["@tabler/icons-react/dist/esm/icons/IconListTree.mjs" :default IconListTree]
            ["@tabler/icons-react/dist/esm/icons/IconMenu2.mjs" :default IconMenu2]
            ["@tabler/icons-react/dist/esm/icons/IconPalette.mjs" :default IconPalette]
            ["@tabler/icons-react/dist/esm/icons/IconPencil.mjs" :default IconPencil]
            ["@tabler/icons-react/dist/esm/icons/IconPhoto.mjs" :default IconPhoto]
            ["@tabler/icons-react/dist/esm/icons/IconPin.mjs" :default IconPin]
            ["@tabler/icons-react/dist/esm/icons/IconPlus.mjs" :default IconPlus]
            ["@tabler/icons-react/dist/esm/icons/IconSearch.mjs" :default IconSearch]
            ["@tabler/icons-react/dist/esm/icons/IconSettings.mjs" :default IconSettings]
            ["@tabler/icons-react/dist/esm/icons/IconStar.mjs" :default IconStar]
            ["@tabler/icons-react/dist/esm/icons/IconTag.mjs" :default IconTag]
            ["@tabler/icons-react/dist/esm/icons/IconTrash.mjs" :default IconTrash]
            ["@tabler/icons-react/dist/esm/icons/IconX.mjs" :default IconX]
            ["@uiw/react-codemirror" :as uiw-cm]
            [graph-ui.web.bind :as bind]
            [graph-ui.web.markdown :as md]
            [graph-ui.web.generated-design :as design]
            [graph-ui.web.dock-panes :as dock-panes]
            [graph-ui.web.nav :as nav]
            [graph-ui.web.theme :as theme]
            [graph-ui.web.draft :as draft]
            [graph-ui.web.unsaved :as unsaved]
            [graph-ui.web.locate :as locate]
            [graph-ui.web.responsive :as responsive]
            [graph-ui.web.activity :as activity]
            [graph-ui.web.busy :as busy]
            [graph-ui.web.lazy :as lazy]
            [graph-ui.web.codemirror :as cm]
            [graph-ui.web.edn-indent :as edn-indent]
            [graph-ui.web.prompt-area :as prompt-area]
            [graph-ui.web.push :as push]))

;; @feature F-gi-v3-010-01-graph-ui-poc
;; @adr ADR-graph-ui-v0-003-01-ui-from-formal-description
;; @adr ADR-graph-ui-v0-012-01-mantine-component-library
;; @adr ADR-graph-ui-v0-013-01-one-layout-model
;; @adr ADR-graph-ui-v0-020-01-a-widget-tree-can-name-its-surface

;; ---------------------------------------------------------------------------
;; Mantine helpers.
;; ---------------------------------------------------------------------------

(defn- mantine-color
  "Map a Meta-UI :tone token to an ikc3 theme colour, as a raw CSS
   var() reference rather than a Mantine theme-palette name (fixed
   2026-07-28: previously :muted/default resolved to Mantine's OWN generic
   'gray' scale, entirely unrelated to the active ikc3 theme's tokens — a
   reader built against the Amber mockup rendered in generic Mantine grey.
   Mantine's own getThemeColor gracefully passes through any string it
   doesn't recognise as a theme-palette key, so a var() reference works
   exactly like a real Mantine color name would, everywhere a :c/:color
   prop is accepted — verified against the installed package, not assumed)."
  [tone]
  (case tone
    :accent  "var(--accent)"
    :success "var(--good)"
    :warning "var(--warn)"
    :danger  "var(--crit)"
    :muted   "var(--muted)"
    "var(--text)"))

(defn- mantine-size
  "Map density/size tokens to Mantine size strings. :base is v1.x's own name
   for the middle step; v2.0 corrected it to Mantine's :md (ADR-graph-ui-v0-013-01
   §19) — both are accepted here because a released version's vocabulary never
   changes, so v1.x descriptions keep sending :base forever."
  [size]
  (case size
    :xs "xs" :sm "sm" :base "sm" :md "sm" :lg "md" :xl "lg"
    "sm"))

;; ---------------------------------------------------------------------------
;; Typography — ADR-graph-ui-v0-013-01 §19's universal slots (:size/:weight/
;; :transform). ONE implementation, applied at each text-bearing call site:
;; the VOCABULARY is declared once (ui.edn :universal-slots), and the renderer
;; honours it where it is meaningful — a documented no-op elsewhere, the same
;; contract :flex set in §4.
;;
;; These map onto Mantine's own Box style props (fz/fw/tt/lts), which is why
;; they are universal there too: they are not properties of any one component.
;; ---------------------------------------------------------------------------

(def ^:private font-weights {:normal 400 :medium 500 :bold 700})

(defn- font-size-token
  "v2.0's :font-size enum → a MantineFontSize value. Two scales in one enum,
   exactly as Mantine's own type allows: the :xs-:xl step scale, and :h1-:h6
   heading sizes (verified in @mantine/core@8.3.18's style-props.types.d.ts —
   `fz?: StyleProp<MantineFontSize | \\`h${1|2|3|4|5|6}\\` | number | (string &
   {})>`). :base is v1.x's own middle step, mapped rather than rejected."
  [size]
  (case size
    (:xs :sm :md :lg :xl :h1 :h2 :h3 :h4 :h5 :h6) (name size)
    :base "sm"
    nil))

(defn unstyled-line?
  "PURE. Is this :input a one-line field drawn as plain text (:variant
   :unstyled), such as the name of a page?"
  [{:keys [variant multiline]}]
  (and (= :unstyled variant) (not multiline)))

(defn text-width-style
  "PURE. The CSS width of a one-line field drawn as plain text: as wide as its
   text, never less than 20 characters, and never wider than its parent.

   THE NAME OF A PAGE SHARES A LINE (IKC3/PLAN-ikc-v3-068-01/H). In George's
   edit of the reading header, the name, the kind, the tags field and the
   controls are one line. The name has no :flex, so its basis is its own
   width, and that width was the browser's 20 characters. A longer name was
   cut inside its own field. Now the width follows the text, so the line
   wraps the next items before it cuts the name. `max-width: 100%` lets the
   field become narrower only when the whole pane is narrower than the text.

   ch is the width of a digit. A capital letter is wider, so each character
   counts 1.1ch, and 1em is room for the caret."
  [text]
  (let [n (max 20 (count (str text)))]
    {:width (str "calc(" (* 1.1 n) "ch + 1em)") :maxWidth "100%"}))

(defn typography-props
  "The Mantine style props for §19's universal typography slots, as a map to
   merge into any text-bearing component's props. Returns {} when the node
   carries none, so a widget that merges it unconditionally passes nothing
   extra — Mantine's defaults only fire on an ABSENT prop, never an explicit
   nil (the Grid/SimpleGrid lesson, 2026-07-27), so absent slots must not
   become explicit nils here.

   The slots are :font-size/:font-weight/:text-transform, NOT :size/:weight —
   a universal :size collided with :icon's, :drawer's and :container's own
   :size, which malli rejected outright. Mantine keeps the same separation for
   the same reason: `size` is per-component, `fz`/`fw`/`tt` are typography.

   :uppercase brings letter-spacing with it: SPEC-alatus-v0-002-01's section
   headers and kind badge are uppercase AND letter-spaced, always together, so
   a separate slot would be a prop with exactly one legal use (§19)."
  [{:keys [font-size font-weight text-transform]}]
  (cond-> {}
    (font-size-token font-size)     (assoc :fz (font-size-token font-size))
    (get font-weights font-weight)  (assoc :fw (get font-weights font-weight))
    (= text-transform :uppercase)   (merge {:tt "uppercase" :lts "0.05em"})))

(defn- mantine-gap
  "Map Meta-UI :gap enum to Mantine gap."
  [gap]
  (case gap
    :none 0
    :sm "xs"
    :md "sm"
    :lg "md"
    "sm"))

;; ---------------------------------------------------------------------------
;; ADR-graph-ui-v0-013-01 §7-10: the unified :on-gesture slot, and §0's real
;; Mantine-backed container/spacing vocabulary. v1.x islands render forever
;; unchanged (a released version's vocabulary never changes), so every
;; dispatch-firing widget below supports BOTH shapes — a render tree only
;; ever carries one or the other (ui.interpret's schema is version-gated and
;; closed), so a simple either/or is safe.
;; ---------------------------------------------------------------------------

;; The rule moved to bind/submit-template so prompt_area.cljs asks the same
;; question instead of guessing (2026-08-20). This alias keeps the local name.
(def ^:private submit-template bind/submit-template)

(defn- fork-template
  "The command template for :tree's fork gesture — :on-gesture's :fork key
   under v2.0, :on-fork under v1.x."
  [{:keys [on-gesture on-fork]}]
  (or (:fork on-gesture) on-fork))

(defn- gesture-actions
  "The named-action map :outline dispatches per row — :on-gesture itself
   under v2.0 (keyed :indent/:outdent/etc directly), :actions under v1.x."
  [{:keys [on-gesture actions]}]
  (or on-gesture actions))

(defn- mantine-align-items
  "Meta-UI v2.0's closed :align enum → CSS align-items keyword."
  [align]
  (case align :start "flex-start" :end "flex-end" :center "center"
              :stretch "stretch" :baseline "baseline" nil))

(defn- mantine-justify-content
  "Meta-UI v2.0's closed :justify enum → CSS justify-content keyword."
  [justify]
  (case justify :start "flex-start" :end "flex-end" :center "center"
                :between "space-between" :around "space-around" nil))

(defn- mantine-spacing-token
  "Meta-UI v2.0's :xs/:sm/:md/:lg/:xl gap/gutter/spacing enum maps 1:1 onto
   Mantine's own theme.spacing keys — no translation needed, unlike
   mantine-gap above (v1.x's differently-scoped :box :gap enum)."
  [tok]
  (some-> tok name))

;; THE BASIS IS PART OF THE VALUE, and leaving it out broke the one migration
;; ADR-graph-ui-v0-013-01 Sec4 tells every island to perform.
;;
;; That section says ":layout-self {:grow 1 :basis :zero} becomes :flex 1".
;; layout-self-class emits "grow basis-0" for that map. This emitted "grow"
;; alone — flex-grow:1 with flex-basis:auto — so a child sized to its CONTENT
;; first and only then shared the leftover. In a column that makes the child
;; hug, and the parent's justify-content then centres it.
;;
;; MEASURED 2026-09-01, migrating crew-editor off v1: the editor's panes filled
;; the viewport before and floated in the middle of it after, with the two
;; declarations the ADR calls equivalent.
;;
;; CSS's own `flex: 1` shorthand means `1 1 0%`, so the ADR was right and this
;; map was wrong. Tailwind spells that `flex-1`; 2 and 3 have no built-in and
;; take the arbitrary form.
(def ^:private flex-slot-classes
  {0 "flex-none" 1 "flex-1" 2 "flex-[2_1_0%]" 3 "flex-[3_1_0%]"})

(defn flex-class
  "CSS flex-item class for a v2.0 child's :flex self-sizing hint
   (ADR-graph-ui-v0-013-01 §4) — a single closed value 0..3, replacing v1.x's
   four-key :layout-self map. Same fill contract as layout-self-class below."
  [flex-val]
  (str/join " "
    ["flex" "flex-col" "min-h-0" "min-w-0"
     "[&>*]:grow" "[&>*]:min-h-0" "[&>*]:min-w-0"
     (get flex-slot-classes flex-val)]))

;; ---------------------------------------------------------------------------
;; Layout tokens — kept for :box and :layout-self, which are layout primitives
;; and still expressed through Tailwind classes mapped to theme tokens.
;; ---------------------------------------------------------------------------

(def ^:private flex-direction-classes {:row "flex-row" :column "flex-col"})
(def ^:private flex-justify-classes
  {:start "justify-start" :end "justify-end" :center "justify-center"
   :between "justify-between" :around "justify-around"})
(def ^:private flex-align-classes
  {:start "items-start" :end "items-end" :center "items-center" :stretch "items-stretch"})
(def ^:private flex-gap-classes {:none "gap-0" :sm "gap-1" :md "gap-2" :lg "gap-4"})

(defn layout-class
  "Tailwind flexbox class for a box's LEGACY :layout prop."
  [layout]
  (case layout
    :horizontal "flex flex-row gap-2"
    :split      "flex flex-col gap-2"
    "flex flex-col gap-1"))

(defn box-layout-class
  "Layout classes for a :box."
  [{:keys [direction wrap justify align gap layout]}]
  (if direction
    (str/join " "
      (remove str/blank?
        ["flex"
         (get flex-direction-classes direction "flex-col")
         (when wrap "flex-wrap")
         (get flex-gap-classes gap "gap-2")
         (when justify (flex-justify-classes justify))
         (when align (flex-align-classes align))]))
    (layout-class layout)))

(def ^:private self-grow-classes {0 "grow-0" 1 "grow" 2 "grow-[2]" 3 "grow-[3]"})
(def ^:private self-shrink-classes {0 "shrink-0" 1 "shrink"})
(def ^:private self-basis-classes
  {:auto "basis-auto" :zero "basis-0" :quarter "basis-1/4" :third "basis-1/3"
   :half "basis-1/2" :two-thirds "basis-2/3" :full "basis-full"})
(def ^:private self-align-classes
  {:auto "self-auto" :start "self-start" :end "self-end" :center "self-center" :stretch "self-stretch"})

(defn layout-self-class
  "CSS flex-item classes for a child's :layout-self hint (ADR-graph-ui-v0-008-01)."
  [{:keys [grow shrink basis align-self]}]
  (str/join " "
    (remove nil?
      ["flex" "flex-col" "min-h-0" "min-w-0"
       "[&>*]:grow" "[&>*]:min-h-0" "[&>*]:min-w-0"
       (self-grow-classes grow)
       (self-shrink-classes shrink)
       (self-basis-classes basis)
       (self-align-classes align-self)])))

(def ^:private box-density-pad-classes
  {:compact "p-1" :cozy "p-2" :roomy "p-4"})

(def ^:private tone-border-classes
  {:muted   "ikc-bd-raised"
   :accent  "ikc-bd-accent"
   :success "ikc-bd-good"
   :warning "ikc-bd-warn"
   :danger  "ikc-bd-crit"})

(def ^:private tone-text-classes
  {:muted   "ikc-fg-faint"
   :accent  "ikc-fg-accent"
   :success "ikc-fg-good"
   :warning "ikc-fg-warn"
   :danger  "ikc-fg-crit"})

;; ---------------------------------------------------------------------------
;; :icon — @tabler/icons-react (ADR-graph-ui-v0-013-01 §11), CLOSED to the set the
;; locked target's own inventory names (SPEC-002's illustrative ~20), not the
;; library's full catalogue. Grows only when Step 1D's island migration
;; reveals a real consumer needing a name not here (§11's own "widen when
;; blocked, never pre-guessed" rule).
;; ---------------------------------------------------------------------------

(def ^:private icon-components
  {:search        IconSearch
   :chevron-down  IconChevronDown
   :chevron-right IconChevronRight
   :chevron-up    IconChevronUp
   :chevron-left  IconChevronLeft
   :tag           IconTag
   :star          IconStar
   :settings      IconSettings
   :close         IconX
   :plus          IconPlus
   :more          IconDots
   :check         IconCheck
   :calendar      IconCalendar
   :folder        IconFolder
   :file          IconFileText
   :link          IconLink
   :image         IconPhoto
   :trash         IconTrash
   :edit          IconPencil
   :menu          IconMenu2
   :home          IconHome
   ;; PLAN-graph-ui-v0-007-01 Phase 2 (2026-07-27): 5 names the locked target
   ;; needs on ACTIVE (non-disabled) affordances, not in the original 20.
   :outline-view  IconListTree
   :theme-config  IconPalette
   :theme-selector IconContrast
   :pin           IconPin
   :copy          IconCopy

   ;; THREE NAMES DESCRIPTIONS WERE ALREADY ASKING FOR AND NOT GETTING
   ;; (2026-08-15). widget-icon renders nil on a miss, so :title, :label and
   ;; :book-open have been drawing empty space — found by inventorying for the
   ;; style guide, not by anyone seeing it. dsl/design/icons.edn is now the closed
   ;; vocabulary and validate-dsl fails both directions, so this cannot recur.
   ;; :book-open became :book: Tabler has no IconBookOpen, and naming a token
   ;; after a drawing that does not exist is how the hole was dug.
   :title         IconHeading
   :label         IconLabel
   :book          IconBook
   ;; 2026-09-28, bug 7 of IKC3-Bugs-20260928: the ALL VAULTS header shows the
   ;; page that is open in the reading pane.
   :reveal        IconFocus2})

(def ^:private icon-size-token
  "Icon sizes were the last thing in this system measured in PIXELS, in a map
   right here — so the one dimension nobody could theme was the one on every
   toolbar. Now tokens, and in rem, so an icon beside larger type grows with it."
  {:xs "--icon-xs" :sm "--icon-sm" :md "--icon-md" :lg "--icon-lg" :xl "--icon-xl"})

(def ^:private elevation-class
  "The description's `:elevation` enum, as the DEPTH TOKEN it means.

   THE WHOLE ELEVATION SCALE WAS DEAD until 2026-08-16 and every check said
   otherwise. Four tokens declared, three of the five themes restating them
   because depth on a dark ground is not depth on a light one, all four exported
   to Penpot as `boxShadow` — and the renderer's entire consumption of them was
   one `(when (= elevation :raised) …)` handing back a TAILWIND shadow class,
   which is a fixed rgba nobody here chose. So `:overlay` was
   sayable in the vocabulary and drew nothing, `:elevation-floating` had no enum
   value at all, and editing any of the four changed the running app not at all.
   The token-orphan gate could not say so: its haystack included
   `generated_themes.cljs`, the mirror that by another gate's REQUIREMENT names
   every token — the check was reading its own reflection.

   `:floating` is new here (Meta-UI v2.0-SNAPSHOT) because the token existed with
   no way to ask for it, which is the same crack from the other side.

   A STYLE, NOT A TAILWIND ARBITRARY VALUE. A bracketed `var(--elevation-raised)`
   in the class string reads well and is how `text-[var(--muted)]` is spelled twenty lines up, but
   Tailwind cannot tell whether the thing inside the brackets is a shadow or a
   shadow COLOUR, and guesses — on the Play CDN, at runtime, in the browser. A
   box-shadow property carries the same value with nothing to guess about.

   THE SHADOW AND THE STACKING ORDER ARE ONE DECISION. A box that casts a shadow
   over its neighbours and then paints UNDER them is the exact bug elevation
   exists to prevent, so each depth carries its layer too — which is also how
   `--layer-raised` stopped being a name nothing read."
  {:flat     {:shadow "var(--elevation-flat)"}
   :raised   {:shadow "var(--elevation-raised)"   :layer "var(--layer-raised)"}
   :floating {:shadow "var(--elevation-floating)" :layer "var(--layer-overlay)"}
   :overlay  {:shadow "var(--elevation-overlay)"  :layer "var(--layer-modal)"}})

(def ^:private typo-token
  "The description's :font-size scale, as the type token it means. A description
   saying :xs and a component saying type-micro are the same decision spelled two
   ways; this is where they meet."
  {:xs :type-micro :sm :type-small :md :type-body :lg :type-h2 :xl :type-h1
   :h1 :type-h1 :h2 :type-h2 :h3 :type-h2})

(defn typo-css
  "A description's OWN typography props as CSS, so they still override the
   component's default treatment.

   WHY THIS EXISTS. Drawing the section header from ikc/section-header first made
   the description's `:text-transform :uppercase` do nothing — the token said
   uppercase too, so it LOOKED fine and the prop was dead. A declared prop the
   renderer ignores is seam 5 of PRINCIPLE-ikc-v3-011-01, and creating one while
   closing others would be a poor trade. The component supplies the default; the
   description still wins."
  [{:keys [font-size font-weight text-transform]}]
  ;; A BOUND :font-size CAN ARRIVE AS A STRING, and a size with no token is no
  ;; size: "xl" over the wire is :xl, and a value outside the scale sets nothing
  ;; rather than a var() nobody defined (the reader's A− and A+, 2026-10-05).
  (cond-> {}
    (typo-token (some-> font-size keyword))
    (merge (let [t (typo-token (keyword font-size))]
                            {:fontSize   (str "var(--" (name t) "-size)")
                             :lineHeight (str "var(--" (name t) "-line-height)")}))
    font-weight    (assoc :fontWeight (case font-weight :bold 700 :semibold 600 400))
    text-transform (assoc :textTransform (name text-transform)
                          :letterSpacing (if (= :uppercase text-transform)
                                           "var(--type-micro-tracking)" "normal"))))


;; ---------------------------------------------------------------------------
;; Drawing a DECLARED component — ADR-graph-ui-v0-019-01, PLAN-013 Phase 1.
;;
;; The three functions below are the whole seam. Above them is a declaration in
;; dsl/design/block-row.edn saying what a row IS, in tokens; below them is hiccup.
;; Nothing between decides how a row looks any more.
;;
;; Every one is PURE and public, because this mapping is exactly the kind of thing
;; that can be wrong without showing: a token name that becomes a var() nobody
;; defined yields a property the browser drops, and the row keeps whatever it had.
;; ---------------------------------------------------------------------------

(defn token-var
  "A declared token name as the CSS custom property it became — `radius-md` →
   `var(--radius-md)`. The one place `--` is prefixed."
  [t]
  (str "var(--" (name t) ")"))

(defn tracks-css
  "A component's `:tracks` as a grid-template-columns value.

   `:fill` is the track that takes what is left — 1fr — and there is deliberately
   no way to say a pixel width: the declaration is checked to hold `ch` or `:fill`
   and nothing else, because a pixel means nothing under zoom."
  [tracks]
  (str/join " " (for [{:keys [width]} tracks]
                  (if (= :fill width) "1fr" (str width)))))

(defn backdrop-style
  "The `:backdrop` universal slot as a style map, or nil — ui.edn v2.0-SNAPSHOT.
   NAMED :surface UNTIL 2026-08-25 (ADR-graph-ui-v0-027-01): four things carried
   that word, and one of them is level 7 — what a screen is for.

   ONE PROPERTY, and that is the whole of it: `:backdrop body` becomes
   `{:background \"var(--body)\"}`. cell-style below does the same translation for
   a design component's cell and does five more beside it; a node in a widget
   tree has no grid owning it, so it gets only the one that needs no owner.

   nil rather than an empty map when the slot is absent, so a caller can
   `cond->` on it and pass NO :style at all. Mantine merges a style prop it is
   given; an empty map would still overwrite nothing, but a nil style prop is
   what several of its components expect to mean \"unset\"."
  [{:keys [backdrop]}]
  (when backdrop {:background (token-var backdrop)}))

(defn cell-style
  "One cell's declared treatment as a style map.

   The vocabulary is small on purpose and every key maps to exactly one CSS
   property, so a reader can check the translation by eye:

     :backdrop → background     :stroke → border-width (solid, --border)
     :radius  → border-radius   :tone   → color
     :type    → font-size / weight / line-height / transform / tracking
     :padding → padding, block then inline, as CSS writes it

   `:type` expands to several properties because a type token is COMPOSITE — one
   decision carrying size, weight, line-height and tracking so they cannot drift
   apart (theme/token->css flattens the same way on the token side).

   `:dim-when :empty` → opacity, and it needs a fact this function cannot know:
   whether the cell is empty. So the RUNTIME half arrives as the second argument
   and the DECISION stays in the declaration — a cell that wants to fade when it
   holds nothing says so in its own `:cells` entry, and one that does not, does
   not fade. It was the other way round until 2026-08-17: the outline hardcoded
   `(empty? highlights) → --opacity-disabled` on the right gutter, so the key was
   decorative and the fade could not be turned off from the file that describes
   it. The same shape as `(or empty-label \"Nothing highlighted yet\")` the day
   before — a cell that insists on dimming cannot be un-dimmed from its
   declaration."
  ([cell] (cell-style cell nil))
  ([{:keys [backdrop stroke radius tone type padding align floor dim-when]}
    {:keys [empty?] :as _runtime}]
   (cond-> {}
    (and (= :empty dim-when) empty?)
    (assoc :opacity (token-var 'opacity-disabled))
    backdrop (assoc :background (token-var backdrop))
    radius  (assoc :borderRadius (token-var radius))
    stroke  (assoc :borderWidth (token-var stroke)
                   :borderStyle "solid"
                   :borderColor "var(--border)")
    tone    (assoc :color (token-var tone))
    type    (assoc :fontSize   (str "var(--" (name type) "-size)")
                   :fontWeight (str "var(--" (name type) "-weight)")
                   :lineHeight (str "var(--" (name type) "-line-height)")
                   :textTransform (str "var(--" (name type) "-transform, none)")
                   :letterSpacing (str "var(--" (name type) "-tracking, normal)"))
    padding (assoc :padding (str (token-var (:block padding)) " "
                                 (token-var (:inline padding))))
    ;; THE FLOOR, APPLIED. George, 2026-08-15: "the minimum legible size should be
    ;; in chars and at some point when we cannot have less chars will make the font
    ;; smaller." The measure is the invariant and the type gives way — expressed in
    ;; pure CSS so it needs no listener and no re-render:
    ;;
    ;;   min(<declared size>, calc(100cqi / (floor-ch × ch-per-em)))
    ;;
    ;; 100cqi is the CONTAINER's inline size, so it answers to the island the
    ;; reader dragged rather than to the window — the only unit that means anything
    ;; on a canvas. --ch-per-em is measured at boot (theme/init!) because it is a
    ;; font metric, 0.5561 for this stack and 0.6 for monospace.
    ;; A CELL WITH A FLOOR IS THE QUERY CONTAINER, and carries no font-size of
    ;; its own. Measured 2026-08-19 in Chrome: an element's own `container-type`
    ;; does NOT apply to itself — a box with `container-type: inline-size` and a
    ;; `100cqi` font-size resolved against its ANCESTOR container and came out
    ;; identical to a box with no container-type at all. Only a DESCENDANT
    ;; resolves against it. So the container is declared here and the size is put
    ;; on the text inside, by `floor-font-size` below.
    ;;
    ;; George decided the box on 2026-08-19: the BODY, which is what
    ;; dsl/design/block-row.edn always said — `[body can-not set-fewer-than floor
    ;; characters]`. The ROW used to be the container, so 45 characters were held
    ;; of the row and the line got what was left after both gutters: 36.7
    ;; characters, measured at a 560px window.
    floor   (assoc :containerType "inline-size")
    align   (assoc :justifyContent (case align :center "center" :end "flex-end" "flex-start")
                   :display "flex"
                   :alignItems "flex-start"))))

(defn floor-font-size
  "The type floor of `cell` as a font-size, or nil when it declares none.

   SEPARATE FROM cell-style ON PURPOSE. cell-style styles the cell, and this
   size must NOT go on the cell: the cell is the query container, and a
   container's own `100cqi` resolves against its ancestor rather than itself.
   The caller puts this on the element that draws the text.

   theme/fluid-font-size does the arithmetic. Nothing here repeats it — that
   duplication is what made the floor emit invalid CSS for three days."
  [{:keys [floor type]}]
  (when floor
    {:fontSize (theme/fluid-font-size (or type 'type-body) floor)}))

(def ^:private block-row
  "The declaration this renderer draws (dsl/design/block-row.edn, mirrored)."
  (:block-row design/components))

(defn pasted-markdown
  "PURE. The markdown a :paste-image reply carries, or nil when the bus refused.
   The reply is the handler's map, or that map under :result."
  [reply]
  (let [m (or (:markdown reply) (get-in reply [:result :markdown]))]
    (when (and (string? m) (seq m)) m)))

(defn paste-refusal
  "PURE. What the row says when a pasted image did not become markdown, or nil
   when it did.

   STALL, NEVER VANISH (fault report 08e4f4c1). A refused or lost paste left
   no trace: the row did nothing and said nothing. A refusal names its own
   reason. A closed connection is named too. The bus closes the socket on a
   message over its limit (http-kit :max-ws, 4 MB, measured 2026-10-05), and a
   photo from a phone can be over it."
  [reply]
  (let [m (js->clj reply :keywordize-keys true)
        m (if (and (map? m) (map? (:result m))) (merge m (:result m)) m)]
    (when-not (pasted-markdown m)
      (cond
        (= :disconnected (:error m))
        "The image did not reach the bus. The connection closed. An image that is too large closes it."

        (:message m) (:message m)

        :else "The bus did not store the image."))))

;; ---------------------------------------------------------------------------
;; INSERT FILE, WITH A STATED LIMIT (PLAN-ikc-v3-061-01, lane
;; IKC3/PLAN-ikc-v3-061-01/UP-1). George, 2026-10-06: "whatever is the means of
;; upload should state its limist and be vocal for errors".
;; ---------------------------------------------------------------------------

(defn size-text
  "PURE. A size in bytes as a person reads it, in decimal units. THE SAME RULE
   AS vault.files/size-text on the bus, and tested with the same cases
   (T-web-widgets-116, T-attach-043), so the browser and the bus give one
   number in one form."
  [n]
  (let [n    (or n 0)
        unit (fn [v u] (let [r (/ (js/Math.round (* 10 v)) 10)]
                         (str (if (or (>= r 10) (== r (js/Math.floor r)))
                                (js/Math.round r)
                                r)
                              " " u)))]
    (cond
      (>= n 1e9) (unit (/ n 1e9) "GB")
      (>= n 1e6) (unit (/ n 1e6) "MB")
      (>= n 1e3) (unit (/ n 1e3) "KB")
      :else      (str n " bytes"))))

(defn- group-digits [n]
  (->> (str (js/Math.round n)) reverse (partition-all 3)
       (map #(apply str (reverse %))) reverse (str/join ",")))

(defn too-large-message
  "PURE. The words of the :too-large refusal, as ui.attachments says them."
  [size limit]
  (let [a (size-text size) l (size-text limit)]
    (if (= a l)
      (str "This file is " (group-digits size) " bytes. The limit is "
           (group-digits limit) " bytes.")
      (str "This file is " a ". The limit is " l "."))))

(defn no-space-message
  "PURE. The words of the :no-space refusal, as vault.files says them."
  [free needed reserve]
  (str "Not stored. The disk has " (size-text free) " free, and this file needs "
       (size-text needed) ". At least " (size-text reserve) " must stay free."))

(defn pre-send-refusal
  "PURE. Why a file of `size` bytes is refused BEFORE it is sent, or nil.
   `limit` is the value of the :attachment-limit source. With no limit read
   yet, nothing is refused here, and the bus checks the same numbers."
  [size {:keys [max-bytes room-bytes free-bytes min-free-bytes]}]
  (cond
    (and (number? max-bytes) (pos? max-bytes) (> size max-bytes))
    (too-large-message size max-bytes)

    (and (number? room-bytes) (> size room-bytes))
    (no-space-message free-bytes size min-free-bytes)))

(defn file-menu-label
  "PURE. The label of a row-menu item. An item that picks a file states the
   limit: \"Insert file (3 MB maximum)\"."
  [{:keys [label from-file]} limit]
  (let [t (:text limit)]
    (if (and (= :file from-file) (string? t) (seq t))
      (str label " (" t " maximum)")
      label)))

(defn attach-refusal
  "PURE. What the row says when a file did not become markdown, or nil when it
   did. STALL, NEVER VANISH: the words stay on the row until the person
   closes them or a later insert succeeds."
  [reply]
  (let [m (js->clj reply :keywordize-keys true)
        m (if (and (map? m) (map? (:result m))) (merge m (:result m)) m)]
    (when-not (pasted-markdown m)
      (cond
        (= :disconnected (:error m))
        "The file was not stored. The connection to the bus closed."

        (:message m) (:message m)

        :else "The bus did not store the file."))))

(defn row-error-line
  "The words of a refusal, in red, on the row. They do not go away by
   themselves. The close control is the person's own act."
  [send-error]
  (when-let [m @send-error]
    [:div {:role "alert" :data-row-error "true"
           :class "flex items-start gap-2 text-xs text-[var(--danger)] pl-8 pr-2 pb-1"}
     [:span {:class "flex-1 min-w-0 break-words"} m]
     [:button {:type "button" :aria-label "Close the message"
               :class "shrink-0 px-1 text-[var(--danger)]"
               :on-click #(reset! send-error nil)}
      "×"]]))

(defn splice-at
  "PURE. `insert` put into `text` at character `at`, with a space before it
   when the caret sits right after a word. Returns {:text :caret-at}, the caret
   just after what was put in. An `at` outside the text is clamped to it."
  [text at insert]
  (let [text (or text "")
        at   (max 0 (min (or at (count text)) (count text)))
        pre  (subs text 0 at)
        sep  (if (and (seq pre) (not (re-find #"\s$" pre))) " " "")
        ins  (str sep insert)]
    {:text     (str pre ins (subs text at))
     :caret-at (+ at (count ins))}))

(defn block-text-style
  "The font-size of a block's TEXT, in both of its modes — the one source.

   George, 2026-09-28: \"When block of a note has its font size reduced due to
   a limited space - when it switch to edit mode the font size is the regular,
   not the current\". The floor went only on the read-mode span. The textarea
   is its SIBLING, not its child, so it inherited nothing and drew at the full
   --type-body-size. The row changed size the instant it was clicked.

   So the read span and the editor both take their size from here, and a row
   keeps its size when it changes mode."
  []
  (floor-font-size (get-in block-row [:draws :cells 'body])))

(def ^:private section-header  (:section-header design/components))
(def ^:private sidebar-item       (:sidebar-item design/components))
(def ^:private reference-card  (:reference-card design/components))


(defn widget-icon
  [{:keys [icon size tone]}]
  (when-let [Cmp (get icon-components icon)]
    ;; STROKE WEIGHT IS A TOKEN NOW. The style guide's own gap list said the icons
    ;; "take a tone but cannot be themed — Tabler's stroke weight is not ours to
    ;; restate". It is: Tabler renders an <svg> and CSS stroke-width overrides its
    ;; default, so a theme that wants a lighter or heavier line restates
    ;; --icon-stroke like any other token.
    [:> Cmp {:style {:strokeWidth "var(--icon-stroke)"
                     :width  (str "var(" (get icon-size-token size "--icon-md") ")")
                     :height (str "var(" (get icon-size-token size "--icon-md") ")")}
             :class (get tone-text-classes tone "text-[var(--text)]")}]))

;; ---------------------------------------------------------------------------
;; :box — composition primitive. Still a flex container; border/background come
;; from theme tokens via Tailwind's mapped palette.
;; ---------------------------------------------------------------------------

;; ---------------------------------------------------------------------------
;; Drag and drop (IKC3/PLAN-ikc-v3-064-01/DRAG, SPEC-ikc-v3-001-01 A13). A
;; :table with :draggable lets each row be dragged. A :box with :on-gesture
;; :drop takes it and sends ONE command, with $dragged as the row's own map.
;; Native HTML5 drag events, and no library. A drop never replaces a keyboard
;; path: the click of a row stays.
;; ---------------------------------------------------------------------------

(def drag-mime
  "THE ONE MIME TYPE of a dragged row. The row crosses as JSON under it, and a
   box reads only this type. So a file, or a drag from another program, is
   never taken as a row."
  "application/x-ikc-row+json")

(defn row->json
  "The row as JSON. A uuid goes as its string, as it does on the bus, and a
   keyword keeps its namespace."
  [row]
  (js/JSON.stringify
   (clj->js (clojure.walk/postwalk #(if (uuid? %) (str %) %) row)
            :keyword-fn #(subs (str %) 1))))

(defn- carries-row?
  "Does this drag carry a row? A dragover may read the TYPES of a transfer and
   not its data, so this is the only question a box can ask before the drop."
  [dt]
  (boolean (some #(= drag-mime %) (array-seq (js/Array.from (or (some-> dt .-types) #js []))))))

(defn- read-dragged
  "The dragged row, read on the drop, or nil when the data is not JSON."
  [dt]
  (let [s (.getData dt drag-mime)]
    (when (seq s)
      (try (js->clj (js/JSON.parse s)) (catch :default _ nil)))))

(defn drop-mark-style
  "The mark of a box while a row is over it: an outline and the token colour
   --accent-soft. Neither moves the layout (an indicator must not move the
   furniture), so no padding, border or margin is here."
  [over?]
  (when over?
    {:outline "2px solid var(--accent)" :outlineOffset "-2px" :background "var(--accent-soft)"}))

(defn drop-attrs
  "The drag handlers of a box that takes a drop. `over?` is the box's OWN
   atom, so the drag state stays out of the props, and an island that draws
   again during a drag keeps the mark. PUBLIC so a test hands each handler an
   event object."
  [template bus session-id over?]
  {:data-drop     "zone"
   :on-drag-enter (fn [e] (when (carries-row? (.-dataTransfer e))
                            (.preventDefault e)
                            (reset! over? true)))
   :on-drag-over  (fn [e] (let [dt (.-dataTransfer e)]
                            (when (carries-row? dt)
                              (.preventDefault e)
                              (set! (.-dropEffect dt) "move")
                              (when-not @over? (reset! over? true)))))
   ;; A dragleave fires also when the pointer goes onto a child of the box.
   ;; The mark stays until the pointer leaves the box itself.
   :on-drag-leave (fn [e] (when-not (some-> (.-currentTarget e) (.contains (.-relatedTarget e)))
                            (reset! over? false)))
   :on-drop       (fn [e] (let [dt (.-dataTransfer e)]
                            (when (carries-row? dt)
                              (.preventDefault e)
                              ;; A box inside a box: the inner one takes the
                              ;; drop, and one drop sends one command.
                              (.stopPropagation e)
                              (reset! over? false)
                              (when-let [cmd (bind/drop-command template (read-dragged dt)
                                                                {'$session-id session-id})]
                                (js-invoke bus "dispatch" cmd (fn [_] nil))))))})

(defn- drop-zone
  "A box that takes a drop. Form-2, so its `over?` atom lives as long as the
   box, and not in the props."
  [_attrs _children _template _bus _session-id]
  (let [over? (r/atom false)]
    (fn [attrs children template bus session-id]
      (let [mark (drop-mark-style @over?)]
        (into [:div (cond-> (merge attrs (drop-attrs template bus session-id over?))
                      mark (update :style merge mark))]
              children)))))

(defn widget-box
  "A plain container. With :on-gesture :drop and a bus, it takes a dragged
   row (drop-zone). The two-argument call is the one every caller made before."
  ([props children] (widget-box props children nil nil))
  ([{:keys [title border tone density elevation] :as props} children bus session-id]
   (let [pad-class      (get box-density-pad-classes density "p-2")
         border-tone    (get tone-border-classes tone "ikc-bd-border")
         border-class   (when (or border title) (str "border " border-tone " rounded-md " pad-class))
         depth          (get elevation-class elevation)
         ;; min-h-0 ON EVERY BOX, and not only on a box that declares its
         ;; layout (2026-09-20). box-layout-class makes EVERY :box a flex
         ;; container — the default arm of layout-class is `flex flex-col
         ;; gap-1`. But this class was given only to a box with :direction, or
         ;; with :layout :split or :horizontal. So the DEFAULT box, which is the
         ;; commonest one in the corpus, was the one box that could not shrink
         ;; below its content. A flex item keeps `min-height: auto` without it.
         ;;
         ;; A :scroll-area INSIDE such a box therefore had no bounded height to
         ;; scroll within, and it grew instead. widget-grid's own docstring
         ;; records the same failure from 2026-08-23, in the other container.
         ;; Measured on the deployment 2026-09-20, reader-v3 Internals, Slots
         ;; tab: the box was 438 px in a tab panel of 321 px that hides its
         ;; overflow, so 117 px of it was cut and no box could scroll.
         flex-min-class "min-h-0"
         header (when title [[:div.text-xs.ikc-fg-muted.font-semibold.mb-1.uppercase.tracking-wide title]])
         ;; TWO STYLE SOURCES, ONE :style. Elevation was the only one until the
         ;; :backdrop slot arrived; a second `assoc :style` would have silently
         ;; replaced the first, so they merge instead. Backdrop first, so a shadow
         ;; still wins its own keys.
         style (merge (backdrop-style props)
                      (when depth (cond-> {:boxShadow (:shadow depth)}
                                    (:layer depth) (assoc :zIndex (:layer depth)
                                                          :position "relative"))))]
     (let [attrs (cond-> {:class (str (box-layout-class props) " " flex-min-class " " (or border-class ""))}
                   (seq style) (assoc :style style))
           kids  (concat header (or children []))
           drop-tmpl (bind/gesture-template props :drop)]
       (if (and drop-tmpl bus)
         [drop-zone attrs kids drop-tmpl bus session-id]
         (into [:div attrs] kids))))))


;; ---------------------------------------------------------------------------
;; :dock — LEVEL 5, THE ARRANGEMENT OF PANES (ADR-graph-ui-v0-026-01)
;;
;; THE ONLY KIND THAT DRAWS NO PANE. dockview owns the arrangement of panes;
;; levels 4 and below arrange what is inside one. That boundary is why ADR-013's
;; single layout model became one model PER SURFACE.
;;
;; dockview-core, NOT a React wrapper, and that is not a preference. Measured
;; 2026-08-26 and recorded in the ADR: dockview@8.2.0's whole ESM entry point is
;; `export * from "dockview-core"`, and the tarball holds no React import at
;; all. So there is exactly one shape available — a vanilla factory — and our
;; own Reagent trees are mounted into the panels it creates.
;;
;; IT HOLDS NO GEOMETRY, and that is the decision rather than an omission. Sizes,
;; positions and tab order are a VALUE the person owns (api.toJSON), stored on
;; their session frame (ADR-graph-ui-v0-025-01 Sec4), so the arrangement travels
;; to another machine. A description that stated geometry would be a second
;; authority over the same fact.
;;
;; THE PANES ARE MOUNTED ONCE. dockview owns the DOM inside a panel, so each
;; pane is rendered into its host element with reagent.dom/render — the same
;; call graph-ui.web.core uses for the app itself — and unmounted with the dock.
;; Re-rendering a pane per layout change would restart every widget inside it.
;; ---------------------------------------------------------------------------

(defn dock-panel-id
  "PURE. The panel's identity across a reload.

   THE :pane SLOT'S :id FIRST — the pane's name in the pattern that declared it
   (ui.patterns). A pane a person MOVED is still that pane next time, and
   panes-stamp below is built from these ids, so a pattern that gains or renames
   a pane makes a stored arrangement inapplicable by itself.

   :import-id CANNOT DO THIS JOB, though this function read it first for a day.
   It is an identity slot the seeder upserts by, and :ui/attach strips it before
   the browser sees anything — measured 2026-09-02: 103 nodes of reader-v3's
   page, none with an :import-id. So every dock named its panels by POSITION and
   the stamp was `pane-0|pane-1` whatever the panes held.

   The position remains the last resort, for a hand-written dock of :box nodes
   that names nothing."
  [child i]
  (or (some-> (get-in child [:props :pane :id]) str not-empty)
      (some-> (get-in child [:props :import-id]) str not-empty)
      (str "pane-" i)))

(defn dock-panel-title
  "PURE. The tab label.

   THE :pane SLOT FIRST, because that is where a pattern writes it and where a
   conformant description can carry it: :title is a prop of some widget kinds
   and of neither :stack nor :container, which are the roots a docked block
   actually has. A bare :title still works, which keeps the convention :tab-set
   uses for its child boxes."
  [child i]
  (or (some-> (get-in child [:props :pane :title]) str not-empty)
      (some-> (get-in child [:props :title]) str not-empty)
      (some-> (:type child) name)
      (str "pane " (inc i))))

(defn dock-panel-pane
  "PURE. What the child says about its own place in the dock — the :pane
   universal slot: {:direction \"right\" :width 270}.

   nil for a pane that says nothing, which joins the previous pane's group and
   draws as a tab. ui.patterns writes this slot from a pattern's `sits` facts;
   a description may also carry it by hand."
  [child]
  (get-in child [:props :pane]))

(defn recordable-arrangement
  "PURE. The arrangement to send as a person's move, or nil.

   `json` is dockview's toJSON after the move, and `applied` is what this dock
   last applied or sent. An empty value, or one equal to `applied`, is not a
   move: a click on a divider that moves nothing sends nothing.

   ONE DECISION FOR BOTH KINDS OF MOVE (PLAN-ikc-v3-050-01). A structural move
   reaches it through onDidLayoutChange, and a divider drag through the release
   of the pointer. Public, so a test examines it without a browser."
  [json applied]
  (when (and (string? json) (seq json) (not= json applied))
    json))

(defn panes-stamp
  "PURE. Which panes an arrangement was made for.

   George, 2026-09-02: *\"If an islands code is updated, on reload it should get
   the new code, and it will render the default layout ... we cannot evaluate
   new changes and know whether the current layout can apply to the new island
   panes.\"*

   HE IS RIGHT, AND THE REASON IS IN dockview's FORMAT. A saved arrangement
   refers to panels BY ID. Change the panes and it points at panels that no
   longer exist and says nothing about the new ones, so restoring it would draw
   a surface neither the person nor the declaration asked for.

   THE STAMP IS THE IDS AND THEIR ORDER, and nothing else. It is deliberately
   narrower than \"the island's code changed\": editing what is INSIDE a pane
   cannot make an arrangement inapplicable, and resetting a person's layout for
   an unrelated edit would be a loss they did not ask for. A RENAMED TAB does
   not reset it either — the label is not what the arrangement refers to."
  [panes]
  (str/join "|" (map first panes)))

(defn pane-fold-info
  "What one drawn pane tells graph-ui.web.dock-panes about folding.

   THE PANE MAPS AND NOT BARE IDS (2026-09-09). The client used to receive only
   the ids and keep its own hard-coded set of three panes an icon may hide — a
   set that was the ONLY implementation of `[x can fold]`, a fact the patterns
   had declared since they were written and the research pattern declares on
   seven panes. Foldability and the opening state are the PANE's own statement
   now, and this is what carries them across."
  [[id _ _ pane]]
  {:id id :foldable (:foldable pane) :folded (:folded pane)})

(defn pane-size
  "PURE: what setSize is given for one pane — `{:width w}`, `{:height h}`, both,
   or nil when the pane asks for neither.

   A HEIGHT ARRIVED WITH THE BAND (2026-09-10, PLAN-graph-ui-v0-016-02 phase
   3). Until then only a width was ever declared, because a measure resolves to
   one. `[toolbar spans full-width]` states a pane's extent on ONE axis, so the
   other has nothing to state it and dockview divides the split evenly —
   measured with the band's placement already correct: the toolbar came out
   1920 x 886 and the four columns under it were 100 tall.
   ui.patterns/band-height supplies the second number.

   nil rather than an empty map, so a caller can skip a pane that asks for
   nothing instead of calling setSize with `{}`."
  [pane]
  (let [m (cond-> {}
            (:width pane)  (assoc :width (:width pane))
            (:height pane) (assoc :height (:height pane)))]
    (when (seq m) m)))

(defn layout-rect
  "PURE: a group's box on the screen, in the pixels that setSize takes.

   `rect` is what getBoundingClientRect answers, `layout-width` is the width
   dockview holds for the same group.

   WHY (fault report 6aeb0e59, George, 2026-10-13: the studio does not render
   faithfully in the Live preview). The preview draws an island inside CSS
   `zoom`, and getBoundingClientRect answers the box AFTER the zoom. setSize
   and every declared width are in pixels BEFORE it. flexible-widths took the
   row in one unit and the claims in the other. At the zoom of the screenshot
   the row was smaller than the claims of the pane Intake and the pane Card,
   so the pane Board got no share. It kept its narrow width, and the pane Card
   took the rest.

   ONE FACTOR FOR THE WHOLE BOX. A zoom scales x, top, bottom and width by the
   same number, so the comparisons that flexible-widths makes between groups
   stay true. With no zoom the factor is 1, and the box comes back unchanged.
   With no layout width the box also comes back unchanged."
  [rect layout-width]
  (let [w (:width rect)]
    (if (and layout-width (pos? layout-width) w (pos? w))
      (let [k (/ layout-width w)]
        (into {} (map (fn [[key v]] [key (* v k)])) rect))
      rect)))

(defn flexible-widths
  "PURE: the width each pane that is NOT a fixed number must be set to, and nil
   when the surface has none.

   `[{:id id :width w} …]`, in declaration order. Two measures land here:

   - `all-remaining` — ONE pane takes everything the numbers leave. George,
     2026-09-11: size the all-remaining pane last from what is left.
   - `equally-divided` — TWO OR MORE panes take an equal share of it. George,
     2026-09-12: it looks to me that narrow-measure and all-remaining will be
     well balanced by equally-divided, but it cannot be applied in isolation.

   One surface uses one of the two, which validate-dsl enforces. The arithmetic
   is the same either way, and a single share IS everything that is left.

   `rows` is one map per pane ON THE SCREEN:
   `{:id :pane {:absorbs :shares :width} :rect {:x :top :bottom :width} :want w}`.
   `:want` is the width that pane is about to be set to, when it states one.

   THE ROW, AND NOT THE SURFACE. A dock is a tree of splits, so the groups that
   share a width with a flexible pane are the ones its own horizontal middle
   crosses. A band above them is not one.

   AND A COLUMN IS AN x, NOT A GROUP. `[thought-body sits below thought-tree]`
   puts two groups in one column, and only one of them is on any given row —
   measured 2026-09-12, the reading area's middle fell exactly on the boundary
   between them, because a split lands in the middle. So a group whose x is a
   flexible pane's x IS that pane's column, and it is neither counted against
   the pool nor sized twice.

   WHAT IS LEFT = the row, less what every other column claims: its declared
   width when it has one, and what it holds now when it does not. So a pane the
   pattern says nothing about keeps its size, and only the panes with a number
   give space back.

   nil WHEN A SHARE WOULD BE BELOW dockview's OWN 100-PIXEL MINIMUM. It would be
   clamped anyway, and a size that fights the grid is worse than none."
  [rows]
  (let [flex (filterv #(or (get-in % [:pane :absorbs]) (get-in % [:pane :shares])) rows)]
    (when (seq flex)
      (let [{:keys [top bottom]} (:rect (first flex))
            y        (/ (+ top bottom) 2)
            on-row   (filterv (fn [r]
                                (let [{t :top b :bottom} (:rect r)]
                                  (and (<= t y) (< y b))))
                              rows)
            same-x?  (fn [a b] (< (js/Math.abs (- a b)) 2))
            in-flex? (fn [r] (boolean (some #(same-x? (get-in % [:rect :x])
                                                      (get-in r [:rect :x]))
                                            flex)))
            here     (filterv (fn [f] (some #(same-x? (get-in % [:rect :x])
                                                      (get-in f [:rect :x]))
                                            on-row))
                              flex)
            total    (reduce + 0 (map #(get-in % [:rect :width]) on-row))
            claimed  (reduce + 0 (map #(or (:want %) (get-in % [:rect :width]))
                                      (remove in-flex? on-row)))
            n        (count here)
            pool     (- total claimed)
            each     (when (pos? n) (js/Math.floor (/ pool n)))]
        (when (and each (>= each 100))
          (vec (map-indexed
                 (fn [i f]
                   ;; THE ROUNDING GOES TO THE FIRST, so the shares add up to
                   ;; the pool exactly and the grid is not left one pixel short.
                   {:id    (:id f)
                    :width (if (zero? i) (- pool (* each (dec n))) each)})
                 here)))))))

(defn pane-reference
  "PURE: which panel a new pane's :direction is relative to.

   :reference NAMES THE PANE THE DIRECTION IS ABOUT (2026-09-09). Without it the
   reference is `prev`, the pane added before this one — which is every dock
   that existed before today, unchanged. With it a pattern can say
   `[thought-body sits below thought-tree]` and the panel lands under THAT
   panel, whatever happened to be added last.

   Until this existed, `below` and `above` were in the :pane :direction enum and
   unreachable: ui.patterns gave every later pane at one place a hard-coded
   `right`, so five panes at `right` sat side by side and the last was 170 px
   wide with a six-column table in it."
  [pane prev]
  (or (not-empty (str (:reference pane))) prev))

(defn widget-dock
  "Level 5. `panes` is [[id title hiccup pane] …], already rendered — this
   component knows nothing about the widget tree and must not. `pane` is that
   child's own :pane slot: where it sits, how wide it opens, and its id.

   THE PANES ARE PORTALS, NOT SEPARATE REACT ROOTS, and that is the whole shape
   of this component. Measured 2026-09-02: mounting a pane with
   reagent.dom/render into dockview's host element makes a SECOND React tree,
   and every Mantine widget inside it threw
   `MantineProvider was not found in component tree`. A pane is arbitrary
   content, so it must sit in the app's own tree with its context intact.
   react-dom/createPortal renders into a foreign DOM node while STAYING in the
   tree, which is exactly the seam dockview needs.

   THE HOSTS ARRIVE LATE. dockview calls createComponent when it builds a
   panel, so the host elements do not exist at first render. They are collected
   into a reagent atom, and writing it re-renders this component with one more
   portal — which is why the atom must be an r/atom and not a plain one."
  [{:keys [tone] :as props0} panes]
  (let [api    (atom nil)
        mount  (atom nil)
        hosts  (r/atom {})
        ;; THE PROPS ARE READ ON EVERY RENDER, NOT ONCE AT MOUNT — and this is
        ;; the defect that made phase 2 look finished when it was not
        ;; (measured 2026-09-02).
        ;;
        ;; TWO OF THEM MOVE AFTER MOUNT. :arrangement-in is a BOUND value, so
        ;; it is nil at first render and arrives when the source answers — a
        ;; dock that read it once therefore drew the declared default and never
        ;; corrected itself. :on-moved closes over the session-id, and an island
        ;; re-attaches with a new session whenever a person opens another one —
        ;; so a move was stored against the session that had been on the screen
        ;; two renders earlier.
        latest (atom (assoc props0 :panes panes))
        ;; WHAT IS ON THE SCREEN NOW: the arrangement this dock last applied, or
        ;; last reported as the person's own. It is the guard against three
        ;; things — restoring twice, restoring over a person's fresh move, and
        ;; the echo, because the source re-emits the very arrangement the move
        ;; just sent and applying that again would fight the person.
        applied (atom nil)
        ;; EVERY PANEL THIS DOCK HAS MADE, by id, so one can be put back after
        ;; an icon hides it. dockview's removePanel disposes the panel, so the
        ;; way back is addPanel with the same spec — which means the spec has to
        ;; survive. It is the pane's own declaration, and it does.
        specs   (atom {})
        ;; THE RECORDER OF A PERSON'S MOVE, set once the dock is built. It lives
        ;; here and not inside :component-did-mount so that a TOGGLE can call it
        ;; too (2026-09-29). A top-bar icon changes which panes are on the
        ;; screen, and dockview reports that change as :origin api, so it was
        ;; never recorded and a reload drew the panes the last DRAG had left.
        reporter (atom nil)
        ;; ONE WARNING PER DOCK when a stored arrangement is refused for its
        ;; stamp, so a reset after a re-seed is visible and not repeated on
        ;; every render.
        warned  (atom nil)
        grip-headers!
        ;; A SLIM DRAG GRIP ON EACH PANE'S TOP EDGE (George, 2026-09-08: "Put a
        ;; slim drag grip on each pane's top edge. Make the pane border more
        ;; pronounced and to show focus"). dockview's tab IS its drag handle,
        ;; so the header stays and css/ikc-base.css (.ikc-dock-theme) draws it
        ;; 10px tall with the tab as a bar and no title and no ✕ in it. Where a
        ;; pane sits is a runtime value the person moves by that grip and the
        ;; session frame keeps — never a word in the pattern (George, the same
        ;; day: "below another pane should not be a declaration but runtime
        ;; option"). The active group's grip and border take the accent.
        ;;
        ;; Until then the header was HIDDEN, for this reason, which still holds
        ;; for a title and a ✕ — the grip has neither:
        ;; NO TAB OVER A PANE, AND NO ✕ ON IT (George, 2026-09-07: *"New
        ;; islands, reader-v3, conversations and research have tabs like titles
        ;; with X for closing - there are no such in ikc1"*).
        ;;
        ;; dockview draws a tab strip over every group it makes, and each tab
        ;; carries a close action. NOTHING HERE ASKED FOR EITHER. A pattern's
        ;; panes each declare a `sits`, so ui.patterns gives every one of them a
        ;; :direction and they come out SIDE BY SIDE — the strip was never
        ;; showing a choice between two panes, only a label and a way to lose
        ;; one. A pane closed that way is also unreachable: dock-panes/icon-panes
        ;; is what the top-bar icons control, and a ✕ writes nothing to it.
        ;;
        ;; ikc1's own right dock has no such chrome. AthensRightDock.tsx is a
        ;; `flex h-full w-full` of two views and a divider — the arrangement this
        ;; pattern already copies. George, 2026-09-05: "the ikc1 is good enough
        ;; to follow its features, no need to go fractal."
        ;;
        ;; THE DECLARED :title IS NOT WASTED. dock-panel-title still names every
        ;; panel, which is what a stored arrangement refers to; it simply stops
        ;; being painted over a pane that already says what it is. The sidebar's
        ;; own heading read "Notes" directly under a tab that read "Notes".
        (fn []
          (when-let [^js dv @api]
            (doseq [^js g (array-seq (.-groups dv))]
              (try
                ;; false, and said so: a group revived from a stored arrangement
                ;; by .fromJSON may carry the hidden header of the session that
                ;; stored it (2026-09-07 to 2026-09-08).
                (set! (.. g -header -hidden) false)
                ;; The header's height is part of the group's layout, so the
                ;; content below it must be measured again. Without this the
                ;; panel keeps the old offset and a pane's first line sits in
                ;; the space of a strip that is no longer drawn.
                (when (fn? (.-relayout g)) (.relayout g))
                (catch :default _ nil)))))
        add-panel!
        (fn [^js dv [id title _ pane] prev]
          (let [ref (pane-reference pane prev)
                pnl (.addPanel
                      dv (clj->js
                           (cond-> {:id id :component "ikc" :title title}
                             (and ref (:direction pane))
                             (assoc :position {:referencePanel ref
                                               :direction      (:direction pane)})
                             ;; A BAND OPENS SHORTER THAN dockview WOULD ALLOW.
                             ;; Its default minimum for a group is 100, and a
                             ;; setSize below that is clamped back — measured
                             ;; 2026-09-11, when a 56-pixel toolbar kept coming
                             ;; back as 100 and George said the bar wasted
                             ;; space. minimumHeight is the only way to say a
                             ;; group may be that short. It also stops the row
                             ;; being crushed below the height it declared.
                             (:height pane)
                             (assoc :minimumHeight (:height pane)))))]
            (swap! specs assoc id {:pane pane :title title})
            pnl))
        group-width
        (fn [^js dv id]
          (try (some-> (.getPanel dv id) .-api .-group .-width)
               (catch :default _ nil)))
        set-group-width!
        (fn [^js dv id w]
          (when (and w (pos? w))
            (try
              (.. (.getPanel dv id) -api -group -api (setSize #js {:width w}))
              (catch :default _ nil))))
        group-rect
        (fn [^js dv id]
          (try
            ;; IN LAYOUT PIXELS, so a dock inside the zoom of the Live preview
            ;; divides its row as it does on its own page (layout-rect).
            (let [r (.getBoundingClientRect (.. (.getPanel dv id) -api -group -element))]
              (layout-rect {:x (.-left r) :top (.-top r) :bottom (.-bottom r) :width (.-width r)}
                           (group-width dv id)))
            (catch :default _ nil)))
        ;; WHAT IS LEFT, GIVEN TO THE PANE THAT SAYS IT TAKES IT (2026-09-11).
        ;; George chose this from four answers: size the all-remaining pane last
        ;; from what is left.
        ;;
        ;; IT REPEATS UNTIL THE GRID AGREES, and that is not a tidiness loop. A
        ;; setSize on one group hands the difference to its NEIGHBOURS, so an
        ;; earlier size can be undone by a later one. Measured 2026-09-11 before
        ;; this existed: `narrow-measure` on the Guide AND the Add pane opened
        ;; the Guide at 1280 and the Add pane at 270, because the Add pane's own
        ;; setSize took the space back from the Guide beside it. The targets are
        ;; absolute, so a second pass corrects what the first one moved.
        ;;
        ;; SIX PASSES AND THEN IT STOPS. An unsized pane is a usable pane, and a
        ;; loop with no end is not — the same rule the first width pass keeps.
        settle-widths!
        (fn settle
          ([dv panes targets] (settle dv panes targets nil))
          ([^js dv panes targets done]
          (let [tries (atom 0)]
            (letfn [(rows []
                      (keep (fn [[id _ _ pane]]
                              (when-let [rect (group-rect dv id)]
                                {:id id :pane pane :rect rect :want (get targets id)}))
                            panes))
                    (off? []
                      (some (fn [[id w]]
                              (when-let [g (group-width dv id)]
                                (> (js/Math.abs (- g w)) 2)))
                            targets))
                    (step []
                      (swap! tries inc)
                      (doseq [[id w] targets] (set-group-width! dv id w))
                      ;; LAST, AND AFTER EVERY DECLARED WIDTH. Their numbers
                      ;; are what those widths leave, so they have to be
                      ;; computed from the grid the declared ones just made.
                      (doseq [{:keys [id width]} (flexible-widths (rows))]
                        (set-group-width! dv id width))
                      (if (and (off?) (< @tries 6))
                        (js/requestAnimationFrame step)
                        ;; THE GRID HAS SETTLED, so what is on the screen now
                        ;; is the value a caller may record.
                        (when done (done))))]
              (js/requestAnimationFrame step)))))
        sync-visible!
        (fn []
          ;; WHAT THE ICONS SAY, APPLIED TO THE PANELS THAT EXIST. Called on
          ;; every render, so a toggle in the top bar reaches the dock through
          ;; the same re-render reagent already does for the atom.
          ;;
          ;; ikc1 DID THIS BY NOT RENDERING A PANEL. dockview holds a live grid
          ;; instead, so hiding is removePanel and showing is addPanel — and the
          ;; declared order is how a returning pane finds its place again.
          (when-let [^js dv @api]
            (let [panes (:panes @latest)
                  ;; ── A DECLARED WIDTH SURVIVES A TOGGLE ──────────────────
                  ;;
                  ;; George, 2026-09-05: "the sidebar on left is better to keep
                  ;; its width - it is very jumpy when it changes on each
                  ;; toggle."
                  ;;
                  ;; dockview holds ONE grid, so removing a panel gives its
                  ;; space back to the whole grid and the navigator is resized
                  ;; with everything else. ikc1 never had this: its sidebar was
                  ;; a CSS grid column of its own, outside the right dock
                  ;; entirely, so a dock toggle could not reach it.
                  ;;
                  ;; THE RULE IS ALREADY IN THE VOCABULARY. A pane declares
                  ;; `narrow-measure` or `all-remaining` (dsl/platform/
                  ;; building-blocks.edn). The first is a width the pattern
                  ;; STATES, so it is kept; the second means "whatever is left",
                  ;; so it is what absorbs the change.
                  ;;
                  ;; THE WIDTH RECORDED IS THE ONE ON THE SCREEN, not the
                  ;; declared number. A person who dragged the sidebar wider
                  ;; keeps their own width — snapping back to 270 would be a
                  ;; second jump, in place of the first.
                  ;; THE WIDTH ON THE SCREEN, OR THE DECLARED ONE. A pane that
                  ;; is currently hidden has no group to measure, so a pane
                  ;; coming BACK would arrive at whatever dockview split for it —
                  ;; measured 2026-09-05: the graph returned at 425 where it
                  ;; declares 270. The declared number is the right fall-back,
                  ;; and it is the only one available.
                  keep-w (into {}
                               (keep (fn [[id _ _ pane]]
                                       (when-let [w (:width pane)]
                                         [id (or (group-width dv id) w)])))
                               panes)
                  changed (atom false)]
              (dock-panes/register-panes! (map pane-fold-info panes))
              (doseq [[id _ _ _ :as pane] panes]
                (let [have (.getPanel dv id)
                      want (dock-panes/showing? id)]
                  (when (not= (boolean have) (boolean want)) (reset! changed true))
                  (cond
                    (and have (not want)) (.removePanel dv have)
                    (and (not have) want)
                    ;; BESIDE THE PANE DECLARED BEFORE IT, if that one is on the
                    ;; screen.
                    ;;
                    ;; THE ROOT PANE IS THE HARD CASE, and it was wrong until it
                    ;; was watched. The first pane carries no :direction — it IS
                    ;; the grid when the dock is built, so there is nothing for
                    ;; it to be relative to. Re-added with no position, dockview
                    ;; puts it in the ACTIVE group: measured 2026-09-05, the
                    ;; sidebar came back as a TAB beside Internals, 864 wide on
                    ;; the right, where it declares 270 on the left.
                    ;;
                    ;; So a returning root goes on the far side of whatever is
                    ;; first now, and the side is the OPPOSITE of the direction
                    ;; the pane after it declared. Its successor said "right of
                    ;; me", so the root is "left of" the grid. A stacked pattern
                    ;; says "below" and the root returns "above".
                    (let [prev (->> (take-while #(not= id (first %)) panes)
                                    (map first)
                                    (filter #(.getPanel dv %))
                                    last)]
                      (if prev
                        (add-panel! dv pane prev)
                        (let [after (second (drop-while #(not= id (first %)) panes))
                              back  (get {"right" "left" "left" "right"
                                          "below" "above" "above" "below"}
                                         (:direction (nth after 3 nil)))
                              first-on (some #(when (.getPanel dv (first %)) (first %)) panes)]
                          (if (and back first-on)
                            (add-panel! dv (assoc-in (vec pane) [3 :direction] back) first-on)
                            (add-panel! dv pane nil)))))
                    :else nil)))
              ;; AFTER DOCKVIEW HAS RE-LAID ITSELF OUT, which is not this tick.
              ;; The same lesson the first width pass records: a size set before
              ;; the grid has measured itself is applied to the old geometry and
              ;; thrown away.
              ;; AND THE PANE THAT ABSORBS TAKES WHAT THEY LEAVE (2026-09-11).
              ;; A toggle is where George found this: the Graph pane arrived and
              ;; the reading column paid for it.
              ;;
              ;; AND THE RESULT IS RECORDED AS THE PERSON'S OWN ARRANGEMENT
              ;; (2026-09-29). Only a person changes `showing` — an icon in the
              ;; top bar — so a change here is their act, even though dockview
              ;; calls every removePanel and addPanel an :origin api change.
              ;; It is recorded after the widths settle, so the stored value
              ;; holds the panes AND the proportions on the screen.
              (when @changed
                (settle-widths! dv panes keep-w
                                (fn [] (when-let [f @reporter] (f))))))))
        restore!
        (fn []
          (when-let [^js dv @api]
            (let [{:keys [arrangement-in panes]} @latest
                  {:keys [arrangement for-panes]} arrangement-in
                  stamp (panes-stamp panes)]
              ;; THREE CONDITIONS, EACH ONE EARNED. There has to BE an
              ;; arrangement; it has to have been made for THESE panes, or the
              ;; island's own code has moved on and the default is what should
              ;; draw (George, 2026-09-02); and it must not already be what is
              ;; on the screen, which is what makes this callable on every
              ;; render without fighting the person who is using it.
              ;; A REFUSED ARRANGEMENT IS SAID ONCE (2026-09-29). The panes of
              ;; the island changed since it was stored — a re-seed, or an edit
              ;; of the pattern — so the declared default draws. Silence made
              ;; that look like a lost layout.
              (when (and arrangement (not= for-panes stamp) (not= @warned arrangement))
                (reset! warned arrangement)
                (js/console.warn
                  "dock: the stored arrangement was made for other panes, drawing the declared default"
                  (pr-str {:stored-for for-panes :panes-now stamp})))
              (when (and arrangement (= for-panes stamp) (not= arrangement @applied))
                (try
                  ;; :origin is `api` for this call, and the renderer reports
                  ;; only `user` — so a restore cannot echo back as a person's
                  ;; own choice (CONCEPT-ikc-v3-012-01).
                  (.fromJSON dv (js/JSON.parse arrangement))
                  (reset! applied arrangement)
                  ;; THE PANES IT HOLDS ARE THE PANES THAT SHOW (2026-09-29).
                  ;; Without this, sync-visible! applied the browser's global
                  ;; icon map over the restored grid on the next render, and
                  ;; took out or put back panes the session had not.
                  (dock-panes/adopt!
                    (dock-panes/visibility-of-arrangement
                      arrangement
                      (keep (fn [[id _ _ pane]]
                              (when (or (dock-panes/icon-panes id) (:foldable pane)) id))
                            panes)))
                  (catch :default e
                    ;; A STORED ARRANGEMENT THAT WILL NOT LOAD IS NOT FATAL and
                    ;; is not silent. The default is already on the screen.
                    (js/console.warn
                      "dock: the stored arrangement did not load, drawing the declared default"
                      e)))))))]
    (r/create-class
      {:display-name "widget-dock"
       :component-did-mount
       (fn [_]
         (when-let [el @mount]
           (let [dv (dockview/createDockview
                      el
                      #js {;; THE DESIGN SYSTEM IS THE THEME, rather than a
                           ;; correction applied over one of dockview's ten.
                           ;; Measured 2026-09-02: dockview builds its own
                           ;; `.dv-shell` INSIDE the element it is given and
                           ;; puts `dockview-theme-abyss` on it by default, so
                           ;; variables set on our own wrapper were inherited
                           ;; and then overridden one level down — the dock drew
                           ;; the Amber island in near-black. The `theme` option
                           ;; names the class that carries the variables, so
                           ;; .ikc-dock-theme in css/ikc-base.css IS the theme
                           ;; and none of dockview's is loaded over it.
                           :theme #js {:name "ikc" :className "ikc-dock-theme"}
                           :createComponent
                           (fn [^js opts]
                             (let [host (js/document.createElement "div")]
                               ;; THE PANE HOST DOES NOT SCROLL, AND THAT IS THE
                               ;; DECLARATION'S CALL RATHER THAN THIS WRAPPER'S
                               ;; (George, 2026-09-07: the reading pane's scroll
                               ;; area belongs *"below the line with OUTLINE and
                               ;; Collapse buttons"*, and the sidebar's *"below
                               ;; PINNED and Recent areas"*).
                               ;;
                               ;; It was `overflow-auto`, and that one class
                               ;; overrode both of those facts at once. Every
                               ;; block placed in a dock already says what
                               ;; scrolls inside it —
                               ;; dsl/alatus/reading-area.edn: `[outline-tools
                               ;; can-not scroll]`, `[page-body can scroll]`;
                               ;; dsl/alatus/universal-sidebar.edn:
                               ;; `[universal-sidebar can-not scroll]`, with
                               ;; George's own 2026-08-07 sentence beside it,
                               ;; "Recent and Pinned should stay fixed and Notes
                               ;; scroll internally". Both were drawn correctly
                               ;; in reader-v2 and neither survived the dock.
                               ;;
                               ;; AND A SCROLLING HOST DISABLED THE INNER ONE
                               ;; TOO, which is why the whole pane moved instead
                               ;; of part of it. An `overflow-auto` parent gives
                               ;; its child unbounded height, so the declared
                               ;; body scroller (:scroll-area, `flex-1
                               ;; min-h-0`) grew to its full content —
                               ;; MEASURED 2026-09-07 at 56990px, with
                               ;; scrollHeight equal to clientHeight, so it was
                               ;; not a scroller at all. `overflow-hidden` plus
                               ;; a flex column restores the bounded height the
                               ;; inner scroll areas need.
                               ;;
                               ;; A PANE WITH NO INNER SCROLL AREA IS CLIPPED
                               ;; RATHER THAN SCROLLED, which is the honest
                               ;; consequence: it is a block that has not said
                               ;; yet what scrolls in it. graph-view is a
                               ;; picture that fits its box, and the two blocks
                               ;; that hold a growing list —
                               ;; frame-internals-viewer and universal-sidebar —
                               ;; each declare their own :scroll-area already.
                               (set! (.-className host)
                                     "h-full w-full min-h-0 min-w-0 overflow-hidden flex flex-col")
                               #js {:element host
                                    :init (fn [_] (swap! hosts assoc (.-id opts) host))}))})]
             (reset! api dv)
             ;; EVERY GROUP THIS DOCK WILL EVER MAKE GETS ITS GRIP, and
             ;; the subscription is what makes that "ever". A group is created
             ;; when the dock is built, when a hidden pane comes back, and when
             ;; a person drags one somewhere new — so hiding only the groups
             ;; that exist right now would let the strip return on the first
             ;; move. dockview's own event is the one place that sees all three.
             (.onDidAddGroup dv (fn [_] (grip-headers!)))
             ;; THE TOP BAR NEEDS TO KNOW WHICH PANES THIS ISLAND HAS, so an
             ;; icon for a pane no island draws is disabled rather than dead.
             (dock-panes/register-panes! (map pane-fold-info panes))
             ;; THE DECLARED DEFAULT IS DRAWN FIRST, ALWAYS. addPanel in
             ;; declaration order IS the default arrangement, so a surface with
             ;; no divergence — and one whose divergence no longer applies —
             ;; needs no special case.
             ;; SIDE BY SIDE, OR TABS — AND THE PANE SAYS WHICH. addPanel with
             ;; no :position puts every panel in ONE group, which draws them as
             ;; tabs. Measured 2026-09-02 on reader-v3's first load: `groups=1`,
             ;; two tabs, where the pattern said a navigator on the left and a
             ;; reading area beside it. A default that contradicts the
             ;; declaration is worse than no default.
             ;;
             ;; :direction is relative to the PREVIOUS pane, so the fold reads
             ;; the id it just added. The first pane carries no direction and is
             ;; the root of the grid.
             (let [added
                   (reduce
                     (fn [acc [id title _ pane :as p]]
                       ;; A PANE AN ICON HAS HIDDEN IS NOT MADE AT MOUNT. It is
                       ;; still declared, still in `panes`, and sync-visible!
                       ;; puts it back the moment the icon says so.
                       (if-not (dock-panes/showing? id)
                         acc
                         (let [pnl (add-panel! dv p (:prev acc))]
                           {:prev id :panels (conj (:panels acc) [pnl pane])})))
                     {:prev nil :panels []} panes)]
               ;; THE WIDTH IS SET AFTER EVERY PANE EXISTS, and on the GROUP.
               ;;
               ;; addPanel's own :initialWidth did nothing here, measured
               ;; 2026-09-02: the panes came out 700 and 700 in a 1400 window
               ;; when the navigator asked for 270. The first pane has no
               ;; position, so it IS the whole surface and has no width to be
               ;; given; the split appears only when the second arrives, and
               ;; dockview divides it evenly. So the size is a statement about a
               ;; grid that does not exist until the last addPanel returns.
               ;;
               ;; setSize lives on dockviewGroupPanelApi and not on the panel —
               ;; a group is what the grid sizes, and a panel is a tab inside
               ;; one.
               ;; THE PERSON'S OWN ARRANGEMENT FIRST, IF IT STILL APPLIES —
               ;; now, or whenever the bound source answers, because restore!
               ;; is called again from :component-did-update. It runs BEFORE the
               ;; width pass below so the order says what it means: a restored
               ;; arrangement carries its own widths and the declared ones are
               ;; not wanted.
               (restore!)
               ;; AND AFTER DOCKVIEW HAS MEASURED ITSELF, which is neither the
               ;; same tick nor the next one.
               ;;
               ;; MEASURED 2026-09-02, twice. addPanel's own :initialWidth did
               ;; nothing: the first pane has no position, so it IS the whole
               ;; surface and has no width to be given, and the split appears
               ;; only when the second pane arrives. A setSize deferred by
               ;; setTimeout 0 did nothing either, and the diagnostic said why —
               ;; the group's width was 100, dockview's pre-layout default. It
               ;; sizes itself from a ResizeObserver on its own element, so a
               ;; width set before that first observation is applied to a grid
               ;; 100 pixels wide and then thrown away by the real layout.
               ;;
               ;; SO THE SIZE WAITS FOR THE MEASUREMENT. The frame loop stops as
               ;; soon as the groups add up to the element, and gives up after a
               ;; second — an unsized pane is a usable pane, and a loop that
               ;; never ends is not.
               ;; A HEIGHT GOES THROUGH THE SAME DOOR AS A WIDTH (2026-09-10).
               ;; setSize takes both, and a BAND — `[toolbar spans full-width]`
               ;; — is the one pane that needs the second. It states its extent
               ;; on one axis, so dockview halves the other: measured with the
               ;; band's placement already correct and no height, the toolbar
               ;; came out 1920 x 886 and the four columns under it were 100
               ;; tall. ui.patterns/band-height supplies the number.
               (let [want (filterv (fn [[_ pane]] (pane-size pane)) (:panels added))
                     apply-sizes!
                     (fn []
                       (doseq [[^js pnl pane] want]
                         (try
                           (.. pnl -api -group -api (setSize (clj->js (pane-size pane))))
                           (catch :default e
                             (js/console.warn "dock: could not size the pane"
                                              (pr-str (pane-size pane)) e)))))
                     measured?
                     (fn []
                       (let [el-w (.-clientWidth el)
                             grid (reduce + 0 (map (fn [[^js pnl _]]
                                                     (or (some-> pnl .-api .-group .-width) 0))
                                                   (:panels added)))]
                         (and (pos? el-w) (>= grid (- el-w 2)))))
                     tries (atom 0)]
                 ;; ONLY WHEN NOTHING WAS RESTORED. The declared widths belong
                 ;; to the DEFAULT; applied over a restored arrangement they
                 ;; would undo the person's own pane widths on every load, and
                 ;; this pass runs a frame later than fromJSON, so it would win.
                 (when (and (seq want) (nil? @applied))
                   (letfn [(step []
                             (swap! tries inc)
                             (cond
                               ;; AN ARRANGEMENT ARRIVED WHILE WE WAITED, and it
                               ;; is the person's own. It replaced the whole
                               ;; grid, so these groups no longer exist and the
                               ;; declared widths are not wanted. Stop, and say
                               ;; nothing: this is the normal path for a surface
                               ;; someone has arranged.
                               (some? @applied) nil
                               (measured?)
                               (do
                                 ;; THE HEIGHTS TOO, AND ONLY HERE. A band is
                                 ;; the one pane that states one, and
                                 ;; settle-widths! is about a row of columns.
                                 (apply-sizes!)
                                 (settle-widths!
                                   dv panes
                                   (into {} (keep (fn [[id _ _ pane]]
                                                    (when-let [w (:width pane)] [id w])))
                                         panes)))
                               (< @tries 60)    (js/requestAnimationFrame step)
                               :else
                               (js/console.warn
                                 "dock: the grid never reported a measured width, panes keep dockview's own sizes")))]
                     (js/requestAnimationFrame step)))))
             ;; ONLY A PERSON'S MOVE IS RECORDED, AND ONLY AFTER IT HAPPENS.
             ;; It takes BOTH events, and using one alone is a real defect I
             ;; shipped and measured on 2026-09-02.
             ;;
             ;; onWillMutateLayout is the only one that says WHO — :origin user
             ;; or api — and ADR-graph-ui-v0-026-01 Sec2 quotes it for exactly
             ;; that. But it is a WILL event: toJSON() inside it returns the
             ;; layout BEFORE the move. The stored arrangement came back with
             ;; one leaf holding both views — the un-split state — so a reload
             ;; faithfully restored the layout the person had just left.
             ;;
             ;; onDidLayoutChange fires after, and carries no origin. So the
             ;; will-event sets a flag and the did-event reads it. The flag is
             ;; cleared on use, so a did-event with no will-event before it —
             ;; there is no such path today — cannot record an api change as a
             ;; person's.
             ;; :on-moved IS READ FROM @latest, never captured. See the
             ;; comment on `latest` above: the closure would otherwise hold the
             ;; session-id of the session that was open when this dock mounted.
             (let [by-person? (atom false)
                   report!    (fn []
                                (when-let [json (recordable-arrangement
                                                  (js/JSON.stringify (.toJSON dv))
                                                  @applied)]
                                  ;; The person's own arrangement IS now what is
                                  ;; on the screen, so the echo of it changes
                                  ;; nothing.
                                  (reset! applied json)
                                  (when-let [f (:on-moved @latest)]
                                    (f json (panes-stamp (:panes @latest))))))]
               (reset! reporter report!)
               (.onWillMutateLayout
                 dv (fn [^js ev] (reset! by-person? (= "user" (.-origin ev)))))
               (.onDidLayoutChange
                 dv (fn []
                      (when @by-person?
                        (reset! by-person? false)
                        (report!))))
               ;; A DIVIDER DRAG IS A PERSON'S MOVE TOO, AND dockview DOES NOT
               ;; SAY SO (PLAN-ikc-v3-050-01). George, 2026-09-27: "it does not
               ;; tracks my open panes and divide proportions".
               ;;
               ;; onWillMutateLayout fires for a STRUCTURAL change only: add,
               ;; remove, move, float, popout, maximize, load, clear (its own
               ;; docstring in dockview-core 8.2.0). A drag of a sash only
               ;; resizes, so the flag above was never set, and the new widths
               ;; were never sent. Measured on a probe bus, 2026-09-28: the
               ;; first pane went from 270 to 420 px, and no
               ;; :ui/set-dock-arrangement crossed the websocket.
               ;;
               ;; ONLY A POINTER MOVES A SASH, so a pointerdown on one is the
               ;; person's act. The layout is read when the pointer is released,
               ;; one tick later, after dockview has applied the last size.
               (.addEventListener
                 el "pointerdown"
                 (fn [^js ev]
                   (when (some-> (.-target ev) (.closest ".dv-sash"))
                     (.addEventListener
                       js/window "pointerup"
                       (fn [_] (js/setTimeout report! 0))
                       #js {:once true})))
                 #js {:capture true})))))
       :component-did-update
       (fn [this _]
         ;; r/argv is [component props panes] — the CURRENT ones.
         (let [[_ props panes] (r/argv this)]
           (reset! latest (assoc props :panes panes))
           (sync-visible!)
           (restore!)
           ;; AFTER restore!, NOT ONLY ON onDidAddGroup. .fromJSON rebuilds the
           ;; grid from a stored arrangement, and a group it revives that way is
           ;; a group whose header was hidden in the session that stored it and
           ;; not in this one. The call is idempotent, so saying it twice for
           ;; the groups the event already covered costs nothing.
           (grip-headers!)))
       :component-will-unmount
       (fn [_]
         ;; The portals unmount with this component, so only dockview's own DOM
         ;; and listeners need disposing.
         (reset! hosts {})
         (some-> ^js @api .dispose))
       :reagent-render
       (fn [_ panes]
         ;; THE DEREF IS THE SUBSCRIPTION, and it has to happen HERE.
         ;;
         ;; Measured in the browser 2026-09-05: the top-bar icon flipped to
         ;; "show" and the pane stayed on the screen. sync-visible! derefs this
         ;; atom, but it runs in a lifecycle callback — and reagent only
         ;; re-renders a component that derefs a ratom inside its RENDER. So the
         ;; dock never subscribed, the icon (which does deref it, in its own
         ;; render) updated alone, and the two disagreed.
         ;;
         ;; The value is not used. Reading it is the whole point: it makes
         ;; :component-did-update run on a toggle, and that is what calls
         ;; sync-visible!.
         @dock-panes/showing
         (into [:<>
                ;; .ikc-dock CARRIES THE THEME. dockview reads its own CSS
                ;; custom properties, and css/ikc-base.css maps them onto the
                ;; tokens under this one class — so every dock is themed and no
                ;; island says anything about it. Without it a dock draws the
                ;; Amber island in dockview's own near-black default.
                [:div {:ref   #(reset! mount %)
                       :class (str "ikc-dock h-full w-full min-h-0 min-w-0 "
                                   (get tone-text-classes tone ""))}]]
               (for [[id _ h] panes
                     :let [host (get @hosts id)]
                     :when host]
                 ^{:key id} (react-dom/createPortal (r/as-element h) host))))})))

(defn widget-dock-fallback
  "What a surface that cannot draw a dock does instead — ADR-graph-ui-v0-026-01
   decision 6.

   A terminal has no dock. An UNDECLARED fallback is the defect that made a
   phone scroll sideways, which is the whole reason :narrow exists, so :dock
   declares its own and this draws it.

   :stack puts every pane one under another. :first draws the first and NAMES
   the rest, so a reader learns what is not on the screen instead of not
   learning it exists."
  [fallback panes]
  (if (= :first fallback)
    (let [[[_ _ h] & more] panes]
      [:div.flex.flex-col.gap-2.min-h-0
       h
       (when (seq more)
         [:div.text-xs.ikc-fg-faint
          (str "not shown here: " (str/join ", " (map second more)))])])
    (into [:div.flex.flex-col.gap-2.min-h-0]
          (for [[id title h] panes]
            ^{:key id} [:div.min-h-0
                        [:div.text-xs.ikc-fg-faint.uppercase.tracking-wide.mb-1 title]
                        h]))))

(defn narrow-dock-choice
  "PURE. Which pane a phone draws, from the panes that are showing.

   `shown` is [[id title hiccup pane] …] in declaration order. `chosen` is the
   pane the person tapped, or nil. A tap wins while that pane is still showing.
   Otherwise the pane that takes all the remaining width wins — the reading
   area on reader-v3. Then the first pane that shares the width equally — the
   reading area on research. Then the first pane. Returns an id, or nil for no
   panes."
  [shown chosen]
  (let [ids (set (map first shown))]
    (cond
      (contains? ids chosen) chosen
      :else (or (some (fn [[id _ _ pane]] (when (:absorbs pane) id)) shown)
                (some (fn [[id _ _ pane]] (when (:shares pane) id)) shown)
                (ffirst shown)))))

(defn widget-dock-narrow
  "A DOCK ON A PHONE: ONE PANE AT A TIME, AND A ROW OF TABS TO PICK IT
   (George, 2026-09-28, bug 3 of IKC3-Bugs-20260928).

   dockview puts every pane SIDE BY SIDE. On a 390-pixel window the sidebar
   and the graph each opened at 270 pixels, and the reading pane got
   dockview's own minimum of 100 — so nothing could be read. That is true of
   every pattern island, so the answer is here, in the kind, and not in one
   island's description.

   THE SAME PANES, THE SAME TOGGLES. A pane the top-bar icon hides has no tab.
   A pane that is showing has one. The panes are NOT unmounted when another
   tab is picked, only hidden, so a tree keeps its open folders.

   A NEW PAGE BRINGS THE READING PANE BACK. A tap on a page in the Notes tab
   opens that page, and the person wants to read it. So a tap is remembered
   together with the page it was made on, and a different page ends it.

   NOTHING IS STORED. The desktop arrangement on the session is not touched,
   and this visit's tab is not a preference. That is the rule the
   :split-pane's phone drawer already keeps."
  [_props _panes]
  (let [chosen (r/atom nil)]
    (r/create-class
      {:display-name "widget-dock-narrow"
       :component-did-mount
       (fn [this]
         (let [[_ _ panes] (r/argv this)]
           (dock-panes/register-panes! (map pane-fold-info panes))))
       :component-did-update
       (fn [this [_ _ old-panes]]
         (let [[_ _ panes] (r/argv this)]
           (when (not= (map pane-fold-info old-panes) (map pane-fold-info panes))
             (dock-panes/register-panes! (map pane-fold-info panes)))))
       :reagent-render
       (fn [{:keys [tone]} panes]
         (let [page  (nav/current)
               tap   @chosen
               shown (filterv (fn [[id]] (dock-panes/showing? id)) panes)
               pick  (narrow-dock-choice
                       shown (when (= page (:page tap)) (:id tap)))]
           [:div {:class (str "ikc-dock-narrow h-full w-full min-h-0 min-w-0 "
                              (get tone-text-classes tone ""))
                  :style {:display "flex" :flex-direction "column"
                          :max-width "100%" :overflow-x "hidden"}}
            (when (> (count shown) 1)
              (into [:div {:role  "tablist"
                           :class "ikc-dock-narrow-tabs"
                           :style {:display "flex" :flex "0 0 auto"
                                   :overflow-x "auto" :gap "2px"
                                   :background "var(--panel)"
                                   :border-bottom "1px solid var(--border)"}}]
                    (for [[id title] shown
                          :let [on? (= id pick)]]
                      ^{:key id}
                      [:button {:role          "tab"
                                :aria-selected (str on?)
                                :data-pane     id
                                :on-click      #(reset! chosen {:id id :page page})
                                :style {:min-height "var(--touch-target, 2.75rem)"
                                        :flex "1 0 auto" :padding "0 0.75rem"
                                        :background "transparent" :border "none"
                                        :border-bottom (if on?
                                                         "2px solid var(--accent)"
                                                         "2px solid transparent")
                                        :color (if on? "var(--text)" "var(--muted)")
                                        :font-weight (if on? "600" "400")
                                        :cursor "pointer"}}
                       (or title id)])))
            (into [:div {:style {:flex "1 1 0" :min-height "0" :min-width "0"
                                 :position "relative"}}]
                  (for [[id _ h] shown]
                    ^{:key id}
                    [:div {:data-pane id
                           :class "h-full w-full min-h-0 min-w-0 overflow-hidden flex flex-col"
                           :style (when-not (= id pick) {:display "none"})}
                     h]))]))})))

;; ---------------------------------------------------------------------------
;; :stack/:group/:flex/:grid/:grid-col/:simple-grid — Meta-UI v2.0's real
;; Mantine-backed arrangement kinds (ADR-graph-ui-v0-013-01 §0/§3), replacing
;; :box's dropped :layout/flex props. Thin adapters onto the actual Mantine
;; components — unlike :box (Tailwind, kept for v1.x compatibility), these
;; are new-at-v2.0, so there is no legacy shape to stay compatible with.
;; ---------------------------------------------------------------------------

;; Mantine's own default params only fire on an ABSENT (undefined) prop, not
;; an explicit null — several components (Grid/SimpleGrid's breakpoint-
;; resolution machinery, verified 2026-07-27) crash on a literal null where
;; they'd have silently defaulted on undefined. So every optional prop below
;; is OMITTED via cond-> when absent, never passed as an explicit nil.

(defn widget-stack
  ;; :density IS DECLARED ON A STACK (ui.edn v2.1) AND WAS NOT DRAWN. A pane
  ;; whose root is a stack therefore had no padding at all, and the dock's
  ;; divider painted over the first letter of every line at its left edge
  ;; ("MPORT", "ook at its frame" — George's screenshot, 2026-09-08). A stack
  ;; that declares none stays as it was: no padding.
  ;;
  ;; A STACK ADDS NO GROW OF ITS OWN (2026-09-26). This root carried `flex-1`,
  ;; so every stack that declared no :flex took an equal share of its column.
  ;; George met it as "more than 400 vertical px between pin icon and Add a
  ;; tag field" (PR #76). ui.edn declares :stack as :box-from :content, and
  ;; ADR-graph-ui-v0-013-01 Sec2 says growth is opt-in and visible. So a stack
  ;; grows only when its description says :flex 1..3, through the wrapper in
  ;; render.cljs — the rule every other kind follows. `min-h-0` stays, so a
  ;; stack in a bounded column can still shrink and let a child scroll.
  [{:keys [gap align justify density] :as props} children]
  (let [surf (backdrop-style props)]
    (into [:> (.-Stack mantine)
           (cond-> {:class (str "min-h-0" (when density (str " " (get box-density-pad-classes density "p-2"))))}
             gap     (assoc :gap (mantine-spacing-token gap))
             align   (assoc :align (mantine-align-items align))
             justify (assoc :justify (mantine-justify-content justify))
             surf    (assoc :style surf))]
          children)))

(defn- group-fit-real-child
  "The real, box-generating element under a possibly `display: contents`
   import-id wrapper (render.cljs) — see the memory
   a-child-selector-stops-at-the-id-wrapper. `>` still walks the DOM under a
   boxless element; only its OWN box is absent."
  [el]
  (loop [e el]
    (if (and e (= "contents" (.-display (js/getComputedStyle e))))
      (recur (.-firstElementChild e))
      e)))

(def ^:private group-fit-min-scale
  "The smallest share of its declared font size a fitted label may draw at."
  0.6)

(defn- group-fit-row!
  "SIZE TO FIT (PLAN-ikc-v3-034-01 item 2; George, 2026-09-24: \"It is
   disgusting to not be able to size buttons and fonts to fit. I do not have
   rule 'to not improve'.\"). Runs on a `:grow` row after layout, shrinking
   every child's font-size and padding by ONE scale until each label fits its
   OWN equal share — measured, not guessed. A preset :density is not always
   enough: measured 2026-09-20, `:compact` still asked the sidebar's four
   labels for 40, 64, 30 and 64 px against the 30, 48, 23 and 48 px a 252 px
   row gave them.

   ONE SCALE FOR EVERY CHILD, because :grow already gives every child the
   SAME width — a uniform shrink keeps the row looking like one row, not four
   buttons each choosing its own size.

   RUNS AGAIN ON A RESIZE, because the reader sets an island's width, not the
   app (AGENTS.md, `he sets the width, not the app`) — dragging a sidebar
   fires no window resize, only a ResizeObserver on the row itself sees it.

   RESETS BEFORE IT MEASURES, or a resize storm compounds (found 2026-09-24,
   the narrower-width measurement of this same repair). A ResizeObserver
   fires more than once while a page settles, and a pass that measured from
   its OWN last shrink read `needs` and `gets` after that shrink had already
   moved them — each firing shrank further, with no floor, even once the row
   had stopped moving. Clearing the inline style FIRST makes every pass
   measure the same DECLARED size, so the result depends only on the
   available width, not on how many times this ran. It also lets a widened
   row grow back: nothing here ever restored a button that no longer needed
   to shrink. Both mutations run in one synchronous pass, before the browser
   paints, so the reset is never seen — see
   an-indicator-must-not-move-the-furniture."
  [group-el]
  (when group-el
    (let [buttons (keep (fn [child]
                          ;; The element that OWNS the label. Under a boxed
                          ;; wrapper (instrument, :layout-self) the real child
                          ;; is the wrapper, and a font-size set there never
                          ;; reaches a Mantine button, which sets its own.
                          (let [real  (group-fit-real-child child)
                                label (some-> real (.querySelector ".mantine-Button-label"))]
                            (or (some-> label (.closest "button")) real)))
                        (array-seq (.-children group-el)))]
      (doseq [btn buttons]
        (set! (.. btn -style -fontSize) "")
        (set! (.. btn -style -paddingLeft) "")
        (set! (.. btn -style -paddingRight) ""))
      (let [worst (reduce
                    (fn [w btn]
                      (if-let [label (.querySelector btn ".mantine-Button-label")]
                        (let [needs (.-scrollWidth label)
                              gets  (.-clientWidth label)]
                          (if (pos? gets) (max w (/ needs gets)) w))
                        w))
                    1 buttons)]
        (when (> worst 1)
          ;; A MARGIN, not the exact ratio. Text width does not shrink exactly
          ;; with font-size — kerning, sub-pixel rounding — so the bare ratio
          ;; still cuts the widest label by a pixel. 4% closes it.
          ;; A FLOOR (review of PR #58): never below 60% of the declared size.
          ;; Past it a label is cut by its ellipsis, which stays readable,
          ;; instead of text too small to read.
          (let [scale (max group-fit-min-scale (/ 1 (* worst 1.04)))]
            (doseq [btn buttons]
              (let [cs (js/getComputedStyle btn)
                    fz (js/parseFloat (.-fontSize cs))
                    pl (js/parseFloat (.-paddingLeft cs))
                    pr (js/parseFloat (.-paddingRight cs))]
                (set! (.. btn -style -fontSize) (str (* fz scale) "px"))
                (set! (.. btn -style -paddingLeft) (str (max 2 (* pl scale)) "px"))
                (set! (.. btn -style -paddingRight) (str (max 2 (* pr scale)) "px"))))))))))

(defn- group-fit-ref
  "The :grow row's ref: fits once at mount and again on every width change.
   `observer` is a plain atom the caller keeps alive across renders (the same
   convention as autosize-ref, above widget-input) so ONE ResizeObserver
   survives re-renders instead of a fresh one leaking on each."
  [observer]
  (fn [el]
    (if el
      (do
        (group-fit-row! el)
        (when (and (nil? @observer) (exists? js/ResizeObserver))
          (let [o (js/ResizeObserver. (fn [_] (group-fit-row! el)))
                ;; A LABEL CAN CHANGE WITH NO RESIZE (review of PR #58): a
                ;; bound text arrives, the row keeps its width, and the old fit
                ;; stays. Text and child changes refit too. The fit itself
                ;; writes only `style` attributes, which this does not observe,
                ;; so it cannot trigger itself.
                m (when (exists? js/MutationObserver)
                    (js/MutationObserver. (fn [_ _] (group-fit-row! el))))]
            (.observe o el)
            (some-> m (.observe el #js {:childList true :characterData true :subtree true}))
            (reset! observer [o m]))))
      (do (doseq [o @observer] (some-> o .disconnect))
          (reset! observer nil)))))

(defn widget-group
  ":grow MEANS AN EQUAL SHARE, and Mantine's own prop does not give one
   (2026-09-20). Mantine sets `flex-grow: 1` on each child and leaves the basis
   at `auto`, so each child keeps a width proportional to its CONTENT and the
   row only shares what is left over. ikc1's sidebar row uses Tailwind's
   `flex-1`, which is `flex: 1 1 0%` — grow 1 AND basis 0 — so every child gets
   the same width whatever its label.

   MEASURED on a probe bus, the sidebar row at 1280 px. With Mantine's prop
   alone the four buttons drew 48.4, 66.3, 41 and 66.3 px, and every label was
   cut. With the basis at zero they draw one width each.

   THE SELECTOR MUST REACH THROUGH THE ID WRAPPER (found 2026-09-20, repaired
   2026-09-24 — see the memory a-child-selector-stops-at-the-id-wrapper). Every
   widget on the deployment carries an import id (render.cljs), and a widget
   with no :layout-self/:flex/:widget-id of its own gets a `display: contents`
   wrapper for it — a boxless element, so it takes part in no flex layout. The
   direct DOM children of this Group are those wrappers, one per widget, and
   `[&>*]` stops on them: their flex-basis is set and does nothing. The real
   flex item is the wrapper's own child, one level further down, where the
   button actually is — measured with `dev/group_basis_probe.mjs`, PR #27:
   wrapper basis 0px grow 1, BUTTON basis auto grow 0, four unequal widths.
   `[&>*>*]` reaches it, so the fix is the SAME for any row that asks for
   :grow, not only the sidebar's.

   MANTINE'S OWN `:grow` PROP HAS THE SAME WRAPPER PROBLEM (found 2026-09-24,
   re-measuring this repair). It sets `[data-grow] > * { flex-grow: 1 }` —
   again the DIRECT child, the wrapper. So `[&>*>*]:basis-0` alone shrank
   every button to its content minimum: basis zero, grow zero, nothing to
   grow INTO. `[&>*>*]:grow` reaches the button with the missing `flex-grow:
   1` the same way `[&>*>*]:basis-0` reaches it with the basis — both halves
   of ikc1's `flex: 1 1 0%`, both two levels down.

   THE SHARE GOES TO THE DIRECT CHILD, AND THROUGH A BOXLESS WRAPPER ONLY
   (review of PR #58). A child has one of three shapes: no wrapper (no
   :import-id), a wrapper WITH a box (`:layout-self`, `:flex`, or
   `?instrument=1`'s `data-widget-id`, which ui.fidelity measures), or the
   boxless `display: contents` wrapper. `[&>*]` gives the share to the first
   two — a boxed wrapper is itself a flex column that stretches its widget.
   `[&>[style*=contents]>*]` reaches through the third only. A blanket `>*>*`
   landed one level too deep on the first shape and measured the unfixed
   geometry on the second.

   The class is added only when the description asks for :grow, so a row that
   does not is unchanged.

   A :grow ROW ALSO FITS ITS CHILDREN (Track R, PLAN-ikc-v3-034-01 item 2):
   group-fit-ref measures the mounted row and shrinks every child uniformly
   until each label fits, then watches the row's own width for a resize.
   That is browser work — the ref is inert under server-side rendering, which
   is how the render-markup test harness runs and why this needs no mock.

   A :wrap ROW WRAPS BEFORE IT SQUEEZES A :flex CHILD
   (IKC3/PLAN-ikc-v3-080-01/POLISH). A child with :flex 1..3 has the basis 0%
   (flex-class), so a wrapping row never wrapped: it shrank each such child
   to any width. The block ikc/work-item in the pane Work item of the board,
   270 px wide, drew its criteria one letter on each line, measured on a
   probe bus. So in a :wrap row that does not :grow, each boxed :flex child
   (its wrapper carries min-w-0) gets the basis min(100%, 18rem). A wide row
   keeps its columns side by side, and a narrow one puts each column on a
   line of its own. A child with no :flex has no box, and keeps its basis."
  [initial-props _initial-children]
  (let [observer (atom nil)
        fit-ref  (group-fit-ref observer)]
    (fn [{:keys [gap align justify wrap grow] :as props} children]
      (let [surf (backdrop-style props)]
        (into [:> (.-Group mantine)
               (cond-> {:wrap (if wrap "wrap" "nowrap") :grow (boolean grow)}
                 grow    (assoc :className "[&>*]:grow [&>*]:basis-0 [&>[style*=contents]>*]:grow [&>[style*=contents]>*]:basis-0" :ref fit-ref)
                 (and wrap (not grow)) (assoc :className "[&>.min-w-0]:basis-[min(100%,18rem)]")
                 gap     (assoc :gap (mantine-spacing-token gap))
                 align   (assoc :align (mantine-align-items align))
                 justify (assoc :justify (mantine-justify-content justify))
                 surf    (assoc :style surf))]
              children)))))

(defn widget-flex
  [{:keys [direction wrap gap row-gap column-gap align justify]} children]
  (into [:> (.-Flex mantine)
         (cond-> {:wrap (if wrap "wrap" "nowrap") :class "flex-1 min-h-0"}
           direction  (assoc :direction (case direction :row "row" :column "column"))
           gap        (assoc :gap (mantine-spacing-token gap))
           row-gap    (assoc :rowGap (mantine-spacing-token row-gap))
           column-gap (assoc :columnGap (mantine-spacing-token column-gap))
           align      (assoc :align (mantine-align-items align))
           justify    (assoc :justify (mantine-justify-content justify)))]
        children))

(defn widget-grid
  "Real 2D proportional layout — CSS GRID, and Mantine's `Grid` until
   2026-08-23.

   WHY IT LEFT MANTINE. Mantine's Grid is a WRAPPING FLEXBOX. Two facts follow,
   and both cost a day. A row's height is its tallest item's CONTENT height, so
   a :scroll-area inside a column has nothing to scroll within and grows instead
   — George found that at once: \"reader-v2 lost its ability to scroll in the
   reading pane\". And a second row does not share the height with the first: four
   tiles drew two rows of full height, so the bottom two were off the screen with
   no way to reach them.

   CSS grid answers both by construction. `minmax(0, 1fr)` tracks in both
   directions give every cell a DEFINITE height, which is exactly the bounded
   height :scroll-area's own declaration asks for, and `grid-auto-rows` makes
   every row an equal share of the pane.

   :columns IS STILL THE TOTAL and :span is still a share of it, so every
   declaration reads the same as before. What went away is what a flexbox could
   do and a grid cannot — :grow, :offset and the :auto/:content spans, all three
   unused and now undeclared, so a description that names one is REFUSED at
   \"disallowed key\" instead of the renderer dropping it in silence. The gate is
   the description validator, proven 2026-08-23 by declaring :offset on the tile
   cell: two tests named it. validate-dsl does NOT catch this — it checks the
   manifest, not the instances."
  [{:keys [columns gutter align justify]} children]
  (into [:div {:className "h-full min-h-0 min-w-0"
               :style (cond-> {:display              "grid"
                               :gridTemplateColumns  (str "repeat(" (or columns 12)
                                                          ", minmax(0, 1fr))")
                               ;; EVERY ROW AN EQUAL SHARE, and 0 as the minimum
                               ;; so a tall child cannot push the row past it.
                               :gridAutoRows         "minmax(0, 1fr)"}
                        gutter  (assoc :gap (str "var(--mantine-spacing-"
                                                 (mantine-spacing-token gutter) ")"))
                        align   (assoc :alignItems (mantine-align-items align))
                        justify (assoc :justifyContent (mantine-justify-content justify)))}]
        children))

(defn widget-grid-col
  "One column of a :grid — a grid item spanning :span of the parent's :columns.

   `min-h-0` and a flex column, so whatever is inside can bound its own height.
   That is the other half of widget-grid's fix: the track gives this cell a
   definite height, and this class lets the child use it."
  [{:keys [span order]} children]
  (into [:div {:className "min-h-0 min-w-0 flex flex-col"
               :style (cond-> {}
                        (int? span) (assoc :gridColumn (str "span " span " / span " span))
                        order       (assoc :order order))}]
        children))

(defn widget-simple-grid
  [{:keys [cols spacing vertical-spacing]} children]
  (into [:> (.-SimpleGrid mantine)
         (cond-> {:cols (or cols 1)}
           spacing          (assoc :spacing (mantine-spacing-token spacing))
           vertical-spacing (assoc :verticalSpacing (mantine-spacing-token vertical-spacing)))]
        children))

(defn size-prop
  "A :size for Mantine, from the OPEN value ADR-graph-ui-v0-001-01 allows: a
   scale token, a pixel number, or a CSS length string.

   `(name size)` was enough while the value was a closed enum of five keywords.
   It throws on a number — numbers are not Named — so widening the vocabulary
   without widening this would turn `:size 900` into a render-time crash rather
   than the measure it asks for. Mantine itself accepts all three."
  [size]
  (cond
    (keyword? size) (name size)
    (string? size)  size
    :else           size))

(defn widget-app-shell
  "§B: a PAGE — Mantine `AppShell`. Header / Navbar / Aside / Main / Footer,
   named by each child's :section rather than ordered.

   `sections` arrives already grouped and rendered — render.cljs partitions the
   raw children by :section before rendering, because the section is a property
   of the NODE and is gone by the time a child is hiccup.

   :mode defaults to :static, and that default is load-bearing. Mantine's own
   default is 'fixed', which positions every section except Main against the
   VIEWPORT — right for a page that owns the window, wrong for an ikc3 island
   that may be one pane of a canvas, where a fixed navbar escapes its island and
   lands on the window."
  [{:keys [mode padding navbar-width aside-width header-height footer-height
           navbar-breakpoint]}
   sections]
  (let [shell (.-AppShell mantine)
        ;; Mantine's navbar/aside config REQUIRES a breakpoint — it is the width
        ;; below which the section collapses. Passing {width} alone leaves the
        ;; section unplaced, and the whole page stacks vertically: the sidebar
        ;; renders full-width above the main area instead of beside it. That is
        ;; what the first build did, and no console error said so — the probe
        ;; found every button present and the screenshot showed the layout
        ;; collapsed. Defaulted rather than required in the DSL, because a
        ;; description that omits it wants a sidebar, not a broken page.
        bp    (name (or navbar-breakpoint :sm))
        conf  (fn [w] (cond-> {:breakpoint bp} w (assoc :width (size-prop w))))]
    ;; A PAGE FRAME DOES NOT SCROLL — ITS PANES DO. Mantine's AppShell root
    ;; carries overflow-y:auto, so a long note scrolled the WHOLE page: sidebar,
    ;; header, toolbar and all moved together, and any :scroll-area inside was
    ;; dead code because nothing ever bounded its height (measured 2026-08-07 —
    ;; the shell showed 482px of 769px and was the only scroller on the page).
    ;;
    ;; So the root is clipped and every section is bounded to it. A section's
    ;; children then have a real height to be `flex-1 min-h-0` inside, which is
    ;; what makes a :scroll-area scroll. This is what the descriptions already
    ;; SAY — [reading-pane can-not scroll], [page-body can scroll] — and could
    ;; not previously be true of the running page.
    (into [:> shell
           (cond-> {:layout "default"
                    :className "w-full h-full min-h-0 overflow-hidden"
                    :padding (some-> (or padding :md) name)}
             (not= mode :fixed) (assoc :mode "static")
             navbar-width  (assoc :navbar (clj->js (conf navbar-width)))
             aside-width   (assoc :aside  (clj->js (conf aside-width)))
             header-height (assoc :header (clj->js {:height header-height}))
             footer-height (assoc :footer (clj->js {:height footer-height})))]
          ;; THE THEME REACHES THE SECTIONS TOO. Mantine's Navbar/Aside/Header
          ;; ship their own light background, so a sidebar rendered black-on-white
          ;; beside an amber page — the island's theme stopped at the Main area
          ;; (George, 2026-08-07). The tokens are the same ones every other
          ;; widget uses (ADR-graph-ui-v0-009-01), so a theme switch moves the
          ;; sidebar with everything else.
          (keep (fn [[k comp]]
                  (when-let [kids (seq (get sections k))]
                    (into [:> comp {:className "h-full min-h-0 overflow-hidden flex flex-col"
                                    :style (if (= k :main)
                                             {:background "var(--ground)" :color "var(--text)"}
                                             {:background "var(--panel)"  :color "var(--text)"
                                              :borderColor "var(--border)"})}]
                          kids)))
                [[:header (.-Header shell)] [:navbar (.-Navbar shell)]
                 [:aside  (.-Aside shell)]  [:main   (.-Main shell)]
                 [:footer (.-Footer shell)]]))))

(defn widget-container
  "§20: a centred, max-width reading column — Mantine `Container`. SPEC-002's
   locked target centres its main pane in a 900px column; without this a
   reading UI runs its prose edge-to-edge on a wide monitor, which is a
   legibility defect in the island whose whole purpose is reading.

   :size is Mantine's own closed max-width scale, read from the shipped
   styles.css rather than recalled: :xs 540 · :sm 720 · :md 960 · :lg 1140 ·
   :xl 1320 pixels. :md is the nearest to the locked target's 900; the enum
   cannot express 900 exactly, which is the standing closed-values trade (§0).
   (An earlier note here claimed :md 768 / :lg 992 — those are Mantine's
   BREAKPOINTS, not its container sizes, and the mistake put the reading column
   at 1140px, wider than the target rather than nearer to it.)

   `flex flex-col` is load-bearing, not decoration: Mantine's Container is a
   plain block element, so a child carrying :flex 1 has nothing to grow inside
   and falls back to its own content height. Measured 2026-07-28 — the reading
   pane came out 180 pixels tall inside a 986-pixel column, which is why the
   content pane looked dead. :fluid takes the parent's full width."
  [{:keys [size fluid] :as props} children]
  (let [surf (backdrop-style props)]
    (into [:> (.-Container mantine)
           (cond-> {:class "w-full min-h-0 flex flex-col"}
             (and size (not fluid)) (assoc :size (size-prop size))
             fluid                  (assoc :fluid true)
             surf                   (assoc :style surf))]
          children)))

(defn short-list-max-height
  "The CSS height a SHORT list stops at: dsl/design/sidebar-section.edn's
   `short` limit, in rows. A row is one line of the list's own type, so N rows
   is N line heights (`lh`), which scales with the type and is not a pixel."
  []
  (let [n (or (get-in design/components [:sidebar-section :variants 'short :limit :rows]) 8)]
    (str "calc(" n " * 1lh)")))

(defn widget-scroll-area
  "§22: a scrolling viewport — Mantine `ScrollArea`. Makes WHAT SCROLLS
   declarable instead of hardcoded per widget in this file, which is an AC-1
   gap, and it is the deferred half of the 2026-07-14 scroll problem
   render.cljs still documents: a min-h-0 on the SHARED root collapsed the
   content pane, so the fix had to move to the pane's own flex chain. A
   description naming its scrolling box IS that move.

   Needs a bounded height to scroll within, so it normally carries :flex 1
   inside a :stack that has one.

   :reset-key SENDS THE BOX BACK TO THE TOP (2026-09-20). It is the same noun
   :input carries, and it means the same thing: when the value changes, the box
   drops what it holds. An :input drops its text. This drops its offset.

   THE DEFECT IT CLOSES. The reading pane holds seven of these, one for each
   modality, inside one :tab-set. A second note of the SAME modality reuses
   the same element, so the offset stays and the browser only clamps it to the
   new content. Measured on the deployment 2026-09-20: a note of 126,287 px
   was read to its foot, and the next note opened at 12,830 px of its own
   13,372 px. The reader arrived 96 per cent of the way down a note they had
   just opened. ikc1 has no reset of its own, because its pane is built again
   for each note, and a new element starts at zero.

   THE RESET RUNS TWICE ON PURPOSE. Once at once, and once after the next
   frame. The content of the new note arrives from the bus, so the element may
   still hold the old note when this render runs. Zero is stable under content
   that grows, so the early call costs nothing and the later one catches the
   rest."
  [initial-props _children]
  (let [viewport (atom nil)
        ;; The FIRST render must not reset. A box that has just been made is at
        ;; the top already, and a reset here would fight a later restore.
        last-key (atom (:reset-key initial-props))]
    (fn [{:keys [type scrollbars reset-key flex] :as props} children]
      (when (not= @last-key reset-key)
        (reset! last-key reset-key)
        (let [top! (fn [] (when-let [el @viewport] (set! (.-scrollTop el) 0)))]
          (top!)
          (when (exists? js/requestAnimationFrame)
            (js/requestAnimationFrame top!))))
      (into [:> (if (= 0 flex) (.-Autosize (.-ScrollArea mantine)) (.-ScrollArea mantine))
             (cond-> {:class "flex-1 min-h-0"
                      :viewportRef (fn [el] (reset! viewport el))}
               ;; :flex 0 — A SCROLL AREA THAT TAKES NO SHARE (2026-09-25). It
               ;; is as tall as what it holds, up to short-list-max-height, and
               ;; scrolls past it. Mantine's Autosize is exactly that box. A
               ;; scroll area with :flex 1 fills its parent, as every one did.
               (= 0 flex) (-> (assoc :mah (short-list-max-height))
                              (assoc :class "min-h-0"))
               (backdrop-style props) (assoc :style (backdrop-style props))
               type       (assoc :type (name type))
               ;; :none is our closed spelling of Mantine's `false` (no scrollbars
               ;; rendered at all) — the enum keeps a keyword vocabulary while the
               ;; adapter speaks Mantine's own value.
               scrollbars (assoc :scrollbars (if (= scrollbars :none) false (name scrollbars))))]
            children))))

;; ---------------------------------------------------------------------------
;; Leaf widgets.
;; ---------------------------------------------------------------------------

(defn widget-text
  "A run of text. :size/:weight/:transform are §19's universal slots, applied
   through typography-props. :empty-label (§23) is what a bound value that
   resolves to an empty string shows instead of nothing — the locked target's
   'Add tags…' on a page with no tags. Rendered dimmed and italic, the same
   empty-state treatment :list/:tree/:outline already give theirs, so an EMPTY
   pane reads as empty rather than as broken."
  [{:keys [value tone size weight empty-label] :as props}]
  ;; Dual-shape, the same way every gesture-firing widget is: v1.x's :text
  ;; carries its OWN :size/:weight (a released vocabulary never changes), v2.0
  ;; carries the universal :font-size/:font-weight instead. A render tree only
  ;; ever holds one or the other, so honouring both is safe.
  (let [typo (typography-props props)]
    (if (and (str/blank? value) (not (str/blank? empty-label)))
      [:> (.-Text mantine)
       (merge {:size "sm" :c "dimmed" :fs "italic"} typo)
       empty-label]
      [:> (.-Text mantine)
       (merge {:size (mantine-size size)
               :fw (when (= weight :bold) 700)
               :c (mantine-color tone)}
              typo)
       (or value "")])))

(defn- normalize-item
  "A :list/:tree item is a bare string under v1.x, or a map under v2.0
   (ADR-graph-ui-v0-013-01 §17) — normalize either to the map shape so the
   renderer has one code path regardless of which major produced the tree."
  [item]
  (if (map? item) item {:label (str item)}))

(defn- nav-row
  "SPEC-002's 'nav row': icon + ellipsised label + trailing accessory,
   active/dim states (ADR-graph-ui-v0-013-01 §17). Degrades to a plain label row
   when :icon/:accessory/:active/:dim are all absent — the common case stays
   just as terse to render.

   WRAP (2026-10-06): with the list's :wrap true the label is shown in full.
   It continues on the next lines and keeps its own line breaks, and the icon
   and the accessory align with its first line. Without it the label is one
   line with an ellipsis. Fault reports 3fc8e2c6 and d8463f96: a conversation
   turn was cut to one line in gi and in studio."
  [{:keys [label icon accessory active dim]} tone wrap?]
  [:> (.-Group mantine)
   {:gap "xs" :wrap "nowrap" :align (if wrap? "flex-start" "center")
    :class (str "px-1 py-0.5 rounded min-w-0"
                (when active " bg-[var(--hover)]")
                (when dim " ikc-dim"))}
   (when icon [widget-icon {:icon icon :size :sm}])
   [:> (.-Text mantine) {:size "sm" :c (mantine-color tone)
                         :class (if wrap?
                                  "flex-1 min-w-0 whitespace-pre-wrap break-words"
                                  "flex-1 min-w-0 truncate")}
    (or label "")]
   (when accessory
     [:> (.-Text mantine) {:size "xs" :c "dimmed" :class "shrink-0"} accessory])])

(defn widget-list
  "A vertical list; each item is a bare string (v1.x) or a nav-row map (v2.0)."
  [{:keys [items tone empty-label wrap]}]
  (if (empty? items)
    (when empty-label
      [:> (.-Text mantine) {:size "sm" :c "dimmed" :fs "italic"} empty-label])
    [:> (.-Stack mantine) {:gap 0 :class "overflow-y-auto flex-1 min-h-0 pr-1"}
     (for [[i raw] (map-indexed vector items)]
       ^{:key i} [nav-row (normalize-item raw) tone (true? wrap)])]))

(defn- fmt-clock
  "epoch-ms → HH:MM:SS.mmm"
  [epoch-ms]
  (let [d  (js/Date. epoch-ms)
        p2 #(.padStart (str %) 2 "0")
        p3 #(.padStart (str %) 3 "0")]
    (str (p2 (.getHours d)) ":" (p2 (.getMinutes d)) ":" (p2 (.getSeconds d))
         "." (p3 (.getMilliseconds d)))))

(defn- activity-row
  [{:keys [kind at type ms label detail] :as e} slow-ms]
  (let [slow?  (and ms (>= ms slow-ms))
        muted  "text-[var(--muted)]"
        cells  (case kind
                 :dispatch (cond-> [[:span {:class muted} "→"]
                                    [:span {:class (str "shrink-0 " (if slow? "text-amber-500 font-bold" "text-[var(--text)]"))} (str type)]]
                             detail (conj [:span {:class (str "truncate " muted)} (str detail)])
                             :always (conj [:span {:class (str "shrink-0 ml-auto " (if slow? "text-amber-500 font-bold" muted))} (str ms "ms")]))
                 :ui       (cond-> [[:span {:class "text-[var(--accent)] shrink-0"} "•"]
                                    [:span {:class "truncate text-[var(--text)]"} (str label)]]
                             detail (conj [:span {:class (str "shrink-0 truncate " muted)} (str detail)]))
                 :event    [[:span {:class (str "shrink-0 " muted)} "⟵"]
                            [:span {:class (str "truncate " muted)} (str type)]]
                 [[:span {:class "text-[var(--text)]"} (pr-str e)]])]
    (into [:div {:class "flex items-baseline gap-2 whitespace-nowrap"}
           [:span {:class (str "shrink-0 " muted)} (fmt-clock at)]]
          cells)))

(defn widget-activity-log
  [{:keys [title max-rows slow-ms]}]
  (let [all   (activity/entries)
        n     (or max-rows 60)
        rows  (if (> (count all) n) (subvec all (- (count all) n)) all)
        slow  (or slow-ms 200)]
    [:div {:class "flex flex-col min-h-0 flex-1"}
     [:div {:class "text-xs uppercase tracking-wide text-[var(--muted)] mb-1 flex items-center gap-2 shrink-0"}
      [:span {:class "truncate min-w-0"} (or title "activity")]
      [:span {:class "ml-auto flex gap-1 shrink-0"}
       [:> (.-Button mantine)
        {:size "xs" :variant "default" :on-click #(some-> js/navigator .-clipboard (.writeText (activity/as-text)))}
        "copy all"]
       [:> (.-Button mantine)
        {:size "xs" :variant "default" :on-click #(activity/clear!)}
        "clear"]]]
     [:div {:class "font-mono text-xs leading-relaxed overflow-y-auto flex-1 min-h-0 pr-1 text-[var(--text)]"}
      (if (empty? rows)
        [:p {:class "italic text-[var(--muted)]"} "no activity yet"]
        (into [:div {:class "flex flex-col overflow-y-auto min-h-0 flex-1"}]
              (for [[i e] (map-indexed vector rows)]
                ^{:key i} [activity-row e slow])))]]))

;; ---------------------------------------------------------------------------
;; :tree — Mantine Tree.
;; ---------------------------------------------------------------------------

(defn- row-hourglass
  "The hourglass on the row you clicked — F-graph-ui pending affordance,
   2026-08-17. A COMPONENT rather than an inline check, and that is what makes it
   affordable on this tree: mantine-tree-node's renderNode is a plain function
   whose result is frozen into an element by r/as-element, so a `busy/…` deref
   written straight into it would not re-render at all. As its own component it
   subscribes on its own behalf, and exactly one row repaints when the state
   changes — not the 1483 rows of foam-home.

   TRAILING, and OUT OF FLOW. A spinner inserted before the label would push the
   label sideways in the instant after the click — the row moving under the cursor
   that just clicked it, which reads as a mis-click rather than as progress. It sat
   in flow at the trailing edge at first, which is fine for a bare page row and
   wrong for a row with an accessory: a page count or a reference's text would be
   shoved left the moment the ring appeared. George made the point about the chrome
   bar on 2026-08-17 — *\"it should live in a fixed space, the realignment of the
   elements after it is disturbing\"* — and it is the same defect here.

   Absolute at the row's right edge, so appearing costs no layout at all. Reserving
   a gutter instead (the fix used in the chrome, where there is one slot) would have
   spent it on every one of 2029 rows to show one ring."
  [session-id value]
  (when (busy/acknowledging? session-id value)
    [:span.ikc-busy-row {:role "status"
                         :aria-label "opening"
                         :title "opening — waiting for the bus"}
     [:span.ikc-busy-spinner {:aria-hidden true}]]))

(defn- tree-row-button
  "Horizontal row-mode tree item."
  ;; :current MARKS THE ROW THAT IS IN FORCE. It was called :today, because the
  ;; daily nav bar was the only strip that had one. The tile strip has one too —
  ;; the focused tile — and a tile is not a day (ADR-graph-ui-v0-023-01). One
  ;; concept, one name. :today is still read, so nothing outside this repository
  ;; breaks on the rename.
  ([item submit bus session-id] (tree-row-button item submit bus session-id nil))
  ([{:keys [label value title today current]} submit bus session-id remove-gesture]
  ;; This one IS a reagent component, so it may deref busy directly.
  (let [clickable? (boolean (and submit bus value))
        pending?   (busy/acknowledging? session-id value)
        ;; A CHIP WITH A WAY OUT (George, 2026-09-25: "the chips of the
        ;; selected tags, each with an × to remove it"). A row tree that wires
        ;; :remove draws the cross INSIDE the chip, the same :remove a column
        ;; tree draws at the row's edge. Always drawn, never on hover.
        cross      (when (and remove-gesture bus value)
                     [:span {:role "button"
                             :aria-label (str "Remove " (str label))
                             :title (str "Remove " (str label))
                             :class "ml-1 cursor-pointer leading-none text-[var(--faint)] hover:text-[var(--danger)]"
                             :on-click (fn [e]
                                         (.preventDefault e)
                                         (.stopPropagation e)
                                         (js-invoke bus "dispatch"
                                                    (bind/fill-command remove-gesture
                                                                       {'$session-id session-id '$value value})
                                                    (fn [_] nil)))}
                      "\u2715"])]
    [:> (.-Button mantine)
     (cond-> {:size "xs"
      :variant (if (or current today) "light" "default")
      :color (if today "accent" "gray")
      :disabled (not clickable?)
      :title title
      ;; MANTINE'S OWN `loading`, not a section of my own. A :leftSection widens
      ;; the button, which in a horizontal strip of dates shoves every neighbour
      ;; along — the defect George named in the chrome bar, third instance. Button
      ;; `loading` overlays a loader inside the EXISTING box and disables the
      ;; control, so the strip cannot move and a second click cannot queue a second
      ;; dispatch while the first is still out.
      :loading pending?
      :on-click (when clickable?
                  (fn [e]
                    (.preventDefault e)
                    (busy/clicked! session-id value)
                    (let [cmd (bind/fill-command submit {'$session-id session-id '$value value})]
                      (js-invoke bus "dispatch" cmd (fn [_] nil)))))}
       cross (assoc :rightSection (r/as-element cross)))
     label])))

(defn- node-value
  "Ensure a tree node value is a non-empty string.

   ONE RULE, HELD IN graph-ui.web.bind. Mantine keys a node by this, a fetched
   branch rejoins the tree by it, and the server answers to it. Three copies of
   it disagreed on 2026-09-20 and the sidebar could not open a branch."
  [value label]
  (bind/node-key {:value value :label label}))

(defn- active-row?
  "Is this row the highlighted one? The :tree kind's :active-value prop names it
   (dsl/contexts/ui.edn), and the row is found here.

   THE ROW USED TO CARRY THE ANSWER. ui.notes-web stamped :active into the item,
   which made the tree's DATA depend on the selection: one click re-read and
   re-shipped 890,091 bytes and 5,577 rows to move one highlight, measured
   2026-08-23 (PLAN-ikc-v3-019-01 phase 4). A row's own :active is still honoured
   for a tree that has no :active-value, so a description that names neither is
   unchanged.

   The comparison is on the NODE VALUE, the same rule items->tree-data uses, so
   it matches what Mantine holds."
  [{:keys [value label active]} active-value]
  (boolean (or active
               (and active-value
                    (= (str active-value) (node-value value label))))))

(defn- active-expand-values
  "The node values to expand so the highlighted item is on screen — every
   ancestor of it, plus the item itself when it has children (a session row
   expands to show its turns) — AND the active value itself, returned
   separately so the effect can key on it: two sibling turns share one
   ancestor path, and an effect keyed on the path alone did not follow the
   selection from one to the next (George, 2026-08-20: 'I clicked Next and
   nothing changed in the sidebar tree'). Uses the same node-value rule
   items->tree-data uses, so the values match what Mantine holds."
  [items active-value]
  (letfn [(walk [its path]
            (some (fn [{:keys [value label children] :as it}]
                    (let [v (node-value value label)]
                      (cond
                        (active-row? it active-value)
                        {:expand (if (seq children) (conj path v) path)
                         :active-value v}
                        (seq children) (walk children (conj path v))
                        :else nil)))
                  its))]
    (or (walk items []) {:expand [] :active-value nil})))

(defn rows-to-expand
  "Every node value that must be OPEN: the tree's own top-level rows, then the
   path to the highlighted item.

   A TOP-LEVEL ROW THAT HAS CHILDREN IS NEVER A CLOSED DOOR (2026-09-22). The
   tree of thought grew a root row of its own on 2026-09-21 — the tree's name,
   with every root thought under it (PLAN-ikc-v3-031-01 Q22) — and `useTree` is
   created with an EMPTY `initialExpandedState`. So on a plain reload, with
   nothing selected, that row drew as `+` and every thought in the tree was
   hidden behind it. Measured in a browser the same day.

   The research island's `Goal:` row has the same shape and had the same
   behaviour since 2026-09-12. This repairs both.

   IT IS NOT `expand everything`. Only the top level opens by itself. A branch
   deeper in stays as the reader left it, and the effect that applies this is
   keyed on the values, so a hand-collapsed row stays collapsed until the set
   itself changes."
  [items active-value]
  (let [{:keys [expand]} (active-expand-values items active-value)
        tops (for [{:keys [value label children]} items
                   :when (seq children)]
               (node-value value label))]
    (vec (distinct (concat tops expand)))))

(defn- items->tree-data
  "Recursive convert Meta-UI :items to Mantine TreeNodeData (JS). :icon/
   :accessory/:active/:dim (ADR-graph-ui-v0-013-01 §17) ride along as extra JS
   fields for mantine-tree-node to read back off the node.

   The highlight comes from `active-value` and not from the item — see
   active-row? for the measurement that moved it there.

   AND THE CURSOR IS A SECOND MARK (2026-09-10, George). With :open-mode :enter
   an arrow key moves a cursor and selects nothing, so the row a reader is ON
   and the row the SERVER says is selected are two different rows. They must
   look different or the keyboard is unreadable."
  ;; ── AND THE RAILS, FOR THE BOXED LOOK (2026-09-12) ──────────────────────
  ;;
  ;; George: "The tree drawing lines do not end vertically at a branch - they
  ;; continue down to the end of the area."
  ;;
  ;; A CORRECT TREE LINE NEEDS TO KNOW WHICH ANCESTORS STILL HAVE SIBLINGS.
  ;; Mantine gives a node its LEVEL and nothing more, so a row drew a line at
  ;; every level it was under — including the levels whose branch had already
  ;; ended. `rails` is one boolean per ancestor: true when that ancestor has a
  ;; later sibling, so its line goes on past this row. `last?` says the node is
  ;; the last of its own siblings, and its own line then stops at the tick
  ;; rather than running to the bottom of the row.
  ;;
  ;; IT IS COMPUTED WHERE THE CHILDREN ARE KNOWN, which is here and nowhere
  ;; else — the renderer sees one node at a time.
  ([items active-value cursor-value] (items->tree-data items active-value cursor-value []))
  ([items active-value cursor-value rails]
  (clj->js
    (for [[i {:keys [label value children icon accessory dim goto has-children
                     open-value open-label] :as it}]
          (map-indexed vector items)
          :let [last? (= i (dec (count items)))]]
      (cond-> {:value (node-value value label) :label (or label (node-value value label))
               :rails (clj->js rails)
               :last (boolean last?)}
        icon       (assoc :icon (name icon))
        accessory  (assoc :accessory accessory)
        ;; :goto — a MARK this row also points at. A footnote row carries the
        ;; mark's id, so its click goes back to the words as well as picking the
        ;; row (George, 2026-08-24: the number should carry a reader "to the note
        ;; and back"). Absent on every other row, which is every other tree.
        goto       (assoc :goto (str goto))
        ;; THE :open GESTURE'S CONTROL (IKC3/PLAN-ikc-v3-057-01/RA-2). The words
        ;; and the value ride on the node, as :accessory does.
        open-label (assoc :openLabel (str open-label)
                          :openValue (str open-value))
        (active-row? it active-value) (assoc :active true)
        (and cursor-value (not= cursor-value active-value)
             (active-row? it cursor-value)) (assoc :cursor true)
        dim        (assoc :dim true)
        (seq children) (assoc :children
                              (items->tree-data children active-value cursor-value
                                                ;; THIS node's own line goes on
                                                ;; below its children only when
                                                ;; it has a later sibling.
                                                (conj rails (not last?))))
        ;; A BRANCH THAT HAS CHILDREN AND DOES NOT CARRY THEM YET
        ;; (PLAN-ikc-v3-033-01 step 4c, Meta-UI v2.1's :has-children).
        ;;
        ;; Mantine draws a chevron only for a node that HAS children, so a
        ;; branch with none would look like a leaf and could never be opened.
        ;; One placeholder child gives it the chevron and gives a reader
        ;; something honest to look at while the real rows are fetched.
        ;;
        ;; STALL, NEVER VANISH. The placeholder says the rows are on their way.
        ;; An empty branch would say there are none, which is the one answer
        ;; nobody has yet.
        (and has-children (empty? children))
        (assoc :children
               (clj->js [{:value (str (node-value value label) "\u0000stalled")
                          :label "…"
                          :stalled true
                          :rails (clj->js (conj rails (not last?)))
                          :last true}])))))))

(def ^:private tree-row-height
  "A tree row's height in pixels — 20, measured on the live sidebar 2026-08-14
   (dev/measure_indent_and_tree.mjs). An open folder's own row parks at
   (level - 1) × this, so a folder open inside a folder stacks BELOW its parent
   instead of covering it.

   It is an estimate of something CSS knows exactly, and that is the cost of the
   effect: if a row's type size changes, a number too small overlaps the stuck
   headers and one too large leaves a gap between them. Stated here rather than
   inlined, so there is one place to correct."
  20)

(defn tree-sticky-style
  "The style that parks an OPEN folder's row at the top of the scrolling sidebar
   while its contents pass underneath — see `mantine-tree-node` for why sticky
   needs no scroll listener here.

   STRING KEYS, because Reagent passes string style keys through exactly as
   written: that is why `zIndex` is camelCase and the CSS property names are not.
   They merge over whatever Mantine's own getStyles gave the row.

   `top` stacks by level, so a folder open inside an open folder parks BELOW its
   parent rather than covering it. `zIndex` descends with level for the same
   reason from the other side — the shallower header has to paint over the deeper
   one sliding up beneath it. The background is opaque or the rows scrolling past
   read straight through the name.

   THE STACK IS A LAYER, and the layer is a token. This used to read `(max 1 (- 30
   level))` — a bare 30 chosen because it was above the content and below the
   scrim, which is precisely what `--layer-sticky` MEANS and was declared to mean,
   unread, since Phase 0. Now the token gives the floor and the level gives the
   descent within it, so a theme that restacks its layers restacks these too.

   Public for the unit test: the arithmetic is checkable without a browser, and
   whether Chrome really sticks the row is not (measured separately, in
   dev/measure_indent_and_tree.mjs).

   THE BACKGROUND IS THE SURFACE UNDER THE ROW, NOT A COLOUR OF ITS OWN
   (IKC3/PLAN-ikc-v3-081-01/TH). George's fault report 1b5eba8a, 2026-10-13,
   island tot: \"of the 6 items 5 are highlighted - it takes time and thinking
   to find out which is the current item.\" Each open row painted --panel. A
   dock pane is --body (ikc-base.css, --dv-group-view-background-color), and
   in several themes --panel is near --hover, the mark of the current row. The
   path to a selected thought is all open rows, so the path read as marked.
   dockview's own variable names the surface of the pane. Outside a dock it is
   not set, and the row falls back to --panel, the surface of a sidebar."
  [level]
  {"position"   "sticky"
   "top"        (str (* (dec level) tree-row-height) "px")
   "zIndex"     (str "calc(var(--layer-sticky) - " (dec level) ")")
   "background" "var(--dv-group-view-background-color, var(--panel))"})

(defn- card-row
  "A tree row drawn as ikc/reference-card — a fixed left column naming the page
   that referred here and a filling right column carrying what it said.

   The locked target's LINKED REFERENCES shape (SPEC-graph-ui-v0-003-01,
   `220px 1fr`), and the reason `:tree` gained `:row`: the DESCRIPTION says which
   shape a row is, rather than the renderer inferring it from an import-id, which
   is the sort of guess that is invisible until it guesses wrong."
  [label accessory]
  (let [cell (fn [k] (get-in reference-card [:draws :cells k]))]
    [:div {:style {:display "grid"
                   :gridTemplateColumns (tracks-css (get-in reference-card [:draws :tracks]))
                   :columnGap (token-var (get-in reference-card [:draws :gap]))
                   :alignItems "start" :width "100%"}}
     ;; NO `truncate`. The name is what a reader scans and what they click, so a
     ;; name too long for the track wraps to a second line rather than losing its
     ;; end — which is what the card did at 25ch, cutting the MEDIAN row of this
     ;; corpus (reference-card.edn carries the measurement).
     [:span {:style (cell-style (cell 'source)) :class "break-words"} (str label)]
     [:span {:style (cell-style (cell 'quote))} (str accessory)]]))

(declare scroll-to-highlight!)

(def ^:private guide-step
  "How wide ONE level of the boxed look is, in pixels.

   It is Mantine's own `levelOffset` for this tree, restated here because the
   boxed look draws the indent itself — one cell per level a row is under — and
   Mantine's padding is turned off. Two numbers that must agree, in one file."
  20)

(defn boxed-row-cells
  "PURE: the guide cells that stand before a row of the BOXED look.

   George, 2026-09-12, with a picture of Leo's own outline from 2005: I had in
   mind the look of this image, not the way Leo looks now — I do not like the
   subtle tree view of the current Leo and our ToT.

   `rails` is one boolean per ANCESTOR, outermost first: true when that ancestor
   has a later sibling, so its vertical line goes on past this row. `last?` says
   this node is the last of its own siblings.

   WHAT EACH CELL SAYS:

     :line?  a full-height vertical rule — the branch continues below
     :stop?  a rule that ends at the TICK — this row is the last of its branch,
             so the line must not go on down an empty column
     :tick?  the horizontal line into the row, on the innermost cell only

   IT WAS `level` ALONE UNTIL 2026-09-12, and that is the defect George
   reported: a row drew a line at every level it was under, including the levels
   whose branch had already ended, so the lines ran to the bottom of the area.
   Mantine gives a node its level and nothing else, so the answer had to be
   computed where the children are known — items->tree-data.

   `[{:line? :stop? :tick?} …]`, outermost first."
  [rails last?]
  (let [rails (vec rails)
        n     (count rails)]
    (if (zero? n)
      []
      (conj (vec (for [i (range (dec n))]
                   {:line? (boolean (nth rails i)) :stop? false :tick? false}))
            ;; THE INNERMOST CELL IS THIS ROW'S OWN. Its rule comes down from
            ;; the parent, so it is always drawn — the question is whether it
            ;; stops at the tick.
            {:line? (not last?) :stop? (boolean last?) :tick? true}))))

(defn boxed-toggle-glyph
  "PURE: what the pressable square of the boxed look says.

   Leo draws a plus on a closed branch, a minus on an open one, and NOTHING on
   a leaf — a leaf gets the line and no box, so the eye can tell at a distance
   which rows go deeper."
  [has-children? expanded?]
  (cond (not has-children?) nil
        expanded?           "−"
        :else               "+"))

(def ^:private guide-line "1px solid var(--border)")

(defn- boxed-guides
  "The hiccup for boxed-row-cells.

   THE CELLS ARE ADJACENT AND THE ROW'S GAP IS NOT BETWEEN THEM (2026-09-12).
   George measured about 25 pixels between the drawn branch and the item icon:
   the guide cells, the toggle and the mark were three flex children of the row,
   so the row's own gap broke the line three times and a leaf's empty toggle
   column added 13 more. They are one strip now, with no gap inside it."
  [rails last?]
  (for [[i {:keys [line? stop? tick?]}] (map-indexed vector (boxed-row-cells rails last?))]
    ^{:key i}
    [:span {:style {:width (str guide-step "px") :flex "0 0 auto"
                    :alignSelf "stretch" :position "relative"}}
     (when (or line? stop?)
       [:span {:style (cond-> {:position "absolute" :left "6px" :top 0
                               :borderLeft guide-line}
                        ;; A LINE THAT STOPS ends at the tick, which is the
                        ;; middle of the row. A line that goes on runs the
                        ;; whole height, and the next row picks it up.
                        stop? (assoc :height "50%")
                        line? (assoc :bottom 0))}])
     (when tick?
       ;; ALL THE WAY TO THE CELL'S EDGE, so the next thing the eye meets is
       ;; the square or the mark, with no gap in between.
       [:span {:style {:position "absolute" :left "7px" :top "50%" :right 0
                       :borderTop guide-line}}])]))

(defn- boxed-toggle
  "The square a person presses. 13 pixels, a real border, and the glyph centred.

   A LEAF KEEPS THE COLUMN so the labels of one branch start at one x, and the
   LINE RUNS ACROSS IT — which is what Leo draws and what closes the gap George
   measured."
  [has-children? expanded? toggle!]
  (if-let [glyph (boxed-toggle-glyph has-children? expanded?)]
    [:span {:on-click toggle!
            :style {:width "13px" :height "13px" :flex "0 0 auto"
                    :display "inline-flex" :alignItems "center" :justifyContent "center"
                    :border guide-line :background "var(--panel)"
                    :fontSize "11px" :lineHeight "11px" :color "var(--text)"
                    :cursor "pointer" :userSelect "none"}}
     glyph]
    [:span {:style {:width "13px" :flex "0 0 auto" :alignSelf "stretch"
                    :position "relative"}}
     [:span {:style {:position "absolute" :left 0 :right 0 :top "50%"
                     :borderTop guide-line}}]]))

(defn- boxed-mark
  "The kind, in a box of its own — Leo's little node rectangle.

   A row with no kind still gets the box, empty, for the same reason a leaf
   keeps the toggle's column: the labels line up."
  [icon-kw]
  [:span {:style {:width "16px" :height "16px" :flex "0 0 auto" :marginLeft "2px"
                  :display "inline-flex" :alignItems "center" :justifyContent "center"
                  :border guide-line :background "var(--field)"
                  :color "var(--muted)"}}
   (when icon-kw [widget-icon {:icon icon-kw :size :xs}])])




(def ^:private idle-branch-ms
  "How long the tree waits before it loads one more branch by itself.

   FIVE SECONDS, and George said so on 2026-09-19: a branch loads when it is
   needed, or after more than five idle seconds. The first half is the
   placeholder row, which asks as soon as a person opens a branch."
  5000)

(defn unloaded-branches
  "Every branch of `items` that says it has children and carries none, deepest
   last. PURE, so the timer above has nothing to decide."
  [items]
  (vec (mapcat (fn [it]
                 (cond
                   ;; bind/node-key, NOT :value — a partition row carries no
                   ;; value and the idle timer then asked for branch nil.
                   (and (:has-children it) (empty? (:children it))) [(bind/node-key it)]
                   (seq (:children it))                             (unloaded-branches (:children it))
                   :else                                            []))
               (or items []))))

(defn branch-args
  "The :args a branch read is made with, from the kind's declared
   :children-query (Meta-UI v2.1).

   :args is the base, :branch-arg names which key carries the branch's own
   :value, and $session-id is filled the way every other bind's args are. The
   default key is :branch, because that is what :reader-tree declares."
  [{:keys [args branch-arg]} branch session-id]
  (-> (or args {})
      (->> (reduce-kv (fn [m k v]
                        (assoc m k (if (= '$session-id v) session-id v)))
                      {}))
      (assoc (or branch-arg :branch) branch)))

(defn- stalled-branch-row
  "The row a branch draws while its children are read (PLAN-ikc-v3-033-01 4c).

   IT ASKS ON MOUNT, AND ONLY ON MOUNT. Mantine's Tree renders no child of a
   closed node, so this drawing IS the first opening of the branch.
   graph-ui.web.lazy records the pair and graph-ui.web.core reads it, which is
   the same path a bind with :load :on-visible takes — one mechanism, not two.

   IT ALSO ASKS AFTER FIVE IDLE SECONDS. George, 2026-09-19, asked for a branch
   to load when it is needed, or after more than five idle seconds. The tree
   sets that timer and not this row, because a row that has drawn was needed."
  [branch children-query session-id]
  (r/create-class
   {:display-name "stalled-branch-row"
    :component-did-mount
    (fn [_]
      (when (and branch (:source children-query))
        (lazy/want! (:source children-query)
                    (branch-args children-query branch session-id))))
    :reagent-render
    (fn [_ _ _]
      [:span {:class "ikc-stalled-branch"
              :data-stalled-branch (str branch)
              :style {:opacity 0.6 :fontStyle "italic"}}
       "…"])}))

(defn open-control
  "The control of a tree row's :open gesture (IKC3/PLAN-ikc-v3-057-01/RA-2),
   or nil.

   The node carries :openLabel and :openValue (items->tree-data). A row with
   no label, or a tree that does not wire :open, draws nothing. A row with a
   value draws the label as a control that sends the value as $value.

   A ROW WITH A LABEL AND NO VALUE DRAWS THE LABEL AS MUTED TEXT, in the same
   slot. The conversations island says there when the transcript comes. So
   the slot is in the row before and after the value arrives, and the label
   of the row stays where it is."
  [open-gesture bus session-id ^js node]
  (let [label (.-openLabel node)
        value (.-openValue node)]
    (cond
      (or (nil? open-gesture) (str/blank? (str label)))
      nil

      (str/blank? (str value))
      [:span {:data-tree-open-pending ""
              :class "ml-1 shrink-0 leading-none px-1 text-xs italic text-[var(--faint)]"}
       (str label)]

      :else
      [:span {:role "button"
              :data-tree-open (str value)
              :title (str label)
              :class (str "ml-1 shrink-0 cursor-pointer leading-none px-1 text-xs "
                          "text-[var(--faint)] hover:text-[var(--accent)]")
              :on-click (fn [e]
                          (.stopPropagation e)
                          (when bus
                            (js-invoke bus "dispatch"
                                       (bind/fill-command open-gesture
                                                          {'$session-id session-id
                                                           '$value      (str value)})
                                       (fn [_] nil))))}
       (str label)])))

(defn- mantine-tree-node
  "renderNode for Mantine Tree: chevron toggles folders, label dispatches
   values. `submit` is the resolved :submit template (submit-template) —
   :on-gesture's :submit key under v2.0, :on-submit under v1.x.

   AN OPEN FOLDER'S NAME STAYS IN VIEW WHILE ITS CONTENTS SCROLL PAST IT.
   George, 2026-08-14: *\"when I scroll in the sidebar, for example expanded
   foam-home, if it goes up, the list hangs below ALL NOTES and local context is
   lost … stop it right below it.\"* A folder with 1483 pages in it is taller
   than the sidebar several times over, so scrolling into it loses the one thing
   that says which folder you are in.

   `position: sticky` is exactly right here and needs no scroll listener,
   because of how Mantine builds the tree: a node is an `<li>` holding its own
   row AND the `<ul>` of its children (TreeNode.mjs), so the row's containing
   block already spans its whole subtree. The row sticks to the top of the
   scrolling viewport for as long as its own contents are on screen and lets go
   when the subtree ends — which is what a section header should do. The
   viewport's top edge is directly under the collapsible's title, so it stops
   right below ALL NOTES, the second of the two placements George offered.

   Only OPEN parents stick. A closed folder has nothing scrolling under it, and
   a leaf is not a header."
  [submit bus session-id row-shape remove-gesture look on-context children-query
   open-gesture]
  (fn [^js payload]
    (let [^js node     (.-node payload)
          ^js tree     (.-tree payload)
          has-children? (.-hasChildren payload)
          expanded?     (boolean (.-expanded payload))
          level         (or (.-level payload) 1)      ; 1-based, from TreeNode
          sticky?       (and has-children? expanded?)
          boxed?        (= :boxed look)
          value         (.-value node)
          label         (.-label node)
          icon-kw       (some-> (.-icon node) keyword)
          accessory     (.-accessory node)
          active?       (boolean (.-active node))
          cursor?       (boolean (.-cursor node))
          dim?          (boolean (.-dim node))
          ;; A PLACEHOLDER ROW OF A BRANCH WHOSE CHILDREN ARE NOT HERE YET
          ;; (PLAN-ikc-v3-033-01 step 4c). It draws only when a person opens
          ;; the branch, because Mantine's Tree renders no child of a closed
          ;; node — measured, not assumed, and pinned by
          ;; a-collapsed-branch-does-not-render-its-children.
          stalled?      (boolean (.-stalled node))
          props         (js->clj (.-elementProps payload))
          clickable?    (boolean (and submit bus value))
          toggle!       (fn [e]
                          (.stopPropagation e)
                          (when tree (.toggleExpanded tree value)))
          ;; THE BRANCH THIS PLACEHOLDER STANDS FOR. Its value is the parent's
          ;; own, with the marker this file appended when it made the row.
          branch        (when stalled?
                          (first (str/split (str value) #"\u0000")))
          ;; ── A CLICK GIVES THE TREE ITS KEYBOARD (2026-09-12) ──────────
          ;;
          ;; George: keyboard navigation on the ToT tree is not working in
          ;; `instantly`. MEASURED: after a real mouse click, focus was on the
          ;; row's <li> at +200ms and on BODY at +1700ms — the row is replaced
          ;; by the re-render the click causes, and focus falls off it. An
          ;; arrow key then reaches nothing, in either mode.
          ;;
          ;; IT IS DEFERRED ON PURPOSE. Called inside the handler it runs
          ;; BEFORE that re-render, and the same replacement drops it again. A
          ;; timeout of zero puts it after.
          ;;
          ;; AND IT IS CALLED FROM BOTH HANDLERS. The label cell stops
          ;; propagation — it has to, or a click would also toggle the branch —
          ;; so the row's own onClick never sees a click on the words, which is
          ;; where a person clicks.
          take-keys!    (fn [e]
                          (when-let [el (some-> (.-currentTarget e)
                                                (.closest "[data-ikc-tree-keys]"))]
                            (js/setTimeout #(.focus el) 0)))
          dispatch!     (fn [e]
                          (.stopPropagation e)
                          (when clickable?
                            ;; BEFORE the dispatch, so the acknowledgement paints on
                            ;; the next frame instead of after the first round trip
                            ;; — the whole point being that the round trip is the
                            ;; part the reader is waiting through.
                            (busy/clicked! session-id value)
                            (let [cmd (bind/fill-command submit {'$session-id session-id '$value value})]
                              (js-invoke bus "dispatch" cmd (fn [_] nil)))))
          root-props    (-> props
                            (dissoc "onClick")
                            ;; THE ROW SAYS WHAT IT IS, so something else can
                            ;; reach it (2026-08-24). A footnote number in the
                            ;; transcript scrolls to its own row here, and the
                            ;; only way to find one row among many is an
                            ;; attribute carrying its value.
                            (assoc "data-row-value" (str value))
                            ;; ── THE RIGHT-CLICK MENU (2026-09-12) ──────────
                            ;;
                            ;; George: there is no context menu over a tree
                            ;; item. The ROW reports where and on what; the
                            ;; widget owns the menu, because only it holds the
                            ;; items a gesture template reads.
                            (cond-> on-context
                              (assoc "onContextMenu"
                                     (fn [e]
                                       (.preventDefault e)
                                       (.stopPropagation e)
                                       (on-context (.-clientX e) (.-clientY e) (str value)))))
                            (assoc "onClick" (fn [e]
                                               (when clickable? (dispatch! e))
                                               ;; AND BACK TO THE WORDS, when the
                                               ;; row names a place (:goto, the
                                               ;; mark's id). George, 2026-08-24:
                                               ;; a footnote number should carry
                                               ;; a reader "to the note and back".
                                               ;; The number goes one way; this is
                                               ;; the other, and it is the same
                                               ;; scroll the gutter has always
                                               ;; done.
                                               (when-let [g (.-goto node)]
                                                 (scroll-to-highlight! g))
                                               ;; ── AND THE TREE TAKES THE
                                               ;; KEYBOARD (2026-09-12) ───────
                                               ;;
                                               ;; George: keyboard navigation on
                                               ;; the ToT tree is not working in
                                               ;; `instantly`.
                                               ;;
                                               ;; MEASURED: after a real mouse
                                               ;; click on a row,
                                               ;; document.activeElement was
                                               ;; BODY — so an arrow key reached
                                               ;; nothing. The handler lives on
                                               ;; the wrapper this row is
                                               ;; inside, and the wrapper was
                                               ;; focusable and never focused.
                                               ;; A click IS how a person starts
                                               ;; to walk a tree.
                                               (take-keys! e)
                                               (when has-children? (toggle! e))))
                            ;; A ROW, not a run of inline spans. The accessory
                            ;; asks to be pushed to the right edge (ml-auto),
                            ;; which does nothing unless this node is the flex
                            ;; container — so a page title and the sentence
                            ;; beside it rendered as one word with no space
                            ;; between them (linked references, 2026-08-03).
                            (update "className" #(str % " flex items-center w-full"
                                                       (if boxed? " gap-1" " gap-2")
                                                       (when active? " bg-[var(--hover)]")
                                                       ;; THE CURSOR, when it is not the
                                                       ;; selection: a ring rather than a
                                                       ;; wash, so a reader can tell "where
                                                       ;; I am" from "what is open".
                                                       (when cursor? " ring-2")
                                                       (when dim? " ikc-dim")))
                            (cond-> active? (assoc "data-ikc-active" "1"))
                            (cond-> cursor? (assoc "data-ikc-cursor" "1"))
                            ;; Merged OVER whatever getStyles gave the label
                            ;; rather than replacing it.
                            ;;
                            ;; EVERY row gets a positioning context, because
                            ;; row-hourglass is absolute at the row's right edge and
                            ;; must anchor to THIS row rather than to whatever
                            ;; ancestor happens to be positioned (the scrolling sidebar
                            ;; — which would park one ring at the sidebar's edge instead
                            ;; of on the clicked line). `sticky` already establishes
                            ;; one, so it wins where it applies and `relative` fills
                            ;; in everywhere else; setting `relative` unconditionally
                            ;; would silently un-stick every open folder header.
                            (assoc "style" (merge (get props "style")
                                                  ;; THE MARK WINS ON THE ROW IT IS ON.
                                                  ;; The sticky style is INLINE, and an
                                                  ;; inline background beats the class
                                                  ;; bg-[var(--hover)]. So an open row
                                                  ;; that is also the current thought
                                                  ;; paints the mark inline, and its open
                                                  ;; ancestors paint the surface
                                                  ;; (review of PR #250, T-web-widgets-132).
                                                  (if sticky?
                                                    (cond-> (tree-sticky-style level)
                                                      active? (assoc "background" "var(--hover)"))
                                                    {"position" "relative"})
                                                  ;; THE BOXED LOOK DRAWS ITS OWN
                                                  ;; INDENT, one cell per level, so
                                                  ;; Mantine's padding would count
                                                  ;; every level twice.
                                                  (when boxed?
                                                    {"paddingInlineStart" "0px"
                                                     "minHeight" "22px"}))))]
      (r/as-element
        (cond
          ;; ── A BRANCH WHOSE ROWS ARE ON THEIR WAY (step 4c) ─────────────
          ;;
          ;; It draws ONLY when a person opens the branch, because Mantine's
          ;; Tree renders no child of a closed node. So this mount is the first
          ;; visibility, and it is where the branch is asked for.
          ;;
          ;; STALL, NEVER VANISH. The row says the children are coming. An
          ;; empty branch would say there are none, which is the one answer
          ;; nobody has yet.
          stalled?
          [stalled-branch-row branch children-query session-id]

          (and (= :card row-shape) (not has-children?))
          [:span (assoc root-props "className"
                        (str (get root-props "className") " w-full"))
           [card-row label accessory]
           ;; The card shape returns early, so it needs the acknowledgement said
           ;; again rather than inherited — a leaf drawn as a card is exactly the
           ;; kind of row a reader clicks to open something.
           [row-hourglass session-id value]]

          :else
          [:span root-props
         ;; ── HOW MUCH OF THE STRUCTURE THE ROW DRAWS ──────────────────────
         ;;
         ;; George, 2026-09-12, with a picture of Leo's own outline from 2005:
         ;; I had in mind the look of this image, not the way Leo looks now — I
         ;; do not like the subtle tree view of the current Leo and our ToT.
         ;;
         ;; :boxed says the structure OUT LOUD — a square you press, a line down
         ;; every level the row is under, a tick into the row, and the kind in a
         ;; box of its own. :plain is the chevron every tree has drawn, and it
         ;; is still the default, so the sidebar's 3,470 pages do not gain a
         ;; grid of faint lines nobody asked for.
         (if boxed?
           ;; ONE STRIP, AND THE ROW'S GAP IS OUTSIDE IT. George measured about
           ;; 25 pixels between the drawn branch and the item icon: the cells
           ;; were three flex children of the row, so the gap broke the line
           ;; three times.
           [:span {:style {:display "inline-flex" :alignItems "center"
                           :alignSelf "stretch" :flex "0 0 auto"}}
            (boxed-guides (array-seq (or (.-rails node) #js [])) (boolean (.-last node)))
            (boxed-toggle has-children? expanded? toggle!)
            (boxed-mark icon-kw)]
           [:<>
            (when has-children?
              [:span {:class "mr-1 cursor-pointer text-[var(--faint)] hover:text-[var(--text)]"
                      :on-click toggle!}
               (if expanded? "▾" "▸")])
            (when icon-kw [:span {:class "mr-1 inline-flex"} [widget-icon {:icon icon-kw :size :sm}]])])
         ;; DRAWN FROM ikc/sidebar-item — the most repeated component in the product,
         ;; 2144 of them one scroll away, and its treatment was a literal here.
         ;; THE NAME CELL FILLS AND SHRINKS, because that is what its own
         ;; declaration says: dsl/design/sidebar-item.edn tracks it as
         ;; {:cell name :width :fill}. It carried `shrink-0`, which is the
         ;; opposite, and the consequence was measured in a browser on
         ;; 2026-09-09 — a 97-character thought's span was 569px wide inside a
         ;; 302px pane, right edge at 877px against the pane's 581px, with
         ;; scrollWidth 598 over clientWidth 302 and NO scrollbar offered. So
         ;; 296px of one line was simply invisible, cut mid-word. George: "I
         ;; cannot read current answers... lines do not wrap, there is no
         ;; horisontal scroll".
         ;;
         ;; `truncate` IS THE HALF ONLY THE BROWSER CAN DO. ui.research/headline
         ;; caps the DATA at a quantity the source decides, so a 2,000-character
         ;; answer does not ship 2,000 characters to a row; the width of the pane
         ;; is known here and nowhere else, so the ellipsis that fits it is CSS's.
         ;; Both halves are needed and neither replaces the other.
         [:span {:style (cell-style (get-in sidebar-item [:draws :cells 'name]))
                 :class (str "flex-1 min-w-0 truncate "
                             (when clickable? "cursor-pointer hover:text-[var(--accent)]"))
                 :on-click (fn [e]
                             (.stopPropagation e)
                             (take-keys! e)
                             (when clickable? (dispatch! e)))}
          (str label)]
         ;; min-w-0 is what lets truncate work inside a flex row: without it a
         ;; long accessory refuses to shrink and widens the whole tree instead.
         (when accessory
           [:span {:style (cell-style (get-in sidebar-item [:draws :cells 'accessory]))
                   :class "ml-auto min-w-0 truncate"} accessory])
         ;; THE SECOND ACT OF A ROW, the :open gesture
         ;; (IKC3/PLAN-ikc-v3-057-01/RA-2). The conversations island draws
         ;; "Transcript" here, and the press opens the full transcript of the
         ;; session. The row's own click does something else, so the press
         ;; stops propagation.
         ;;
         ;; ALWAYS DRAWN, NEVER ON HOVER, as the remove control below: a
         ;; control that appears on hover moves the row it is in.
         (open-control open-gesture bus session-id node)
         ;; THE WAY BACK OUT, on the rows of a tree that wires :remove — today
         ;; only the sidebar's PINNED section (George, 2026-09-10: the pinned
         ;; items "do not have unpin icon or means").
         ;;
         ;; ALWAYS DRAWN, NEVER ON HOVER. A control that appears on hover moves
         ;; the row it is in, and this project has already refused one twice:
         ;; the outline's hover strip went on 2026-08-13 at George's word, and
         ;; the island picker's new-tab link has "a reserved slot instead".
         ;;
         ;; ONLY A ROW THAT NAMES SOMETHING. A branch has children and no frame
         ;; to unpin, so it gets nothing rather than a control that would refuse.
         ;;
         ;; stopPropagation, or the press would also OPEN the page it is
         ;; removing — the row's own click is one span to the left.
         ;;
         ;; "Remove", NOT "Unpin" (2026-09-17). :tree is universal, and Pinned
         ;; was its first caller — so the caller's own verb went into the widget.
         ;; The sidebar's tag chip is the second caller, and "Unpin
         ;; #aiassisteddev" is false there. A universal kind must not name one
         ;; caller's domain.
         (when (and remove-gesture bus value (not has-children?))
           [:span {:role "button"
                   :aria-label (str "Remove " (str label))
                   :title (str "Remove " (str label))
                   :class (str "ml-1 shrink-0 cursor-pointer leading-none px-1 "
                               "text-[var(--faint)] hover:text-[var(--danger)]")
                   :on-click (fn [e]
                               (.stopPropagation e)
                               (let [cmd (bind/fill-command
                                           remove-gesture
                                           {'$session-id session-id '$value value})]
                                 (js-invoke bus "dispatch" cmd (fn [_] nil))))}
            "\u2715"])
         ;; LAST, and its own component — see row-hourglass. This is the
         ;; acknowledgement George asked for on 2026-08-17: a page click costs a
         ;; dispatch plus one :ui/read per pane source, and until now the row gave
         ;; back nothing at all while that ran.
         [row-hourglass session-id value]])))))

(defn- item-by-value
  "The item whose node value is `v`, anywhere in `items` — the row the keyboard
   acts on. The same node-value rule items->tree-data uses, so the match is
   the one Mantine holds."
  [items v]
  (some (fn [it]
          (let [it (normalize-item it)]
            (if (= (str v) (node-value (:value it) (:label it)))
              it
              (item-by-value (:children it) v))))
        items))

(def ^:private kind-keys
  "One letter, one kind — RESEARCH-ikc-v3-021-01 D8, Leo's own habit of a key
   per node type. The six kinds of a thought, first letters, no two alike."
  {"q" :question "h" :hypothesis "b" :belief "f" :fact "o" :observation "d" :decision})

(def ^:private nav-keys
  "The keys that move the CURSOR, and the step each one means. No modifier: the
   Alt versions are the :move gesture, which reorders a node among its siblings,
   and the two must not be confused (RESEARCH-ikc-v3-021-01 D8, Leo's habit)."
  {"ArrowDown" :down "ArrowUp" :up "Home" :first "End" :last})

(defn next-value
  "PURE: the row a cursor step lands on — given the values a reader can SEE, in
   the order they see them, the value the cursor is on, and the step.

   nil for an empty tree. A step from nowhere lands on the first row, which is
   what a reader means by a first Down."
  [vals current step]
  (when (seq vals)
    (let [v (vec vals)
          n (count v)
          i (or (first (keep-indexed (fn [i x] (when (= x current) i)) v)) -1)]
      (case step
        :first (nth v 0)
        :last  (nth v (dec n))
        :down  (nth v (min (inc i) (dec n)))
        :up    (if (neg? i) (nth v 0) (nth v (max 0 (dec i))))
        nil))))

(defn- visible-values
  "The values of the rows the tree is DRAWING, in the order a reader sees them.

   READ FROM THE DOM, and that is the honest place. Which rows are visible
   depends on Mantine's own expanded state, which nothing in the description
   knows and no source can answer. widget-tree already reads the DOM to scroll
   the selection into sight, for the same reason."
  [^js el]
  (when el
    (->> (.querySelectorAll el "[data-row-value]")
         (array-seq)
         (mapv #(.getAttribute % "data-row-value")))))

(defn edit-field-element
  "The <input> of the box a :tree's :edit-field names, or nil. An expanded
   description names a node after its island (\"tree/note-tree-headline\"),
   so the name matches the whole id or its last segment."
  [import-id]
  (some-> js/document
          (.querySelector (str "[data-import-id=\"" import-id "\"], [data-import-id$=\"/" import-id "\"]"))
          (as-> el (if (= "INPUT" (.-tagName el)) el (.querySelector el "input")))))

(defn- edit-in-field!
  "Move the keyboard to `field` with its words selected, as F2 does in an
   outliner. Esc gives the keyboard back to the tree, and so does Enter after
   the box sent its command — Leo's own habit after a headline edit."
  [^js field ^js tree-el]
  (.focus field)
  (.select field)
  (letfn [(back! [] (when tree-el (.focus tree-el)))
          (on-key [^js ev]
            (case (.-key ev)
              "Escape" (do (.preventDefault ev) (done!) (back!))
              "Enter"  (do (done!) (js/setTimeout back! 0))
              nil))
          (done! []
            (.removeEventListener field "keydown" on-key)
            (.removeEventListener field "blur" done!))]
    (.addEventListener field "keydown" on-key)
    (.addEventListener field "blur" done!)))

(defn tree-key-gesture
  "PURE: which :on-gesture key a keyboard event fires on a :tree, and what it
   adds to $value — or nil when the key is not one of the six (Meta-UI v2.1,
   dsl/contexts/ui.edn :tree).

     Enter            :insert
     Tab / Shift-Tab  :indent / :outdent
     Alt-Shift-Right, Alt-Shift-Left  :indent / :outdent (Leo's own keys)
     F2               :edit-field — the keyboard goes to the box :edit-field names
     Alt-Up, Alt-Down :move   with :direction :up / :down
     Alt-Home, Alt-End :move  with :direction :first / :last
     q h b f o d      :set-kind with :kind
     a                :delegate  (ask)

   THREE MORE SINCE 2026-09-10 (George: keyboard navigation over the tree of
   thought, with instant show of the content of the current item).

     ArrowUp/Down, Home/End   :cursor with :step — MOVE, and select only when
                              :open-mode is :instant
     Enter                    :open — the row the cursor is on
     Insert                   :insert — the sibling Enter used to add

   ENTER CHANGED HANDS, AND IT COST NOTHING. Enter added a sibling before this,
   and that had NEVER worked from a browser: :tree-of-thought/branch-thought
   declared no :payload, so the row's id arrived as a string and the handler
   answered :frame-not-found every time (measured on the wire, 2026-09-10). Enter
   cannot mean both open and insert, so insert moved to Insert — which is Leo's
   own key for it.

   PLAIN ARROWS SENT NOTHING AT ALL BEFORE THIS. Measured: a row selected, then
   Down, Down, Up — no command left the browser, and Mantine did not move its
   own focus either.

   A key with Ctrl or Meta is the browser's, never ours."
  [^js e]
  (let [k     (.-key e)
        alt?  (boolean (.-altKey e))
        shift? (boolean (.-shiftKey e))
        ctrl? (boolean (or (.-ctrlKey e) (.-metaKey e)))]
    (cond
      ctrl?                        nil
      ;; F2 IS THE RENAME KEY of most outliners and file managers
      ;; (IKC3/PLAN-ikc-v3-076-01/TREE). Leo's own key is Ctrl+H, which is the
      ;; browser's history. It sends no command: it moves the keyboard to the
      ;; box the description names in :edit-field.
      (= k "F2")                   [:edit-field {}]
      (= k "Insert")               [:insert {}]
      (= k "Enter")                [:open {}]
      (and (= k "Tab") shift?)     [:outdent {}]
      (= k "Tab")                  [:indent {}]
      ;; LEO'S OWN MOVE-OUTLINE KEYS (IKC3/PLAN-ikc-v3-076-01/TREE). Leo binds
      ;; Alt+Shift+Left and Alt+Shift+Right to move-outline-left and -right:
      ;; out and in. Alt+Shift+Up and Down are its move up and down, and the
      ;; Alt-arrow lines below already give those.
      (and alt? shift? (= k "ArrowRight")) [:indent {}]
      (and alt? shift? (= k "ArrowLeft"))  [:outdent {}]
      (and alt? (= k "ArrowUp"))   [:move {:direction :up}]
      (and alt? (= k "ArrowDown")) [:move {:direction :down}]
      (and alt? (= k "Home"))      [:move {:direction :first}]
      (and alt? (= k "End"))       [:move {:direction :last}]
      (and (not alt?) (contains? nav-keys k)) [:cursor {:step (nav-keys k)}]
      (and (not alt?) (contains? kind-keys k)) [:set-kind {:kind (kind-keys k)}]
      (and (not alt?) (= k "a"))   [:delegate {}]
      :else nil)))

(defn tree-key-handler
  "The keydown handler of a :tree: the six gestures of Meta-UI v2.1, each fired
   only when the description declares it AND a row is selected. $value is the
   SELECTED ITEM'S MAP plus what the key adds (:direction, :kind), so a
   template reads a field with [:of $value parent-id] (bind/fill-command).

   THE ROW IS THE ONE :active-value NAMES. The selection is the source's, not
   the widget's, so a key acts on what the server says is selected — the same
   row the highlight is on — and never on a row the widget alone remembers.
   A key with no declared gesture, or with no selected row, is left to the
   browser and to Mantine's own tree navigation.

   ── AND THE ROW IS THE CURSOR'S, WHEN A CURSOR HAS MOVED (2026-09-10) ──────

   :cursor and :open are the kind's OWN navigation and name no command in a
   description. An arrow moves the cursor. Whether that also OPENS the row is
   :open-mode's answer, and it is bindable, because it is the reader's choice:

     :instant  every move fires the :submit this kind already declares, so the
               pane below shows the row's content as the reader walks it
     :enter    a move draws the cursor and sends nothing. Enter opens it.

   THE DECLARED GESTURES ACT ON THE CURSOR TOO. A reader who walks to a row in
   :enter mode and presses a kind letter means THAT row, not the one still
   open — which is the whole point of a cursor."
  [props bus session-id items selected cursor]
  (fn [^js e]
    (when-let [[gesture extras] (tree-key-gesture e)]
      (let [at       (or @cursor selected)
            instant? (= :instant (:open-mode props))
            open!    (fn [v]
                       (when-let [template (bind/gesture-template props :submit)]
                         (when (and v bus (item-by-value items v))
                           ;; $value is the row's VALUE for :submit, exactly as
                           ;; a click sends it (mantine-tree-node). A clone's
                           ;; `<id>@<parent>` therefore still names one thought.
                           (busy/clicked! session-id v)
                           (js-invoke bus "dispatch"
                                      (bind/fill-command template {'$session-id session-id
                                                                   '$value v})
                                      (fn [_] nil)))))]
        (case gesture
          :cursor
          (when-let [to (next-value (visible-values (.-currentTarget e)) at (:step extras))]
            (.preventDefault e)
            (.stopPropagation e)
            (reset! cursor to)
            ;; ── AND THE ROW YOU WALK TO STAYS IN SIGHT (2026-09-12) ────────
            ;;
            ;; George: "I can navigate down out of the visible area - it does
            ;; not scroll the current item to keep it in sight."
            ;;
            ;; THE SELECTION ALREADY SCROLLED and the CURSOR did not. widget-
            ;; tree's own effect watches :active-value, which :enter mode never
            ;; moves — so walking a tree with Enter-to-open left the reader
            ;; below the fold with nothing to see.
            ;;
            ;; AND IT IS DEFERRED, for the reason the focus call is (2026-09-12).
            ;; George, after the first attempt: "The tree items current
            ;; positions still goes out of view, it is longer than the area in
            ;; Thyroid project." Run inside the handler it scrolls a row that
            ;; the render this keypress causes then REPLACES, and the new row is
            ;; wherever the container had it. A timeout of zero puts it after,
            ;; and the element is looked up THERE rather than captured here.
            (let [host (.-currentTarget e)]
              (js/setTimeout
                (fn []
                  (some-> host
                          (.querySelector (str "[data-row-value=\"" to "\"]"))
                          (.scrollIntoView #js {:block "nearest"})))
                0))
            (when instant? (open! to)))

          :open
          (when at
            (.preventDefault e)
            (.stopPropagation e)
            (open! at))

          :edit-field
          (when-let [field (some-> (:edit-field props) edit-field-element)]
            (.preventDefault e)
            (.stopPropagation e)
            (edit-in-field! field (.-currentTarget e)))

          (when-let [template (bind/gesture-template props gesture)]
            (when-let [item (and (some? at) bus (item-by-value items at))]
              (.preventDefault e)
              (.stopPropagation e)
              (let [cmd (bind/fill-command template {'$session-id session-id
                                                     '$value      (merge item extras)})]
                (js-invoke bus "dispatch" cmd (fn [_] nil))))))))))

(defonce ^{:doc "WHERE A TREE OFFERS ITS REVEAL to the section that holds it
  (George, 2026-09-28: \"Put on 'ALL VAULTS' before the chip with the count an
  icon that will expand the tree so it shows the currently opened item in the
  reading pane\").

  A React context and not a prop, because a section header takes only :title,
  :count and :icon in the hash-locked v2.0 vocabulary, and reader-v2 is pinned
  there. widget-collapsible provides an r/atom, and a tree inside it writes its
  reveal function into it. The header draws the icon while the atom holds one.
  So no description changes, and a section with no such tree draws no icon."}
  reveal-context
  (react/createContext nil))

(defn reveal-wants
  "PURE. The branch keys of `path` whose rows the client does not hold yet: a
   key with no row in `items`, or a row with no children. These are the
   branches a reveal must ask for. `path` is the :reveal answer of the source,
   the shallowest first."
  [items path]
  (let [loaded (letfn [(walk [its]
                         (mapcat (fn [it]
                                   (when (seq (:children it))
                                     (cons (bind/node-key it) (walk (:children it)))))
                                 its))]
                 (set (walk items)))]
    (vec (remove loaded path))))

(defn reveal?
  "PURE. Must the tree open the path to the highlighted row, and scroll to it?

   ONLY WHEN THE SELECTION IS NEW. The reveal ran whenever the rows changed, and
   the rows change every time a branch arrives — a person's own opening, or the
   idle loader's tick every five seconds. A branch that held the open page
   then opened itself and the view moved to it, away from the branch the person
   had just opened (George, 2026-09-25). `revealed` is the selection this tree
   last revealed, and a selection is revealed once."
  [revealed active-value]
  (boolean (and active-value (not= revealed active-value))))

(defn reveal-key
  "PURE. What a reveal is ONCE FOR: the highlighted row AND the path down to
   it, as one string, or nil with no highlighted row.

   THE VALUE ALONE WAS NOT ENOUGH (IKC3/PLAN-ikc-v3-076-01/TREE). Tab in the
   note tree moves the selected note under the note before it. The row keeps
   its value, so the old key said the selection was revealed already, and the
   new parent stayed closed: the note a person had just moved was out of view.
   A new path is a new place, and a new place is revealed once, as a new
   selection is. A branch that only arrives does not change the path of a row
   already drawn, so the idle loader still opens nothing by itself."
  [items active-value]
  (let [{:keys [expand] v :active-value} (active-expand-values items active-value)]
    (when v (str v "|" (str/join ">" expand)))))

(defn- tree-idle-loader
  "A BRANCH ALSO LOADS WHEN THE TREE HAS BEEN IDLE (George, 2026-09-19). The
   placeholder row asks the moment a person opens a branch. This asks for one
   unloaded branch per tick, newest first. A STABLE component (see tree-host),
   so its timer is not torn down and set again on every render."
  [{:keys [children-query items session-id]}]
  (let [latest (react/useRef nil)]
    (set! (.-current latest) {:cq children-query :items items :sid session-id})
    (react/useEffect
     (fn []
       (let [t (js/setInterval
                (fn []
                  (let [{:keys [cq items sid]} (.-current latest)]
                    (when-let [b (first (unloaded-branches items))]
                      (lazy/want! (:source cq) (branch-args cq b sid)))))
                idle-branch-ms)]
         (fn [] (js/clearInterval t))))
     #js [])
    nil))

(defn- tree-host
  "Mantine's Tree and the useTree that holds which branches are open.

   ONE COMPONENT FOR THE LIFE OF THE TREE. useTree keeps the open branches, and
   Mantine keeps them across new data: its `initialize` reads the current state
   for every value it already knows. So the state survives new rows only when
   this component is not replaced, which is why it is a named function and not
   an inline one."
  [{:keys [data tops to-expand active-value reveal-at keys-el render-node reveal-spec]}]
  (let [tree     ((.-useTree mantine) #js {:initialExpandedState #js {}})
        revealed (react/useRef nil)
        ;; THE REVEAL THE SECTION HEADER ASKS FOR (reveal-context). `latest`
        ;; holds this render's rows and props for the function the header
        ;; calls, and `pending` holds the way down while its branches arrive.
        slot     (react/useContext reveal-context)
        latest   (react/useRef nil)
        pending  (react/useRef nil)]
    (set! (.-current latest) {:spec reveal-spec :active-value active-value :tree tree})
    ;; OFFER THE REVEAL while this tree is on the screen. Only a tree that loads
    ;; its branches and highlights a row can say where the open page is.
    (react/useEffect
     (fn []
       (let [{:keys [bus children-query]} reveal-spec
             offer (fn []
                     (let [{{:keys [bus session-id children-query selected]} :spec}
                           (.-current latest)
                           src  (:source children-query)
                           arg  (or (:branch-arg children-query) :branch)
                           args (-> (branch-args children-query nil session-id)
                                    (dissoc arg)
                                    (assoc :reveal (str selected)))]
                       (when (and bus src (some? selected))
                         (js-invoke bus "dispatch"
                                    {:type :ui/read-many :reads [{:source src :args args}]}
                                    (fn [result]
                                      (let [path (when-not (bind/reply-failed? result)
                                                   (first result))]
                                        (when (and (sequential? path)
                                                   (not (bind/reply-failed? path)))
                                          (let [items (get-in (.-current latest) [:spec :items])]
                                            (doseq [k (reveal-wants items path)]
                                              (lazy/want! src (branch-args children-query k session-id))))
                                          (set! (.-current revealed) nil)
                                          (set! (.-current pending)
                                                {:path (vec path) :until (+ (js/Date.now) 20000)})
                                          ;; A render, so the effect below runs now
                                          ;; even when every branch is loaded already.
                                          (let [t (:tree (.-current latest))]
                                            (doseq [k path] (.expand t k))))))))))]
         (when (and slot bus (:source children-query))
           (reset! slot offer))
         (fn [] (when (and slot (= offer @slot)) (reset! slot nil)))))
     #js [])
    ;; APPLY A PENDING REVEAL after each render, until the row is drawn. A
    ;; branch that arrives re-renders this tree, and Mantine keeps an open
    ;; state only for the values its data holds, so each key is opened again
    ;; when its row exists. Twenty seconds and then it stops.
    (react/useEffect
     (fn []
       (when-let [{:keys [path until]} (.-current pending)]
         (if (> (js/Date.now) until)
           (set! (.-current pending) nil)
           (let [items (get-in (.-current latest) [:spec :items])]
             (doseq [k path] (.expand tree k))
             (when (and active-value (empty? (reveal-wants items path)))
               (set! (.-current pending) nil)
               (set! (.-current revealed) reveal-at)
               (js/setTimeout
                (fn []
                  (some-> (or @keys-el js/document)
                          (.querySelector "[data-ikc-active=\"1\"]")
                          (.scrollIntoView #js {:block "center"})))
                120)))))
       js/undefined))
    ;; THE TOP LEVEL OPENS BY ITSELF — see rows-to-expand. Keyed on the rows to
    ;; open, so a branch the reader closed stays closed until that set changes.
    (react/useEffect
     ;; THE TOP LEVEL ONLY. The selection's path opens in the reveal below,
     ;; once. Opening it here, on every change of the rows, opened a branch by
     ;; itself each time the idle loader brought the one that held the page.
     (fn []
       (doseq [v tops] (.expand tree v))
       js/undefined)
     #js [(str tops)])
    ;; EXPAND TO THE SELECTION, ONCE PER SELECTION (reveal?). And when a row
    ;; for the selection is already on screen — a note can be drawn twice, under
    ;; its project and under its vault — the tree only brings that one into
    ;; view and opens nothing.
    (react/useEffect
     (fn []
       (when (reveal? (.-current revealed) reveal-at)
         (let [host   (or @keys-el js/document)
               shown  (.querySelector host "[data-ikc-active=\"1\"]")]
           (when-not shown
             (doseq [v to-expand] (.expand tree v)))
           ;; active-value is non-nil only when the selected row is IN the
           ;; data (active-expand-values), so a selection whose branch has not
           ;; arrived yet is revealed when it does, and once. The mark is the
           ;; reveal-key: a row that moves to a new parent is revealed again.
           (set! (.-current revealed) reveal-at)
           (js/setTimeout
            (fn []
              (some-> (or @keys-el js/document)
                      (.querySelector "[data-ikc-active=\"1\"]")
                      (.scrollIntoView #js {:block "nearest"})))
            80)))
       js/undefined)
     #js [(str reveal-at)])
    [:> (.-Tree mantine)
     {:data data
      :levelOffset 20
      :expandOnClick false
      :selectOnClick false
      :tree tree
      :renderNode render-node}]))

(declare row-context-menu)

(defn widget-tree
  "A nested outline, and since 2026-09-10 a keyboard a reader can walk.

   FORM-2, FOR ONE REASON: the CURSOR. With :open-mode :enter an arrow moves a
   cursor without selecting anything, so the widget has to remember where the
   reader is between renders. Nothing on the server knows it and nothing should
   — a cursor is not a selection until the reader says so.

   THE CURSOR FOLLOWS THE SELECTION when the selection moves from OUTSIDE — a
   click here, or another pane, or a restored session. Same reason widget-input's
   buffer follows its bound value: the widget's own memory must not stand against
   what the graph says."
  [_props _bus _session-id]
  (let [cursor        (r/atom nil)
        last-selected (atom ::none)
        ;; ── THE CHOICE ABOUT THE KEYBOARD RETURNS THE KEYBOARD (2026-09-12) ─
        ;;
        ;; George: "'instantly' - when I press it, it grabs the focus and I
        ;; cannot navigate with keys until I click an item in tree with the
        ;; mouse."
        ;;
        ;; He is right, and the chip is not at fault: a pressed control keeps
        ;; the focus, which is what every control does. What makes this one
        ;; different is WHAT IT IS FOR — it says how an arrow key behaves, so
        ;; the next thing the reader does is press an arrow.
        ;;
        ;; SO THE TREE TAKES IT BACK, and only on a CHANGE. Taking focus on
        ;; every render would steal it from a person typing in another pane.
        keys-el       (atom nil)
        last-mode     (atom ::none)
        ;; ── THE RIGHT-CLICK MENU OVER A ROW (2026-09-12) ──────────────────
        ;;
        ;; George: there is no context menu over a tree item.
        ;;
        ;; THE WIDGET OWNS IT AND NOT THE ROW, because a gesture template reads
        ;; the row's ITEM MAP — `[:of $value thought-id]` — and only this scope
        ;; has the items. The row reports where and on what.
        menu          (r/atom nil)]
    (fn [{:keys [items tone empty-label direction row wrap look] :as props} bus session-id]
  ;; :active-value names the highlighted row and the renderer finds it. It is
  ;; destructured with a rename because `active-value` is also the name the
  ;; expand effect uses for the value it FOUND, and the two must not be one
  ;; symbol.
  (let [_        (let [mode (:open-mode props)]
                   ;; The FIRST render only remembers; a change after that is a
                   ;; person pressing the chip, and the keyboard goes home.
                   (when (and (not= ::none @last-mode) (not= mode @last-mode))
                     (when-let [el @keys-el] (js/setTimeout #(.focus el) 0)))
                   (reset! last-mode mode))
        submit   (submit-template props)
        ;; THE SECOND GESTURE A TREE MAY WIRE (George, 2026-09-10: "In the
        ;; sidebar, the pinned items do not have unpin icon or means").
        ;;
        ;; A :tree ROW COULD NEVER CARRY A CONTROL: its item map is
        ;; {:closed true} and identical in v2.0 and v2.1, so nothing can be
        ;; added to a row. ui.pins/toggle-pin said so in its own docstring —
        ;; "a sidebar row, WHEN :tree CAN OFFER ROW ACTIONS, will pass one".
        ;;
        ;; :per-row is the v2.1 answer and reader-v2 and alatus-reader are
        ;; pinned to the hash-locked v2.0 — measured 2026-09-10, both fail with
        ;; {:per-row ["disallowed key"]}. A SECOND KEY IN :on-gesture validates
        ;; at BOTH versions, so the gesture is where this lives.
        remove-g (:remove (:on-gesture props))
        selected (:active-value props)]
    (when (not= @last-selected selected)
      (reset! last-selected selected)
      (reset! cursor selected))
    (cond
      (empty? items)
      (when empty-label
        [:> (.-Text mantine) {:size "sm" :c "dimmed" :fs "italic"} empty-label])

      (= direction :row)
      ;; :wrap DEFAULTS TO TRUE, so every strip that predates the prop is
      ;; unchanged — a strip of dates wants to wrap. A strip inside a band of
      ;; fixed height does not: measured 2026-09-11, the Studio's eight level
      ;; tabs wrapped to two lines at 1400 and pushed "Undo all" out of a
      ;; 44-pixel pane with no way to reach it.
      [:> (.-Group mantine) {:gap "xs" :align "center"
                             :wrap (if (false? wrap) "nowrap" "wrap")}
       (for [[i item] (map-indexed vector items)]
         ^{:key i} [tree-row-button item submit bus session-id remove-g])]

      :else
      (let [data (items->tree-data items selected @cursor)
            ;; The values to expand so the :active row is visible: every
            ;; ancestor of it, and the row itself when it has children.
            ;; Computed from the same items the data came from, so the two
            ;; cannot disagree.
            {active-value :active-value path :expand} (active-expand-values items selected)
            ;; THE TOP LEVEL OPENS BY ITSELF — see rows-to-expand. NOT IN A
            ;; TREE THAT LOADS ITS BRANCHES (IKC3/PLAN-ikc-v3-076-01/TREE):
            ;; there a reveal opens the path to the selected row and nothing
            ;; else. A top row whose rows the idle loader had brought opened
            ;; with each reveal, and foam-home's 1,482 notes took the screen
            ;; after a Tab on a note above it.
            to-expand (if (:children-query props) path (rows-to-expand items selected))
            ;; The top level alone, with no selection's path in it.
            ;;
            ;; NOT FOR A TREE THAT LOADS ITS BRANCHES (2026-09-25). There a
            ;; top-level row gets rows only when it is fetched, and the idle
            ;; loader fetches one every five seconds. Opening each one as it
            ;; arrived made the tree grow by itself under the reader's cursor.
            tops      (if (:children-query props) [] (rows-to-expand items nil))]
        ;; THE KEYBOARD LIVES ON A WRAPPER, not on Mantine's Tree: Tree keeps
        ;; its own arrow and space handling on each row, and the six gestures
        ;; of v2.1 (Enter, Tab, Alt-arrows, a letter) are ours. The wrapper
        ;; sees them bubble, fires the declared command, and stops the ones it
        ;; handled. :tab-index makes the tree focusable so a letter reaches it
        ;; after a click.
        ;; data-ikc-tree-keys NAMES THE ELEMENT THAT HOLDS THE KEYBOARD, and a
        ;; row's click reaches for it by that name (2026-09-12). `closest
        ;; [tabindex]` cannot: Mantine gives every row's own <li> tabindex 0, so
        ;; the nearest one is the ROW — and the row is replaced on the next
        ;; render, which drops the focus back to BODY. This element is not.
        [:div {:tab-index 0
               :data-ikc-tree-keys "1"
               :ref (fn [el] (reset! keys-el el))
               :class "outline-none"
               :on-key-down (tree-key-handler props bus session-id items selected cursor)}
         ;; ── A BRANCH ALSO LOADS WHEN THE TREE HAS BEEN IDLE ──────────────
         ;;
         ;; George, 2026-09-19, asked for a branch to load when it is needed,
         ;; or after more than five idle seconds. The FIRST is the placeholder
         ;; row, which asks the moment a person opens a branch. This is the
         ;; second, and the tree owns it rather than the row: a row that has
         ;; drawn was needed already, and only the tree can see them all.
         ;;
         ;; IT ASKS FOR ONE BRANCH PER TICK, NEWEST FIRST. Asking for all of
         ;; them would send the whole tree, which is the request this step
         ;; exists to remove. One at a time fills the sidebar quietly while
         ;; nobody is waiting, and a person who opens a branch still gets it at
         ;; once through the placeholder.
         (when (:children-query props)
           [:f> tree-idle-loader {:children-query (:children-query props)
                                  :items items :session-id session-id}])
         ;; A STABLE COMPONENT, AND THAT IS THE REPAIR (2026-09-25). This was
         ;; an inline `[:f> (fn [] …)]`. Reagent names a function component
         ;; by the function it is given, and an inline fn is a new function on
         ;; every render — so React saw a new component each time, unmounted
         ;; the old one and mounted a fresh one. useTree's open branches lived
         ;; in the unmounted one. Every render of this tree — a branch
         ;; arriving, the idle loader's tick, a click — closed every branch
         ;; the reader had opened, and the reveal effect then opened the top
         ;; level again and scrolled to the selection. George: "the tree does
         ;; something else like collapsing entirely or scrolling in another
         ;; location". T-web-widgets-tree-stable-001 holds the identity.
         [:f> tree-host {:data data :tops tops :to-expand to-expand :active-value active-value
                         :reveal-at (reveal-key items selected)
                         :keys-el keys-el
                         :reveal-spec (when (:children-query props)
                                        {:bus bus :session-id session-id :items items
                                         :children-query (:children-query props)
                                         :selected selected})
                         :render-node (mantine-tree-node submit bus session-id row remove-g look
                                                         (when (seq (:row-menu props))
                                                           (fn [x y v] (reset! menu {:x x :y y :value v})))
                                                         ;; Meta-UI v2.1: which source
                                                         ;; answers a branch (step 4c).
                                                         (:children-query props)
                                                         (:open (:on-gesture props)))}]
         ;; THE SAME LIST THE OUTLINE RENDERS, through the same two functions,
         ;; so a tree and a block can never offer different shapes of menu.
         (when-let [{:keys [x y value]} @menu]
           [row-context-menu
            {:x x :y y
             :items (:row-menu props)
             :on-close #(reset! menu nil)
             :fire (fn [gesture]
                     (when-let [template (bind/gesture-template props gesture)]
                       (when-let [item (and bus (item-by-value items value))]
                         (js-invoke bus "dispatch"
                                    (bind/fill-command template {'$session-id session-id
                                                                 '$value      item})
                                    (fn [_] nil)))))}])]))))))

;; ---------------------------------------------------------------------------
;; :button, :input.
;; ---------------------------------------------------------------------------

(def ^:private button-density-sizes
  "Meta-UI :density on a button, in Mantine's own size vocabulary. :compact is
   Mantine's compact padding, 8 px on each side against 18 px."
  {:compact "compact-sm" :cozy "sm" :roomy "md"})

(declare refusal-of)

(defn widget-button
  "A button that SHRINKS AND ELLIPSISES rather than one that overflows.

   Two properties, and a row of buttons in a narrow column needs both.

   `min-width: 0` lets the button shrink below its label. A flex item keeps
   `min-width: auto` without it, so a `:group` that declares `:grow` cannot make
   its children share a row that is narrower than their labels.

   The label then gets an ellipsis. Nothing here constrains a button on its own,
   because a button takes its content's width unless a parent says otherwise.
   The two properties are therefore inert until a row asks the button to share.

   ikc1 does the same thing, and its sidebar row is the reference:
   `flex-1`, `px-2 py-1.5`, and a label in `<span className=\"truncate\">`
   (AthensSidebar.tsx line 793)."
  [_props _bus _session-id]
  ;; A REFUSAL IS SHOWN, AND SO IS THE WAIT (fault report 7c1932b8, George,
  ;; 2026-10-12: "No progress is shown or that task is started"). He pressed
  ;; Ask the project. The bus refused it, and the button threw the reply
  ;; away, so nothing on the screen changed. Now the button is busy until
  ;; the reply, and a refusal stays beside it in the handler's own words
  ;; until the next press. The rule is :input's: STALL, never VANISH.
  ;;
  ;; A FRAGMENT AND NOT A BOX, so a button with no refusal is the same flex
  ;; item it always was, in every row of every island.
  ;;
  ;; :effect :enable-push (IKC3/PLAN-ikc-v3-082-01/WD-PUSH) runs the client
  ;; half of web push first (graph-ui.web.push/enable!) and fills
  ;; $push-subscription and $device-label in the command. :show-result
  ;; {:key k :says s} writes s and the value of k of the answer beside the
  ;; button, for a command whose answer is a count.
  (let [err  (r/atom nil)
        note (r/atom nil)
        busy (r/atom false)]
    (fn [{:keys [label tone disabled density effect show-result] :as props} bus session-id]
      (let [submit (submit-template props)
            send!  (fn [subs]
                     (js-invoke bus "dispatch"
                                (bind/fill-command submit (merge {'$session-id session-id} subs))
                                (fn [reply]
                                  (reset! busy false)
                                  (reset! err (refusal-of reply))
                                  (reset! note (when-not @err (push/result-note show-result reply))))))]
        [:<>
         [:> (.-Button mantine)
          {:size (get button-density-sizes density "sm")
           :variant (if (#{:accent :success :warning :danger} tone) "filled" "default")
           :color (mantine-color tone)
           :disabled (boolean disabled)
           :loading @busy
           :style #js {:minWidth 0}
           ;; :height "auto" KEEPS THE LABEL IN THE MIDDLE (fault report
           ;; e6d32ab1). Mantine's label is a flex box of the full height that
           ;; centres its text. :display "block" lets the ellipsis work, and
           ;; it took the centring away, so the label sat at the top of a tall
           ;; button. With its own height the label is centred by the inner box.
           :styles #js {:label #js {:overflow "hidden"
                                    :textOverflow "ellipsis"
                                    :whiteSpace "nowrap"
                                    :display "block"
                                    :height "auto"}}
           :on-click (fn [e]
                       (.preventDefault e)
                       (when (and submit bus (not disabled))
                         (reset! err nil)
                         (reset! note nil)
                         (reset! busy true)
                         (if (= "enable-push" (some-> effect name))
                           (push/enable! bus
                                         (fn [{:keys [subscription device-label error]}]
                                           (if error
                                             (do (reset! busy false) (reset! err error))
                                             (send! {'$push-subscription subscription
                                                     '$device-label device-label}))))
                           (send! {}))))}
          (or label "")]
         (when-let [why @err]
           [:> (.-Text mantine) {:size "xs" :c "red" :role "alert"} why])
         (when-let [n @note]
           [:> (.-Text mantine) {:size "xs" :c "dimmed" :role "status"} n])]))))

(defn refusal-of
  "The refusal a dispatch reply carries, as the sentence to show, or nil when
   the reply is an acceptance (STALL, never VANISH — George, 2026-08-23, after
   losing work to a field that emptied itself on a failed save).

   A handler refuses in one of three shapes, and all three are read here.
   A map, {:error :no-thought-selected :message \"Select a thought…\"}, which
   is how ui.research answers. A vector holding an event whose :type is
   :error, or carries an :error key, which is how a saga answers. And a vector
   holding an event whose :type NAMES the error: :ui/rename-page-error,
   :ui/create-note-error, :ui/open-file-error, :conversation/error,
   :frames/error — the convention notes-web and observe already follow, and
   the one the PR #40 review found missing (2026-09-20): the page title is the
   most-deployed submit field in the product, and create-note refuses an empty
   title on purpose. Any event of the vector counts, not the first alone.
   {:error :disconnected} from bus-client is a refusal too: the words did not
   reach the bus, so they must stay on screen.

   The sentence is the handler's own :message when it wrote one, then its
   :reason or :error, so the person reads WHY in the handler's words and never
   a bare 'refused'. A keyword reads as words, a string as itself, and anything
   else as its printed form: a handler's shape must never throw here."
  [reply]
  (let [error-event? (fn [ev]
                       (when (map? ev)
                         (let [tn (some-> (:type ev) name)]
                           (or (contains? ev :error)
                               (contains? ev :rejected)
                               (= "error" tn)
                               (and tn (str/ends-with? tn "-error"))))))
        ev (if (sequential? reply) (some #(when (error-event? %) %) reply)
               (when (error-event? reply) reply))
        words (fn [r] (cond (keyword? r) (str/replace (name r) "-" " ")
                            (string? r)  r
                            (some? r)    (pr-str r)))]
    (when ev
      (or (:message ev)
          ;; THE GATE'S REFUSAL. The bus answers authz, partition and rate-limit
          ;; with {:rejected {:reason .. :message ..}} (ikc.bus.memory
          ;; dispatch!), or with the reason alone. Without this arm a real
          ;; rejection read as an acceptance.
          (when (contains? ev :rejected)
            (let [r (:rejected ev)]
              (or (when (map? r) (or (:message r) (words (:reason r))))
                  (when-not (map? r) (words r))
                  "the bus rejected the command")))
          (words (:reason ev))
          (words (:error ev))
          "refused"))))

(defn autosize!
  "Grow a textarea to exactly its content. Height is set to \"auto\" FIRST so
   scrollHeight reports the content rather than the box it is already stretched
   to — without that reset the editor grows and never shrinks again.

   IT MEASURES THE VALUE AND NEVER THE PLACEHOLDER, which is the whole of the
   repair below. scrollHeight is the height of what a textarea HOLDS, so an
   empty field is one row at any width.

   MOVED UP THE FILE ON 2026-09-20 and made public. The outline editor had it
   to itself. :input needs the same arithmetic now, and a test drives it
   through autosize-ref."
  [el]
  (when el
    (set! (.. el -style -height) "auto")
    (set! (.. el -style -height) (str (.-scrollHeight el) "px"))))

(defn autosize-ref
  "The React ref a multiline :input gives its textarea: measure at mount, and
   measure again each time the BOX changes width.

   THE FIELD WAS TALLER THAN ITS PANE (George, 2026-09-20, on the tot island:
   *\"the thought field alone is bigger than the pane it resides in\"*). Measured
   the same day on the deployment: an EMPTY thought box carried
   `height: 729px !important` inside a pane 493 px tall, and the note box
   carried 556 px.

   WHY. Mantine's `autosize` prop is react-textarea-autosize, and that library
   measures a hidden copy of the field WITH ITS PLACEHOLDER in it. 729 and 556
   follow the two placeholder lengths, 41 and 32 characters. A dock pane has no
   width when its panel is built, so the copy wrapped at one character per line.
   The library then listens for one event only, a window resize. A pane that
   gets its width fires none, so nothing measured a second time.

   TWO CHANGES, AND EACH ONE ALONE IS NOT ENOUGH:

   1. The height comes from scrollHeight, which is the height of the VALUE. An
      empty field is one row at first paint whatever the pane is doing, because
      a placeholder is not content.
   2. A ResizeObserver on the textarea measures again when the pane hands it a
      width. That is the event the library did not have.

   NO SYNTHETIC WINDOW RESIZE. Dispatching one would repair this field and
   re-lay out every other island on the page, and it would state the cause
   nowhere.

   ONLY A WIDTH CHANGE RE-MEASURES. autosize! writes the HEIGHT, and the
   observer watches the same box, so a height reaction would call itself for
   ever."
  [el-ref observer last-width]
  (fn [el]
    (if el
      (do
        (reset! el-ref el)
        (reset! last-width (.-clientWidth el))
        (autosize! el)
        (when (and (nil? @observer) (exists? js/ResizeObserver))
          (let [o (js/ResizeObserver.
                    (fn [_]
                      (let [w (.-clientWidth el)]
                        (when (not= w @last-width)
                          (reset! last-width w)
                          (autosize! el)))))]
            (.observe o el)
            (reset! observer o))))
      (do (some-> @observer (.disconnect))
          (reset! observer nil)
          (reset! el-ref nil)))))

(defn with-submit-button
  "An :input's field, with its Send button beside it when it declares a
   :submit-label (fault report ab952203, George, 2026-10-12). Enter was the
   only way to send, and nothing on the screen said so. George typed his
   message and looked for a control to send it. He found the Ask section
   below, whose button does a different thing. The button does what Enter
   does, and it shows that it works until the bus answers. No label, no
   button: every other field is unchanged."
  [label busy? on-send field]
  (if (str/blank? (str label))
    field
    [:div {:style {:display "flex" :gap "0.5rem" :align-items "flex-start"}}
     [:div {:style {:flex 1 :min-width 0}} field]
     [:> (.-Button mantine)
      {:size "sm" :variant "filled" :loading (boolean busy?)
       :on-click (fn [e] (.preventDefault e) (on-send))}
      label]]))

(defn widget-input
  "The renderer owns the edit buffer, so typing is not lost between renders —
   but the buffer must still FOLLOW its bound value when that value changes
   underneath it.

   That second half was missing until 2026-07-28, and it was a serious defect
   rather than a rough edge: the buffer was seeded once, at mount, from the
   first props, and the render function never looked at :value again. So the
   page title showed \"(select a page)\" forever. Selecting a page in the
   sidebar, or pressing Today — which really did create and select today's
   daily note, as the bus events proved — changed nothing on screen. Three
   separate bug reports, one cause.

   The fix keeps both properties by tracking the last value SEEN FROM THE
   BINDING, not the buffer's own contents: when the incoming value differs from
   the last one the binding delivered, the binding has moved and the buffer
   re-seeds; when it is unchanged, whatever the reader has typed stands."
  [{:keys [value reset-key] :as _initial-props} _bus _session-id]
  (let [buf       (r/atom (or value ""))
        last-bound (r/atom value)
        ;; :reset-key (2026-09-09): a second reason to re-seed. The research
        ;; island binds the open project's id; two projects with no goal bind
        ;; the same "" and the value test above cannot tell them apart, so a
        ;; goal typed for one project stood in the other's box (George).
        last-reset (atom reset-key)
        ;; THE REFUSAL, shown under the field (STALL, never VANISH). Set from a
        ;; dispatch reply that refuses, cleared by the next keystroke. Until
        ;; 2026-09-20 the buffer was emptied on ANY reply — `(fn [_] (reset! buf
        ;; ""))` — so a refused Enter took the words with it and showed the
        ;; handler's :message nowhere. George, on the tot island: "The field
        ;; clearing on Enter is one of the most unpleasant behaviours." The
        ;; reference already promised the opposite for :ui/edit-thought-body:
        ;; "the box keeps what was typed on a refusal". This makes it true for
        ;; every :input with a submit, in every island.
        err        (r/atom nil)
        ;; THE WORDS OF EACH :reset-key that were typed and not sent (fault
        ;; report ff329728). A plain atom: nothing renders from it.
        drafts     (atom {})
        ;; A SUBMIT ON ITS WAY (fault report 7c1932b8, "No progress is shown").
        ;; True from the dispatch to its reply, so the Send button says it is
        ;; working. A reply that never comes leaves it true, and that is
        ;; honest: the words did not arrive.
        busy       (r/atom false)
        ;; THE MULTILINE FIELD MEASURES ITSELF — see autosize-ref. These three
        ;; are plain atoms and not r/atoms: nothing renders from them.
        el-ref     (atom nil)
        observer   (atom nil)
        last-width (atom nil)]
    (fn [{:keys [placeholder state tone variant leading-icon value multiline reset-key masked] :as props} bus session-id]
      (when (or (not= value @last-bound) (not= reset-key @last-reset))
        (let [key-moved? (not= reset-key @last-reset)]
          ;; UNSENT WORDS STAY WITH THEIR ROW (fault report ff329728, George,
          ;; 2026-10-12: "The text field keeps the text I entered in the
          ;; branch"). The words typed for one row stood in the box of the
          ;; next row, so they seemed to belong to it. Now they are kept
          ;; under the key they were typed for, and they come back with that
          ;; key. Only words that differ from the bound value are kept, so a
          ;; saved value is never covered by an old draft. They are never
          ;; dropped: STALL, never VANISH.
          (when (and key-moved? (not= @buf (or @last-bound "")))
            (swap! drafts assoc @last-reset @buf))
          (reset! last-bound value)
          (reset! last-reset reset-key)
          ;; A RESEED CLEARS THE REFUSAL TOO (PR #40 review). The words the
          ;; refusal was about are gone, so the sentence about them goes as well.
          (reset! err nil)
          (reset! buf (if key-moved?
                        (get @drafts reset-key (or value ""))
                        (or value ""))))
        ;; A NEW BOUND VALUE IS NEW CONTENT, and no keystroke announced it — a
        ;; thought picked in the tree fills this box. The measure waits for the
        ;; frame that writes the text into the element.
        (when @el-ref
          (js/requestAnimationFrame (fn [] (autosize! @el-ref)))))
      (let [disabled? (= state :disabled)
            ;; :masked (IKC3/PLAN-ikc-v3-059-01/AT-2) draws dots. A textarea
            ;; cannot mask, so a masked field is one line. The type reads
            ;; the props only, never the refusal, so a refused secret stays
            ;; dots while the words stay in the field.
            multiline (and multiline (not masked))
            submit    (submit-template props)
            ;; §19's typography applies to the INPUT ELEMENT, not the wrapper —
            ;; Mantine's Styles API `styles` addresses the inner element by its
            ;; selector name, so an :unstyled + :size :h1 title actually renders
            ;; at heading size instead of styling an invisible root div.
            typo      (typography-props props)
            ;; ONE SUBMIT, FOR ENTER AND FOR THE SEND BUTTON.
            ;;
            ;; AN ACCEPTED SUBMIT EMPTIES THE FIELD. A REFUSED ONE KEEPS THE
            ;; WORDS and shows the refusal. Nothing else may clear this buffer:
            ;; not a reply of any shape, not a reconnect (graph-ui.web.unsaved
            ;; holds the block editor's half of the same rule).
            send!     (fn []
                        (when (and submit bus)
                          (reset! busy true)
                          (js-invoke bus "dispatch"
                                     (bind/fill-command submit {'$session-id session-id '$value @buf})
                                     (fn [reply]
                                       (reset! busy false)
                                       (if-let [why (refusal-of reply)]
                                         (reset! err why)
                                         (do (reset! err nil)
                                             (swap! drafts dissoc reset-key)
                                             (reset! buf "")))))))]
        ;; :multiline draws Mantine's Textarea, autosized from one row, so the
        ;; whole text shows; Enter still submits and Shift+Enter breaks a line.
        (with-submit-button
         (when submit (:submit-label props)) @busy send!
        [:> (if multiline (.-Textarea mantine) (.-TextInput mantine))
         (cond-> {:value @buf
                  :placeholder (or placeholder "")
                  :disabled disabled?
                  :size "sm"
                  ;; §21: Mantine's own InputVariant enum verbatim. :unstyled
                  ;; drops the field chrome so an editable page title reads as
                  ;; a heading rather than as a form control.
                  :variant (name (or variant :default))
                  ;; nil for every field that is not masked, so React
                  ;; writes no attribute and those fields do not change.
                  :type (when masked "password")
                  ;; A browser must not offer to keep a secret that the
                  ;; operator sets for someone else.
                  :autoComplete (when masked "new-password")
                  :color (when (= state :invalid) "red")
                  :leftSection (when (and leading-icon (not multiline))
                                 (r/as-element [widget-icon {:icon leading-icon :size :sm}]))
                  :on-change (fn [e]
                               (reset! err nil)
                               (reset! buf (.. e -target -value))
                               ;; The element already holds the new text when
                               ;; this fires, so scrollHeight is the answer.
                               (when multiline (autosize! (.-target e))))
                  ;; Mantine draws :error under the field, in the field's own
                  ;; colour scheme, for every variant including :unstyled.
                  :error @err
                  :on-key-down (fn [e]
                                 (when (and (= 13 (.-keyCode e))
                                            (not (and multiline (.-shiftKey e))))
                                   (.preventDefault e)
                                   (when (and submit bus)
                                     (do
                                       (send!)
                                       ;; ENTER IN A PAGE'S NAME PUTS THE CARET IN
                                       ;; ITS BODY (George, 2026-09-07: "Pressing
                                       ;; Enter in the name of the new note does
                                       ;; not move cursor to the note body").
                                       ;;
                                       ;; ikc1's OWN FOUR LINES. PageView.tsx:
                                       ;;
                                       ;;   if (e.key === 'Enter') {
                                       ;;     e.preventDefault();
                                       ;;     (document.querySelector('.block-content')
                                       ;;       as HTMLElement)?.focus();
                                       ;;   }
                                       ;;
                                       ;; NO DECLARATION IS NEEDED, AND I FIRST
                                       ;; SAID ONE WAS. The reasoning ran: a
                                       ;; gesture must say "then move the caret",
                                       ;; that is a Meta-UI prop, v2.0 is
                                       ;; hash-locked, so reader-v2 is blocked and
                                       ;; George must choose. Every step was
                                       ;; wrong, because the :outline kind already
                                       ;; states the rule: "'select' a block for
                                       ;; focus is local renderer state, never a
                                       ;; bus dispatch". Focus is exempt, so the
                                       ;; version pin never applied.
                                       ;;
                                       ;; :ui/rename-page IS WHAT MAKES THIS INPUT
                                       ;; THE TITLE. ikc1 hung the handler on the
                                       ;; title element; this vocabulary has one
                                       ;; generic :input, and the sidebar's search
                                       ;; box is the same kind. The command a
                                       ;; submit dispatches is declared, and only
                                       ;; the page's name renames a page — so the
                                       ;; scope is read from the description
                                       ;; rather than from a widget's identity.
                                       ;;
                                       ;; A CLICK, NOT A .focus(). ikc1's row IS a
                                       ;; contenteditable, so focusing it is
                                       ;; enough. Here a row shows RENDERED
                                       ;; markdown until it is clicked, and the
                                       ;; click is what swaps in the textarea —
                                       ;; which then carries :auto-focus and
                                       ;; caret-to-end! of its own. Focusing the
                                       ;; rendered body would move nothing.
                                       ;;
                                       ;; AFTER THE FRAME, because the rename
                                       ;; re-renders the column and a click
                                       ;; dispatched into the old DOM lands on a
                                       ;; node that is being replaced.
                                       ;;
                                       ;; A PAGE WITH NO BLOCKS GETS NOTHING, and
                                       ;; that is ikc1's behaviour too — its `?.`
                                       ;; is the same silence. The empty state has
                                       ;; its own :insert-first gesture.
                                       (when (= :ui/rename-page (:command submit))
                                         (js/requestAnimationFrame
                                           (fn []
                                             (some-> (js/document.querySelector ".ikc-block-content")
                                                     (.click)))))))))}
           ;; OMITTED when the node carries no typography — never an explicit
           ;; nil, which is what Mantine's own defaults refuse to fire on.
           ;; :autosize AND :minRows ARE GONE (2026-09-20). They were
           ;; react-textarea-autosize, which measures the placeholder and hears
           ;; only a window resize. autosize-ref measures the value and hears
           ;; the pane. `rows 1` is what :minRows 1 said.
           multiline  (assoc :rows 1 :ref (autosize-ref el-ref observer last-width))
           (or (seq typo) (unstyled-line? props))
           (assoc :styles (clj->js (cond-> {:input (merge typo (when (unstyled-line? props)
                                                                 (text-width-style @buf)))}
                                     ;; THE ROOT IS THE FLEX ITEM of a row, and a
                                     ;; percentage on the input resolves against
                                     ;; a root that takes the input's width. So
                                     ;; the limit is on the root.
                                     (unstyled-line? props)
                                     (assoc :root {:minWidth 0 :maxWidth "100%"})))))])))))

;; ---------------------------------------------------------------------------
;; :code-block, :text-area.
;; ---------------------------------------------------------------------------

(defn- code-language
  "Map Meta-UI :language keyword to a CodeHighlight / Mantine language string."
  [language]
  (case language
    (:clojure :edn) "clojure"
    :js "javascript"
    :ts "typescript"
    :json "json"
    :md "markdown"
    :html "html"
    :css "css"
    :py "python"
    :sh "bash"
    :shell "bash"
    :text "text"
    (name (or language :clojure))))

(defn widget-image
  "AN IMAGE, drawn from a bound data URL (PLAN-ikc-v3-017-01 phase 11).

   HAND-WRITTEN RATHER THAN GENERIC, and the generated declaration said so
   itself: \"Generic is not finished: this kind has no data binding ... A kind
   that needs one of those graduates to a hand-written widget.\" Mantine's own
   `src` prop is :unmapped in that declaration — typed `any`, no data contract —
   so a bound value could not reach it.

   NOTHING IS DRAWN WITHOUT A VALUE, and that is not an oversight. The bytes do
   not travel until a reader picks a row, so an empty value is the normal
   resting state and an empty box is the honest picture of it. A broken-image
   glyph would say the fetch failed.

   IT IS AN <img> AND NOT THE MANTINE COMPONENT, because the whole widget is one
   element and one element does not need a wrapper. :fit and :radius are the two
   declared props that mean anything here."
  [{:keys [value alt fit radius] :as _props} _bus _session-id]
  (when-let [src (not-empty (str value))]
    [:img {:src src
           :alt (or alt "an image from this conversation")
           :style (cond-> {:maxWidth "100%" :display "block"}
                    fit    (assoc :objectFit (name fit))
                    radius (assoc :borderRadius (if (keyword? radius)
                                                  (str "var(--radius-" (name radius) ")")
                                                  radius)))}]))

(defn widget-code-block
  "A syntax-highlighted code block using Mantine CodeHighlight."
  [{:keys [value language density]}]
  ;; min-w-0 BESIDE min-h-0, AND IT WAS MISSING (2026-09-11). `overflow-auto`
  ;; scrolls BOTH axes, and this box had the vertical half of what makes that
  ;; work. A flex child defaults to `min-width: auto`, so a long line pushed
  ;; the box wider than its pane instead of scrolling inside it — measured on
  ;; the Studio's Declaration tab: 648 pixels of content and no horizontal bar
  ;; anywhere, because the only element that overflowed was an ancestor whose
  ;; own scrollbar Mantine had decided was unnecessary.
  [:div {:class (str "overflow-auto flex-1 min-h-0 min-w-0 " (get box-density-pad-classes density "p-2"))}
   [:> CodeHighlight
    {:code (or value "")
     :language (code-language language)
     :withCopyButton false}]])

(defn editor-size
  "The wrapper attributes that give an editor its text size and say its wrap.

   THE SIZE IS A TYPE TOKEN (George, 2026-10-05: \"Can I -/+ the font size\").
   It was a Tailwind class per step until then — text-xs to text-lg, four sizes
   that no theme could move and that did not match the type the reading pane
   draws. typo-css gives the token of themes.edn, and css/ikc-base.css
   (.ikc-editor-sized) makes CodeMirror inherit it. No :font-size, no style.

   data-wrap says the wrap in words, so a probe and a stylesheet can read it."
  [{:keys [font-size wrap]}]
  (let [css (select-keys (typo-css {:font-size font-size}) [:fontSize :lineHeight])]
    (cond-> {:data-wrap (if wrap "on" "off")}
      (seq css) (assoc :style css))))

(defn widget-code-view
  "A whole source FILE, read the way an editor shows one — F-graph-ui-v0-011-01,
   ADR-ikc-v3-070-01 decision 8.

   NOT :code-block WITH MORE PROPS, and the split is deliberate. A :code-block
   is a snippet inside a document and colour is all it needs; Mantine's
   CodeHighlight gives exactly that and nothing else. A :code-view is a file
   opened to be READ, so it needs the three things CodeHighlight has no concept
   of: line numbers, folding, and live ids. CodeMirror already provides the
   first two through basicSetup — the same editor Studio's source pane uses, in
   read-only mode.

   READ-ONLY, KEEPING THE CURSOR. :read-only? rather than :editable false,
   because dropping the cursor would also drop selection, and selecting and
   copying a function is most of what reading a source file is for.

   THE LINKS ARE SUPPLIED, NOT DISCOVERED. :links arrives from the server as
   [{:text :frame-id}] — whether `ADR-ikc-v3-070-01` names a real frame is a
   question only the graph can answer, and asking it per identifier from here
   would be one round trip each. Clicking one fills $value with that frame id
   and dispatches the node's :submit gesture, exactly as clicking a :tree node
   does, so WHERE a click goes stays in the description rather than here."
  [{:keys [value language line-numbers folding links wrap] :as props} bus session-id]
  (let [submit (submit-template props)
        sized  (editor-size props)]
    [:div (merge {:class (str "flex-1 min-h-0 min-w-0 overflow-auto ikc-code-view"
                              (when (:style sized) " ikc-editor-sized"))
                  :data-line-numbers (str (not (false? line-numbers)))
                  :data-folding (str (not (false? folding)))}
                 sized)
     [cm/editor
      {:value      (or value "")
       :language   (or language :clojure)
       :wrap?      (boolean wrap)
       :read-only? true
       :on-change  (fn [_] nil)
       :links      links
       :on-link-click
       (fn [frame-id]
         (when (and submit bus frame-id)
           (let [cmd (bind/fill-command submit {'$session-id session-id
                                                '$value frame-id})]
             (js-invoke bus "dispatch" cmd (fn [_] nil)))))}]]))

(defn- apply-locate!
  "Select the node span for `loc` (a {:widget-id :nonce}) inside the CodeMirror
   `view`, given its current `text`, and scroll it into view. Studio Designer
   link-select (F-graph-ui-v0-005-01): a click in the live preview lands the
   Source editor's cursor on that widget's node. No-op when the id isn't in the
   buffer.

   `indent?` selects which grammar the buffer is in: the bracket-stripped
   indentation format spans different offsets than the EDN it round-trips to,
   so locating has to be done against the text actually on screen."
  [view text loc indent?]
  (when-let [[s e] (if indent?
                     (edn-indent/indent-node-span text (:widget-id loc))
                     (locate/node-span text (:widget-id loc)))]
    (let [ES (.-EditorSelection ^js uiw-cm)]
      (.focus ^js view)
      (.dispatch ^js view
        #js {:selection (.single ^js ES s e)
             :scrollIntoView true}))))

(defn- ->edn
  "Buffer text → EDN text. Identity in :edn format; in :indent format converts
   the bracket-stripped form back, falling back to the raw buffer when it does
   not parse (mid-edit, the buffer is routinely not yet valid — a failed
   conversion must not destroy what the user is typing)."
  [text indent?]
  (if indent? (or (edn-indent/indent->edn text) text) text))

(defn- ->display
  "EDN text → buffer text, the inverse of ->edn."
  [text indent?]
  (if indent? (edn-indent/edn->indent text) text))

(defn widget-text-area
  "A multi-line CodeMirror editor for the Studio/EDN editing surface.

  When it carries a :draft-key it is ALSO a Designer link-select target: it
  derefs the locate channel for [session-id draft-key], and when the preview
  publishes a clicked widget-id it selects that node's span in this buffer
  (F-graph-ui-v0-005-01). Reactive, so a click repaints just this widget.

  :format (Meta-UI v1.2-SNAPSHOT) chooses the authoring grammar: :edn (default)
  edits EDN directly, :indent edits the bracket-stripped indentation form — the
  bracket-free surface for deeply nested widget trees. The BUFFER holds display
  text, but everything leaving this widget is EDN: the draft the live preview
  reads and the :on-submit value are both converted back, so the preview works
  regardless of which format the editor is in."
  [{:keys [value format] :as _initial-props} _bus _session-id]
  (let [buf        (r/atom (->display (or value "") (= :indent format)))
        last-bound (atom value)
        ;; WHAT ARRIVED WHILE THE BUFFER WAS DIRTY, and nil when there is no
        ;; conflict. George, 2026-08-26, lost unsaved text in the reader's Edit
        ;; tab: he was typing, a git pull changed the file on the serving
        ;; machine, :page-markdown re-read it, and the re-seed below replaced his
        ;; words with the file's. Reproduced headlessly as
        ;; T-web-widgets-060 before this atom existed.
        ;;
        ;; A reagent atom so the notice repaints, and per-widget because a
        ;; conflict belongs to the editor it happened in.
        incoming   (r/atom nil)
        ;; THE THREE SIDES, SNAPSHOT WHEN THE CONFLICT OPENS. A toggle can only be
        ;; free if every answer is DERIVED from these and never applied to them
        ;; (ADR-graph-ui-v0-030-01 section 3).
        base-snap  (atom nil)   ; the text as it was when the editor opened
        mine-snap  (atom nil)   ; what the person had typed, at that moment
        ;; :each | :mine | :theirs | :both — a SELECTION, not an act. `applied`
        ;; is the last selection written into the buffer, so a re-render does not
        ;; overwrite per-chunk work.
        choice     (r/atom :each)
        applied    (atom nil)
        timer      (atom nil)
        view-ref   (atom nil)
        last-loc   (atom nil)]
    (fn [{:keys [value placeholder state draft-key format font-size wrap] :as props} bus session-id]
      (let [indent? (= :indent format)
            sized   (editor-size props)
            submit-tmpl (submit-template props)]
        ;; RE-SEED ONLY A CLEAN BUFFER. The buffer is clean when it still holds
        ;; exactly what was last seeded into it — so a person who has typed keeps
        ;; their words, and an untouched editor still follows the file.
        ;;
        ;; A DIRTY BUFFER IS NOT OVERWRITTEN AND NOT SILENTLY IGNORED: the
        ;; incoming text is held and the editor says so, which is this project's
        ;; standing rule — a write that cannot complete stays visible on screen
        ;; (PLAN-ikc-v3-018-01).
        (when (not= @last-bound value)
          (if (= @buf (->display (or @last-bound "") indent?))
            (do (reset! last-bound value)
                (reset! incoming nil)
                (reset! choice :each)
                (reset! applied nil)
                (reset! buf (->display (or value "") indent?))
                (when draft-key (draft/set-draft! session-id draft-key (or value ""))))
            ;; A PENDING INCOMING CHANGE. Snapshot all three sides once, and
            ;; leave the buffer exactly as the person left it.
            (when (not= @incoming value)
              (reset! base-snap @last-bound)
              (reset! mine-snap @buf)
              (reset! incoming value)
              (reset! choice :each)
              (reset! applied :each))))

        ;; A CHANGED SELECTION REBUILDS THE TEXT, and an unchanged one leaves it
        ;; alone. So flipping between answers is free and observable, and typing
        ;; inside one answer is not undone by the next render.
        (when (and @incoming (not= @choice @applied))
          (reset! applied @choice)
          (reset! buf
            (case @choice
              (:each :mine) (or @mine-snap "")
              :theirs       (->display (or @incoming "") indent?)
              :both         (->display (cm/union-merge (or @base-snap "")
                                                       (->edn (or @mine-snap "") indent?)
                                                       (or @incoming ""))
                                       indent?))))
        ;; Designer link-select: a preview click publishes a widget-id on the
        ;; locate channel for [session-id draft-key]; deref it (reactive) and,
        ;; when a NEW request lands, select that node's span in the buffer.
        (when draft-key
          (let [loc (locate/target session-id draft-key)]
            (when (and loc (not= (:nonce loc) @last-loc))
              (reset! last-loc (:nonce loc))
              (when-let [view @view-ref]
                (js/requestAnimationFrame #(apply-locate! view @buf loc indent?))))))
        (let [disabled? (= state :disabled)
              submit!   (fn []
                          (when (and submit-tmpl bus)
                            (js-invoke bus "dispatch"
                              (bind/fill-command submit-tmpl
                                {'$session-id session-id '$value (->edn @buf indent?)})
                              (fn [_] nil))))]
          [:div (merge {:class (str "flex flex-col flex-1 min-h-0 gap-1"
                                    (when (:style sized) " ikc-editor-sized"))}
                       sized)
           [cm/editor
            {;; A CONFLICT TURNS THIS INTO A MERGE VIEW. The doc stays the
             ;; person's own text and `merge-original` is what arrived, so every
             ;; changed chunk carries its own accept (keep mine) and reject
             ;; (take theirs). Nil the rest of the time, and then this is a plain
             ;; editor with no merge machinery loaded.
             :merge-original (when (= @choice :each) @incoming)
             :value @buf
             :on-change (fn [v]
                          (reset! buf v)
                          (when draft-key
                            (some-> @timer js/clearTimeout)
                            (reset! timer
                              (js/setTimeout
                                #(draft/set-draft! session-id draft-key (->edn v indent?))
                                150))))
             :language :clojure
             :format format
             :placeholder (or placeholder "")
             :disabled? disabled?
             :class "flex-1 min-h-0"
             ;; WRAP ON: a long line continues on the next screen line. OFF:
             ;; the line stays whole and CodeMirror's own scroller moves to
             ;; the side.
             :wrap? (boolean wrap)
             :on-submit submit!
             :on-create-editor (fn [view]
                                 (reset! view-ref view)
                                 (when indent?
                                   (cm/apply-default-folds! view)))}]
           ;; THE CONFLICT, MADE VISIBLE. It sits above the Save row so a person
           ;; reads it before pressing anything, and it offers the only two
           ;; honest answers: keep typing, or take what arrived.
           (when-let [theirs @incoming]
             ;; FOUR ANSWERS, AS A SELECTION. Toggling one rebuilds the text so a
             ;; person watches it change, and nothing is applied, discarded or
             ;; closed by choosing (ADR-graph-ui-v0-030-01 section 3).
             ;;
             ;; Each option names ONE SIDE and says nothing about the other's
             ;; fate. George, 2026-08-26: "Keep all mine — should not state
             ;; anything about Theirs."
             ;;
             ;; The incoming text stays PENDING through a Save. Only the explicit
             ;; control at the end answers it, which is section 2 of the same
             ;; decision: saving does not resolve a conflict.
             [:div {:class "flex flex-col gap-1"}
              [:> (.-Text mantine) {:size "xs" :c "orange"}
               "This file changed elsewhere. Your text is kept, and the version that arrived is still pending."]
              [:div {:class "flex flex-row items-center gap-2 flex-wrap"}
               [:> (.-Text mantine) {:size "xs" :c "dimmed"} "Use for every change:"]
               [:> (.-SegmentedControl mantine)
                {:size "xs"
                 :value (name @choice)
                 :onChange (fn [v] (reset! choice (keyword v)))
                 :data (clj->js [{:value "each"   :label "Decide each change"}
                                 {:value "mine"   :label "Mine"}
                                 {:value "theirs" :label "Theirs"}
                                 {:value "both"   :label "Both"}])}]
               [:> (.-Button mantine)
                {:size "xs" :variant "subtle"
                 :on-click (fn []
                             ;; ANSWERED. last-bound becomes what arrived, so the
                             ;; same change is not announced twice.
                             (reset! last-bound theirs)
                             (reset! incoming nil)
                             (reset! applied nil)
                             (reset! choice :each))}
                "Done with this change"]]
              [:> (.-Text mantine) {:size "xs" :c "dimmed"}
               (case @choice
                 :each   "Each changed block below has its own choice. Save writes the text as it stands."
                 :mine   "Showing your text alone. Save writes it, and the arrived version stays pending."
                 :theirs "Showing the arrived text alone. Save writes it."
                 :both   "Both changes, merged. Where the same lines changed on both sides, git markers show it.")]])

           (when (and submit-tmpl (not disabled?))
             [:div {:class "flex flex-row items-center justify-end gap-2"}
              [:> (.-Text mantine) {:size "xs" :c "dimmed"} "⌘/Ctrl+Enter"]
              [:> (.-Button mantine)
               {:size "xs" :color "accent" :on-click submit!}
               "Save"]])])))))

;; ---------------------------------------------------------------------------
;; :select / :menu / :tab-set / :collapsible.
;; ---------------------------------------------------------------------------

(defn select-gesture-value
  "PURE. The $value a :select sends for the option whose text is `v`.

   A NATIVE <select> HOLDS TEXT, so its value is always a string. When the
   option's own :value is a number, the gesture sends that number, as the
   source declared it: :ui/send-to-tile takes :tile :int, and the tile
   dropdown of the reading header sends it (IKC3/PLAN-ikc-v3-068-01/H). Every
   other value goes as the string, as before."
  [options v]
  (let [o (some #(when (= v (str (or (:value %) (str (:label %))))) %) options)]
    (if (number? (:value o)) (:value o) v)))

(defn widget-select
  [{:keys [options value placeholder tone state] :as props} bus session-id]
  ;; A REFUSED CHOICE IS SHOWN under the select, in the handler's words,
  ;; until the next choice (fault report 7c1932b8). Before, the reply was
  ;; thrown away, as the button's was. r/with-let keeps the refusal per
  ;; select, and the widget still returns its element.
  (r/with-let [err (r/atom nil)]
  (let [disabled? (= state :disabled)
        submit    (submit-template props)
        ;; Mantine v8 NativeSelect does NOT inject a placeholder <option> — the
        ;; `placeholder` prop is passed to InputBase as an HTML attribute, which
        ;; <select> elements silently ignore.  Without a value-matching option the
        ;; browser shows the FIRST real option, so an idle island picker displays
        ;; the first island instead of "island…".  Inject a disabled placeholder
        ;; option ourselves when one is provided and the current value doesn't
        ;; match any real option.
        val-str   (str (or value ""))
        matched   (some #(= val-str (str (or (:value %) (str (:label %))))) options)
        ph-opts   (when (and placeholder (not matched))
                    [{:value "" :label placeholder :disabled true}])
        ;; AN OPTION'S :accessory IS PART OF ITS WORDS (IKC3/PLAN-ikc-v3-068-01/H).
        ;; The tile dropdown of the reading header lists tiles 1 to 6, and a tile
        ;; that is not open yet carries "new". George reads on e-ink, so a state
        ;; is in words: "5 · new", not a shade.
        data (clj->js (concat ph-opts
                              (mapv (fn [{:keys [label value accessory]}]
                                      {:value (or value (str label))
                                       :label (str (or label (str value))
                                                   (when (seq (str accessory)) (str " · " accessory)))})
                                    options)))
        current (if matched val-str "")]
    [:> (.-NativeSelect mantine)
     {:placeholder (or placeholder "")
      :data data
      :value current
      :disabled disabled?
      ;; A CHOICE DOES NOT LOOK LIKE A FIELD TO WRITE IN (fault report
      ;; e6d32ab1, George, 2026-10-12: "selectors white as text fields").
      ;; Mantine's filled variant gives a select a shaded face. Every :input
      ;; keeps the white face, so the two kinds differ at a glance.
      :variant "filled"
      :error (or (when (= state :invalid) "invalid") @err)
      :on-change (fn [e]
                   (let [v (.. e -target -value)]
                     (when (and submit bus (not disabled?))
                       (reset! err nil)
                       (let [cmd (bind/fill-command submit {'$value (select-gesture-value options v) '$session-id session-id})]
                         (js-invoke bus "dispatch" cmd (fn [reply] (reset! err (refusal-of reply))))))))}])))

(defn widget-menu
  ":items is {:label :command :with} under v1.x (the item carries its own
   template), or {:label :gesture} under v2.0 — :gesture names a key in this
   SAME node's :on-gesture map, where the template actually lives
   (ADR-graph-ui-v0-013-01 §9)."
  [{:keys [items on-gesture]} bus session-id]
  (let [Menu (.-Menu mantine)
        Target (.-Target (.-Menu mantine))
        Dropdown (.-Dropdown (.-Menu mantine))
        Item (.-Item (.-Menu mantine))]
    [:> Menu {:withinPortal false}
     [:> Target
      [:> (.-Button mantine) {:size "sm" :variant "default"} "actions"]]
     [:> Dropdown {}
      (for [[i {:keys [label command with gesture tone disabled]}] (map-indexed vector items)]
        (let [tmpl (if gesture (get on-gesture gesture) (when command {:command command :with with}))]
          ^{:key i}
          [:> Item
           {:disabled (boolean disabled)
            :color (mantine-color tone)
            :on-click (fn [_]
                        (when (and tmpl bus (not disabled))
                          (let [cmd (bind/fill-command tmpl {'$session-id session-id})]
                            (js-invoke bus "dispatch" cmd (fn [_] nil)))))}
           (or label (str (or command gesture)))]))]]))

(defn tab-panel
  "PURE. A :tab-set child as its panel draws it: a :box loses its :title.

   THE TAB SAYS THE TITLE, SO THE PANEL DOES NOT SAY IT AGAIN. A child's :title
   is its tab label (dsl/contexts/ui/meta-ui/v2.1-SNAPSHOT/tab-set.edn). The
   :box renderer also drew that :title as an upper-case header, with a border
   and a padding round the panel. So reader-v3 showed PAGE, FILE and PREVIEW
   or EDIT under the tabs that said them, in three nested frames. George, fault
   report 20fee998, 2026-10-05: *\"PAGE is redundant, EDIT is redundant - the
   tab already says it\"*.

   A :tab-set with :chrome false draws no tab, and its child's :title is still
   a label and not a header: 'Page' named a mode the person cannot pick.

   A box that asks for its border with :border true keeps it."
  [child]
  (if (= :box (:type child))
    (update child :props dissoc :title)
    child))

(defn tab-line-child?
  "PURE. Is this :tab-set child drawn on the line of the tabs, and not as a
   tab? A child with :section :left-section or :right-section is one
   (IKC3/PLAN-ikc-v3-068-01/T). It has no panel and no tab, and :active counts
   the other children only. ui.render.tui/tab-line-child? is the same rule."
  [child]
  (contains? #{:left-section :right-section} (get-in child [:props :section])))

(defn tab-after-chrome-change
  "PURE: which tab is active after :chrome changed from `was?` to `now?`. When
   the tabs closed, the first tab (or the bound :active). Otherwise unchanged."
  [was? now? current bound-active]
  (if (and was? (not now?))
    (or bound-active 0)
    current))

(defn widget-tab-set
  "A tabbed container using Mantine Tabs.

   THE LINE OF THE TABS CAN HOLD OTHER WIDGETS (IKC3/PLAN-ikc-v3-068-01/T).
   `sections` is {:left [hiccup …] :right [hiccup …]}: the children that said
   :section :left-section or :right-section. :left draws before the tabs and
   :right after them, at the right edge. The line wraps, so a narrow pane cuts
   no control. With :chrome false the line holds these children only, and with
   none of them it is not drawn.

   IT DRAWS ONE CHILD, which is what every version of the :tab-set declaration
   has said: 'one child visible at a time'. The web renderer used to mount all of
   them, and the TUI has always drawn only the active one — two renderers
   disagreeing about one description, with the words on the TUI's side.

   Measured 2026-08-23 on the running deployment: one page click cost 798 DOM
   mutations and 799 of 815 were inside this component, because a click changes
   the bound value of every panel and all seven rebuilt.

   A CHILD THAT CAN HOLD UNSAVED TEXT STAYS DRAWN, whichever tab is active. Its
   buffer lives in the renderer (holds-draft? says which kinds), so unmounting it
   would throw away what a person typed with nothing saying so. That is derived
   from the child's own subtree, so no island declares it and none can forget.

   Each entry of `labelled-children` is [title child holds-draft?]."
  [props _labelled-children & _]
  (let [active     (r/atom (or (:active props) 0))
        last-bound (atom (:active props))
        last-chrome (atom (not (false? (:chrome props))))]
    (fn [props labelled-children & [{:keys [left right]}]]
      (when (not= @last-bound (:active props))
        (reset! last-bound (:active props))
        (reset! active (or (:active props) 0)))
      ;; A SWITCH THAT CLOSES RETURNS TO THE FIRST TAB (IKC-11). :chrome can be
      ;; bound, and File | Frame of the reading pane draws its tabs only when
      ;; the graph is newer than the file. Without this, a reader on the Frame
      ;; tab when the switch closed would stay on a panel with no tab to leave it.
      (let [now (not (false? (:chrome props)))]
        (when (not= @last-chrome now)
          (reset! active (tab-after-chrome-change @last-chrome now @active (:active props)))
          (reset! last-chrome now)))
      (let [n       (count labelled-children)
            idx     (min (max 0 @active) (max 0 (dec n)))
            chrome? (not (false? (:chrome props)))
            Tabs (.-Tabs mantine)
            TabsList (.-List Tabs)
            TabsTab (.-Tab Tabs)
            TabsPanel (.-Panel Tabs)]
        [:> Tabs
         {:value (str idx)
          :on-change #(reset! active (js/parseInt %))
          :class "flex flex-col flex-1 min-h-0"
          ;; THE CLASS ASKED FOR THIS AND DID NOT GET IT (2026-09-11). Mantine's
          ;; own `.mantine-Tabs-root` sets `display: block`, and it wins over the
          ;; utility class beside it — measured on the live Studio: the root
          ;; computed `display: block` at 817px while its PANEL, which asks for
          ;; `flex-1 min-h-0`, grew to 3372px for a declaration file and 9544px
          ;; for the EDN editor. In a block parent `flex-1` means nothing, so the
          ;; panel was never bounded, the CodeMirror scroller inside it was never
          ;; bounded either, and `overflow-hidden` clipped the rest. George,
          ;; 2026-09-11: the absence of scroll in the tabs.
          ;;
          ;; An inline style is the fix because it is the one thing Mantine's
          ;; stylesheet cannot outrank. It states what the class already meant.
          :style {:display "flex" :flexDirection "column" :minHeight 0
                  ;; A SWITCH TAKES THE SIZE OF WHAT IT SHOWS (2026-10-09,
                  ;; IKC3/PLAN-ikc-v3-068-01/H). A tab-set with :chrome false
                  ;; draws no tab, and the reading header uses it as a gate in a
                  ;; ROW. `1 1 0%` gave the gate no width there, so A−, Size, A+
                  ;; and Wrap went one under another in a pane of 286 px.
                  ;; `1 1 auto` starts from the content and still grows and
                  ;; shrinks. A gate with :flex 1, such as the page body, gets
                  ;; its share from the :flex wrapper round it, as before.
                  :flex (if chrome? "1 1 0%" "1 1 auto")}}
         (when (or chrome? (seq left) (seq right))
           ;; ONE LINE: the left children, the tabs, then the right children
           ;; pushed to the right edge. Each child keeps its own width, and a
           ;; child that does not fit goes to the next line.
           (into [:div {:class "flex flex-row flex-wrap items-center gap-x-2 gap-y-1"
                        :data-tab-line true}]
                 (concat
                  (for [[i h] (map-indexed vector left)] ^{:key (str "l" i)} [:div {:class "flex-none"} h])
                  (when chrome?
                    [^{:key "tabs"}
                     [:> TabsList {:style {:flex "0 0 auto"}}
                      (for [[i [title _]] (map-indexed vector labelled-children)]
                        ^{:key i} [:> TabsTab {:value (str i)} (or title "?")])]])
                  (when (seq right)
                    [^{:key "r"}
                     (into [:div {:class "flex flex-row flex-wrap items-center gap-x-2 gap-y-1 ml-auto"}]
                           (for [[i h] (map-indexed vector right)] ^{:key (str "r" i)} [:div {:class "flex-none"} h]))]))))
         (for [[i [_ child draft?]] (map-indexed vector labelled-children)]
           ^{:key i} [:> TabsPanel {:value (str i)
                                    :class "flex-1 min-h-0 flex flex-col overflow-hidden [&>*]:flex-1 [&>*]:min-h-0"
                                    ;; AND THE PANEL NEEDS THE SAME INLINE STYLE
                                    ;; AS THE ROOT. Measured 2026-09-11 after the
                                    ;; root was fixed: `.mantine-Tabs-panel`
                                    ;; overrides the utility here too, so the
                                    ;; panel computed `flex: 0 1 0%` — grow ZERO —
                                    ;; and the active tab was given no height at
                                    ;; all. Its content then had a scroller with a
                                    ;; clientHeight of 0, which reads on screen as
                                    ;; an empty tab rather than as a tall one.
                                    :style {:display "flex" :flexDirection "column"
                                            :flex "1 1 0%" :minHeight 0}}
                      ;; The panel element stays — Mantine keys its tabs to it —
                      ;; and its CONTENT is drawn only when this tab is the one
                      ;; on screen, or when it can be holding unsaved text.
                      (when (or (= i idx) draft?) child)])]))))

(def draft-holding-kinds
  "The widget kinds whose RENDERER owns an edit buffer, so unmounting one throws
   away text a person typed and has not saved.

   :input and :text-area each hold a `buf` reagent atom, and :outline's rows hold
   one per row with a `dirty?` flag beside it. A remount seeds the buffer from the
   bound value again, which is the LAST SAVED text — so the unsaved part is gone
   with no message. That is the failure mode this project refuses by name: a
   write that cannot complete must stay visible on screen.

   The other reagent atoms in this file are not drafts. :markdown's `pending`,
   :highlight-list's `tops` and :collapsible's `open?` are the renderer's own
   working state, and losing them costs a re-measure or a re-open, not a person's
   words."
  #{:input :text-area :outline})

(defn holds-draft?
  "Can any widget in this description subtree be holding unsaved text right now?

   Asked of the DESCRIPTION and not of the DOM, at the one place the resolved
   subtree still exists (graph-ui.web.render/render-node* — the same reason
   content-empty? below is decided there for :collapsible).

   WHY A TAB-SET NEEDS TO ASK. A tab-set draws one child at a time, and the web
   renderer used to MOUNT them all: measured 2026-08-23, one page click rebuilt
   every panel of the reading pane's seven and cost 798 DOM mutations, of which
   799 of 815 were inside the Tabs component. Drawing only the active child fixes
   that — and would silently drop an unsaved edit in the tab a person had
   switched away from. So the exception is DERIVED from what the tab holds, not
   declared per island: a derived rule cannot drift, and there is nothing to keep
   in step.

   IT IS ALSO A SYMPTOM. An editor's unsaved text should not live in component
   state at all (PLAN-ikc-v3-018-01). When it does not, this function is deleted
   and a tab-set draws one child with no exception."
  [{:keys [type children]}]
  (or (contains? draft-holding-kinds type)
      (boolean (some holds-draft? (or children [])))))

(defn content-empty?
  "Does this render-tree node hold nothing to show?

   The rule behind :collapsible's :hide-when-empty (F-platform-v0-014-01): a node
   is empty when no descendant carries a non-empty `:items` and none carries a
   non-blank `:value`. Absent `:items` counts as empty — an unbound node holds no
   content of its own, and every user of this prop binds a collection.

   STATED TWICE, HERE AND IN ui.render.tui, and that is a known cost rather than an
   oversight: shadow-cljs sees only `src/cljs`, so a `.cljc` shared with the server
   renderer is not reachable without a new source root. The same split the binding
   runtime already lives with (src/ui/bind.clj vs bind.cljs). Both copies are
   pinned by the same table of cases — T-web-widgets-061 here, T-tui-hide-empty
   there — so a change to one that is not made in the other fails a test rather
   than drifting."
  [{:keys [props children]}]
  (and (empty? (:items props))
       (str/blank? (str (:value props)))
       (every? content-empty? (or children []))))

(defn reveal-button
  "The icon a section header draws before its count while a tree inside it
   offers a reveal (reveal-context). `slot` is the r/atom the header provides.
   Nothing when the slot is empty, so a section with no such tree is unchanged."
  [slot]
  (when-let [go! @slot]
    [:span {:role "button" :tab-index 0
            :data-import-id "reveal-open-page"
            :title "Show the open page in the tree"
            :aria-label "Show the open page in the tree"
            :class "ikc-touch-target hover:bg-[var(--hover)]"
            :style {:display "inline-flex" :alignItems "center"
                    :justifyContent "center" :borderRadius "4px"
                    :cursor "pointer" :color "var(--muted)"}
            :on-click (fn [e] (.stopPropagation e) (.preventDefault e) (go!))
            :on-key-down (fn [e]
                           (when (#{"Enter" " "} (.-key e))
                             (.stopPropagation e) (.preventDefault e) (go!)))}
     [widget-icon {:icon :reveal :size :sm}]]))

(defn widget-collapsible
  "ADR-graph-ui-v0-013-01 §17: :count (a badge beside the title) and :icon (leading
   the title) are v2.0 additions — both nil under v1.x, both no-ops here.

   A CLOSED FOLD PLACES NOTHING INSIDE IT (PLAN-ikc-v3-033-01 step 4b). Mantine's
   Collapse was handed its children whatever `:in` said, so a closed section
   MOUNTED all of them and only hid them. A bind that waits for its widget to
   draw would then have fired at first paint and deferred nothing. The four
   sidebar trees live in closed folds, and they are the 878 kB.

   `children` is [[hiccup draft?] …], the shape :tab-set already takes, and the
   exception is the same one: a child that can hold unsaved text stays placed
   whatever the fold says. A remount seeds its buffer from the last SAVED value,
   so the typed part would go with nothing saying so. holds-draft? derives that
   from the subtree, so no island declares it and none can forget."
  [{:keys [title collapsed]} children & _]
  (let [open? (r/atom (not collapsed))
        ;; A tree inside offers its reveal here (reveal-context).
        reveal (r/atom nil)]
    (fn [{:keys [title count icon flex] :as props} children & [bus session-id]]
      ;; §19's typography lands on the TITLE line — SPEC-002's sidebar section
      ;; headers are small, bold and uppercase, which the description now says
      ;; (:size :xs :weight :bold :transform :uppercase) instead of the
      ;; renderer hardcoding one look for every collapsible in every island.
      (let [typo (typography-props props)]
        ;; A COLLAPSIBLE CAN BE THE THING THAT HOLDS A SCROLLING LIST, and then
        ;; its own title must stay put while the list moves under it (George,
        ;; 2026-08-07: "the Notes scroll scrolls NOTES title instead of to be
        ;; below it"). That needs the body to be a bounded flex child, so a
        ;; :scroll-area inside it has a height to scroll within.
        ;;
        ;; ONLY WHEN THE DESCRIPTION ASKED FOR THE HEIGHT (:flex). Applying it to
        ;; every collapsible let the SHORT sections collapse to nothing while
        ;; their rows spilled out — the Notes header drew on top of the Recent
        ;; list, seen 2026-08-07. min-h-0 is a licence to shrink, and a section
        ;; that was never given a height to fill must not take it.
        [:div {:class (str "text-sm" (when flex " flex flex-col min-h-0"))}
         [:> (.-UnstyledButton mantine)
          {:on-click (fn [_]
                       (let [now (not @open?)]
                         (reset! open? now)
                         ;; :toggle (PLAN-ikc-v3-028-01 Q5): the guide learns a
                         ;; section was opened. Fires only when declared.
                         (when-let [tpl (get-in props [:on-gesture :toggle])]
                           (when bus
                             (let [cmd (bind/fill-command tpl {'$session-id session-id
                                                               '$value {:import-id (str (:import-id props)) :open? now}})]
                               (js-invoke bus "dispatch" cmd (fn [_] nil)))))))
           :class "w-full text-left"}
          ;; DRAWN FROM ikc/section-header. The locked target states this line
          ;; exactly — 11px / 700 / uppercase / .05em with the count right-aligned
          ;; — and it is --type-micro plus a pill. The declaration owns the
          ;; treatment; this reads it.
          (let [cell (fn [k] (get-in section-header [:draws :cells k]))]
            [:div {:style (merge {:display "flex" :alignItems "center"
                                  :gap (token-var (get-in section-header [:draws :gap]))}
                                 )}
             [:span {:style (cell-style (cell 'caret))} (if @open? "▾" "▸")]
             (when icon [widget-icon {:icon icon :size :sm}])
             [:span {:style (merge (cell-style (cell 'name)) {:flex 1} (typo-css props))}
              (or title "")]
             ;; BEFORE THE COUNT (George, 2026-09-28). A span and not a button:
             ;; the whole header is one button, and a button may not hold one.
             [reveal-button reveal]
             (when count
               [:span {:style (cell-style (cell 'count))} (str count)])])]
         [:> (.-Collapse mantine)
          (cond-> {:in @open?} flex (assoc :className "flex-1 min-h-0"))
          [:> (.-Provider reveal-context) {:value reveal}
           (into [:div {:class (str "pl-2" (when flex " h-full min-h-0 flex flex-col"))}]
                 (keep (fn [[hiccup draft?]] (when (or @open? draft?) hiccup))
                       children))]]]))))

;; ---------------------------------------------------------------------------
;; :icon-button/:badge/:chip/:drawer/:color-input — Meta-UI v2.0's new kinds
;; (ADR-graph-ui-v0-013-01 §11-18), scoped by SPEC-002's locked target. New-at-v2.0,
;; so — like the container kinds above — no legacy shape to stay compatible
;; with.
;; ---------------------------------------------------------------------------

(defn- coach-target-rect
  "The bounding box of the element a coach mark points at, or nil: no DOM (a
   test), or no root carries this import-id yet."
  [target]
  (when (and (exists? js/document) (not (str/blank? (str target))))
    (when-let [el (.querySelector js/document (str "[data-import-id=\"" target "\"]"))]
      ;; A display:contents wrapper has NO BOX, so its rect is all zeros (seen
      ;; 2026-09-08: the mark sat at the top-left corner). Measure the first
      ;; child that has one; the ring goes on that child too.
      (let [boxed (loop [e el n 0]
                    (let [r (.getBoundingClientRect e)]
                      (if (or (and (pos? (.-width r)) (pos? (.-height r))) (> n 3) (nil? (.-firstElementChild e)))
                        e
                        (recur (.-firstElementChild e) (inc n)))))
            r (.getBoundingClientRect boxed)]
        {:el boxed :top (.-top r) :left (.-left r) :width (.-width r) :height (.-height r)}))))

(defn coach-card
  "The card a coach mark draws — PURE, so a test can hold it. `fire!` takes the
   gesture key and an optional $value."
  [{:keys [step title says index count has-do? done? pinned? done-all? on-gesture]} fire!]
  (let [btn (fn [label enabled? title on-click]
              [:button {:class (str "px-2 py-1 rounded border border-[var(--border)]" (if enabled? " ikc-hover" " ikc-disabled"))
                        :disabled (not enabled?) :title title
                        :on-click #(when enabled? (on-click))} label])
        can-do? (and has-do? (not done?))]
    [:div {:class "ikc-coach-card rounded-md border border-[var(--border)] p-3 text-sm max-w-[36ch]"
           :data-coach-step (str step)}
     (if done-all?
       [:<>
        [:div {:class "font-semibold mb-1"} "The guide is walked"]
        [:div {:class "ikc-dim mb-2"} (str says)]
        ;; "Start new research", not "Start again" (George, 2026-09-08: "'Start
        ;; again' dangerously sounds like 'Cancel' and start fresh"). The gesture
        ;; keeps its declared name :restart; what it fires is the declaration's.
        (btn "Start new research" true "Leave this project as it is, and begin the guide for a new one" #(fire! :restart nil))]
       [:<>
        [:div {:class "flex items-baseline justify-between gap-2 mb-1"}
         [:span {:class "font-semibold"} (str title) (when done? [:span {:class "ikc-dim"} " · done"])]
         [:span {:class "flex items-baseline gap-2"}
          (when (and index count) [:span {:class "ikc-dim text-xs"} (str index " / " count)])
          ;; A CLOSE ONLY WHEN ONE IS DECLARED. The shell's card declares
          ;; :close (2026-09-30: it had none, and only Guide me removed it); the
          ;; research pane's card lives in a pane that closes already.
          (when (:close on-gesture)
            [:button {:class "ikc-dim ikc-hover px-1" :title "Close the guide. Guide me opens it again."
                      :aria-label "Close the guide"
                      :data-coach-close "true"
                      :on-click #(fire! :close nil)} "✕"])]]
        [:div {:class "mb-2 whitespace-pre-wrap"} (str says)]
        [:div {:class "flex flex-wrap gap-2"}
         (btn "Previous" (and index (> index 1)) "Look at the step before" #(fire! :previous (dec index)))
         (btn "Do it for me" can-do?
              (cond done? "This step is done already" has-do? "Fire this step's own command" :else "This step is done by hand")
              #(fire! :submit nil))
         (btn "Next" (and index count (< index count)) "Look at the step after" #(fire! :next (inc index)))
         (when pinned? (btn "Resume" true "Back to the first step still to do" #(fire! :resume nil)))]])]))

(defn coach-fire
  "The gesture dispatcher of a coach mark: :on-gesture's key → the declared
   command, $session-id and $value filled, on the bus."
  [props bus session-id]
  (fn [k value]
    (when-let [tpl (get-in props [:on-gesture k])]
      (when bus
        (let [cmd (bind/fill-command tpl (cond-> {'$session-id session-id} value (assoc '$value value)))]
          (js-invoke bus "dispatch" cmd (fn [_] nil)))))))

(defn widget-coach-mark
  "A guide's pointer (PLAN-ikc-v3-028-01 Phase D). Stateless: every word is a
   prop bound from the guide's sources, every button one declared command.

   ANCHORED WHEN IT CAN BE. After each render it looks for the root whose
   data-import-id is :target, gives it the ring class and places the card under
   it (fixed position, measured on this frame). With no such element the card
   draws in place, at the top of its own pane — a step whose control is inside
   a folded section is still told (never nothing). :dim? draws a translucent
   overlay behind the card; the ring keeps the target readable through it."
  [_props _bus _session-id]
  (let [rect (r/atom nil)
        ringed (atom nil)
        measure! (fn [tgt]
                   (let [r (coach-target-rect tgt)]
                     (when-let [old @ringed] (when (not= old (:el r)) (.remove (.-classList old) "ikc-coach-target")))
                     (when-let [el (:el r)] (.add (.-classList el) "ikc-coach-target") (reset! ringed el))
                     (when (not= (dissoc r :el) (dissoc @rect :el)) (reset! rect r))))]
    (r/create-class
     {:display-name "coach-mark"
      :component-did-mount  (fn [this] (measure! (:target (r/props this))))
      :component-did-update (fn [this _] (measure! (:target (r/props this))))
      :component-will-unmount (fn [_] (when-let [el @ringed] (.remove (.-classList el) "ikc-coach-target")))
      :reagent-render
      (fn [{:keys [dim? index count] :as props} bus session-id]
        ;; THE CARD STAYS IN ITS PANE, in flow. What floats is the target's ring
        ;; and a small badge with the step's number at the target's corner — a
        ;; card floated beside a column of controls always covered one of them
        ;; (George, 2026-09-08, three times).
        (let [card (coach-card props (coach-fire props bus session-id))
              r    @rect]
          [:<>
           card
           (when r
             [:<>
              (when dim? [:div {:class "ikc-coach-overlay"}])
              ;; AT THE TARGET'S TOP-RIGHT CORNER. At the top-left it sat on the
              ;; first letter of the section label above the box ("NQUIRY",
              ;; George's screenshot, 2026-09-08); a label starts at the left,
              ;; so the right corner is the one with nothing under it.
              [:div {:class "ikc-coach-badge"
                     :title (str (:title props) " — " (:says props))
                     :style {:top  (str (max 4 (- (:top r) 11)) "px")
                             :left (str (max 4 (- (+ (:left r) (:width r)) 26)) "px")}}
               (if (and index count) (str index) "•")]])]))})))

(defn widget-icon-button
  ":on (§12) is a renderer convention — ActionIcon has no native 'pressed'
   prop, so it swaps variant filled/subtle. Also covers SPEC-002's 'toggle
   button' row: mutual exclusion among several is the composing description's
   concern (each button's :on-gesture clears its siblings), not a second kind
   here.

   :confirm asks its question first, and a click sends nothing without a yes.
   :copy-result writes that key of the command's answer to the clipboard, in
   the reply callback, because the reply is the only place the text exists
   (lane AL-R: Delete note and Copy note as text)."
  [{:keys [icon tooltip on disabled copy-result] question :confirm :as props} bus session-id]
  (let [submit (submit-template props)
        Cmp    (get icon-components icon)
        btn    [:> (.-ActionIcon mantine)
                {:variant (if on "filled" "subtle")
                 :color "accent"
                 :disabled (boolean disabled)
                 :aria-label tooltip
                 :on-click (fn [e]
                             (.preventDefault e)
                             (when (and submit bus (not disabled)
                                        (or (not question) (js/confirm question)))
                               (let [cmd (bind/fill-command submit {'$session-id session-id})]
                                 (js-invoke bus "dispatch" cmd
                                   (fn [reply]
                                     (when-let [t (and copy-result (get reply copy-result))]
                                       (some-> js/navigator .-clipboard (.writeText t))))))))}
                (when Cmp [:> Cmp {:size 16}])]]
    (if tooltip
      [:> (.-Tooltip mantine) {:label tooltip} btn]
      btn)))

(defn- highlight-swatch
  "The dot carrying a highlight's own colour.

   The colour comes from the theme token — var(--hl-1) … var(--hl-4) — and NOT
   from a hardcoded hex or a Mantine palette name, which the quality gate forbids
   for exactly this reason: a highlight painted in Mantine 'yellow' would stay
   that yellow when the theme changed, and the dot beside the text would then
   disagree with the wash over the text.

   Full opacity here, deliberately, while the wash over the document text is 35%:
   a 6px dot at 35% alpha is invisible. The dot's job is identification, the
   wash's is not obscuring what it covers."
  [color]
  [:span {:style {:display "inline-block" :width "8px" :height "8px"
                  :borderRadius "50%" :flexShrink 0
                  ;; The SAME function the wash over the words reads
                  ;; (fault report d122f7ab: the two disagreed).
                  :background (md/highlight-colour color)}}])

(defn- scroll-to-highlight!
  "Bring the marked words into view, and flash them.

   The margin lists what you marked; a listed highlight you cannot reach is a
   reference with no referent (George, 2026-08-15: \"I expect that if I click it
   will be taken to the highlight itself\"). The mark carries its own id, so this
   is a lookup rather than a search through the text.

   An ORPHANED highlight has no mark to scroll to — its words are gone from the
   document, which is what orphaned means — so its row does not offer the jump."
  [id]
  (when id
    (when-let [el (.querySelector js/document
                                  (str "[data-highlight-id=\"" id "\"]"))]
      (.scrollIntoView el #js {:behavior "smooth" :block "center"})
      ;; A brief ring: scrolling alone leaves you looking at a paragraph without
      ;; saying which words you came for.
      (.add (.-classList el) "ring-2")
      (js/setTimeout #(.remove (.-classList el) "ring-2") 1200))))

(defn stack-tops
  "Rows placed at their marks' offsets, pushed down so none covers the one above.

   PURE, and public so it can be tested without a browser: `rows` are
   `{:id :top}` in any order, `row-h` is a row's height plus its gap. Returns them
   ordered by position with `:top` adjusted.

   THE TEXT NEVER MOVES. Two highlights on one line would want the same offset, so
   the second cascades DOWN the margin instead of the document reflowing to make
   room (George, 2026-08-15: \"Text rendering do not change if more highlights are
   on a line, the highlights in the gutter wrap down on next lines\"). A margin is
   an annotation; annotations do not get to move what they annotate.

   A ROW WITH NO :top HAS NO MARK ON SCREEN — orphaned, or its text is somewhere
   the renderer could not reach — and it goes to the BOTTOM, after every placed
   row. It used to go to the TOP, because `nil` sorts before every number and the
   cascade then started from 0: on a document whose marks were 900px down, the
   unplaceable one sat alone at the top of an otherwise empty margin, which is
   exactly what it looks like when a feature is broken (George, 2026-08-16: the
   highlights are \"displayed in the empty space\"). Listed-but-last says the same
   thing honestly."
  [rows row-h]
  (let [placed   (sort-by :top (filter :top rows))
        unplaced (remove :top rows)]
    (->> (concat placed unplaced)
         (reduce (fn [acc {:keys [top] :as r}]
                   (let [floor (if-let [prev (peek acc)] (+ (:top prev) row-h) 0)]
                     (conj acc (assoc r :top (max (or top 0) floor)))))
                 []))))

(def ^:private gutter-row-height
  "A row plus its gap, in px. Used only to keep rows from overlapping — the rows
   themselves are laid out by the browser."
  22)

(defn widget-highlight-list
  "The document's highlights, listed beside it and LEVEL WITH THEM — ikc1's right
   gutter, grown up (F-platform-v0-011-01, ADR-graph-ui-v0-017-01 §5).

   A COLUMN, not a floating list. It draws its own left border so it reads as a
   region of the page even when empty — a place things go rather than a thing that
   appears, because it will carry more than highlights (George, 2026-08-15).

   THE ONLY RIGHT-HAND REGION. It sits directly beside the page body, starting
   where the text ends. There was briefly a second one — a per-row chip column
   inside the block row, carrying a `2 hl` count — and George removed the idea
   rather than the duplicate: \"no extra gutters\" (2026-08-15), then, of the
   captioned panel further right, \"it holds a highlight that belongs to the right
   gutter\" (2026-08-16). A count beside the text and the highlights themselves
   further right stated one fact in two places, in two columns.

   A header is opt-in (:title). Beside the text it needs none.

   EACH ROW SITS AT ITS OWN MARK. The margin and the document scroll together (the
   block file puts this inside that body's own scroller — one per modality since
   2026-09-12, ADR-graph-ui-v0-031-01), so a mark's position and a row's
   position are in one coordinate system: the row is placed at the mark's offset
   from the top of this column, measured after paint. Two marks on one line
   cascade down (stack-tops) rather than overlapping, and the text is never
   touched.

   A highlight with no mark on screen — an orphan, or one whose text the renderer
   could not reach — keeps its place in document order at the bottom, listed and
   removable. Losing it because it cannot be positioned would be the one outcome
   worse than misplacing it.

   Gestures: :remove ($value = the row's :id). Creating is not a gutter
   affordance: you highlight by selecting text in the document."
  [_props _bus _session-id]
  (let [tops (r/atom {})
        root (atom nil)
        ;; MEASURE AFTER LAYOUT, AND MORE THAN ONCE.
        ;;
        ;; The marks are in a SIBLING — the document body, or the row's own text
        ;; cell — so when this column mounts they may not be laid out yet, and a
        ;; measurement taken then finds nothing. It used to stop there: the rows
        ;; fell back to their unmeasured order, stacked from the top of the
        ;; gutter, and nothing ever measured again. George, 2026-08-16: "they are
        ;; not aligned with its line … but after setting new highlight on the
        ;; first line of the block it appeared on its line and the other aligned
        ;; with their line" — the new highlight forced the re-render that this
        ;; should not have needed.
        ;;
        ;; rAF puts the read after the browser's own layout. The retries cover
        ;; the case where the text arrives a frame or two later still; they stop
        ;; as soon as anything is found, and `measure!` only writes when the
        ;; result CHANGED, so neither can loop.
        attempt
        (fn attempt [tries]
          (js/requestAnimationFrame
           (fn []
             (when-let [el @root]
            (let [base (.-top (.getBoundingClientRect el))
                  ;; ONLY MARKS THAT ARE ACTUALLY LAID OUT. An editable page draws
                  ;; its Preview and its Edit tab at once and hides one, so every
                  ;; highlight has TWO marks in the document and the hidden one
                  ;; measures at zero. Which won came down to document order, which
                  ;; is not a thing to depend on: a zero-size rect means the element
                  ;; is not on screen, and an offset taken from it is a guess.
                  ;; THE TOPMOST ONE WINS, not the last in document order. Since
                  ;; 2026-08-16 a highlight is drawn as several marks — the run is
                  ;; cut at every overlap boundary — and a highlight that spans a
                  ;; line break has one mark per line anyway. `into {}` would have
                  ;; kept whichever came last, putting the row beside the END of
                  ;; the passage instead of its beginning.
                  found (reduce
                         (fn [acc m]
                           (let [id   (.getAttribute m "data-highlight-id")
                                 rect (.getBoundingClientRect m)]
                             (if (and id (pos? (.-width rect)) (pos? (.-height rect)))
                               (let [t (max 0 (- (.-top rect) base))]
                                 (assoc acc id (min t (get acc id t))))
                               acc)))
                         {}
                         (array-seq (.querySelectorAll js/document "[data-highlight-id]")))]
               ;; Only write when it actually changed, or the re-render this
               ;; triggers measures again and never settles.
               (when (not= found @tops) (reset! tops found))
               (when (and (pos? tries) (empty? found))
                 (js/setTimeout #(attempt (dec tries)) 120)))))))
        measure! (fn [& _] (attempt 4))]
    (r/create-class
     {:component-did-mount  measure!
      :component-did-update measure!
      :reagent-render
      (fn [{:keys [items title empty-label chrome level-with-text] :as props} bus session-id]
        (let [actions  (gesture-actions props)
              remove*  (:remove actions)
              ;; :set-level (Meta-UI v2.1, PLAN-026 D, RESEARCH-021 D5): Forte's
              ;; layer 1 to 5, picked per row; $value is {:highlight-id :level}.
              level*   (:set-level actions)
              ;; :link — the wikilink for one mark, to paste into a note
              ;; (George, 2026-08-24). Absent by default, so the reading pane's
              ;; gutter shows no new control until its description asks.
              link*    (:link actions)
              ;; :make-work-item — a work item from this highlight
              ;; (IKC3/PLAN-ikc-v3-071-01/HIGHLIGHT). $value is the row's :id.
              ;; Absent by default, as :link is.
              item*    (:make-work-item actions)
              ;; DOCUMENT ORDER, not the order they were made in. The query
              ;; returns a page's highlights however storage holds them, which for
              ;; a block slot is the order they were added — so a gutter that had
              ;; not measured yet listed them by age (George, 2026-08-16: "they
              ;; are not in the order they appear in the text, they are listed in
              ;; the order of making"). Once measured, positions decide; this is
              ;; what the list says in the moment before that, and after a reload
              ;; it is the first thing seen.
              ;;
              ;; :start is the offset in the text the highlight is ON — the block
              ;; for a row's gutter, the file for a document's — so within one
              ;; gutter it IS document order.
              rows     (vec (sort-by #(or (:start %) 0) items))
              measured @tops
              placed   (stack-tops (map-indexed
                                    (fn [i {:keys [id]}]
                                      {:id id :i i :top (get measured id)})
                                    rows)
                                   gutter-row-height)
              by-id    (into {} (map (juxt :id identity)) placed)
              ;; Anything with no mark on screen keeps document order at the end.
              unplaced (remove #(contains? measured (:id %)) placed)]
          ;; :chrome false drops the left edge and the padding — for a list drawn
          ;; inside a box that already has both, which is the block row's right
          ;; gutter. A second border inside a bordered cell is a line nobody asked
          ;; for.
          [:div {:class (str "flex flex-col h-full relative "
                             (when-not (false? chrome)
                               "pl-2 border-l border-[var(--border)]"))
                 :ref (fn [el] (reset! root el))}
           ;; A HEADER ONLY IF THE DESCRIPTION ASKS FOR ONE. It used to caption
           ;; itself "HIGHLIGHTS" unconditionally, which was right while this was
           ;; a panel at the far right edge of the pane and had to announce what
           ;; it was. It now sits directly beside the text with its rows level
           ;; with the words they mark, and a caption over that is a label on
           ;; something already self-evident (George, 2026-08-16). The reading
           ;; area passes no :title; a surface that wants one still can.
           (when title
             [:div {:class (str "flex items-center justify-between text-[10px] uppercase "
                                "tracking-wide text-[var(--muted)] pb-1")}
              [:span title]
              (when (seq rows) [:span {:class "text-[var(--faint)]"} (str (count rows))])])
           ;; AN EMPTY GUTTER SAYS NOTHING. It used to print "Nothing highlighted
           ;; on this page" on every unmarked document — George, 2026-08-17:
           ;; "Parasitic message on Markdown and Leo pages". Most pages are
           ;; unmarked, so that sentence was on screen almost always, stating
           ;; something the reader can see for themselves.
           ;;
           ;; The column is still drawn, and that is the whole message: a place
           ;; things go, empty. No :empty-label, no text — and no hardcoded
           ;; fallback either, which is what made the old one unavoidable from the
           ;; declaration. A surface that genuinely wants a sentence can still
           ;; pass one.
           (if (empty? rows)
             (when-not (str/blank? empty-label)
               [:div {:class "text-[11px] text-[var(--faint)]"} empty-label])
             (into [:div {:class "relative flex-1"}]
                   (map
                    (fn [{:keys [id anchor-text color level note orphaned n work-items] :as row}]
                      (let [top (get-in by-id [id :top])
                            ;; LEVEL WITH THE TEXT, or a plain list.
                            ;;
                            ;; This widget MEASURES the marks and puts each row at
                            ;; its mark's own height, which is the whole point
                            ;; beside a document. It only works where the widget
                            ;; sits beside the body it measured. In a tile's
                            ;; Bookmarks section it does not, and the rows landed
                            ;; in the tile BELOW — seen on 2026-08-24.
                            ;;
                            ;; DEFAULT TRUE, because the reading pane's gutter is
                            ;; the older caller and its behaviour must not change.
                            positioned? (and (not (false? level-with-text))
                                             (contains? measured id))]
                        ^{:key (or id anchor-text)}
                        [:div {:class (str "flex items-center gap-1.5 text-[11px] min-w-0 w-full "
                                           (when-not orphaned
                                             "cursor-pointer hover:bg-[var(--hover)] rounded-sm"))
                               :style (cond-> {}
                                        orphaned    (assoc :opacity 0.45)
                                        positioned? (assoc :position "absolute" :top top :left 0 :right 0))
                               :title (str anchor-text (when note (str " - " note)))
                               :on-click (when-not orphaned #(scroll-to-highlight! id))}
                         (highlight-swatch color)
                         ;; ITS INDEX, when the row carries one. A bookmark has
                         ;; no colour to be told apart by, and two may share a
                         ;; name — George, 2026-08-24: "allow for bookmarks with
                         ;; the same name, may be to index them". The number is
                         ;; the place in reading order, derived on the server.
                         (when n
                           [:span {:class "text-[10px] font-semibold text-[var(--accent)] shrink-0"}
                            (str n)])
                         (if (and level* bus)
                           [:select {:class (str "text-[10px] bg-transparent shrink-0 rounded-sm "
                                                 "border border-[var(--border)] text-[var(--muted)]")
                                     :value (str (or level 1))
                                     :aria-label "Layer, 1 to 5"
                                     :title "Progressive summarization layer: 1 saved, 2 bold, 3 best, 4 summary, 5 remix"
                                     :on-click #(.stopPropagation %)
                                     :on-change (fn [e]
                                                  (.stopPropagation e)
                                                  (let [n   (js/parseInt (.. e -target -value) 10)
                                                        cmd (bind/fill-command
                                                             level* {'$session-id session-id
                                                                     '$value {:highlight-id id :level n}})]
                                                    (js-invoke bus "dispatch" cmd (fn [_] nil))))}
                            (for [n (range 1 6)]
                              ^{:key n} [:option {:value (str n)} (str "L" n)])]
                           (when level
                             [:span {:class "text-[10px] text-[var(--muted)] shrink-0"} (str "L" level)]))
                         [:span {:class (str "flex-1 min-w-0 overflow-hidden text-ellipsis "
                                             "whitespace-nowrap text-[var(--text)] "
                                             (when orphaned "line-through"))}
                          anchor-text]
                         (when note
                           [:span {:class "text-[10px] text-[var(--muted)] shrink-0"} "\u270e"])
                         ;; THE MARK FOR EACH WORK ITEM OF THE HIGHLIGHT
                         ;; (IKC3/PLAN-ikc-v3-071-01/HIGHLIGHT): its key, for
                         ;; example IKC-12, level with the marked text. The
                         ;; rows come from :highlights/for-page. Spread with
                         ;; `into`, because a bare vector as one child is read
                         ;; as a component.
                         (when (seq work-items)
                           (into [:span {:class "flex items-center gap-1 shrink-0"
                                         :data-work-items (str (count work-items))}]
                                 (map (fn [{k :key t :title wid :id}]
                                        ^{:key (str wid)}
                                        [:span {:class (str "text-[10px] font-semibold rounded-sm px-1 "
                                                            "border border-[var(--border)] text-[var(--accent)]")
                                                :title (str "Work item " k (when t (str ": " t)))}
                                         (or k "item")]))
                                 work-items))
                         (when (and item* bus)
                           [:> (.-ActionIcon mantine)
                            {:variant "subtle" :size "xs" :color "gray"
                             :aria-label "Make a work item"
                             :title "Make a work item from this highlight"
                             :on-click (fn [e]
                                         ;; Not the row's click: this makes, it does not go.
                                         (.stopPropagation e)
                                         (.preventDefault e)
                                         (let [cmd (bind/fill-command
                                                    item* {'$session-id session-id '$value id})]
                                           (js-invoke bus "dispatch" cmd (fn [_] nil))))}
                            (when-let [Cmp (get icon-components :plus)] [:> Cmp {:size 12}])])
                         ;; THE LINK, TO PASTE INTO A NOTE (2026-08-24). George
                         ;; asked for it on a bookmark: "at least bookmarks to
                         ;; have context menu to get link that targets it - so I
                         ;; can paste it in my notes."
                         ;;
                         ;; THE CLIPBOARD IS THE CLIENT'S. The command answers
                         ;; with the text and this writes it, because a server
                         ;; cannot reach a clipboard. The reply is the only place
                         ;; the text exists, so it is copied in the callback.
                         (when (and link* bus)
                           [:> (.-ActionIcon mantine)
                            {:variant "subtle" :size "xs" :color "gray"
                             :aria-label "Copy a link to this mark"
                             :on-click (fn [e]
                                         (.stopPropagation e)
                                         (.preventDefault e)
                                         (let [cmd (bind/fill-command
                                                    link* {'$session-id session-id '$value id})]
                                           (js-invoke bus "dispatch" cmd
                                             (fn [reply]
                                               (when-let [t (:link reply)]
                                                 (some-> js/navigator .-clipboard
                                                         (.writeText t)))))))}
                            (when-let [Cmp (get icon-components :link)] [:> Cmp {:size 12}])])
                         (when (and remove* bus)
                           [:> (.-ActionIcon mantine)
                            {:variant "subtle" :size "xs" :color "gray"
                             :aria-label "Remove highlight"
                             :on-click (fn [e]
                                         ;; Not the row's click: removing is not reaching.
                                         (.stopPropagation e)
                                         (.preventDefault e)
                                         (let [cmd (bind/fill-command
                                                    remove* {'$session-id session-id '$value id})]
                                           (js-invoke bus "dispatch" cmd (fn [_] nil))))}
                            (when-let [Cmp (get icon-components :close)] [:> Cmp {:size 12}])])]))
                    rows)))]))})))

(defn widget-badge
  "Non-interactive — no :on-gesture. A labelless, circular :badge (§13) is
   SPEC-002's 'status LED' row: a state-coloured dot, not a seventh kind.
   §19's typography applies: the locked target's kind badge is uppercase and
   letter-spaced, which :transform :uppercase now says in the description."
  [{:keys [label circle tone] :as props}]
  [:> (.-Badge mantine)
   (merge {:circle (boolean circle)
           :color (mantine-color tone)
           :variant "light"}
          (typography-props props))
   (or label "")])

(defn widget-chip
  "Interactive, unlike :badge — reports its own selected state (§14): the
   ikc1 #tag filter needs a clickable tag that toggles."
  [{:keys [label selected] :as props} bus session-id]
  (let [submit (submit-template props)]
    [:> (.-Chip mantine)
     {:checked (boolean selected)
      :variant "light"
      :on-change (fn [checked]
                   (when (and submit bus)
                     (let [cmd (bind/fill-command submit {'$session-id session-id '$value checked})]
                       (js-invoke bus "dispatch" cmd (fn [_] nil)))))}
     (or label "")]))

(defn widget-drawer
  "§15: closing (Escape, scrim click, or the built-in close button — all
   three are Mantine ModalBase's own affordances) fires :submit with no
   $value, the same slot a plain :button fires."
  [{:keys [opened title position size] :as props} bus session-id children]
  (let [submit (submit-template props)
        close! (fn []
                 (when (and submit bus)
                   (let [cmd (bind/fill-command submit {'$session-id session-id})]
                     (js-invoke bus "dispatch" cmd (fn [_] nil)))))]
    (into [:> (.-Drawer mantine)
           {:opened (boolean opened)
            :onClose close!
            :title (or title "")
            :position (or (some-> position name) "right")
            :size (or (some-> size name) "md")}]
          children)))

(defn widget-color-input
  "§16: fires :submit on change (a swatch pick is discrete, like :select's
   choose→command — not buffered like :input's Enter→command)."
  [{:keys [value placeholder] :as props} bus session-id]
  [:> (.-ColorInput mantine)
   {:value (or value "")
    :placeholder (or placeholder "")
    :on-change (fn [v]
                 (when-let [submit (submit-template props)]
                   (when bus
                     (let [cmd (bind/fill-command submit {'$session-id session-id '$value v})]
                       (js-invoke bus "dispatch" cmd (fn [_] nil))))))}])

;; ---------------------------------------------------------------------------
;; :tags-input — the tags of the thing being read (F-ikc-v3-018-01).
;;
;; HAND-WRITTEN BECAUSE IT BINDS DATA. graph-ui.web.mantine-generic drives a
;; generated kind straight from its declaration, and its own docstring says what
;; it cannot give: "no data binding, no edit buffer and no selection state". This
;; one needs the first, Mantine keeps the other two, and the diff below is the
;; third thing generic could not do.
;;
;; ONE HANDLER COVERS SIX BEHAVIOURS. Mantine's TagsInput reports the WHOLE new
;; array on every change — Enter, a comma, a blur, the cross on a tag, Backspace
;; in an empty field, and a pick from the dropdown all arrive the same way. The
;; declared gestures carry ONE tag each (ADR-ikc-v3-080-01 decision 7), because
;; :knowledge-graph/tag-frame and its remove half take one tag each. So this
;; compares the new array with the old and fires per difference.
;;
;; THE DIFF IS SET-BASED AND ORDER IS IGNORED, deliberately. A person who drags a
;; tag has not added or removed one, and a pair of dispatches for a reorder would
;; write the slot twice for no change.
;;
;; A CLICK ON A CHIP IS THE WAY TO THE FILTER (SPEC-alatus-v0-002-02 row C-36,
;; ikc1's affordance at SPEC-alatus-v0-001-02 §5b). Mantine gives a Pill no
;; onClick of its own, so the click a pill bubbles up through the field is
;; delegated by where it landed: inside .mantine-Pill-root but not inside the
;; cross's <button> is a pick of the name the chip shows — the very spelling
;; :page-tag-list was asked for — and anywhere else is the field itself.
;; ---------------------------------------------------------------------------

(defn- fire-tag-gesture!
  "Dispatch one declared gesture with one tag in $value."
  [props bus session-id gesture tag]
  (when-let [template (bind/gesture-template props gesture)]
    (when bus
      (js-invoke bus "dispatch"
                 (bind/fill-command template {'$session-id session-id '$value tag})
                 (fn [_] nil)))))

(defn- pick-tag-at!
  "A click inside the tags field: when it landed on a chip but not on the
   chip's cross, send :pick with the label that chip shows."
  [props bus session-id e]
  (let [t (.-target e)
        pill (when (and t (.-closest t)) (.closest t ".mantine-Pill-root"))]
    (when (and pill (not (.closest t "button")))
      (when-let [tag (some-> (.querySelector pill ".mantine-Pill-label")
                             (.-textContent))]
        (fire-tag-gesture! props bus session-id :pick tag)))))

(defn tag-matches?
  "PURE. Does the tag `option` answer what a person typed?

   A LEADING `#` IS NOT PART OF THE QUESTION (IKC3-Bugs-20260928 item 12,
   George: \"There is no code completion or suggestions when adding tag above
   reading pane\"). He writes a tag as he writes it in a note, `#IKC3`, and the
   vocabulary holds `ikc3`. Mantine's own filter looked for `#ik` inside `ikc3`,
   found nothing, and drew an empty list — measured on a probe bus 2026-09-29:
   108 suggestions for `i`, 0 for `#i`. Case does not count either."
  [search option]
  (let [norm (fn [x] (str/lower-case (str/replace (str/trim (str x)) #"^#+" "")))
        q    (norm search)]
    (str/includes? (norm option) q)))

(defn- tag-filter
  "Mantine's OptionsFilter for the tags line, over tag-matches?."
  [^js input]
  (let [search (.-search input)]
    (.filter (.-options input)
             (fn [^js o] (tag-matches? search (or (.-value o) (.-label o)))))))

(defn widget-tags-input
  "Meta-UI :tags-input. :value is the tags, :suggestions the vocabulary the
   client filters. Read-only draws them and dispatches nothing, which is also the
   TUI posture. A click on a chip fires :on-gesture's :pick — ikc1's way to the
   sidebar's tag filter."
  [{:keys [value suggestions placeholder read-only size] :as props} bus session-id]
  (let [tags (vec (keep #(when (seq (str %)) (str %)) (or value [])))]
    ;; THE DELEGATED CHIP CLICK IS THE WIDGET'S OWN ELEMENT, not a Mantine
    ;; prop — no prop channel reaches an element that contains the pills:
    ;; ...rest lands on the inner field (the <input>, a sibling of every
    ;; pill) and :wrapperProps ends as a dead attribute on InputBase. A
    ;; display:contents div has no box of its own, but every chip click
    ;; bubbles through it. The cross inside the pill is a <button> and
    ;; answers for itself, so pick-tag-at! reads the target.
    [:div {:style {:display "contents"}
           :on-click (fn [e]
                       (when-not read-only
                         (pick-tag-at! props bus session-id e)))}
     [:> (.-TagsInput mantine)
      {:value tags
       :data (vec (keep #(when (seq (str %)) (str %)) (or suggestions [])))
       :placeholder (or placeholder "Add a tag")
       :readOnly (boolean read-only)
       :size (name (or size :sm))
       :clearable false
       :filter tag-filter
       ;; A chip a person can click LOOKS like one — the pointer is the whole
       ;; affordance, and it is Mantine's own styles API that draws it.
       :styles #js {:pill #js {:cursor "pointer"}
                     ;; THE FIELD TAKES THE WIDTH IT IS GIVEN (2026-10-09,
                     ;; IKC3/PLAN-ikc-v3-068-01/H). It shares the first line of
                     ;; the reading header, and in a pane of 170 px its own
                     ;; minimum pushed it past the edge of the pane. The root
                     ;; sits under a display:contents wrapper, so the :flex
                     ;; wrapper's min-w-0 does not reach it. It is said here.
                     :root #js {:minWidth 0}
                     :inputField #js {:minWidth 0}}
       ;; The vocabulary holds hundreds of tags. A list longer than this is
       ;; scrolled past, not read.
       :limit 50
       ;; A comma is Mantine's own split character. Enter and a blur are its
       ;; defaults, so the four ways to add need no configuration here.
       :splitChars #js [","]
       :onChange
       (fn [next]
         (when-not read-only
           (let [nxt   (vec (js->clj next))
                 was   (set tags)
                 now   (set nxt)
                 added (remove was nxt)
                 gone  (remove now tags)]
             (doseq [t added] (fire-tag-gesture! props bus session-id :add t))
             (doseq [t gone]  (fire-tag-gesture! props bus session-id :remove t)))))}]]))

;; ---------------------------------------------------------------------------
;; :table.
;; ---------------------------------------------------------------------------

(defn- table-cell
  [row k]
  (cond
    (contains? row k)                       (get row k)
    (and (keyword? k) (contains? row (name k))) (get row (name k))
    (and (string? k) (contains? row (keyword k))) (get row (keyword k))
    :else ""))


;; ---------------------------------------------------------------------------
;; :verse-rows — a book's reading surface. ONE ROW PER VERSE.
;;
;; WHY IT EXISTS. The book drew two markdown documents side by side, one per
;; language, and they drift: the same 275 verses are 45,580 characters of English
;; and 11,234 of Chinese, so by the ninth verse the two are a screen apart.
;; George drew the drift on a screenshot, 2026-08-25. Synchronising the scroll
;; would keep two drifting documents at one offset, which is not alignment.
;;
;; FOUR CELLS, the shape alatus/reading-area already states for blocks:
;; `block-row holds number-gutter / body / right-gutter`. Here it is the verse
;; number, the translation, the source text, and the verse's notes.
;;
;; THE NOTES CELL IS THE GUTTER, so it follows what is read with no mechanism at
;; all — it is in the row. A verse with no notes renders an empty cell.
;;
;; A VERSE IS ONE PARAGRAPH, which is what lets a row exist: prose typography
;; here needs no markdown, so the cell can be styled text and still read as
;; prose. A markdown document cannot be a table cell.
;; ---------------------------------------------------------------------------

(defn- verse-note-cell
  "THE EXPLANATION, NOT THE LEMMA. This drew each note's :head, which for a
   Chinese classic is usually the term itself — George, 2026-08-25: \"There are
   some Chinese chars in the augumented reading space - that do not augument my
   reading but the opposite.\" A head is a label; what augments reading is the
   note's text. The kind rides along as a small tag, because knowing a note is a
   contested reading rather than a definition changes how it is read."
  [notes]
  (if (empty? notes)
    ;; NOTHING TO SHOW SHOWS NOTHING. George, 2026-08-25.
    [:div {:class "min-w-0"}]
    [:> (.-Stack mantine) {:gap 6}
     (for [[i {:keys [kind text]}] (map-indexed vector notes)]
       ^{:key i}
       [:div {:class "min-w-0"}
        (when kind
          [:> (.-Text mantine) {:size "xs" :c "dimmed" :tt "uppercase" :fw 700} kind])
        [:> (.-Text mantine) {:size "xs" :style #js {:lineHeight 1.5}} text]])]))

(defn- verse-divider
  "A draggable rule between two reading columns.

   THE WIDTHS ARE THE READER'S. George, 2026-08-25: \"when you fix the dividers,
   I will drag the widths as I wish.\" So this does not pick proportions — it
   moves them, and dispatches the reader's choice on release so the session keeps
   it. A drag that only lived in the browser tab would be forgotten on reload,
   and a layout belongs to the surface.

   `drag` is the reagent atom holding the in-flight fractions, `commit!` sends
   them once the mouse comes up. Live feedback is local; the dispatch is one per
   drag, not one per pixel."
  [i drag widths commit!]
  [:div
   ;; POSITIONED AND RAISED, so the handle actually receives the press. It first
   ;; carried negative margins to widen its grab area, which put the neighbouring
   ;; text on top of it — two handles rendered, and a drag did nothing at all.
   {:style #js {:flex "0 0 11px" :cursor "col-resize" :alignSelf "stretch"
                :position "relative" :zIndex 2 :minHeight "1.4rem"}
    :data-testid "verse-column-divider"
    :title "Drag to resize"
    :on-mouse-down
    (fn [e]
      (.preventDefault e)
      (let [row     (.. e -currentTarget -parentNode)
            ;; THE FRACTIONS SHARE WHAT THE CELLS HOLD, not the whole row (fault
            ;; report 0de32d08), so a pixel of drag is measured against the
            ;; cells alone. The gutter and the handles do not move.
            total   (max 1 (reduce + (map #(.-offsetWidth %)
                                          (array-seq (.querySelectorAll row "[data-verse-cell]")))))
            start-x (.-clientX e)
            base    (vec (or @drag widths))
            move    (fn [^js ev]
                      (let [d  (/ (- (.-clientX ev) start-x) total)
                            a  (nth base i)
                            b  (nth base (inc i))
                            a' (max 0.10 (min (- (+ a b) 0.10) (+ a d)))
                            b' (- (+ a b) a')]
                        (reset! drag (assoc base i a' (inc i) b'))))
            up      (atom nil)]
        (reset! up (fn [_]
                     (.removeEventListener js/window "mousemove" move)
                     (.removeEventListener js/window "mouseup" @up)
                     (when-let [w @drag] (commit! w))))
        (.addEventListener js/window "mousemove" move)
        (.addEventListener js/window "mouseup" @up)))}
   [:div {:style #js {:width "1px" :height "100%" :margin "0 auto"
                      :background "var(--border)"}}]])

(defn widget-verse-rows
  [{:keys [items empty-label show-source show-notes widths] :as props} bus session-id]
  (r/with-let [drag (r/atom nil)]
    (let [source?  (not (false? show-source))
          notes?   (not (false? show-notes))
          ws       (let [w (or @drag widths [0.42 0.28 0.30])]
                     (if (= 3 (count w)) (vec w) [0.42 0.28 0.30]))
          template (bind/gesture-template props :resize)
          commit!  (fn [w]
                     (reset! drag w)
                     (when (and template bus)
                       (js-invoke bus "dispatch"
                                  (bind/fill-command template {'$session-id session-id
                                                               '$widths (vec w)})
                                  (fn [_] nil))))
          ;; A CELL IS A FRACTION OF WHAT IS LEFT, so every row divides the
          ;; same way and the columns stay columns. The fraction is the GROW of
          ;; a cell with no basis, so the cells share the row after the gutter
          ;; and the two rules take their fixed widths.
          ;;
          ;; IT WAS A BASIS IN PERCENT OF THE WHOLE ROW (fault report 0de32d08,
          ;; George, 2026-10-16: "the right most text is cut off"). The three
          ;; fractions came to 100%, and the 3.5rem gutter and the two rules
          ;; came on top of that. So each row was about 74px wider than its
          ;; pane, and the Notes column went past the right edge at 1500px.
          ;; A column that the reader closes now gives its share to the others.
          cell     (fn [n] #js {:flex (str (nth ws n) " 1 0%") :minWidth 0})
          rule     #js {:flex "0 0 11px" :alignSelf "stretch"}
          gutter   #js {:flex "0 0 3.5rem" :textAlign "right"}]
      (if (empty? items)
        (when empty-label
          [:> (.-Text mantine) {:size "sm" :c "dimmed" :fs "italic"} empty-label])
        [:> (.-Stack mantine) {:gap 0}
         ;; THE HEADER CARRIES THE HANDLES, because every row shares one set of
         ;; widths. Two dividers for three columns.
         [:> (.-Group mantine)
          {:gap 0 :align "stretch" :wrap "nowrap"
           :style #js {:width "100%" :paddingBottom "0.35rem"
                       :borderBottom "1px solid var(--border)"}}
          [:div {:style gutter}]
          [:> (.-Text mantine) {:size "xs" :c "dimmed" :tt "uppercase" :fw 700
                                :data-verse-cell true :style (cell 0)} "Translation"]
          (when source? [verse-divider 0 drag ws commit!])
          (when source?
            [:> (.-Text mantine) {:size "xs" :c "dimmed" :tt "uppercase" :fw 700
                                  :data-verse-cell true :style (cell 1)} "Source"])
          (when notes? [verse-divider 1 drag ws commit!])
          (when notes?
            [:> (.-Text mantine) {:size "xs" :c "dimmed" :tt "uppercase" :fw 700
                                  :data-verse-cell true :style (cell 2)} "Notes"])]
         (for [[i {:keys [verse-id text original notes]}] (map-indexed vector items)]
           ^{:key (or verse-id i)}
           [:> (.-Group mantine)
            {:gap 0 :align "flex-start" :wrap "nowrap"
             :style #js {:width "100%" :paddingTop "0.6rem" :paddingBottom "0.6rem"
                         :borderBottom "1px solid var(--border)"}}
            [:> (.-Text mantine) {:size "xs" :fw 700 :c "dimmed" :style gutter} verse-id]
            [:> (.-Text mantine)
             {:size "sm" :style (js/Object.assign (cell 0) #js {:lineHeight 1.6
                                                                :paddingRight "0.75rem"})}
             text]
            (when source? [:div {:style rule}
                           [:div {:style #js {:width "1px" :height "100%" :margin "0 auto"
                                              :background "var(--border)"}}]])
            (when source?
              [:> (.-Text mantine)
               {:size "sm" :style (js/Object.assign (cell 1) #js {:lineHeight 1.9
                                                                  :paddingLeft "0.75rem"
                                                                  :paddingRight "0.75rem"})}
               original])
            (when notes? [:div {:style rule}
                          [:div {:style #js {:width "1px" :height "100%" :margin "0 auto"
                                             :background "var(--border)"}}]])
            (when notes?
              ;; ROOM FOR THE SCROLL BAR. The scroll area draws its bar over
              ;; the content, and in the screenshot of 0de32d08 it covered the
              ;; last letters of each note.
              [:div {:style (js/Object.assign (cell 2) #js {:paddingLeft "0.75rem"
                                                           :paddingRight "0.75rem"})}
               [verse-note-cell notes]])])]))))

(defn row-tone
  "PURE: the :tone of one table row, as a keyword, or nil. A bound row comes
   over the wire with a string or a keyword, so both are read."
  [row]
  (let [t (or (get row :tone) (get row "tone"))]
    (when (or (string? t) (keyword? t)) (keyword (name t)))))

(defn widget-table
  "A read-only grid, and — since 2026-09-09, PLAN-ikc-v3-029-01 Q4 — a ROW THAT
   CAN BE CLICKED when the description wires :on-gesture :submit. $value is the
   row's OWN MAP, the way the :tree's six gestures hand the selected item, so a
   template reads a field with [:of $value measurement-id]. With no :submit
   wired nothing is clickable and no cursor changes: every existing table is
   display-only, exactly as before.

   :draggable (IKC3/PLAN-ikc-v3-064-01/DRAG): each row can be dragged, and a
   :box with :on-gesture :drop takes it. It adds to the click, and replaces
   nothing."
  [{:keys [columns rows tone draggable] :as props} bus session-id]
  (let [cols (or (seq columns)
                 (when-let [r (first rows)]
                   (mapv (fn [k] {:label (name k) :key k}) (keys r))))
        submit     (bind/submit-template props)
        Table      (.-Table mantine)
        TableThead (.-Thead Table)
        TableTbody (.-Tbody Table)
        TableTr    (.-Tr Table)
        TableTh    (.-Th Table)
        TableTd    (.-Td Table)]
    [:div {:class "overflow-x-auto min-w-0"}
     [:> Table
      {:striped true :highlightOnHover true :withTableBorder true}
      [:> TableThead
       [:> TableTr
        (for [c cols]
          ^{:key (or (:key c) (:label c))}
          [:> TableTh (or (:label c) (str (:key c)))])]]
      [:> TableTbody
       (for [[ri row] (map-indexed vector rows)]
         ;; A CLICKABLE ROW CARRIES AN ATTRIBUTE MAP; a display-only one carries
         ;; none at all. Built with `into` rather than a `when` in the child
         ;; slot, so no nil is ever handed to Reagent as a child.
         ;; A ROW :tone (2026-10-05, decision 33 of RESEARCH-ikc-v3-033-01): a
         ;; row whose map holds :tone draws its text in that colour token, as
         ;; a blocked card of the board does. The table's own :tone is not a
         ;; row's colour, so a row with no :tone is unchanged.
         ^{:key ri} (into [:> TableTr]
                          (concat
                           (let [rt    (row-tone row)
                                 attrs (cond-> {}
                                         ;; A DRAGGABLE ROW (IKC3/PLAN-ikc-v3-064-01/DRAG)
                                         ;; carries its own map as JSON, the map
                                         ;; a :submit gives as $value. A drop
                                         ;; reads it as $dragged. The click stays.
                                         draggable
                                         (assoc :draggable true
                                                :style {:cursor "grab"}
                                                :on-drag-start (fn [e]
                                                                 (let [dt (.-dataTransfer e)]
                                                                   (.setData dt drag-mime (row->json row))
                                                                   (set! (.-effectAllowed dt) "move"))))
                                         (and submit bus)
                                         (assoc :style {:cursor "pointer"}
                                                :on-click (fn [_]
                                                            (let [cmd (bind/fill-command submit {'$value row '$session-id session-id})]
                                                              (js-invoke bus "dispatch" cmd (fn [_] nil)))))
                                         (get tone-text-classes rt)
                                         (assoc :class (get tone-text-classes rt)))]
                             (when (seq attrs) [attrs]))
                           [(for [c cols]
                              ^{:key (or (:key c) (:label c))}
                              [:> TableTd (str (table-cell row (:key c)))])])))]]]))

;; ---------------------------------------------------------------------------
;; :markdown.
;; ---------------------------------------------------------------------------

(def ^:private highlight-colors
  "The four highlight colours, in the order the picker offers them. Names only —
   the swatch takes its colour from the theme token, never from a literal
   (ADR-graph-ui-v0-017-01 §4)."
  [:hl-1 :hl-2 :hl-3 :hl-4])

(def ^:private quote-context
  "How many rendered characters of context go with a selection, each side."
  32)

(defn selection-quote
  "PURE: where a selection is, as the server needs it to find the words.

   `before` is the element's rendered text up to the selection, and `after` is
   its rendered text from the end of the selection. The answer is the rendered
   offset of the selection and the words just around it.

   FAULT REPORT d122f7ab (George, 2026-10-03): \"Show on wrong location, not
   where it was highlighted\". The offset was `indexOf` of the selected text,
   which is the FIRST place those words occur, not the place the reader
   selected. So every repeat was sent as its first occurrence. The prefix and
   the suffix are the W3C Web Annotation quote selector, and they do not drift
   with the marks of the markdown above the selection.

   PUBLIC so it can be tested without a browser."
  [before after]
  (let [before (or before "") after (or after "")]
    {:approx-start (count before)
     :prefix (subs before (max 0 (- (count before) quote-context)))
     :suffix (subs after 0 (min (count after) quote-context))}))

(defn- selection-in
  "The selected string when the selection lies inside `el`, where it starts in
   that element's own rendered text, and the words around it.

   The offset is ADVISORY and is meant to be: it disambiguates repeats and nothing
   more (highlights.anchor/find-anchor uses it only to choose between matches).
   Rendered text is shorter than its markdown source, so this number is near
   rather than right — which is exactly the contract text mode was designed
   around (ADR-graph-ui-v0-017-01 §1). The words around the selection
   (`selection-quote`) choose between repeats before the offset does."
  [el]
  (when-let [sel (.getSelection js/window)]
    (let [text (.toString sel)]
      (when (and (seq (str/trim text))
                 (pos? (.-rangeCount sel))
                 (.contains el (.-commonAncestorContainer (.getRangeAt sel 0))))
        (let [rng    (.getRangeAt sel 0)
              rect   (.getBoundingClientRect rng)
              ;; Two ranges, from the edge of `el` to each end of the
              ;; selection. A range's toString is the text of its text nodes,
              ;; the same text textContent reads.
              before (doto (.createRange js/document)
                       (.selectNodeContents el)
                       (.setEnd (.-startContainer rng) (.-startOffset rng)))
              after  (doto (.createRange js/document)
                       (.selectNodeContents el)
                       (.setStart (.-endContainer rng) (.-endOffset rng)))]
          (merge
           {:text text
            ;; The selection's own rectangle, in VIEWPORT coordinates — which is
            ;; exactly what `position: fixed` wants, so the picker can be placed
            ;; next to the words without any caret arithmetic.
            :rect {:top (.-top rect) :bottom (.-bottom rect) :left (.-left rect)}}
           (selection-quote (.toString before) (.toString after))))))))

(defn- selection-ref
  "A `:ref` callback that keeps `box-ref` pointing at the element AND clears
   `pending` the moment the document's selection stops being a selection inside
   it.

   George, 2026-09-08: \"The highligths colors selector does not disappear when
   text selection is unselected.\"

   THE SWATCHES WERE DISMISSED BY ONE EVENT AND ONE ONLY — a mouse-up inside the
   same pane, which re-reads the selection and finds nothing. Every other way of
   dropping a selection happens somewhere else: a click in the sidebar, in
   another pane, in the row above, or a keypress. None of them reaches that
   handler, so the bar stayed over a passage that was no longer selected, and
   pressing a colour then marked text the reader could not see.

   `selectionchange` IS THE EVENT THAT ACTUALLY MEANS THIS. It fires on the
   document whenever the selection changes for any reason, which is the whole
   set of causes rather than the one the pane can see. The listener lives for
   as long as the element does: added when the ref arrives, removed when it
   arrives as nil, which is React's own unmount signal.

   IT CANNOT FIRE WHILE A SWATCH IS PRESSED, and that matters — the value this
   would clear is the value the click is about to use. highlight-picker calls
   preventDefault on MOUSEDOWN precisely so a press outside the words does not
   collapse the selection, so no selectionchange is raised and `pending`
   survives the click. That guard was written for a different reason and this
   depends on it, which is why it is named here.

   `pending` IS READ FIRST, because this fires on every tick of a drag-select and
   there is nothing to do until a selection has actually been made."
  [box-ref pending listener]
  (fn [el]
    (reset! box-ref el)
    (if el
      (when-not @listener
        (let [f (fn [_]
                  (when (and @pending (nil? (some-> @box-ref selection-in)))
                    (reset! pending nil)))]
          (reset! listener f)
          (.addEventListener js/document "selectionchange" f)))
      (when-let [f @listener]
        (.removeEventListener js/document "selectionchange" f)
        (reset! listener nil)))))

(defn textarea-selection
  "The same thing as `selection-in`, for a row that is being EDITED.

   A focused row is a <textarea>, and a textarea's selection is NOT in the DOM
   Selection API — `window.getSelection()` returns nothing for it. So a row you
   had clicked into offered no swatches at all, and the only way to mark it was
   to click away and come back (George, 2026-08-16: \"often to be able to
   highlight I have to move focus away and come back to the block\"). The
   capture was written against rendered markdown and simply had no counterpart
   for the editor, which is the state a row spends most of its time in while you
   are working in it.

   THE OFFSET HERE IS EXACT, not advisory. A textarea holds the block's markdown
   SOURCE, so `selectionStart` is the true offset — the one case where the
   position needs no anchoring at all. It is still sent as `:approx-start` and
   still checked against `:anchor-text`, because a highlight must survive later
   edits either way (CONCEPT-ikc-v3-008-01) and one path is cheaper to trust
   than two paths to reason about.

   PUBLIC so it can be tested without a browser, the same reason `stack-tops` is.
   `ev` is the mouse event when there is one — the picker goes where the pointer
   let go, since a textarea gives no rectangle for its own selection."
  [el ev]
  (let [start (.-selectionStart el)
        end   (.-selectionEnd el)
        v     (or (.-value el) "")]
    (when (and (number? start) (number? end) (> end start))
      (let [text (subs v start (min end (count v)))]
        (when (seq (str/trim text))
          {:text text
           :approx-start start
           :rect (if ev
                   {:top (- (.-clientY ev) 10)
                    :bottom (+ (.-clientY ev) 10)
                    :left (.-clientX ev)}
                   (let [r (.getBoundingClientRect el)]
                     {:top (.-top r) :bottom (.-bottom r) :left (.-left r)}))})))))

(defn- picker-position
  "Where to put the colour picker, in viewport coordinates.

   ABOVE THE SELECTION, or below it when the selection starts too near the top of
   the window to fit. Clamped horizontally so it cannot run off the right edge.

   IT IS `fixed`, NOT `sticky`, AND THAT IS THE WHOLE POINT. The first version was
   a sticky strip at the top of the reading pane, on the reasoning that a floating
   bubble needs caret geometry and would be one more thing to get wrong. Use
   disproved it: the strip sticks to the top of the PANE, so with a long document
   scrolled past that point the picker was off-screen and the feature looked
   broken (George, 2026-08-15: \"when top of the block is higher than visible
   area, the highlight chooser is not visible\"). The geometry it supposedly
   needed is one call on the range that already exists."
  [{:keys [top bottom left]}]
  (let [width      260                     ; the strip's approximate width
        margin     8
        max-left   (max margin (- (.-innerWidth js/window) width margin))
        above?     (> top 60)]
    {:position "fixed"
     :top      (if above? (- top 44) (+ bottom 8))
     :left     (-> (or left margin) (max margin) (min max-left))
     :zIndex   "var(--layer-modal)"}))

(defn highlight-picker
  "The four swatches, floating beside a selection.

   ONE IMPLEMENTATION, TWO SURFACES. A vault file's body and a note's block rows
   are different widgets that must offer the identical gesture, so the strip, its
   placement and — critically — its two event handlers live here rather than
   being written twice. The handlers are the part that must not be duplicated:
   they are invisible in markup, they were wrong once already, and a second copy
   is a second chance to get them wrong (F-platform-v0-011-01).

   `pending` is what selection-in returned; `on-pick` takes a colour keyword.
   `on-bookmark` (optional, PLAN-ikc-v3-015-01 phase 3) adds a bookmark
   control beside the swatches — passed only where the description wires the
   :bookmark gesture, which is only where the body is a conversation."
  ([pending on-pick on-cancel] (highlight-picker pending on-pick on-cancel nil))
  ([pending on-pick on-cancel on-bookmark] (highlight-picker pending on-pick on-cancel on-bookmark nil))
  ;; `thought` (optional, PLAN-ikc-v3-026-01 Phase D) is {:on-to-thought f
  ;; :on-against-thought f}: two controls beside the swatches that send the
  ;; selection to the selected THOUGHT as evidence for or against it
  ;; (RESEARCH-ikc-v3-021-01 R-AC-7) — passed only where the description wires
  ;; the :to-thought / :against-thought gestures.
  ([{:keys [rect]} on-pick on-cancel on-bookmark thought]
   (into [:div {:class (str "flex items-center gap-2 rounded border "
                            "border-[var(--border)] bg-[var(--panel)] "
                            "px-2 py-1 text-xs text-[var(--muted)]")
                :style (assoc (picker-position rect)
                              :boxShadow "var(--elevation-floating)")
                ;; preventDefault on MOUSEDOWN — a browser collapses the selection
                ;; when you press outside it, and every swatch is outside it.
                ;; stopPropagation on MOUSEUP — otherwise this bubbles to the
                ;; pane's own handler, which re-reads the now-empty selection and
                ;; wipes the pending value this click is about to use. Both were
                ;; missing in the first version and the swatches did nothing.
                :on-mouse-down #(.preventDefault %)
                :on-mouse-up   #(.stopPropagation %)}
          [:span "Highlight:"]]
         (-> (mapv (fn [c]
                     [:button {:key (name c)
                               :aria-label (str "Highlight " (name c))
                               :on-click #(on-pick c)
                               :class "w-4 h-4 rounded-full border border-[var(--border)]"
                               :style {:background (str "var(--" (name c) ")")}}])
                   highlight-colors)
             (cond->
               on-bookmark
               (conj [:button {:on-click on-bookmark
                               :aria-label "Bookmark this entry"
                               :title "Bookmark this entry"
                               :class "ml-1 ikc-dim ikc-hover"}
                      "🔖"])
               (:on-to-thought thought)
               (conj [:button {:on-click (:on-to-thought thought)
                               :aria-label "Send to the selected thought as evidence for it"
                               :title "Send to the selected thought as evidence FOR it (supports)"
                               :class "ml-1 text-[var(--muted)] hover:text-[var(--text)]"}
                      "→ thought"])
               (:on-against-thought thought)
               (conj [:button {:on-click (:on-against-thought thought)
                               :aria-label "Send to the selected thought as evidence against it"
                               :title "Send to the selected thought as evidence AGAINST it (contradicts)"
                               :class "text-[var(--muted)] hover:text-[var(--text)]"}
                      "⇄ thought"])
               ;; BRANCH HERE (PLAN-ikc-v3-056-01 lane TR). A detour that
               ;; quotes the selected sentence — passed only where the
               ;; description wires :branch-selection, the body of a thought.
               (:on-branch thought)
               (conj [:button {:on-click (:on-branch thought)
                               :aria-label "Branch here: a detour that quotes this text"
                               :title "Branch here: a detour that quotes this text"
                               :class "ml-1 text-[var(--muted)] hover:text-[var(--text)]"}
                      "⑂ Branch here"]))
             (conj [:button {:on-click on-cancel
                             :class "ml-1 text-[var(--faint)] hover:text-[var(--text)]"}
                    "✕"])))))

(defn widget-markdown
  "Rendered markdown, optionally washed with this page's highlights and able to
   make one from a selection (F-platform-v0-011-01).

   SELECT, THEN PICK A COLOUR. On mouse-up over a non-empty selection a small row
   of four swatches appears; clicking one dispatches the :highlight gesture with
   the selected TEXT (not a range — see selection-in). Nothing is created by
   selecting alone, because a selection is also how you copy, and a reader who
   drags across a paragraph has not asked for anything yet."
  [{:keys [value links highlights density refused-tags] :as props} bus session-id]
  ;; BOTH atoms live out here, across renders. box-ref was inside the render fn
  ;; and was therefore a fresh nil on every repaint — it survived only because
  ;; React re-invokes an inline :ref, which is a coincidence to depend on rather
  ;; than a mechanism.
  (let [pending (r/atom nil)
        box-ref (atom nil)
        ;; The document listener that dismisses the swatches — see
        ;; selection-ref. Held so it can be removed on unmount.
        sel-listener (atom nil)]
    (fn [{:keys [value links highlights density] :as props} bus session-id]
      (let [target->pid (when (seq links) (into {} (map (juxt :target :page-id)) links))
            link-target (when target->pid #(get target->pid %))
            ;; A LINK TO A MARK LANDS ON THE WORDS (2026-08-24). George's
            ;; question decided the shape of the link — it carries the mark's ID,
            ;; because a footnote number moves when one is written before it. So
            ;; the target is `mark:<id>`, and after the page opens this scrolls to
            ;; that id. Without the second step the link opens a 285-entry
            ;; transcript at the top, which is the scanning it exists to end.
            ;;
            ;; THE DELAY IS THE PANE'S RENDER, not a guess about the network: the
            ;; element cannot be found before the new page is drawn.
            mark-of     (fn [t] (second (re-matches #"mark:(.+)" (str t))))
            on-nav      (when bus
                          (fn [pid target]
                            (if pid
                              (js-invoke bus "dispatch"
                                {:type :ui/select-page :session-id session-id :page-id pid}
                                (fn [_]
                                  (when-let [mid (mark-of target)]
                                    (js/setTimeout #(scroll-to-highlight! mid) 350))))
                              ;; NO PAGE YET, SO MAKE IT. resolve-and-create is
                              ;; ONE command for the reason the plain-text
                              ;; linkifier states below: the client cannot tell
                              ;; "no page" from "a page I could not see"
                              ;; without asking anyway. md/render withholds the
                              ;; click for a `mark:` target that did not
                              ;; resolve, so this arm only ever sees a page
                              ;; name.
                              (js-invoke bus "dispatch"
                                {:type :ui/follow-wikilink :session-id session-id
                                 :target target}
                                (fn [_] nil)))))
            gesture     (:highlight (gesture-actions props))
            ;; The bookmark gesture (PLAN-ikc-v3-015-01 phase 3). Wired only
            ;; where the body is a conversation — the description decides, so
            ;; a vault page's popover shows the four swatches and nothing new.
            bm-gesture  (:bookmark (gesture-actions props))
            ;; :to-thought and :against-thought (Meta-UI v2.1, PLAN-026 D): the
            ;; same selection map a bookmark sends, colour omitted; the command
            ;; adds the highlight and links it to the selected thought.
            thought!    (fn [g]
                          (when (and g bus)
                            (fn []
                              (when-let [{:keys [text approx-start prefix suffix]} @pending]
                                (let [cmd (bind/fill-command
                                           g {'$session-id session-id
                                              '$value {:anchor-text text
                                                       :approx-start approx-start
                                                       :prefix (or prefix "")
                                                       :suffix (or suffix "")}})]
                                  (js-invoke bus "dispatch" cmd (fn [_] nil))))
                              (reset! pending nil)
                              (some-> (.getSelection js/window) (.removeAllRanges)))))
            to-thought! (thought! (:to-thought (gesture-actions props)))
            against!    (thought! (:against-thought (gesture-actions props)))
            fire!       (fn [color]
                          (when-let [{:keys [text approx-start prefix suffix]} @pending]
                            (when (and gesture bus)
                              (let [cmd (bind/fill-command
                                         gesture {'$session-id session-id
                                                  '$value {:anchor-text text
                                                           :approx-start approx-start
                                                           :prefix (or prefix "")
                                                           :suffix (or suffix "")
                                                           :color color}})]
                                (js-invoke bus "dispatch" cmd (fn [_] nil))))
                            (reset! pending nil)
                            (some-> (.getSelection js/window) (.removeAllRanges))))
            bookmark!   (when bm-gesture
                          (fn []
                            (when-let [{:keys [text approx-start]} @pending]
                              (when bus
                                (let [cmd (bind/fill-command
                                           bm-gesture {'$session-id session-id
                                                       '$value {:anchor-text text
                                                                :approx-start approx-start}})]
                                  (js-invoke bus "dispatch" cmd (fn [_] nil))))
                              (reset! pending nil)
                              (some-> (.getSelection js/window) (.removeAllRanges)))))]
        [:> (.-Box mantine)
         ;; THE MEASURE, ON THE TEXT (ADR-graph-ui-v0-019-01). An imported vault
         ;; file is continuous prose, so it is the one surface the measure is
         ;; actually about; without it the reading pane's own width would set the
         ;; line, which is the legibility defect CONCEPT-graph-ui-v0-009-01 exists
         ;; to prevent. A MAXIMUM and centred, so a narrow island is unaffected and
         ;; the reader still owns the island's width.
         ;; NO MAXIMUM WIDTH. The island's own edge is the measure, and the
         ;; reader sets it by dragging (George, 2026-08-19). `mx-auto` goes with
         ;; it: centring is what a maximum needed, and with no maximum it
         ;; centres a box that already fills its parent.
         {:class (str "overflow-auto flex-1 min-h-0 relative w-full "
                      (get box-density-pad-classes density "p-1"))
          ;; THE READER'S SIZE (A− and A+, 2026-10-05) is the box's own type
          ;; token, so the paragraphs inherit it and a table, which takes a
          ;; size relative to its text, follows it.
          :style (not-empty
                   (merge (backdrop-style props)
                          (select-keys (typo-css {:font-size (:font-size props)})
                                       [:fontSize :lineHeight])))
          :ref (selection-ref box-ref pending sel-listener)
          :on-mouse-up (when (and gesture bus)
                         (fn [_] (reset! pending (some-> @box-ref selection-in))))}
         (when @pending
           [highlight-picker @pending fire!
            #(do (reset! pending nil)
                 (some-> (.getSelection js/window) (.removeAllRanges)))
            bookmark!
            (when (or to-thought! against!)
              {:on-to-thought to-thought! :on-against-thought against!})])
         (md/render (or value "") link-target on-nav highlights
                    ;; A #hashtag CHIP FILTERS ON A CLICK when the description
                    ;; wires the :tag gesture. Same handler the block row uses,
                    ;; so a tag in a file body and a tag in a typed block behave
                    ;; alike (F-ikc-v3-018-01).
                    ;; NOT `fire!` — this scope shadows it with the highlight
                    ;; picker's own two-argument callback, and the top-level one
                    ;; is unreachable from here.
                    (when (and bus (get-in props [:on-gesture :tag]))
                      (fn [tag]
                        (fire-tag-gesture! props bus session-id :tag tag)))
                    ;; THE WORDS A PERSON SAID ARE NOT TAGS. Each draws as plain
                    ;; text. Without this the browser goes on drawing a chip the
                    ;; server has already stopped writing a mention for
                    ;; (ADR-ikc-v3-101-01 decision 5).
                    refused-tags)]))))

;; ---------------------------------------------------------------------------
;; :outline (block editor) — unchanged; it's a custom content surface, not a
;; generic widget Mantine covers directly. Still uses theme tokens via Tailwind.
;; ---------------------------------------------------------------------------

(defn- linkify-wikitext
  "text split at every [[target]] into hiccup pieces."
  [text links bus session-id]
  (let [re (js/RegExp. "\\[\\[([^\\]|]+)(?:\\|[^\\]]*)?\\]\\]" "g")]
    (loop [last-end 0 pieces [] key 0]
      (if-let [m (.exec re text)]
        (let [start   (.-index m)
              matched (aget m 0)
              target  (str/trim (aget m 1))
              end     (+ start (count matched))
              before  (subs text last-end start)
              link    (first (filter #(= (:target %) target) links))]
          (recur end
                 (cond-> pieces
                   (seq before)
                   (conj (with-meta [:span before] {:key key}))

                   true
                   ;; A wikilink is clickable whether or not its page exists.
                   ;; An UNRESOLVED one used to render as plain text — it looked
                   ;; almost like a link, did nothing, and said nothing about
                   ;; why (2026-08-03). Naming a page is how you make one, so an
                   ;; unresolved link is the invitation to create it, styled as
                   ;; a promise rather than a fact: dashed and muted until real.
                   (conj (let [resolved? (boolean (and link (:page-id link)))]
                           (with-meta
                             [:span.cursor-pointer
                              {:class (str "inline-flex items-baseline gap-1 px-1.5 rounded align-baseline "
                                           (if resolved?
                                             (str "border border-[var(--border)] bg-[var(--raised)] "
                                                  "text-[var(--accent)] hover:bg-[var(--hover)] "
                                                  "hover:border-[var(--accent)]")
                                             (str "border border-dashed border-[var(--faint)] "
                                                  "text-[var(--muted)] hover:text-[var(--accent)] "
                                                  "hover:border-[var(--accent)]")))
                               :title (if resolved?
                                        (str "Open " target)
                                        (str "Create " target))
                               :on-click (fn [e]
                                           (.preventDefault e)
                                           (when bus
                                             (js-invoke bus "dispatch"
                                               (if resolved?
                                                 {:type :ui/select-page :session-id session-id
                                                  :page-id (:page-id link)}
                                                 ;; resolve-and-create is ONE command: the
                                                 ;; client cannot tell "no page" from "a page
                                                 ;; I could not see" without asking anyway
                                                 {:type :ui/follow-wikilink :session-id session-id
                                                  :target target})
                                               (fn [_] nil))))}
                              target]
                             {:key (inc key)}))))
                 (+ key 2)))
        (conj pieces (with-meta [:span (subs text last-end)] {:key key}))))))

(defn- fire!
  "Dispatch one of a row's actions. `on-reply` is called with the reply, or with
   nil when there was nothing to dispatch.

   THE REPLY IS NOT DISCARDED ANY MORE. It was `(fn [_] nil)` until 2026-08-23,
   so every caller was told nothing about whether the bus accepted the command —
   and the block editor cleared its buffer regardless. George lost a note on
   2026-08-22 (PLAN-ikc-v3-018-01: \"the failure must stall, not vanish\")."
  ([actions action-name bus session-id value extra]
   (fire! actions action-name bus session-id value extra nil))
  ([actions action-name bus session-id value extra on-reply]
   (if-let [tmpl (get actions action-name)]
     (if bus
       (let [cmd (bind/fill-command tmpl (merge {'$session-id session-id '$value value} extra))]
         (js-invoke bus "dispatch" cmd (fn [reply] (when on-reply (on-reply reply)))))
       (when on-reply (on-reply nil)))
     (when on-reply (on-reply nil)))))

;; WHICH FRAME THIS TAB LAST REPORTED, per session. The :focus gesture fires from
;; two capture-phase listeners, and a click inside a row that already holds the
;; caret would otherwise dispatch again on every click. One focus is one dispatch.
;;
;; A COMMENT AND NOT A DOCSTRING: ClojureScript's defonce takes no docstring, and
;; shadow-cljs fails the build with "Wrong number of args (3)".
(defonce ^:private last-focused-frame (atom {}))

;; A CARET REPORT FROM A STALE RENDER IS AN ECHO, NOT A PICK. While a session's
;; start-page rule travels (graph-ui.web.core/apply-page-address!), the pane
;; still draws the page the attach snapshot named — the page the session is
;; leaving — and its outline autofocuses a block of THAT page. The report
;; reaches :ui/focus-frame, whose reading-pane follow then selects the stale
;; page back over the one the rule just chose (S-C08-1). core mutes the session
;; for the life of the rule; the session's first selection ends it.
(defonce ^:private focus-muted (atom #{}))

(defn mute-focus!
  "Swallow caret reports for `session-id` until unmute-focus!. core's start
   rule calls this so a stale outline's autofocus cannot write while the pane
   is still moving to the page the session is opening."
  [session-id]
  (swap! focus-muted conj (str session-id)))

(defn unmute-focus! [session-id]
  (swap! focus-muted disj (str session-id)))

(defn- report-focus!
  "Tell the session which frame the caret is on, once per change.

   CAPTURE PHASE AND NO preventDefault, so this cannot alter what the row does
   next. It reads nothing and edits nothing — it reports. If the description
   declares no :focus gesture, fire! finds no template and nothing happens."
  [actions bus session-id block-id]
  (when (and bus block-id (not (contains? @focus-muted (str session-id)))
             (not= block-id (get @last-focused-frame session-id)))
    (swap! last-focused-frame assoc session-id block-id)
    (fire! actions :focus bus session-id block-id {})))

(defn fit-in-viewport
  "CSS position for a popup anchored at (`x`,`y`) in a `vw`×`vh` viewport.

   NOTHING HERE KNOWS THE POPUP'S SIZE, and that is the point. The first version
   of this took a measured w/h, and it never worked in a browser: the popup has
   to render before it can be measured, the first measurement of a freshly
   portalled node comes back 0×0, and a fit computed with h=0 returns the
   ORIGINAL y — so the menu stayed exactly where it was and the code looked
   correct while doing nothing. Verified in Chromium: style.top never changed,
   at +0ms or +1200ms (2026-08-04).

   So flip with CSS instead of arithmetic. Anchoring the popup's BOTTOM edge to
   the anchor (`:bottom`, measured up from the viewport floor) makes it grow
   UPWARD by whatever height it turns out to need, which the browser knows and
   we do not. Same trick horizontally with `:right`.

   `:y-flip` is the edge to hang from when flipping — for a menu under a row
   that is the row's TOP, while `:y` is its bottom. They are the same point for
   a pointer-anchored menu, so it defaults to `:y`."
  [{:keys [x y y-flip vw vh margin]}]
  (let [m  (or margin 8)
        yf (or y-flip y)]
    (merge
     ;; Below the halfway line there is more room above than below, so open
     ;; upward. Cheap, stable, and independent of how tall the menu is.
     (if (> y (/ vh 2))
       {:bottom (max m (- vh yf))}
       {:top    (max m y)})
     (if (> x (/ vw 2))
       {:right (max m (- vw x))}
       {:left  (max m x)}))))

(defn menu-max-height
  "PURE. The height in pixels that a floating menu can take: the room on the
   side where fit-in-viewport opens it, less a margin at each end.

   WITHOUT IT A MENU RAN OFF THE TOP OF A PHONE (lane AL-K, 2026-09-29). A row
   below the middle opens its menu upward, anchored at its bottom edge. The
   row menu has thirteen items, 44 px each under a coarse pointer, so it was
   613 px tall above a row at 469 px, and its first three items were above the
   screen, where no finger can reach them. `max-h-[80vh]` did not stop it,
   because 80vh is more than the room above the row. Now the menu scrolls
   inside the room it has."
  [{:keys [y y-flip vh margin]}]
  (let [m (or margin 8)]
    (if (> y (/ vh 2))
      (- (or y-flip y) (* 2 m))
      (- vh y (* 2 m)))))

(defn floating-menu
  "A menu positioned against the VIEWPORT and rendered through a portal.

   Two things, fixing different halves of one report:

   PORTAL — an absolutely positioned popup is clipped by any ancestor with an
   overflow context, and the reading pane puts every block inside a
   :scroll-area. The slash menu could be positioned perfectly and still be
   invisible, because it was drawn inside a box that scrolls.

   FLIP — a menu anchored at the pointer or under a row opens DOWNWARD, so near
   the bottom of the window it continued past the fold with nothing moving it.

   A plain function, deliberately: the version with lifecycle hooks and a
   measured box is what failed in the browser. There is no state here, nothing
   to race, and `max-h-[80vh] overflow-y-auto` covers the one case the flip
   cannot — a menu taller than the window, which now scrolls instead of
   spilling.

   DEPTH BELONGS TO THE COMPONENT, not to its callers. Both call sites used to
   pass a Tailwind shadow class of their own — the same decision written twice, in
   a fixed rgba, where a theme could not reach it. A floating menu is elevated
   BY DEFINITION, so it says so once, here, in the token."
  [{:keys [x y y-flip class on-click]} children]
  [:> (.-Portal mantine)
   [:div (cond-> {:class (str "fixed max-h-[80vh] overflow-y-auto " class)
                  :style (assoc (fit-in-viewport
                                 {:x x :y y :y-flip y-flip
                                  :vw (.-innerWidth js/window)
                                  :vh (.-innerHeight js/window)})
                                :maxHeight (str (menu-max-height
                                                 {:y y :y-flip y-flip
                                                  :vh (.-innerHeight js/window)})
                                                "px")
                                :zIndex   "var(--layer-modal)"
                                :boxShadow "var(--elevation-overlay)")}
           on-click (assoc :on-click on-click))
    children]])

(defn row-menu-items
  "The CONTENT of the block context menu: the declared :row-menu turned into
   affordances.

   Split out from row-context-menu on purpose. That one renders through a
   PORTAL, and reagent.dom.server renders a portal as NOTHING — it targets
   document.body, which server-side rendering has no notion of. Escaping the
   scroll-area therefore blinded every render test that asserted this list
   exists. Keeping the content addressable on its own is what lets those tests
   go on meaning something; whether the portal escapes the real clipping
   ancestor is a browser question, and lives in the e2e specs."
  [{:keys [items on-close fire]}]
  [:<>
   (for [{:keys [gesture label icon tone divider-before]} items]
     ^{:key gesture}
     [:<>
      (when divider-before
        [:div {:class "my-1 border-t border-[var(--border)]"}])
      [:button {:class (str "w-full text-left px-3 py-1.5 flex items-center gap-2 "
                            "hover:bg-[var(--gutter)] "
                            (if (= tone :danger)
                              "text-[var(--crit)]" "text-[var(--text)]"))
                :on-click (fn [_] (fire gesture) (on-close))}
       [:span {:class "w-4 text-center text-[var(--faint)]"} (or icon "")]
       label]])])

(defn row-context-menu
  "The right-click menu over a block — the SAME :row-menu list the hover strip
   renders, so the two can never offer different actions. Positioned at the
   pointer, dismissed by any click or Escape.

   Rendered inline rather than through the :menu widget because a menu over a
   ROW needs that row's block-id, and :menu's items carry literal :with args
   with no notion of which row they are over. The outline's gestures already
   carry it through $value."
  [{:keys [x y items on-close fire]}]
  [:div {:class "fixed inset-0"
         :style {:zIndex "var(--layer-overlay)"}
         :on-click on-close
         :on-context-menu (fn [e] (.preventDefault e) (on-close))}
   ;; x/y are clientX/clientY — viewport coordinates — and floating-menu treats
   ;; them as such. Before this the menu opened down-right from the pointer with
   ;; nothing checking the fold, so a right-click on a block near the bottom of
   ;; the page produced a menu mostly below it (George, 2026-08-04).
   [floating-menu
    {:x x :y y
     :class (str "min-w-[180px] py-1 rounded-md text-sm "
                 "bg-[var(--field)] border border-[var(--border)]")
     :on-click (fn [e] (.stopPropagation e))}
    [row-menu-items {:items items :on-close on-close :fire fire}]]])

(defn slash-pick-state
  "PURE. What a row's own state becomes when a slash command is picked.

   TWO FACTS, and the second one was a defect.

   The text is CLEARED. The block should become a to-do, and not a to-do that
   says \"/todo\".

   The row STAYS IN EDIT MODE. A block that has just become a to-do is a block
   somebody is about to write in. George, the note IKC3-TODOs-20260919: \"When
   added TODO it comes in not writtable state - have to click in the block to
   switch\". The pick closed the editor, and the row does not open again by
   itself: a row opens at MOUNT, and a slash command changes the block's type
   and not its identity, so the row is the same row and never mounts again.

   A SEPARATOR NEEDS NO EXCEPTION. Its row draws its own branch and never reads
   the edit flag, so this rule cannot reach it."
  [entry]
  (when entry {:text "" :editing? true}))

(defn slash-matches
  "The :slash-menu entries a buffer beginning with \"/\" selects.

   Returns nil when the text is not a slash query at all, so the caller can tell
   \"no menu\" from \"a menu with nothing in it\" — an empty list after typing
   /xyz should say so rather than silently vanish and leave the slash looking
   broken."
  [buf menu]
  (when (and (seq menu) (string? buf) (str/starts-with? buf "/"))
    (let [q (str/lower-case (subs buf 1))]
      ;; SUBSTRING, not prefix: typing "do" should offer both /todo and /done
      ;; and let you choose. Prefix matching hid /todo behind a leading "to"
      ;; nobody would guess to type, which is a menu keeping a secret.
      (filterv #(str/includes? (str/lower-case (:trigger %)) q) menu))))

(defn- long-completion-at
  "The completion of a trigger longer than one character (`[[`), or nil.

   IT IS FOUND BY TEXT: the nearest trigger before the caret. The query keeps its
   spaces, because a page title has them (ikc1's `allowSpaces`). A `]` or a
   line break in the query ends it: the link is closed, or the caret has left
   the line. The trigger sits on a boundary as a one-character trigger does."
  [before triggers]
  (->> triggers
       (keep (fn [t]
               (let [i (str/last-index-of before t)]
                 (when (and i
                            (or (zero? i)
                                (re-find #"[\s,;(]" (subs before (dec i) i))))
                   (let [q (subs before (+ i (count t)))]
                     (when-not (re-find #"[\]\n]" q)
                       {:trigger t :start i :query q}))))))
       (sort-by :start >)
       first))

(defn completion-at
  "The completion the caret sits inside, as {:trigger :start :query}, or nil.

   THE TRIGGER MATCHES AT A WORD BOUNDARY, not at the start of the buffer, and
   that is the whole difference from slash-matches. A slash command is the FIRST
   thing in a block — `/todo` and nothing before it. A hashtag is written
   mid-sentence, so the search walks back from the caret to the nearest boundary
   and asks whether a trigger sits on it.

   WHITESPACE ENDS THE SEARCH. `#a b|` is not a completion of `a b`: a tag has no
   spaces, so once the walk reaches one it has left the word the caret is in.

   A TRIGGER NOT ON A BOUNDARY IS NOT A TRIGGER, and the walk stops rather than
   keeping on looking. `C#|` must not open a popup, and neither must the `#` in
   `abc#d` — the same two refusals the server-side grammar makes for the same
   reason (ADR-ikc-v3-080-01 decision 4)."
  [buf caret triggers]
  (let [all (set (remove nil? triggers))
        ts  (set (filter #(= 1 (count %)) all))
        long-ts (filter #(< 1 (count %)) all)]
    (when (and (string? buf) (number? caret) (<= 0 caret (count buf)) (seq all))
      (let [before (subs buf 0 caret)]
        (or
         (long-completion-at before long-ts)
         (loop [i (dec (count before))]
           (when-not (neg? i)
             (let [c (subs before i (inc i))]
               (cond
                 (re-find #"\s" c) nil
                 (contains? ts c)
                 (when (or (zero? i)
                           (re-find #"[\s,;(]" (subs before (dec i) i)))
                   {:trigger c :start i :query (subs before (inc i) caret)})
                 :else (recur (dec i)))))))))))

(def ^:private completion-limit
  "How many rows the popup offers at once. The vocabulary is about 300 strings
   and a list longer than a screen is a list nobody reads to the end of."
  12)

(defn completion-state
  "The popup for a buffer and a caret, or nil.

   {:trigger :start :query :items}. :items is the bound list, narrowed to the
   query by SUBSTRING — the same rule slash-matches uses, and for the same
   reason: typing `front` should offer `project/frontend`, which a prefix match
   would hide behind a path segment nobody would guess to type first.

   A SOURCE ENTRY (`[[`, lane IKC3/PLAN-alatus-v0-003-01/AL-L) has no prop. Its
   titles are `found`, the last answer of the source, already narrowed by the
   server. The entry's :limit cuts them, as ikc1's picker cut at eight. With
   :create? the typed text is the LAST item when no title equals it, as ikc1's
   \"Create\" row was, and the state says so in :create?."
  ([buf caret completions props] (completion-state buf caret completions props nil))
  ([buf caret completions props found]
   (when (seq completions)
     (when-let [{:keys [trigger start query] :as at}
                (completion-at buf caret (map :trigger completions))]
       (let [entry (first (filter #(= trigger (:trigger %)) completions))
             q     (str/lower-case (str query))]
         (if (:source entry)
           ;; `found` IS {:q <the query answered> :rows [{:label :value} …]}, the
           ;; reply of the source. ikc1 filtered in memory, so its list was never
           ;; behind the text. Here the answer comes later, so an answer to
           ;; ANOTHER query is not used: the state is :pending? with no items,
           ;; and no Create row, until the answer to THIS query arrives.
           (let [fresh?  (and (some? (:q found)) (= (:q found) query))
                 failed? (boolean (and fresh? (:failed? found)))
                 titles  (if fresh?
                           (into [] (comp (keep :label) (filter string?)
                                          (take (or (:limit entry) completion-limit)))
                                 (:rows found))
                           [])
                 typed   (str/trim (str query))
                 create? (and fresh?
                              (not failed?)
                              (:create? entry)
                              (not (str/blank? typed))
                              (not-any? #(= (str/lower-case %) (str/lower-case typed)) titles))]
             (cond-> (assoc at :items (cond-> titles create? (conj typed))
                            :create? (boolean create?)
                            :pending? (not fresh?)
                            :failed? failed?)
               (:close entry) (assoc :close (:close entry))
               (:label entry) (assoc :label (:label entry))))
           (assoc at :items
                  (into [] (comp (filter string?)
                                 (filter #(str/includes? (str/lower-case %) q))
                                 (take completion-limit))
                        (or (get props (:items entry)) [])))))))))

(defn splice-completion
  "The buffer with the picked item written in, and where the caret goes.

   A PICK DISPATCHES NOTHING. It writes text, and the ordinary edit path carries
   it from there — which is what makes a completion different from a slash
   command (ADR-ikc-v3-080-01 decision 3). On a file-backed page the next scan
   indexes the tag. On a native page the block-event subscriber does.

   IT ENDS WITH A SPACE, so the next word is not swallowed into the tag — unless
   the text already continues with one, because a completion that leaves a double
   space has edited the sentence as well as the tag."
  [buf caret {:keys [trigger start close]} item]
  (let [head  (subs buf 0 start)
        tail  (subs buf (min caret (count buf)))
        gap?  (re-find #"^\s" tail)
        ;; A CLOSED ENTRY (`[[Title]]`) ends with its own closer and no space,
        ;; as ikc1's pick did. A tail that already starts with the closer
        ;; loses it, so the pick never writes `]]]]`.
        tail  (if (and close (str/starts-with? tail close)) (subs tail (count close)) tail)
        ins   (if close
                (str trigger item close)
                (str trigger item (when-not gap? " ")))]
    {:text  (str head ins tail)
     :caret (+ (count head) (count ins))}))

(def source-timeout-ms
  "How long a source completion waits for the bus, in ms. After it the popup says
   the search did not answer, and Enter and Tab are the row's again."
  5000)

(defn ask-source!
  "Ask the bind source of a completion entry for `query`, ONCE, and call
   :on-done with {:q query :rows [...]}. The answer is a FAILURE,
   {:q query :rows [] :failed? true}, when the reply is a refusal (the
   `refusal-of` reader of the other widgets, or `reply-failed?`), when there is
   no bus, or when nothing came back within :timeout-ms. :req is an atom that
   counts requests, so an answer to an older request, or one that arrives after
   the timeout, is dropped. Nothing stays pending for ever."
  [{:keys [bus entry session-id query req timeout-ms on-done]}]
  (let [n    (swap! req inc)
        q    (str query)
        fail (fn []
               (when (= n @req)
                 (swap! req inc)
                 (on-done {:q q :rows [] :failed? true})))]
    (if-not bus
      (fail)
      (do
        (js/setTimeout fail timeout-ms)
        (js-invoke
         bus "dispatch"
         {:type :ui/read
          :source (:source entry)
          :args (cond-> {:session-id session-id
                         :query q
                         :limit (or (:limit entry) completion-limit)}
                  (:kinds entry) (assoc :kinds (:kinds entry)))}
         (fn [rows]
           (cond
             (not= n @req) nil
             (or (bind/reply-failed? rows) (refusal-of rows)) (fail)
             :else (do (swap! req inc)
                       (on-done {:q q :rows (vec (or rows []))})))))))))

(defn completion-key!
  "The keys of an open completion popup. Returns true when the popup took the
   key, and then the browser's own act is prevented. `e` is the keydown event.
   `comp` is the state of `completion-state`, or nil when no popup is open.
   `slash-open?` is true while the slash menu holds the keys.
   `acts` is {:move (fn [+1/-1]) :pick (fn []) :close (fn [])}.

   A POPUP WITH A READ PENDING takes Enter and Tab and does nothing: the answer
   will come, or the read will fail and end the wait. A FAILED or EMPTY popup
   takes neither key, so Enter splits the block as it always did. Escape always
   closes the popup."
  [e comp slash-open? {:keys [move pick close]}]
  (let [k     (.-keyCode e)
        rows? (seq (:items comp))
        take! (fn [f] (.preventDefault e) (when f (f)) true)]
    (when comp
      (cond
        (= k 27) (take! close)
        slash-open? nil
        (and rows? (= k 40)) (take! #(move 1))
        (and rows? (= k 38)) (take! #(move -1))
        (and (:pending? comp) (or (= k 13) (= k 9))) (take! nil)
        (and rows? (or (= k 13) (= k 9))) (take! pick)
        :else nil))))

(defn completion-menu-body
  "The CONTENT of the completion popup. Split from the popup for the same reason
   slash-menu-body is: the popup renders through a portal, which
   reagent.dom.server renders as nothing."
  [{:keys [items active query on-pick label trigger create? pending? failed?]}]
  (let [link? (= "[[" trigger)]
    [:<>
     [:div {:class "px-3 py-1 text-xs uppercase tracking-wide text-[var(--faint)]"}
      (or label "Tags")]
     (if (empty? items)
       [:div {:class "px-3 py-1.5 text-[var(--faint)] italic"}
        (if link?
          (cond pending? "Searching…"
                failed? "The search did not answer"
                :else "No matching page")
          (if (str/blank? (str query)) "No tags yet" "No matching tag"))]
       (for [[i item] (map-indexed vector items)]
         ^{:key (str i item)}
         [:button {:class (str "w-full text-left px-3 py-1.5 flex items-center gap-2 "
                               (if (= i active) "bg-[var(--gutter)]" "hover:bg-[var(--gutter)]"))
                   :on-mouse-down (fn [e] (.preventDefault e) (on-pick i))}
          (cond
            (and create? (= i (dec (count items))))
            [:span {:class "text-[var(--accent)]"} (str "Create \"" item "\"")]
            link?
            [:span {:class "truncate"} item]
            :else
            [:span {:class "text-[var(--accent)] font-mono"} (str "#" item)])]))]))

(defn completion-popup
  "The tag list under the word being typed. Same portal and same flip as
   slash-popup, because it has the same problem: the row lives inside the
   reading pane's :scroll-area, and an overflow ancestor clips an absolutely
   positioned descendant."
  [{:keys [items active query on-pick anchor label trigger create? pending? failed?]}]
  [floating-menu
   {:x (or (:left anchor) 0)
    :y (or (:bottom anchor) 0)
    :y-flip (or (:top anchor) (:bottom anchor) 0)
    :class (str "min-w-[220px] py-1 rounded-md "
                "bg-[var(--field)] border border-[var(--border)] text-sm")}
   [completion-menu-body {:items items :active active :query query :on-pick on-pick
                          :label label :trigger trigger :create? create?
                          :pending? pending? :failed? failed?}]])

(defn slash-menu-body
  "The CONTENT of the slash menu. Split from slash-popup for the same reason
   row-menu-items is split from row-context-menu: the popup renders through a
   portal, which reagent.dom.server renders as nothing, so the list has to be
   reachable without it for a render test to see it at all."
  [{:keys [items active on-pick]}]
  [:<>
   [:div {:class "px-3 py-1 text-xs uppercase tracking-wide text-[var(--faint)]"}
    "Commands"]
   (if (empty? items)
     [:div {:class "px-3 py-1.5 text-[var(--faint)] italic"} "No matching command"]
     (for [[i {:keys [trigger label icon]}] (map-indexed vector items)]
       ^{:key trigger}
       [:button {:class (str "w-full text-left px-3 py-1.5 flex items-center gap-2 "
                             (if (= i active) "bg-[var(--gutter)]" "hover:bg-[var(--gutter)]"))
                 ;; mouse-down, not click: clicking would blur the editor first,
                 ;; which commits the raw \"/todo\" as the block's text and then
                 ;; applies the command to it
                 :on-mouse-down (fn [e] (.preventDefault e) (on-pick i))}
        [:span {:class "w-5 text-center"} (or icon "")]
        [:span {:class "text-[var(--accent)] font-mono"} (str "/" trigger)]
        [:span {:class "text-[var(--muted)]"} label]]))])

(defn slash-popup
  "The command list under a block whose text starts with \"/\". Rendered from
   the DECLARED :slash-menu, so a new command is a line in the description and
   no change here.

   `:anchor` is the editing row's viewport rect. It is required rather than
   optional because this popup used to be `absolute … top-full` inside the row,
   and the row lives inside the reading pane's :scroll-area — an ancestor with
   an overflow context CLIPS an absolutely positioned descendant, so the menu
   was drawn correctly and then cut off by the box it was drawn in. Positioning
   against the viewport through a portal is what escapes that; flipping above
   the row when there is no space below is what `floating-menu` adds on top."
  [{:keys [items active on-pick anchor]}]
  [floating-menu
   {:x (or (:left anchor) 0)
    ;; hangs below the row…
    :y (or (:bottom anchor) 0)
    ;; …and when it flips, it hangs ABOVE it: the row's top edge, not its
    ;; bottom, or the flipped menu would cover the line being typed.
    :y-flip (or (:top anchor) (:bottom anchor) 0)
    :class (str "min-w-[240px] py-1 rounded-md "
                "bg-[var(--field)] border border-[var(--border)] text-sm")}
   [slash-menu-body {:items items :active active :on-pick on-pick}]])

(defn- caret-to-end!
  "Put the cursor after the last character. A textarea opened with
   :auto-focus lands the caret at position 0, so clicking a written block to
   edit it would drop you in FRONT of the text you meant to continue."
  [el]
  (when el
    (let [n (.. el -value -length)]
      (.setSelectionRange el n n))))

;; ---------------------------------------------------------------------------
;; THE BLOCK KEYS OF ikc1 (lane AL-K of PLAN-alatus-v0-003-01, rows C-42 to
;; C-46 and C-53 of SPEC-alatus-v0-002-02 §4d).
;;
;; COPIED, NOT DESIGNED. The source is ikc1's BlockEditor.tsx — handleKeyDown,
;; handleTab and handleBackspace — and the paste handler of AthensEditor.tsx.
;; Each act that changes the note sends a declared command through a gesture
;; of the :outline node. The row menu sends the same gestures, so a phone, a
;; keyboard and a script do one thing (the Programmability pillar).
;; ---------------------------------------------------------------------------

(defn outline-key
  "PURE. The act of one key in a block's editor, or nil for a key the textarea
   keeps. The event is {:key :shift? :alt? :ctrl? :meta? :at-start? :at-end?
   :empty?}.

   ikc1's own tests, in ikc1's own order:
   - Alt+Up and Alt+Down move the block, wherever the caret is.
   - Up with no modifier, at the start of the text, goes to the block before.
     Down at the end goes to the block after. Anywhere else the textarea
     moves the caret.
   - Backspace in an EMPTY block deletes it. In a block with text it deletes
     a character: ikc1 joins no blocks.
   - Shift+Backspace is NOT here, and this is a change from ikc1. George
     pressed it often while he typed, and it asked to delete the block and
     its children (IKC-307). Now the textarea keeps it, so it deletes one
     character. Delete in the row menu deletes the branch, after a question.
   - Tab indents. Shift+Tab outdents.
   - Ctrl+Shift+V pastes one block for each paragraph. ikc1 reads Ctrl, not
     Meta, and this copies it.

   Enter, Shift+Enter and Escape are not here. The row answered them before
   this map existed, and it goes on answering them."
  [{:keys [key shift? alt? ctrl? meta? at-start? at-end? empty?]}]
  (let [bare? (not (or shift? alt? ctrl? meta?))]
    (cond
      (and alt? (= key "ArrowUp"))                    :move-up
      (and alt? (= key "ArrowDown"))                  :move-down
      (and bare? at-start? (= key "ArrowUp"))         :focus-up
      (and bare? at-end? (= key "ArrowDown"))         :focus-down
      (and (not shift?) empty? (= key "Backspace"))   :delete-empty
      (= key "Tab")                                   (if shift? :outdent :indent)
      (and ctrl? shift? (#{"v" "V"} key))             :paste-blocks
      :else                                           nil)))

(defn outline-neighbours
  "PURE. {block-id {:up id :down id}} over the rows of one outline, in order.

   ikc1's rule, from its tree of frames: Up goes to the SIBLING before, and to
   the parent when there is none. Down goes to the sibling after, and nowhere
   when there is none. A sibling is the next row at the same depth before a
   row at a smaller depth. The rows in between are its children, and the
   arrow passes over them, as ikc1's does."
  [items]
  (let [v (vec items)
        n (count v)
        d #(or (:depth (nth v %)) 0)]
    (into {}
          (map (fn [i]
                 (let [di   (d i)
                       up   (loop [j (dec i)]
                              (cond (neg? j)      nil
                                    (> (d j) di)  (recur (dec j))
                                    :else         (:block-id (nth v j))))
                       down (loop [j (inc i)]
                              (cond (>= j n)      nil
                                    (> (d j) di)  (recur (inc j))
                                    (= (d j) di)  (:block-id (nth v j))
                                    :else         nil))]
                   [(:block-id (nth v i)) {:up up :down down}])))
          (range n))))

(defn paste-paragraphs
  "PURE. The paragraphs of a pasted text: cut at each empty line, trimmed,
   and the empty ones dropped. ikc1's plain-text rule (pasteUtils.ts,
   splitClipboardToMarkdownChunks). ikc1 reads the HTML of the clipboard first
   and cuts at each block element. A textarea gets the plain text, where a
   browser writes an empty line between two paragraphs."
  [text]
  (->> (str/split (or text "") #"\n\s*\n")
       (map str/trim)
       (remove str/blank?)
       vec))

(defn- place-caret!
  "The caret at the :start or at the :end of a textarea's text."
  [el at]
  (when el
    (let [n (if (= at :start) 0 (.. el -value -length))]
      (.setSelectionRange el n n))))

;; WHERE THE NEXT ROW TO OPEN PUTS ITS CARET, {:block-id :at}. Down puts it at
;; the start of the next block, as ikc1's focusStart does. A row that opens
;; for any other reason puts it at the end. A COMMENT, because defonce takes no
;; docstring.
(defonce ^:private caret-request (atom nil))

(defn- open-outline-row!
  "Put the caret in the row of `block-id`, in the list `ul`. An open row is
   focused. A closed row gets the click a person gives it, so the row opens as
   it always does, and its focus sends the :focus gesture. Answers true when
   the row was there."
  [ul block-id at]
  (when-let [li (and ul block-id
                     (.querySelector ul (str "li[data-block-id=\"" block-id "\"]")))]
    (if-let [ta (.querySelector li "textarea")]
      (do (.focus ta) (place-caret! ta at))
      (when-let [span (.querySelector li ".ikc-block-content")]
        (reset! caret-request {:block-id (str block-id) :at at})
        (.click span)))
    true))

(defn- open-outline-row-soon!
  "open-outline-row! for a row the bus has made and the list has not drawn
   yet. It tries again for two seconds, as ikc1 focuses a new block after a
   timeout."
  [ul block-id at]
  (let [tries (atom 0)]
    ((fn attempt []
       (when-not (or (open-outline-row! ul block-id at) (> (swap! tries inc) 13))
         (js/setTimeout attempt 150))))))

(defn- refusal-text
  "What a row says when the bus refused its write."
  [reply]
  (or (:message (js->clj reply :keywordize-keys true))
      "The bus refused this edit. Your text is still here."))

(defn- outline-row
  ;; A BLANK block opens in edit mode. This runs once per row, at mount, so a
  ;; block that appears blank is one that was just created — by the empty-state
  ;; click or by Enter on the row above — and the next thing anyone wants is to
  ;; type into it. Requiring a second click to find the cursor is how "I made a
  ;; block and still cannot write" happens. Blurring sets it false and the outer
  ;; fn does not re-run, so this cannot re-open a row the user left alone.
  [item _actions _links _bus _session-id _row-menu _slash-menu _completions _props]
  (let [;; OPEN IF THIS BLOCK HAS UNSAVED TEXT (2026-09-08). Holding the words
        ;; in `unsaved` is only half of keeping them: a row that remounts CLOSED
        ;; draws its last SAVED content, so the typed words are off the screen
        ;; even though nothing lost them. From where a person sits that is still
        ;; a vanish, and the rule is about what they can see.
        ;;
        ;; Measured 2026-09-08, with the store in place and this line not: the
        ;; words survived Enter with the bus down, survived the reconnect in
        ;; memory, and were nowhere on the page afterwards.
        editing?  (r/atom (or (some? (unsaved/text (:block-id item)))
                              (str/blank? (:content item))))
        ;; A row can be highlighted too (F-platform-v0-011-01). `pending` holds
        ;; the selection the swatches will act on; `body-ref` is the rendered
        ;; body, so a selection outside this row is ignored the same way the
        ;; markdown widget ignores one outside its pane.
        pending   (r/atom nil)
        ;; As in the markdown pane: the swatches must go when the
        ;; selection does, however it was dropped (selection-ref).
        sel-listener (atom nil)
        body-ref  (atom nil)
        ;; SEEDED FROM THE UNSAVED STORE FIRST (2026-09-08). A remount
        ;; otherwise seeds from `item`, which is the LAST SAVED text —
        ;; `draft-holding-kinds` names that failure and can only prevent one of
        ;; its causes. The other is the whole widget tree being replaced, which
        ;; is what a re-attach does, and a reconnect after a bus restart
        ;; re-attaches. Measured that day: the words survived Enter with the bus
        ;; down and vanished when it came back.
        buf       (r/atom (let [u (unsaved/text (:block-id item))]
                            (if (some? u) u (:content item))))
        ;; DID THE READER ACTUALLY TYPE? Blur used to commit `buf` whatever it
        ;; held, and `buf` is seeded ONCE at mount — so anything that left it out
        ;; of step with the block wrote the stale value back over the real one.
        ;; On 2026-08-16 a browser session that opened a row, clicked elsewhere
        ;; and never typed a character emptied it: the block's text was gone from
        ;; the graph and its three highlights went orphaned with it.
        ;;
        ;; A blur is not an edit. Committing on one is how a UI can destroy text
        ;; nobody touched, and the fix is to know the difference rather than to
        ;; guess at what the buffer should have held.
        ;; AND DIRTY, for the same remount. `dirty?` is what makes a blur try
        ;; the save again; seeded false, a restored buffer would sit on screen
        ;; and never be written even once the bus was back.
        dirty?    (r/atom (some? (unsaved/text (:block-id item))))
        ;; THE STALL, MADE VISIBLE (PLAN-ikc-v3-018-01 phase 1).
        ;;
        ;; `sending?` is true while the bus has not answered, so the editor
        ;; stays open and the row can say it is waiting. `send-error` holds what
        ;; the bus said when it refused. Both are per-row, because a refusal
        ;; belongs at the block it happened to and nowhere else.
        sending?   (r/atom false)
        send-error (r/atom nil)
        menu-at   (r/atom nil)              ; {:x :y} while the context menu is open
        slash-idx (r/atom 0)                ; highlighted slash-menu row
        ;; THE COMPLETION'S THREE PIECES (F-ikc-v3-018-01). `caret` is where the
        ;; cursor is, which a slash menu never needed — it always matched from
        ;; the start of the buffer, and a hashtag is written mid-sentence.
        ;; `comp-idx` is the highlighted row. `comp-off?` is Escape: a person who
        ;; dismisses the popup must be able to go on typing the word, so the
        ;; popup stays shut until the buffer changes again.
        caret     (r/atom 0)
        comp-idx  (r/atom 0)
        comp-off? (r/atom false)
        ;; THE TITLES A SOURCE ENTRY LAST GOT (the `[[` picker), the query they
        ;; answered, a counter so the LAST request wins, and the debounce timer.
        found     (r/atom {:q nil :rows []})
        found-req (atom 0)
        found-tm  (atom nil)
        ;; The editing control's VIEWPORT rect, which is where the slash menu
        ;; hangs from. Kept fresh as you type because autosize! changes the
        ;; row's height underneath it.
        anchor    (r/atom nil)
        ;; THE BLOCK KEYS (lane AL-K). `ta-el` is this row's textarea and
        ;; `row-el` its <li>, so a key can find the list and the next row.
        ;; `hold-open` keeps the editor open while a move is on its way: a
        ;; move re-orders the rows, the browser can take the focus away from a
        ;; moved textarea, and a blur must not close the row under the caret.
        ;; `paste-armed` is Ctrl+Shift+V, which the paste event after it reads.
        ta-el       (atom nil)
        row-el      (atom nil)
        hold-open   (atom false)
        paste-armed (atom false)
        ;; THE CARET AT THE LAST BLUR, for Split in the row menu. A right click
        ;; on the row's gutter takes the focus first, and the editor closes
        ;; before the item is chosen.
        blur-caret  (atom nil)
        remember! (fn [el]
                    (when el
                      (let [r (.getBoundingClientRect el)]
                        (reset! anchor {:left (.-left r)
                                        :top (.-top r)
                                        :bottom (.-bottom r)}))))]
    (fn [{:keys [num block-id block-type content checked? collapsed? has-children?
                 depth highlights up-id down-id]}
         actions links bus session-id row-menu slash-menu completions props]
      ;; THE NUMBER GUTTER DOES NOT MOVE WHEN A BLOCK INDENTS. George,
      ;; 2026-08-14: *"when indenting a block in the notes, its left gutter also
      ;; indents - it should not move."* The indent used to sit on the <li>,
      ;; which carries the whole three-column row — number gutter included — so
      ;; the numbers stopped forming a column you could read down, and by depth
      ;; four the gutter had slid 96px from the pane's edge (measured on the live
      ;; reader, dev/measure_indent_and_tree.mjs).
      ;;
      ;; So the indent goes on the BODY cell only. The row itself stays put, both
      ;; gutters keep their columns, and the depth is still visible — it is the
      ;; text that steps right, which is what indenting means.
      ;; Declared too: [body has indent per-depth], [number-gutter can-not move]
      ;; in dsl/alatus/reading-area.edn.
      (let [;; ONE STEP PER DEPTH, and the step is the declaration's, not this
            ;; file's — dsl/design/block-row.edn says the body indents by space-5.
            ;; calc() rather than arithmetic here, so a theme restating the space
            ;; scale moves the indent with it.
            depth' (or depth 0)
            indent {:margin-left (if (pos? depth')
                                   (str "calc(" (token-var (get-in block-row [:draws :cells 'body :indent]))
                                        " * " depth' ")")
                                   "0")}
            ;; OUTLINE TOOLBAR: Collapse/Expand Content (PLAN-ikc-v3-051-01,
            ;; ikc1's PageView.tsx:266-289). `props` is the WHOLE :outline
            ;; widget's props map (see widget-outline's call below), carrying
            ;; :content-collapsed?/:dim-done? bound in dsl/alatus/reading-
            ;; area.edn — read straight off it rather than added to this row's
            ;; own destructured keys, so no call site between here and
            ;; widget-outline needs to change.
            ;;
            ;; ikc1's OWN RULE: a block truncates when it is multi-line OR
            ;; over eighty characters, to its own first sixty
            ;; (BlockEditor.tsx:426-428). The ellipsis is on TOTAL length, not
            ;; the first line's — a five-line block whose first line is nine
            ;; characters still gets one, because there is more of it below.
            ;; `(or content "")`: a separator row's own :content is nil
            ;; (BLANK BY KIND, never typed into), and this whole `let` runs
            ;; BEFORE the `:separator` branch below chooses not to read
            ;; `content` at all — so a nil here must not reach `str/includes?`
            ;; or `count`, both of which throw on it (T-widgets-cljs's own
            ;; block-row-characterization caught this).
            content'           (or content "")
            content-collapsed? (boolean (:content-collapsed? props))
            multiline?         (or (str/includes? content' "\n") (> (count content') 80))
            truncated?         (and content-collapsed? multiline?)
            display-content    (if truncated?
                                  (let [first-line (first (str/split content' #"\n" 2))
                                        head       (subs first-line 0 (min 60 (count first-line)))
                                        ;; THE ELLIPSIS MARKS WHAT WAS DROPPED,
                                        ;; not the total length (PR #95
                                        ;; review). "a\nb" is three characters
                                        ;; total — the old `(> (count
                                        ;; content') 60)` test truncated it to
                                        ;; "a" with NO ellipsis, so its own
                                        ;; second line vanished with nothing on
                                        ;; screen saying more was there. A
                                        ;; second line is dropped whenever one
                                        ;; EXISTS at all (the newline itself),
                                        ;; and the first line is dropped
                                        ;; whenever IT ALONE ran past sixty.
                                        dropped?   (or (str/includes? content' "\n")
                                                       (> (count first-line) 60))]
                                    (str head (when dropped? "...")))
                                  content)
            ;; Dim Done (ikc1's setDimDone, BlockEditor.tsx:861): a done row's
            ;; OWN opacity, never its children's — the same "opacity-40" class
            ;; ikc1 applies to the one row.
            dim-this? (and (boolean (:dim-done? props)) (boolean checked?))
            ;; THE LOCKED TARGET'S OWN ROW, quoted from
            ;; SPEC-graph-ui-v0-003-01's Measurements section:
            ;;
            ;;   block row — grid-template-columns: 30px 1fr 132px, gap: 6px
            ;;
            ;; `1fr`, not a measure. The row does NOT carry the reading width any
            ;; more, because carrying it here is what broke the column: the blocks
            ;; held a fixed width while the title and the toolbar spread to the
            ;; whole pane, so widening the window moved them apart (George,
            ;; 2026-08-15: *"the other elements get placed/moved in ways that do
            ;; not make sense. ALL of the reading pane should stay as a column."*)
            ;;
            ;; The maximum belongs to the ONE box that holds the whole pane —
            ;; `:size "900px"` on alatus/reading-area's container, which is also
            ;; the locked target's number. Then the row fills whatever the column
            ;; gives it, and nothing inside can drift relative to anything else.
            ;;
            ;; THE META GUTTER IS ALWAYS DRAWN, INCLUDING EMPTY. I had dropped it
            ;; when no block carried :meta, on the reasoning that 132px of dim empty
            ;; box is width the text could have. George's screenshot of the locked
            ;; target (2026-08-15) settles it the other way: its row 4 carries no
            ;; tags and the box is there, pale and empty, holding the column.
            ;;
            ;; It also fixes a number my own change had made worse. With the track
            ;; dropped, `1fr` took the whole column and the line measured 90.1ch at
            ;; a 1920px window — further above the comfortable range than the 66ch
            ;; box had been below it. Keeping the gutter puts it near 78ch, which is
            ;; what the locked geometry produces.
            ;; THE TRACKS AND THE GAP COME FROM THE DECLARATION, not from here.
            ;; dsl/design/block-row.edn says 3.5ch / :fill / 15ch with a space-2
            ;; gap; this reads it. The three defects of 2026-08-14 are properties
            ;; of that component now — the gutter that must not move, the
            ;; separator that must stop where the text does, the meta gutter drawn
            ;; even empty — so the next person changes a declaration rather than
            ;; rediscovering them in this function.
            grid   {:display "grid"
                    :gridTemplateColumns (tracks-css (get-in block-row [:draws :tracks]))
                    :columnGap (token-var (get-in block-row [:draws :gap]))
                    ;; THE ROW IS NO LONGER THE REFERENCE BOX (2026-08-19). It
                    ;; was, and that held 45 characters of the ROW — gutters
                    ;; included — while the declaration says the BODY. The body
                    ;; cell now declares the container itself, in cell-style.
                    ;; The row keeps one as the OUTER container, so a `100cqi`
                    ;; in a cell without its own floor still answers to the row
                    ;; instead of falling back to the small viewport.
                    :containerType "inline-size"}
            cell   (fn [k] (get-in block-row [:draws :cells k]))
            ;; A KEY OR A MENU ITEM ACTS ONLY AFTER THE TYPED TEXT IS SAVED
            ;; (lane AL-K). STALL, never VANISH (George, 2026-08-23): when the
            ;; bus refuses the text, the text stays on the row with the
            ;; refusal, and the act does not happen. When the bus does not
            ;; answer, the row stays in its sending state with the text, and
            ;; the act waits. The Enter path below does the same, in its own
            ;; words, since 2026-09-08.
            commit-then!
            (fn [k]
              (if-not @dirty?
                (k)
                (do (reset! sending? true)
                    (reset! send-error nil)
                    (fire! actions :update-text bus session-id @buf
                           {'$block-id block-id}
                           (fn [reply]
                             (reset! sending? false)
                             (if (bind/reply-failed? reply)
                               (reset! send-error (refusal-text reply))
                               (do (reset! dirty? false)
                                   ;; THE SERVER HAS IT NOW.
                                   (unsaved/forget! block-id)
                                   (k))))))))
            ;; One gesture of this row. A refusal is named on the row. `on-ok`
            ;; gets the answer of the command.
            send!
            (fn [g value extra on-ok]
              (fire! actions g bus session-id value (merge {'$block-id block-id} extra)
                     (fn [reply]
                       (if (bind/reply-failed? reply)
                         (reset! send-error (refusal-text reply))
                         (do (reset! send-error nil)
                             (when on-ok (on-ok (js->clj reply :keywordize-keys true))))))))
            the-list #(some-> @row-el (.closest "ul"))
            ;; A DELETED ROW HAS NOTHING LEFT TO SAVE. Its text is gone by the
            ;; person's own act, so a blur after the delete must not write it
            ;; back to the archived block.
            gone!
            (fn []
              (reset! dirty? false)
              (unsaved/forget! block-id))
            ;; Indent, outdent and the two moves keep the caret in this row, as
            ;; ikc1 does. The rows re-order when the bus pushes the new outline,
            ;; after the answer, so the focus comes back a moment later.
            move!
            (fn [g]
              (commit-then!
               (fn []
                 (reset! hold-open true)
                 (send! g block-id {} nil)
                 (js/setTimeout (fn []
                                  (when-let [el @ta-el]
                                    (when (.-isConnected el) (.focus el)))
                                  (reset! hold-open false))
                                600))))
            paste-blocks!
            (fn [paragraphs]
              (let [ul (the-list)]
                (commit-then!
                 (fn []
                   (send! :paste-blocks paragraphs {}
                          (fn [r] (open-outline-row-soon! ul (last (:block-ids r)) :end)))))))
            ;; ONE IMAGE PATH FOR A PASTE, A DROP AND A PICKED FILE (fault
            ;; report 08e4f4c1). The file goes to the bus as a data URL and
            ;; comes back as one line of markdown, put at character `at` of
            ;; the block. A closed row has no blur to save it, so `save?`
            ;; saves it at once.
            put-image!
            (fn [file el at save?]
              (let [rdr (js/FileReader.)]
                (set! (.-onload rdr)
                      (fn [_]
                        (fire! actions :paste-image bus session-id
                               (.-result rdr) {'$block-id block-id}
                               (fn [reply]
                                 (reset! send-error (paste-refusal reply))
                                 (when-let [md (pasted-markdown reply)]
                                   (let [base (if @editing? @buf (or content ""))
                                         {:keys [text caret-at]} (splice-at base at md)]
                                     (reset! buf text)
                                     (reset! caret caret-at)
                                     (reset! dirty? true)
                                     (unsaved/remember! block-id text)
                                     (when el (js/setTimeout #(autosize! el) 0))
                                     (when save? (commit-then! (fn [] nil)))))))))
                (.readAsDataURL rdr file)))
            ;; INSERT FILE (PLAN-ikc-v3-061-01). The size is checked against
            ;; the limit BEFORE the file is read, so a refused file is never
            ;; sent. The reply's link goes in at character `at`, as an image
            ;; line does.
            put-file!
            (fn [file el at]
              (if-let [why (pre-send-refusal (.-size file) (:attachment-limit props))]
                (reset! send-error why)
                (let [rdr (js/FileReader.)]
                  (reset! sending? true)
                  (set! (.-onerror rdr)
                        (fn [_]
                          (reset! sending? false)
                          (reset! send-error "The browser could not read the file. Nothing was sent.")))
                  (set! (.-onload rdr)
                        (fn [_]
                          (fire! actions :attach-file bus session-id
                                 (.-result rdr) {'$block-id block-id '$name (.-name file)}
                                 (fn [reply]
                                   (reset! sending? false)
                                   (reset! send-error (attach-refusal reply))
                                   (when-let [md (pasted-markdown reply)]
                                     (let [base (if @editing? @buf (or content ""))
                                           {:keys [text caret-at]} (splice-at base at md)]
                                       (reset! buf text)
                                       (reset! caret caret-at)
                                       (reset! dirty? true)
                                       (unsaved/remember! block-id text)
                                       (when el (js/setTimeout #(autosize! el) 0))
                                       (commit-then! (fn [] nil))))))))
                  (.readAsDataURL rdr file))))
            ;; An event that carries no image is left to the browser.
            insert-image!
            (fn [e]
              (when-let [file (and (get actions :paste-image)
                                   (prompt-area/image-file-of e))]
                (.preventDefault e)
                (let [el (.-target e)]
                  (put-image! file el (.-selectionStart el) false))))
            ;; THE ROW MENU SENDS THE SAME GESTURES AS THE KEYS. An item's
            ;; :confirm asks first, its :copy-result writes that key of the
            ;; answer to the clipboard, and :from-clipboard sends the
            ;; paragraphs of the clipboard. $offset is the caret, for Split.
            menu!
            (fn [g]
              (let [{:keys [copy-result from-clipboard from-file] question :confirm}
                    (some #(when (= g (:gesture %)) %) row-menu)
                    offset (if-let [el (and @editing? @ta-el)]
                             (.-selectionStart el)
                             (or @blur-caret (count (or content ""))))
                    no-clip "The browser gave no clipboard text. Press Ctrl+Shift+V in the block."
                    act (fn [value]
                          (commit-then!
                           (fn []
                             (send! g value {'$offset offset}
                                    (fn [r]
                                      (when (#{:delete-branch} g) (gone!))
                                      (when-let [t (and copy-result (get r copy-result))]
                                        (some-> js/navigator .-clipboard (.writeText t)))
                                      ;; A NEW BLOCK GETS THE CARET, as ikc1
                                      ;; focuses it after Insert Block Before,
                                      ;; Duplicate, Split and a paste.
                                      (let [nid (or (:new-block-id r) (last (:block-ids r))
                                                    (:block-id r))]
                                        (when (and nid (not= (str nid) (str block-id)))
                                          (open-outline-row-soon! (the-list) nid :end))))))))]
                (when (and (or (not question) (js/confirm question))
                           ;; ikc1's Split Block: with the caret at the end
                           ;; there is nothing to split, and nothing is sent.
                           (not (and (= g :split) (>= offset (count (or content ""))))))
                  (cond
                    ;; A PICKED IMAGE (fault report 08e4f4c1). Firefox for
                    ;; Android gives a keyboard image or a pasted image only to
                    ;; a contenteditable field, never to this textarea. A file
                    ;; input works in every browser: on a phone it opens the
                    ;; photo picker or the camera.
                    (= :image from-file)
                    (prompt-area/pick-image!
                     (fn [file] (put-image! file @ta-el offset true)))

                    ;; ANY FILE (PLAN-ikc-v3-061-01).
                    (= :file from-file)
                    (prompt-area/pick-file!
                     (fn [file] (put-file! file @ta-el offset)))

                    from-clipboard
                    (if-let [cb (some-> js/navigator .-clipboard)]
                      (-> (.readText cb)
                          (.then (fn [t]
                                   (let [ps (paste-paragraphs t)]
                                     (if (seq ps) (act ps) (reset! send-error no-clip)))))
                          (.catch (fn [_] (reset! send-error no-clip))))
                      (reset! send-error no-clip))

                    :else
                    (act block-id)))))
            ;; THE KEYS, after the menus of completion and slash have had
            ;; theirs. Each one is ikc1's (outline-key).
            key!
            (fn [act e]
              (let [ul (the-list)]
                (case act
                  (:indent :outdent :move-up :move-down)
                  (do (.preventDefault e) (move! act))

                  :focus-up
                  (do (.preventDefault e)
                      (when up-id (commit-then! #(open-outline-row! ul up-id :end))))

                  :focus-down
                  (do (.preventDefault e)
                      (when down-id (commit-then! #(open-outline-row! ul down-id :start))))

                  :delete-empty
                  (do (.preventDefault e)
                      (send! :delete block-id {}
                             (fn [_] (gone!) (open-outline-row! ul up-id :end))))

                  ;; NOT prevented: the browser's paste event comes next, and
                  ;; the paste handler reads this flag.
                  :paste-blocks
                  (do (reset! paste-armed true)
                      (js/setTimeout #(reset! paste-armed false) 1000))

                  nil)))
            ;; ONE GRID, used by every row including the separator. A separator
            ;; is a block like any other, so it gets the same tracks and its rule
            ;; lands in the BODY column by construction rather than by
            ;; arithmetic.
            ;;
            ;; The first attempt at this indented the separator's <li> by
            ;; calc(32px + step) — the gutter's width plus the grid's gap, worked
            ;; out by hand. It aligned the LEFT edge and left the right edge to
            ;; run to the end of the row, straight through the meta gutter:
            ;; measured 578 → 1097 where the body column ends at 979 (George,
            ;; 2026-08-14: "Separator starts from left of the block and end to the
            ;; right of the right gutter"). Two hardcoded numbers to get one edge
            ;; right and no way to get the other; the grid gives both for free.
            ]
        (if (= block-type :separator)
          ;; IT KEEPS ITS NUMBER. A separator is a block and holds an ordinal, so
          ;; leaving its gutter cell empty put a HOLE in the number column — 1,
          ;; blank, 3 — which is the same defect as a gutter that slides, one row
          ;; later. Plain type rather than the badge box the text rows use: the
          ;; column stays readable without putting a filled panel around a
          ;; divider.
          ;;
          ;; Its third cell, when there is one, is empty and stays empty: it
          ;; holds the track open so the rule stops where the text above it does.
          ;;
          ;; var(--muted), not var(--border): at 1px of the faintest line token
          ;; in the palette this was "very suttle color" — barely a divider at
          ;; all. --muted is the colour the block numbers are set in, so a
          ;; separator now reads as deliberate rather than merely darker.
          [:li {:style grid :class "items-center" :data-block-id (str block-id)}
           [:div {:style (assoc (cell-style (cell 'number-gutter))
                                :background "transparent" :borderWidth "0"
                                :alignItems "center")
                  :class "tabular-nums select-none"}
            (or num "")]
           [:hr {:style (merge indent
                               {:marginBlock (token-var 'space-2)
                                :borderTopWidth (token-var 'stroke-hairline)
                                :borderTopStyle "solid"
                                :borderTopColor (token-var 'muted)})}]
           [:div]]
          ;; Right-click anywhere on the row opens the SAME list the hover strip
          ;; shows. Suppressed when there is no :row-menu, so the browser's own
          ;; menu still works on a read-only outline rather than being swallowed.
          [:li.group {;; DIM DONE (PLAN-ikc-v3-051-01): this row's own opacity,
                      ;; never its children's — ikc1's own
                      ;; `dimDone && isDone && "opacity-40"` (BlockEditor.tsx:861).
                      ;; `.ikc-dim`, not a Tailwind opacity utility: the dim
                      ;; state is a token no theme can restate otherwise
                      ;; (PRINCIPLE-ikc-v3-011-01 seam 4) — the same class
                      ;; ui.voice's own disabled-mic row already uses.
                      :class (when dim-this? "ikc-dim")
                      ;; THE ROW'S ID ON THE ROW (lane AL-K). Up and Down find
                      ;; the next row by it, and a scenario reads it.
                      :data-block-id (str block-id)
                      :ref #(reset! row-el %)
                      :on-context-menu (when (seq row-menu)
                                         (fn [e]
                                           (.preventDefault e)
                                           (reset! menu-at {:x (.-clientX e) :y (.-clientY e)})))
                      ;; WHERE THE CARET WENT, reported once (2026-09-05). The
                      ;; internals viewer shows the frame behind whatever the
                      ;; reading pane is on, so it needs to be told. George:
                      ;; "sync of presented in the reading pane to be the same
                      ;; as in internals".
                      ;;
                      ;; CAPTURE PHASE, NO preventDefault, NO stopPropagation.
                      ;; Both listeners run before the row's own handlers and
                      ;; change none of them. The click one catches a click on
                      ;; the gutter, which focuses nothing.
                      :on-focus-capture (fn [_] (report-focus! actions bus session-id
                                                               (:block-id item)))
                      :on-click-capture (fn [_] (report-focus! actions bus session-id
                                                               (:block-id item)))}
           ;; The swatches, floating beside the selection — the SAME component the
           ;; file body uses, so a note and a document are marked identically and
           ;; the two event handlers that make it work exist once.
           (when @pending
             [highlight-picker @pending
              (fn [color]
                (when-let [{:keys [text approx-start prefix suffix]} @pending]
                  (fire! actions :highlight bus session-id
                         (cond-> {:block-id block-id :anchor-text text
                                  :approx-start approx-start :color color}
                           ;; Only a selection over the RENDERED row has
                           ;; them. A textarea's offset is exact already.
                           prefix (assoc :prefix prefix)
                           suffix (assoc :suffix suffix))
                         nil))
                (reset! pending nil)
                (some-> (.getSelection js/window) (.removeAllRanges)))
              #(do (reset! pending nil)
                   (some-> (.getSelection js/window) (.removeAllRanges)))
              nil
              (when (contains? actions :branch-selection)
                {:on-branch
                 (fn []
                   (when-let [{:keys [text]} @pending]
                     (fire! actions :branch-selection bus session-id
                            {:block-id block-id :anchor-text text} nil))
                   (reset! pending nil)
                   (some-> (.getSelection js/window) (.removeAllRanges)))})])
           (when-let [{:keys [x y]} @menu-at]
             [row-context-menu
              {:x x :y y
               :items (mapv #(assoc % :label (file-menu-label % (:attachment-limit props)))
                            row-menu)
               :on-close #(reset! menu-at nil)
               :fire menu!}])
           [:div {:style grid :class "items-stretch py-[3px]"}
            [:div {:style (cell-style (cell 'number-gutter))
                   :class "tabular-nums select-none"}
             (or num "")]
            [:div {:style (merge (cell-style (cell 'body)) indent)
                   :class "relative flex items-baseline gap-2 min-w-0 group-hover:border-[var(--accent-2)]"}
             (when has-children?
               ;; A FINGER TARGET ON A PHONE (row C-48 of SPEC-alatus-v0-002-02).
               ;; It measured 6 x 23 px at 390 px wide. A span with a click is
               ;; out of reach of the coarse-pointer rules for buttons, and
               ;; `ikc-touch-target` is the class ikc-base.css names for it. A
               ;; desktop draws it as before.
               [:span {:class (str "self-center cursor-pointer text-[var(--faint)] hover:text-[var(--text)] "
                                   "ikc-touch-target inline-flex items-center justify-center")
                       :role "button"
                       :aria-label (if collapsed? "Unfold" "Fold")
                       :on-click #(fire! actions :toggle-collapse bus session-id block-id nil)}
                (if collapsed? "▸" "▾")])
             ;; A to-do shows its checkbox, because that is a CONTROL — you
             ;; click it and the block changes. An ordinary block shows nothing
             ;; before its text: the dot that used to sit here was decoration,
             ;; and it stole the first characters of every line (George,
             ;; 2026-08-07). Declared in the description too:
             ;; [typed-blocks shows-not bullet], dsl/alatus/reading-area.edn.
             (when (= block-type :task)
               [:input {:type "checkbox" :checked (boolean checked?)
                        :class "mt-1 accent-[var(--accent)] cursor-pointer"
                        :on-change #(fire! actions :toggle-done bus session-id block-id nil)}])
             (if @editing?
               (let [matches (slash-matches @buf slash-menu)
                     ;; THE COMPLETION, and it is computed per render from the
                     ;; buffer and the caret rather than held in state. Anything
                     ;; that moves either one — a keystroke, a click, an arrow —
                     ;; changes the answer, and a cached one would lag by a key.
                     comp    (when-not @comp-off?
                               (completion-state @buf @caret completions props
                                                 @found))
                     ;; ASK THE SOURCE when the caret sits in a source entry
                     ;; and its query is not the one already answered. One
                     ;; bounded read through :ui/read, the read the Ctrl+K
                     ;; palette makes, after a short pause in the typing.
                     refresh-found!
                     (fn []
                       (when-let [{:keys [trigger query]}
                                  (completion-at @buf @caret (map :trigger completions))]
                         (when-let [entry (first (filter #(and (= trigger (:trigger %))
                                                               (:source %))
                                                         completions))]
                           (when (and bus (not= query (:q @found)))
                             (when-let [t @found-tm] (js/clearTimeout t))
                             (reset! found-tm
                                     (js/setTimeout
                                      (fn []
                                        (ask-source!
                                         {:bus bus :entry entry :session-id session-id
                                          :query query :req found-req
                                          :timeout-ms source-timeout-ms
                                          :on-done (fn [answer]
                                                     (reset! found answer)
                                                     (reset! comp-idx 0))}))
                                      120))))))
                     comp-open? (some? comp)
                     pick-comp!
                     (fn [i]
                       (when-let [item (nth (:items comp) i nil)]
                         (let [{:keys [text]} (splice-completion @buf @caret comp item)]
                           ;; A PICK DISPATCHES NOTHING. It writes text, and the
                           ;; ordinary edit path carries it from there — which is
                           ;; what makes a completion different from a slash
                           ;; command (ADR-ikc-v3-080-01 decision 3).
                           (reset! buf text)
                           (reset! caret (count text))
                           (reset! dirty? true)
                           (reset! comp-idx 0)
                           (reset! found {:q nil :rows []})
                           (unsaved/remember! block-id text))))
                     ;; picking a command CLEARS the slash text first: the block
                     ;; should become a to-do, not a to-do that says "/todo"
                     pick!   (fn [i]
                               (when-let [entry (nth matches i nil)]
                                 (let [next-state (slash-pick-state entry)]
                                   (reset! buf (:text next-state))
                                   (reset! editing? (:editing? next-state))
                                   (fire! actions :update-text bus session-id (:text next-state)
                                          {'$block-id block-id})
                                   (fire! actions (:gesture entry) bus session-id block-id nil))))]
                 [:<>
                  ;; A TEXTAREA, not an input. An input is single-line by
                  ;; construction, so a three-line block COLLAPSED to one line
                  ;; for as long as you were editing it and sprang back on blur
                  ;; — the block visibly changed shape under the cursor, and
                  ;; text typed across lines only wrapped once you left
                  ;; (George, 2026-08-04, items 4 and 10 of one dump: two
                  ;; reports of this single cause). It also made a newline
                  ;; inside a block untypable at all.
                  ;;
                  ;; Height is driven from content by autosize! rather than by
                  ;; a row count, so the editor is exactly as tall as the text
                  ;; it holds — which is what makes entering and leaving edit
                  ;; mode a no-op for layout. p-0/border-0/font-[inherit] exist
                  ;; because a bare textarea brings its own padding, border and
                  ;; MONOSPACE font, any of which would move the text the
                  ;; instant you clicked it.
                  ;; THE STALL AND THE REFUSAL ARE DRAWN ON THE ROW
                  ;; (PLAN-ikc-v3-018-01 phase 1). The border colour is the
                  ;; whole indicator while the bus has not answered, and the
                  ;; message below it is what the bus said when it refused.
                  ;;
                  ;; A BORDER AND NOT AN INSERTED ELEMENT. An indicator must not
                  ;; move the furniture: a spinner added to this row would push
                  ;; the text as it appeared and again as it went. The textarea
                  ;; already has border-0, so a coloured left edge costs no
                  ;; layout at all.
                  [:textarea {:style (block-text-style)
                              :class (str "flex-1 min-w-0 self-center block w-full "
                                          "bg-transparent outline-none resize-none overflow-hidden "
                                          "p-0 m-0 border-0 font-[inherit] leading-normal "
                                          "min-h-[1.5rem] "
                                          (cond @send-error "border-l-2 pl-1 border-[var(--danger)] "
                                                @sending?   "border-l-2 pl-1 border-[var(--muted)] "
                                                :else       "")
                                          (if (= block-type :heading)
                                            "text-lg font-semibold text-[var(--heading)]"
                                            "text-[var(--text)]"))
                           :rows 1
                           :value @buf :auto-focus true
                           ;; Mount-time only (Reagent calls this with nil on
                           ;; unmount): size it to the content it opened with,
                           ;; and put the caret after that content.
                           :ref (fn [el]
                                  (reset! ta-el el)
                                  (when el
                                    (autosize! el)
                                    ;; Down opens the next row with the caret at
                                    ;; its start, as ikc1's focusStart does.
                                    (if (= (str block-id) (:block-id @caret-request))
                                      (do (place-caret! el (:at @caret-request))
                                          (reset! caret-request nil))
                                      (caret-to-end! el))
                                    (remember! el)))
                           ;; A PASTED IMAGE (IKC3-Bugs-20260928 item 9). The
                           ;; file goes to the bus as a data URL and comes back
                           ;; as one line of markdown, put where the caret was.
                           ;; A paste of TEXT carries no image file and falls
                           ;; through to the browser, untouched.
                           ;;
                           ;; A DROPPED IMAGE TAKES THE SAME PATH, and
                           ;; data-image-input marks the editor for the
                           ;; stylesheet. Under a finger that makes it a field
                           ;; an Android keyboard may put an image into (fault
                           ;; report 08e4f4c1, T-responsive-016).
                           :data-image-input (when (get actions :paste-image) "true")
                           :on-paste (fn [e]
                                       ;; CTRL+SHIFT+V, ONE BLOCK FOR EACH
                                       ;; PARAGRAPH (ikc1 AthensEditor.tsx). One
                                       ;; paragraph is an ordinary paste, as in
                                       ;; ikc1, so the browser keeps it.
                                       (if @paste-armed
                                         (let [ps (paste-paragraphs
                                                   (some-> (.-clipboardData e) (.getData "text/plain")))]
                                           (reset! paste-armed false)
                                           (when (>= (count ps) 2)
                                             (.preventDefault e)
                                             (paste-blocks! ps)))
                                         (insert-image! e)))
                           :on-drag-over (fn [e]
                                           (when (and (get actions :paste-image)
                                                      (prompt-area/carries-files? e))
                                             (.preventDefault e)))
                           :on-drop insert-image!
                           :on-change (fn [e]
                                        (let [el (.-target e)]
                                          (reset! buf (.-value el))
                                          (reset! dirty? true)
                                          ;; OUTLIVES THIS COMPONENT. The atom
                                          ;; above dies with the row; this does
                                          ;; not, which is the whole point.
                                          (unsaved/remember! block-id (.-value el))
                                          (reset! slash-idx 0)
                                          ;; THE CARET IS WHAT MAKES A MID-WORD
                                          ;; COMPLETION POSSIBLE. A slash menu
                                          ;; matches from the start of the buffer
                                          ;; and never needed one. Reset on every
                                          ;; change, so an Escape that shut the
                                          ;; popup does not keep it shut once the
                                          ;; word changes.
                                          (reset! caret (.-selectionStart el))
                                          (reset! comp-idx 0)
                                          (reset! comp-off? false)
                                          (refresh-found!)
                                          ;; grow/shrink as you type, including
                                          ;; when a paste arrives all at once
                                          (autosize! el)
                                          ;; …which moves the row's bottom edge,
                                          ;; and the slash menu hangs off it
                                          (remember! el)))
                           ;; SELECTING INSIDE THE EDITOR OFFERS THE SWATCHES.
                           ;; Without these two, a row you had clicked into could
                           ;; not be marked at all — see `textarea-selection`.
                           ;; Mouse for dragging a selection, key-up for
                           ;; shift+arrow, which is how a keyboard user makes one.
                           :on-mouse-up
                           (when (and bus (:highlight actions))
                             (fn [e]
                               (reset! pending (textarea-selection (.-target e) e))))
                           :on-key-up
                           ;; UNCONDITIONAL NOW, and it was guarded by the
                           ;; highlight gesture. An arrow key moves the caret
                           ;; without changing the buffer, so a row that wired
                           ;; this only for highlights would leave the completion
                           ;; popup open over a word the cursor had left.
                           (fn [e]
                             (reset! caret (.-selectionStart (.-target e)))
                             (refresh-found!)
                             (when (and bus (:highlight actions) (.-shiftKey e))
                               (reset! pending (textarea-selection (.-target e) nil))))
                           :on-click (fn [e]
                                       (reset! caret (.-selectionStart (.-target e)))
                                       (refresh-found!))
                           :on-blur (fn [e]
                                      (reset! blur-caret (.. e -target -selectionStart))
                                      ;; THE TEXT STAYS UNTIL THE BUS CONFIRMS
                                      ;; (PLAN-ikc-v3-018-01 phase 1).
                                      ;;
                                      ;; George lost a note on 2026-08-22. Its
                                      ;; five minutes of typing were in this
                                      ;; atom and nowhere else, and the editor
                                      ;; closed on blur whatever the bus said —
                                      ;; it was not even told. The rule he named
                                      ;; is that a failure must STALL, not
                                      ;; vanish.
                                      ;;
                                      ;; So the editor stays open while the
                                      ;; reply is outstanding, closes on
                                      ;; success, and on a refusal stays open
                                      ;; WITH THE TEXT and says what happened.
                                      ;; :dirty? is cleared only on success, so
                                      ;; the next blur tries again.
                                      ;; A MOVE IS ON ITS WAY (lane AL-K): the
                                      ;; row keeps its editor, and move! puts
                                      ;; the focus back.
                                      (cond
                                        @hold-open nil
                                        (not @dirty?)
                                        (reset! editing? false)
                                        :else
                                        (do
                                          (reset! sending? true)
                                          (fire! actions :update-text bus session-id @buf
                                                 {'$block-id block-id}
                                                 (fn [reply]
                                                   (reset! sending? false)
                                                   (if (bind/reply-failed? reply)
                                                     (reset! send-error
                                                             (or (:message (js->clj reply :keywordize-keys true))
                                                                 "The bus refused this edit. Your text is still here."))
                                                     (do (reset! send-error nil)
                                                         (reset! dirty? false)
                                                         ;; THE SERVER HAS IT NOW.
                                                         (unsaved/forget! block-id)
                                                         (reset! editing? false))))))))
                           :on-key-down
                           ;; While the slash menu is open the arrow keys and
                           ;; Enter belong to IT — otherwise Enter would commit
                           ;; the literal "/todo" as the block's text, which is
                           ;; the one thing nobody typing a command wants.
                           (fn [e]
                             (let [k (.-keyCode e)
                                   open? (seq matches)
                                   ;; THE COMPLETION CLAIMS THE SAME FOUR KEYS,
                                   ;; and it claims them FIRST only when the
                                   ;; slash menu is shut. The two can never both
                                   ;; be open: a slash menu needs the buffer to
                                   ;; begin with "/", and a completion needs a
                                   ;; trigger at a word boundary before the
                                   ;; caret. Ordered anyway, because "cannot
                                   ;; both" is a property of today's two
                                   ;; triggers, not a rule anything enforces.
                                   copen? (and comp-open? (seq (:items comp)) (not open?))
                                   ;; A KEY IN A MENU BELONGS TO THAT MENU FIRST
                                   ;; (lane AL-K). Only with both menus shut is
                                   ;; a key one of ikc1's block keys.
                                   el  (.-target e)
                                   n   (count (str (.-value el)))
                                   act (when-not (or open? copen?)
                                         (outline-key
                                          {:key       (.-key e)
                                           :shift?    (.-shiftKey e)
                                           :alt?      (.-altKey e)
                                           :ctrl?     (.-ctrlKey e)
                                           :meta?     (.-metaKey e)
                                           :at-start? (= 0 (.-selectionStart el) (.-selectionEnd el))
                                           :at-end?   (= n (.-selectionStart el) (.-selectionEnd el))
                                           :empty?    (zero? n)}))]
                               (cond
                                 ;; THE POPUP'S KEYS, in `completion-key!`: Up, Down, Enter,
                                 ;; Tab and Escape. A pending read takes Enter and Tab.
                                 (completion-key!
                                  e (when comp-open? comp) open?
                                  {:move  (fn [d] (swap! comp-idx #(mod (+ % d) (count (:items comp)))))
                                   :pick  (fn [] (pick-comp! @comp-idx))
                                   :close (fn [] (reset! comp-off? true))})
                                 nil

                                 (and open? (= k 40))            ; down
                                 (do (.preventDefault e)
                                     (swap! slash-idx #(mod (inc %) (count matches))))

                                 (and open? (= k 38))            ; up
                                 (do (.preventDefault e)
                                     (swap! slash-idx #(mod (dec %) (count matches))))

                                 (and open? (= k 13))            ; enter picks
                                 (do (.preventDefault e) (pick! @slash-idx))

                                 act (key! act e)

                                 (= k 27)                        ; escape closes
                                 ;; ESCAPE IS A PERSON SAYING "DROP IT", which
                                 ;; is the one discard this namespace honours.
                                 (do (.preventDefault e)
                                     (unsaved/forget! block-id)
                                     (reset! buf ""))

                                 ;; Shift+Enter is a newline INSIDE the block,
                                 ;; and is claimed by NO branch on purpose: the
                                 ;; textarea inserts it itself. Spelled out in
                                 ;; the guard below rather than left as an
                                 ;; absence, because "Enter commits" reads as
                                 ;; total until you notice the (not shiftKey).
                                 (and (= k 13) (not (.-shiftKey e)))
                                 (do (.preventDefault e)
                                     ;; ENTER STALLS TOO (George, 2026-09-08:
                                     ;; "the text entered in a block vanishes on
                                     ;; press Enter"). THE BLUR PATH ABOVE WAS
                                     ;; FIXED ON 2026-08-23 AND THIS ONE WAS NOT
                                     ;; — it read:
                                     ;;
                                     ;;   (reset! editing? false)
                                     ;;   (fire! … :update-text … @buf …)
                                     ;;   (fire! … :insert-after …)
                                     ;;
                                     ;; The editor closed BEFORE the bus was
                                     ;; asked, and neither dispatch passed a
                                     ;; reply callback. So the row repainted its
                                     ;; OLD content and the typed words were
                                     ;; gone, with the screen still looking
                                     ;; correct. That is the exact shape of the
                                     ;; note George lost on 2026-08-22, and the
                                     ;; rule he named for it: a write that
                                     ;; cannot complete must STALL, visibly, and
                                     ;; must never VANISH.
                                     ;;
                                     ;; It is reachable without a bug in the
                                     ;; server. A bus restart closes the socket;
                                     ;; bus-client's on-close answers every
                                     ;; outstanding callback with
                                     ;; {:error :disconnected} — which this path
                                     ;; had no callback to receive.
                                     ;;
                                     ;; :insert-after MOVED INSIDE THE SUCCESS
                                     ;; ARM. A new empty block below text that
                                     ;; was never saved is a second wrong thing:
                                     ;; it moves the caret away from the words
                                     ;; still at risk.
                                     ;;
                                     ;; The three atoms are the blur path's own,
                                     ;; and the row already draws them — a
                                     ;; muted left border while sending, a
                                     ;; danger border and the message on a
                                     ;; refusal.
                                     (reset! sending? true)
                                     (reset! send-error nil)
                                     (fire! actions :update-text bus session-id @buf
                                            {'$block-id block-id}
                                            (fn [reply]
                                              (reset! sending? false)
                                              (if (bind/reply-failed? reply)
                                                (reset! send-error
                                                        (or (:message (js->clj reply :keywordize-keys true))
                                                            "The bus refused this edit. Your text is still here."))
                                                (do (reset! send-error nil)
                                                    (reset! dirty? false)
                                                    ;; THE SERVER HAS IT NOW.
                                                    (unsaved/forget! block-id)
                                                    (reset! editing? false)
                                                    (fire! actions :insert-after bus session-id
                                                           block-id nil)))))))))}]
                  (when (and (string? @buf) (str/starts-with? @buf "/") (seq slash-menu))
                    [slash-popup {:items (or matches []) :active @slash-idx
                                  :on-pick pick! :anchor @anchor}])
                  (when comp-open?
                    [completion-popup {:items (:items comp) :active @comp-idx
                                       :query (:query comp) :on-pick pick-comp!
                                       :label (:label comp) :trigger (:trigger comp)
                                       :create? (:create? comp)
                                       :pending? (:pending? comp)
                                       :failed? (:failed? comp)
                                       :anchor @anchor}])])
               ;; The click target that opens the editor. It MUST keep a height
               ;; when :content is empty — a new block starts empty, and an
               ;; empty span in a baseline-aligned row has width but no line
               ;; box, so it is 0px tall and cannot be clicked. The block then
               ;; exists, is correct in the graph, and is permanently
               ;; unreachable (2026-08-03). min-h holds the box open; the
               ;; placeholder makes it look like somewhere to write rather than
               ;; like a row that failed to render.
               ;; whitespace-pre-wrap is load-bearing now that Shift+Enter can
               ;; put a real newline in a block: HTML collapses \n to a space,
               ;; so without it the editor would show two lines and the blurred
               ;; block would show one — the same discontinuity this change
               ;; exists to remove, moved one layer down.
               (let [blank? (str/blank? content)]
                 (into [:span {;; THE FLOOR LANDS HERE, on the text, because the
                               ;; body cell that holds it is the query container
                               ;; and a container cannot measure itself. A
                               ;; heading keeps `text-lg`, which is its own
                               ;; decision and overrides this deliberately.
                               :style (block-text-style)
                               ;; `ikc-block-content` IS A HANDLE, NOT A STYLE, and
                               ;; it is ikc1's own name for the same thing
                               ;; (2026-09-07). PageView.tsx reaches the body of
                               ;; the first block with
                               ;; `document.querySelector('.block-content')` when
                               ;; Enter is pressed in the page title. Every other
                               ;; class on this element is a Tailwind utility, so
                               ;; there was nothing stable to aim at.
                               ;;
                               ;; NOTHING STYLES IT. A class that carries no rule
                               ;; is the cheapest stable selector a renderer can
                               ;; offer, and the alternative — an id, or a
                               ;; `data-` attribute — would be a third convention
                               ;; for a job ikc1 already named.
                               :class (str "ikc-block-content "
                                           "flex-1 min-w-0 cursor-text self-center min-h-[1.5rem] "
                                           "whitespace-pre-wrap "
                                           (if blank?
                                             "text-[var(--faint)] italic "
                                             "text-[var(--text)] ")
                                           (when (= block-type :heading)
                                             "text-lg font-semibold text-[var(--heading)]"))
                               ;; A CLICK ON A LINK IS NOT A CLICK ON THE ROW.
                               ;; Rendering markdown gave rows real anchors, and
                               ;; this handler swallowed them: following a
                               ;; [[wikilink]] flipped the row to raw source AND
                               ;; navigated, so the page you left flashed its
                               ;; markup on the way out. Anything inside an <a>
                               ;; belongs to the anchor — let it act, and do not
                               ;; open the editor behind it.
                               :ref (selection-ref body-ref pending sel-listener)
                               ;; A selection inside THIS row offers the swatches.
                               ;; Scoped by body-ref, so a selection in another
                               ;; row or in the margin is ignored — the same rule
                               ;; the file body uses for its own pane.
                               :on-mouse-up
                               (when (and bus (:highlight actions))
                                 (fn [_]
                                   (reset! pending (some-> @body-ref selection-in))))
                               ;; A CLICK ON A LINK IS NOT A CLICK ON THE ROW.
                               ;; Rendering markdown gave rows real anchors, and
                               ;; this handler swallowed them.
                               ;;
                               ;; A CLICK THAT ENDS A SELECTION IS NOT ONE EITHER:
                               ;; dragging across a row's words used to open the
                               ;; editor on mouse-up, which replaced the rendered
                               ;; text with raw source and threw the selection
                               ;; away before the swatches could be used.
                               :on-click (fn [e]
                                           (let [t (.-target e)
                                                 a (when (and t (.-closest t)) (.closest t "a"))]
                                             (when-not (or a @pending)
                                               (reset! buf content)
                                               (reset! editing? true))))}]
                       ;; MARKDOWN, BECAUSE ikc1 RENDERS MARKDOWN
                       ;; (ADR-graph-ui-v0-016-01). A block's :content is markdown
                       ;; source; showing it raw is what made an imported note look
                       ;; MODIFIED — `#Juma \\` and `<https://…>` on screen where
                       ;; ikc1 shows a line break and a link, while the two stores
                       ;; were byte-identical. The data was right and the screen was
                       ;; wrong, which reads as data loss.
                       ;;
                       ;; The SOURCE is still what you edit: clicking swaps this for
                       ;; the textarea above, seeded from `content` verbatim. Read
                       ;; the meaning, edit the text — ikc1's own behaviour, so no
                       ;; third convention is invented here.
                       ;;
                       ;; Same renderer as :markdown (md/render over `marked`), so
                       ;; wikilinks navigate through the same :ui/select-page path
                       ;; rather than a second, nearly-identical linkifier.
                       ;;
                       ;; AND THE SAME CAPTURE. Selecting inside a row offers the
                       ;; same swatches a file body offers, through the same
                       ;; shared picker — a note and a document are marked the
                       ;; same way, which is the whole claim of the uniform shape
                       ;; one layer down (F-platform-v0-011-01).
                       (cond
                         blank?     ["Write something…"]
                         :else      [(md/render (or display-content "")
                                                (when (seq links)
                                                  (let [t->p (into {} (map (juxt :target :page-id)) links)]
                                                    #(get t->p %)))
                                                (when bus
                                                  ;; TWO ARGUMENTS NOW, AND THE
                                                  ;; SECOND CASE IS THE FIX
                                                  ;; (2026-09-07). A block whose
                                                  ;; text names a page that does
                                                  ;; not exist yet CREATES it on
                                                  ;; the click, which is what
                                                  ;; the :markdown declaration
                                                  ;; has always said an
                                                  ;; unresolved wikilink is for.
                                                  ;; This row could not do it,
                                                  ;; and the row above it —
                                                  ;; plain text, same syntax —
                                                  ;; always could.
                                                  (fn [pid target]
                                                    (js-invoke bus "dispatch"
                                                      (if pid
                                                        {:type :ui/select-page
                                                         :session-id session-id
                                                         :page-id pid}
                                                        {:type :ui/follow-wikilink
                                                         :session-id session-id
                                                         :target target})
                                                      (fn [_] nil))))
                                                ;; This row's own highlights,
                                                ;; washed by the same renderer
                                                ;; the file body uses. NONE
                                                ;; while truncated — a
                                                ;; highlight's own offsets are
                                                ;; into the FULL text, and
                                                ;; washing them over the
                                                ;; sixty-character preview
                                                ;; would mark the wrong words.
                                                (if truncated? [] highlights)
                                                ;; A #hashtag CHIP FILTERS ON A
                                                ;; CLICK when the description
                                                ;; wires the :tag gesture. With
                                                ;; no gesture the chip stays
                                                ;; inert, which is what every
                                                ;; surface drew before
                                                ;; (F-ikc-v3-018-01).
                                                (when (and bus (:tag actions))
                                                  (fn [tag]
                                                    (fire! actions :tag bus session-id
                                                           tag nil))))]))))
             ;; NO HOVER STRIP. It rendered the declared :row-menu as icons over
             ;; every row and was removed 2026-08-13 at George's word: "I didn't
             ;; ask for those on hover icons, didn't understand them and do not
             ;; need them." An affordance nobody can read is not an affordance;
             ;; it was costing width on every row to advertise commands by glyph.
             ;;
             ;; THE ACTIONS ARE NOT GONE. :row-menu is still declared, and the
             ;; RIGHT-CLICK menu below renders the same list with its labels —
             ;; the same commands, named in words, on demand instead of always.
             ;; Restoring the strip is a renderer change, not a declaration one,
             ;; which is the right way round: the declaration says WHICH commands
             ;; a row offers, this file decides how they are surfaced.
             ]

            ;; THE RIGHT GUTTER — this block's highlights, beside the lines they
            ;; mark.
            ;;
            ;; This is the ORIGINAL gutter of the locked target (`30px / 1fr /
            ;; 132px`), not a new column. I deleted it on 2026-08-15, reading
            ;; George's "what is this invented meta-gutter?" as "remove that
            ;; column" when it meant "that column is the right gutter — stop
            ;; inventing a second one beside it". He said so plainly on 2026-08-16:
            ;; "the right gutter is not restored — there is something there which
            ;; is not the original gutter."
            ;;
            ;; Drawn even when empty. A column that appears per row is not a
            ;; column, and its emptiness is information: nothing marked here.
            ;;
            ;; THE SAME WIDGET THE DOCUMENT'S GUTTER USES, so a row sits level
            ;; with the LINE it marks rather than stacking from the top of the
            ;; cell. A block is often several lines; listing its highlights in
            ;; order down the cell put the third one beside the first line
            ;; (George, 2026-08-16: "in the right gutter they are listed from the
            ;; top, are not aligned with their lines").
            ;;
            ;; It measures marks against its OWN top, so used per row it aligns
            ;; within the row for free — the same code, given a smaller box. The
            ;; alternative was a second copy of stack-tops and the measuring
            ;; effect, which is how two gutters happened in the first place.
            ;; THE TWO GUTTERS OF A ROW PAINT THE SAME. George, 2026-08-17:
            ;; "Make style of the right gutter to match left gutter (background
            ;; color, border color, radius)" — and they were already declared
            ;; identical in block-row.edn, so nothing in the declaration was
            ;; wrong. This line was: the cell was faded to
            ;; `--opacity-disabled` (0.38) whenever the row carried no
            ;; highlights, which is almost every row, and opacity fades the
            ;; background and the border along with the contents.
            ;;
            ;; Two things were wrong with the fade, beyond not matching.
            ;; `--opacity-disabled` says DISABLED, and the gutter is not
            ;; disabled — it is empty, and there is nothing you could do to it
            ;; if it were not. And an empty gutter already says what it has to
            ;; say: the column is drawn, with nothing in it. That is the same
            ;; call made one day earlier, one component over, when the document
            ;; gutter's "Nothing highlighted on this page" came out (29dd0e0) —
            ;; a treatment written for a region that APPEARS, applied to a
            ;; region that is always there.
            ;;
            ;; The emptiness is still passed in, because `:dim-when` is a real
            ;; declared key that cell-style honours now. Nothing declares it.
            [:div {:style (cell-style (cell 'right-gutter)
                                      {:empty? (empty? highlights)})
                   :class "min-w-0 overflow-hidden relative"}
             (when (seq highlights)
               [widget-highlight-list
                {:items highlights
                 :chrome false
                 ;; the row's gesture, under the name the list dispatches
                 :on-gesture {:remove (:remove-highlight actions)}}
                bus session-id])]]
           ;; A REFUSAL IN WORDS, on the row it happened to (PLAN-ikc-v3-061-01).
           [row-error-line send-error]])))))

(defn- outline-visible-items
  [items]
  (loop [items items acc [] collapse-depth nil]
    (if-let [item (first items)]
      (let [more          (rest items)
            depth         (:depth item)
            has-children? (boolean (and (first more) (> (:depth (first more)) depth)))
            hidden?        (and collapse-depth (> depth collapse-depth))
            next-collapse  (cond hidden?            collapse-depth
                                  (:collapsed? item) depth
                                  :else               nil)]
        (recur more
               (if hidden? acc (conj acc (assoc item :has-children? has-children?)))
               next-collapse))
      acc)))

(defn widget-outline
  ":actions (its named row-command map) is :on-gesture itself under v2.0,
   :actions under v1.x (gesture-actions, ADR-graph-ui-v0-013-01 §7-8) — fire!
   just looks a name up in whichever map it's handed."
  [{:keys [items links empty-label highlights] :as props} bus session-id]
  (let [actions (gesture-actions props)
        ;; The page's highlights, split by the block each one is on. Done ONCE
        ;; here rather than filtered per row inside the row component, which
        ;; would be O(rows x highlights) on every keystroke.
        by-block (group-by :block-id (or highlights []))
]
    (if (empty? items)
      ;; The empty state is a FALLBACK now, not the way an empty page gets its
      ;; first block: ui.notes-web/select-page makes one server-side before this
      ;; ever renders (George, 2026-08-07 — an empty page must come ready to
      ;; type). It stays because a page CAN still be empty — every block deleted,
      ;; say — and a dead end there is worse than a click.
      ;;
      ;; It briefly did the insert on mount, and that was wrong twice over:
      ;; `r/create-class` in the render path mints a new component type on every
      ;; render, so the row unmounted and remounted and inserted AGAIN — two
      ;; blocks, cursor in the second. And "no items" at mount can mean "not
      ;; loaded yet", which no client can tell apart from "genuinely empty".
      (when empty-label
        (if (:insert-first actions)
          [:p.text-sm.italic.cursor-text
           {:class    "text-[var(--faint)] hover:text-[var(--text)] transition-colors"
            :title    "Click to start writing"
            :on-click (fn [_] (fire! actions :insert-first bus session-id nil {}))}
           empty-label]
          [:p.text-sm.italic {:class "text-[var(--faint)]"} empty-label]))
      (let [visible (outline-visible-items items)
            ;; Up and Down between blocks (lane AL-K): each row is told which
            ;; row is its sibling before and after, by ikc1's rule.
            near    (outline-neighbours visible)]
      (into [:ul.space-y-1.overflow-y-auto.flex-1.min-h-0.pr-1.py-1]
            (for [[i item] (map-indexed vector visible)]
              ^{:key (:block-id item)}
              [outline-row (assoc item
                                  :num (inc i)
                                  :highlights (get by-block (:block-id item))
                                  :up-id   (get-in near [(:block-id item) :up])
                                  :down-id (get-in near [(:block-id item) :down]))
               actions links bus session-id
               (:row-menu props) (:slash-menu props)
               ;; THE WHOLE PROPS MAP, because :completions names a PROP by
               ;; keyword and the row has to look it up. A vector of items passed
               ;; positionally would fix the completion to one list, and the
               ;; declaration deliberately does not.
               (:completions props) props]))))))

;; ---------------------------------------------------------------------------
;; :split-pane — unchanged; a layout manager Mantine does not cover.
;; ---------------------------------------------------------------------------

(defn- ls-get [k]
  (when (exists? js/localStorage) (.getItem js/localStorage k)))

(defn- ls-set! [k v]
  (when (exists? js/localStorage) (.setItem js/localStorage k v)))

(defn- ls-num [k default]
  (let [v (some-> (ls-get k) js/parseFloat)]
    (if (and v (not (js/isNaN v))) v default)))

(defn widget-split-pane
  "A two-pane split, and — since PLAN-ikc-v3-015-01 phase 6 — a phone.

   THE NARROW ANSWER IS DECLARED, not inferred: :narrow on the node says :fold,
   :stack or :keep, and this kind's own :defaults in dsl/contexts/ui.edn say
   :fold when a description says nothing. Below --viewport-narrow the desktop
   geometry does not fit (:initial 270 + divider + :flex-min 280 = 556px against
   a 360px phone) and the pane's own `overflow-x: auto` turned that into an
   island the reader had to drag sideways.

   :fold hands the whole width to the filling pane and puts the resizable one
   behind ONE control — a sidebar becoming a control, which is what a sidebar is
   on a phone. That control is at least --touch-target across.

   THE NARROW FOLD IS NOT THE STORED FOLD. `folded` is the reader's own choice
   on a wide window and lives in localStorage; `narrow-open` is this visit's
   drawer and lives nowhere. A phone visit must not rewrite a desktop
   preference."
  [props _panes]
  (let [{:keys [pane-id initial collapsible fold-side]} props
        right?      (= fold-side :right)
        init        (or initial 270)
        mn          (or (:min props) 140)
        hard-mx     (:max props)
        flex-min    (or (:flex-min props) 280)
        collapsible? (not (false? collapsible))
        wkey        (str "ikc3-split-" pane-id "-w")
        fkey        (str "ikc3-split-" pane-id "-folded")
        width       (r/atom (max mn (ls-num wkey init)))
        folded      (r/atom (= "1" (ls-get fkey)))
        container   (atom nil)
        ;; This visit's drawer, on a narrow window only. Never persisted — see
        ;; the docstring.
        narrow-open (r/atom false)
        clamp       (fn [el px]
                      (let [cw  (.-width (.getBoundingClientRect el))
                            cap (max mn (- cw flex-min))
                            cap (if hard-mx (min hard-mx cap) cap)]
                        (max mn (min cap px))))
        on-move     (fn [ev]
                      (when-let [el @container]
                        (let [r  (.getBoundingClientRect el)
                              px (if right?
                                   (- (.-right r) (.-clientX ev))
                                   (- (.-clientX ev) (.-left r)))]
                          (reset! width (clamp el px)))))
        on-up       (fn on-up [_]
                      (.removeEventListener js/window "mousemove" on-move)
                      (.removeEventListener js/window "mouseup" on-up)
                      (ls-set! wkey (str @width)))
        start-drag  (fn [e]
                      (.preventDefault e)
                      (.addEventListener js/window "mousemove" on-move)
                      (.addEventListener js/window "mouseup" on-up))
        toggle-fold (fn [e]
                      (.stopPropagation e)
                      (swap! folded not)
                      (ls-set! fkey (if @folded "1" "0")))
        pane-div    (fn [child hidden?]
                      ;; A hidden pane must remain a grid item.  `display:none` removes
                      ;; the box entirely and auto-placement shifts the remaining panes
                      ;; into earlier tracks, so the filling pane collapses to 6px and
                      ;; the area to its right is "cleared".  Width 0 + overflow hidden
                      ;; keeps the grid cell empty while preserving the track layout.
                      [:div {:class (when-not hidden? "[&>*]:grow [&>*]:min-h-0 [&>*]:min-w-0")
                             :style (if hidden?
                                      {:width "0px" :overflow "hidden" :padding "0"
                                       :visibility "hidden"}
                                      {:overflow "hidden" :min-width "0" :min-height "0"
                                       :display "flex" :flex-direction "column"
                                       :padding "0.5rem"})}
                       (when-not hidden? child)])]
    (fn [props panes]
      (let [mode (responsive/split-narrow (:narrow props) (responsive/narrow?))
            w    (if @folded 0 @width)
            flex (str "minmax(" flex-min "px, 1fr)")
            cols (if right?
                   (str flex " 6px " w "px")
                   (str w "px 6px " flex))
            chev (if right? (if @folded "‹" "›") (if @folded "›" "‹"))
            sidebar (if right? (second panes) (first panes))
            fill (if right? (first panes) (second panes))]
        (case mode
          ;; ---- a phone, :fold --------------------------------------------
          ;; One column, no sideways scroll anywhere, and the sidebar one tap away.
          :fold
          [:div {:style {:display "flex" :flex-direction "column"
                         :height "100%" :min-height "0" :width "100%"
                         :max-width "100%" :overflow-x "hidden"}}
           [:button
            {:on-click #(swap! narrow-open not)
             :title    (if @narrow-open "Close the panel" "Open the panel")
             :style    {:min-height "var(--touch-target)" :width "100%"
                        :display "flex" :align-items "center" :gap "0.5rem"
                        :padding "0 0.75rem" :flex "0 0 auto"
                        :background "var(--panel)" :color "var(--text)"
                        :border "none" :border-bottom "1px solid var(--border)"
                        :font-weight "600" :cursor "pointer"}}
            [:span (if @narrow-open "✕" "☰")]
            [:span (if @narrow-open "Close panel" "Panel")]]
           [:div {:style {:flex "1 1 0" :min-height "0" :min-width "0"
                          :display "flex" :flex-direction "column"
                          :overflow-x "hidden"}
                  :class "[&>*]:grow [&>*]:min-h-0 [&>*]:min-w-0"}
            (if @narrow-open sidebar fill)]]

          ;; ---- a phone, :stack -------------------------------------------
          ;; Both halves, one above the other, the resizable one first.
          :stack
          [:div {:style {:display "flex" :flex-direction "column"
                         :height "100%" :min-height "0" :width "100%"
                         :max-width "100%" :overflow-x "hidden" :overflow-y "auto"}}
           (pane-div sidebar false)
           [:div {:style {:height "6px" :background "var(--border)" :flex "0 0 auto"}}]
           (pane-div fill false)]

          ;; ---- the desktop split, unchanged ------------------------------
          [:div {:ref   (fn [el] (reset! container el))
                 :style {:display "grid"
                         :grid-template-columns cols
                         :height "100%" :min-height "0" :width "100%"
                         :overflow-x "auto" :overflow-y "hidden"}}
           (pane-div (first panes)  (and @folded (not right?)))
           [:div {:on-mouse-down start-drag
                  :style {:cursor "col-resize" :position "relative"
                          :background "var(--border)"}}
            (when collapsible?
              [:div {:on-click   toggle-fold
                     :title      (if @folded "Show pane" "Fold pane")
                     :style (merge {:position "absolute" :top "8px"
                                    :width "16px" :height "26px" :border-radius "5px"
                                    :background "var(--raised)" :border "1px solid var(--border)"
                                    :display "grid" :place-items "center" :cursor "pointer"
                                    :color "var(--faint)" :font-size "12px" :z-index "3"}
                                   (if right? {:right "-8px"} {:left "-8px"}))}
               chev])]
           (pane-div (second panes) (and @folded right?))])))))
